export const translations = {
  ru: {
    // Auth Page
    'auth.title': 'Chatity',
    'auth.subtitle': 'AI-ресепшн для бьюти и wellness',
    'landing.value.title': 'Ваши клиенты уже пишут вам. Chatity берёт это на себя.',
    'landing.value.subtitle': 'Каждое непрочитанное сообщение — потерянная запись. Chatity отвечает мгновенно, записывает клиентов, принимает оплаты и возвращает их снова — пока вы работаете.',
    'landing.value.c1': 'Не упускайте ни одного обращения',
    'landing.value.c1d': 'Мгновенные ответы в WhatsApp, Instagram и на сайте — 24/7, даже когда салон закрыт.',
    'landing.value.c2': 'Записывайте автоматически',
    'landing.value.c2d': 'AI предлагает свободное время, бронирует и подтверждает — без участия администратора.',
    'landing.value.c3': 'Принимайте оплаты',
    'landing.value.c3d': 'Предоплаты и депозиты прямо в переписке — меньше неявок.',
    'landing.value.c4': 'Возвращайте клиентов',
    'landing.value.c4d': 'Умные напоминания и персональные приглашения «уснувшим» клиентам.',
    'auth.login': 'Вход',
    'auth.register': 'Регистрация',
    'auth.email': 'Email',
    'auth.password': 'Пароль',
    'auth.salonName': 'Название салона',
    'auth.companyName': 'Название компании',
    'auth.companyNamePlaceholder': 'Например: Beauty Studio',
    'auth.companyWebsite': 'Сайт компании (необязательно)',
    'auth.websiteImportant': '💡 Важно: укажите верный адрес сайта, чтобы ИИ считал с него базовую информацию для общения с клиентами',
    'auth.loginButton': 'Войти',
    'auth.registerButton': 'Зарегистрироваться',
    'auth.termsAccept': "Я принимаю",
    'auth.termsLink': "Условия использования",
    'auth.termsAnd': "и",
    'auth.privacyLink': "Политику конфиденциальности",
    'ms.book.privacyNotice': "Нажимая «Записаться», вы передаёте свои данные {business} для обработки заявки и управления вашим визитом (включая напоминания). Chatity — технический провайдер и обрабатывает данные по поручению бизнеса.",
    'ms.book.learnMore': "Подробнее",
    'ms.book.optional': "необязательно",
    'ms.book.marketingConsent': "Я согласен(на) получать предложения и новости {business} по e-mail, SMS или в мессенджерах",
    'privacy.title': "Конфиденциальность и юридические данные",
    'privacy.intro': "По GDPR вы — контролёр данных ваших клиентов, Chatity (MINDUNITE SAS) — обработчик. Эти данные показываются клиентам в уведомлении о конфиденциальности на мини-сайте и в чат-виджете.",
    'privacy.legalName': "Юридическое название",
    'privacy.address': "Юридический адрес",
    'privacy.email': "Контактный email",
    'privacy.privacyEmail': "Email для запросов о данных",
    'privacy.phone': "Телефон",
    'privacy.policyUrl': "Ссылка на вашу политику конфиденциальности (необязательно)",
    'privacy.marketingTitle': "Маркетинговые рассылки",
    'privacy.marketingEnabled': "Разрешить маркетинговые сообщения клиентам (реактивация, акции)",
    'privacy.marketingHint': "На форме записи появится отдельный невыбранный чекбокс согласия. Без согласия рекламные сообщения не отправляются; напоминания о записи работают всегда.",
    'privacy.existingCustomers': "Исключение для существующих клиентов",
    'privacy.existingCustomersHint': "Отправлять предложения по похожим услугам клиентам, которые уже были у вас, если они не отписались (STOP). Убедитесь, что это допустимо по вашему законодательству.",
    'privacy.retentionTitle': "Сроки хранения",
    'privacy.chatRetention': "Переписка с клиентами, дней",
    'privacy.bookingRetention': "История записей и карточки клиентов",
    'privacy.retention.active': "Пока клиент активен (3 года после последнего визита)",
    'privacy.retention.2y': "2 года после последнего визита",
    'privacy.retention.1y': "1 год после последнего визита",
    'privacy.retentionHint': "Автоматическое удаление/анонимизация по этим срокам выполняется ежедневной задачей.",
    'privacy.healthTitle': "Медицинские данные",
    'privacy.healthEnabled': "Режим работы с данными о здоровье (PMU, эстетическая медицина)",
    'privacy.healthHint': "По умолчанию ИИ не запрашивает и не сохраняет медицинскую информацию и передаёт такие вопросы администратору. Отдельный защищённый процесс для медицинских данных — в разработке.",
    'privacy.save': "Сохранить настройки конфиденциальности",
    'privacy.saved': "Настройки конфиденциальности сохранены",
    'auth.loading': 'Загрузка...',
    'auth.loginSuccess': 'Вход выполнен успешно!',
    'auth.registerSuccess': 'Регистрация успешна!',
    'auth.error': 'Ошибка авторизации',
    'auth.websiteUrl': 'Сайт салона',
    'auth.forgotPassword': 'Забыли пароль?',
    'auth.loginWithCode': 'Войти по коду из письма (без пароля)',
    'auth.loginWithPassword': 'Войти по паролю',
    'auth.sendCode': 'Получить код входа',
    'auth.verifyCode': 'Войти',
    'auth.enterCode': 'Код из письма',
    'auth.codeSentInfo': 'Код отправлен на вашу почту',
    'auth.codeSentHint': 'Код и кнопка входа отправлены на почту (проверьте папку Спам)',
    'auth.resendCode': 'Отправить код ещё раз',
    'auth.magicLoginError': 'Ссылка недействительна или устарела',
    'auth.magicLoggingIn': 'Входим...',
    'auth.backToLogin': 'Вернуться ко входу',
    
    // Forgot Password
    'forgot.title': 'Восстановление пароля',
    'forgot.subtitle': 'Введите email для получения кода восстановления',
    'forgot.enterCode': 'Введите код из письма и новый пароль',
    'forgot.sendCode': 'Отправить код',
    'forgot.resetCode': 'Код восстановления',
    'forgot.newPassword': 'Новый пароль',
    'forgot.confirmPassword': 'Подтвердите пароль',
    'forgot.resetPassword': 'Сбросить пароль',
    'forgot.resendCode': 'Отправить код повторно',
    'forgot.backToLogin': 'Назад к входу',
    'forgot.codeSent': 'Код отправлен на email',
    'forgot.success': 'Пароль успешно изменен!',
    'forgot.error': 'Ошибка восстановления пароля',
    'forgot.passwordMismatch': 'Пароли не совпадают',
    'forgot.passwordTooShort': 'Пароль должен быть минимум 6 символов',
    
    // Dashboard
    'dashboard.title': 'Chatity',
    'dashboard.logout': 'Выход',
    'dashboard.logoutSuccess': 'Выход выполнен',
    
    // Tabs
    'tabs.settings': 'Настройки',
    'tabs.bookings': 'Заявки',
    'tabs.widget': 'Интеграции',
    'tabs.marketing': 'Маркетинг', 'tabs.analytics': 'Аналитика',
    'mk.triggersTitle': 'Триггерные слова',
    'mk.triggersHint': 'Клиент пишет кодовое слово (например, из рекламы) — бот мгновенно отправляет ваш оффер. Работает в Instagram, WhatsApp и виджете.',
    'mk.keyword': 'Кодовое слово',
    'mk.response': 'Что отправить в ответ',
    'mk.responsePh': 'Например: Поздравляем! 🎁 Вам доступен уход в подарок при записи на любую услугу. Напишите, когда вам удобно прийти!',
    'mk.addTrigger': 'Добавить слово',
    'mk.active': 'Активно',
    'mk.save': 'Сохранить',
    'mk.saved': 'Сохранено ✓', 'clients.language': 'Язык клиента (WhatsApp/Instagram уведомления)', 'clients.langAuto': 'Авто по коду страны', 'clients.langAutoUnknown': 'Авто (по переписке)', 'clients.langHint': 'Напоминания и подтверждения уходят на этом языке. Авто: по коду страны номера (+33 — французский, +7 — русский…), иначе по переписке.', 'clients.langSaved': 'Язык клиента сохранён', 'mk.remindersTitle': 'Напоминания клиентам о визите', 'mk.remindersHint': 'Автоматически в WhatsApp. Если у клиента нет WhatsApp — AI-звонок за 24 ч (нужен подключённый телефон).', 'mk.remindersNoWhatsapp': 'WhatsApp не подключён — напоминания в WhatsApp не уйдут.', 'mk.remindersNoPhone': 'Телефон не подключён — напоминание звонком (для клиентов без WhatsApp) работать не будет.', 'mk.remindersConnect': 'Подключить', 'mk.remindersChannelsOk': 'WhatsApp и телефон подключены — напоминания работают.', 'mk.remindersTextLabel': 'Свой текст (необязательно)', 'mk.reminder24hTitle': 'За 24 часа', 'mk.reminder24hHint': 'Накануне визита — с возможностью перенести или отменить ответом', 'mk.reminder24hPh': '{name}, напоминаем о записи завтра ✨ {service}{master} — {when}. Ждём вас!', 'mk.reminder2hTitle': 'За 2 часа', 'mk.reminder2hHint': 'Короткое напоминание в день визита', 'mk.reminder2hPh': '{name}, ждём вас сегодня в {time} ⏰ {service}{master}. До встречи!', 'mk.remindersPlaceholders': 'Подстановки: {name} — имя, {service} — услуга, {master} — « у мастера …», {when} — дата и время, {date}, {time}', 'mk.remindersLogTitle': 'Последние отправки', 'mk.remindersUpcoming': 'Ожидают напоминания: {n}', 'mk.remindersLogEmpty': 'Пока ничего не отправлялось — напоминания уйдут автоматически перед ближайшими визитами', 'mk.remindersNotDelivered': 'не доставлено',
    'addons.title': 'Дополнения', 'addons.subtitle': 'Каналы, филиалы и телефония добавляются к вашей подписке и продлеваются вместе с ней — без повторного ввода карты. Пакеты диалогов — разовая покупка до конца оплаченного месяца.',
    'addons.dialogs': 'Пакет диалогов', 'addons.dialogsHint': '+100 диалогов за €10. Можно купить несколько — спишутся после основного лимита, сгорают в конце оплаченного месяца.',
    'addons.channel': 'Доп. канал', 'addons.channelHint': 'В тариф включён 1 канал (WhatsApp или Instagram). Каждый дополнительный — €19/мес. Виджет и мини-сайт всегда бесплатны.',
    'addons.branch': 'Доп. филиал', 'addons.branchHint': 'В тариф включён 1 филиал. Каждый дополнительный — 50% от цены вашего тарифа в месяц.',
    'addons.buy': 'Купить', 'addons.mo': 'мес', 'addons.active': 'Активно', 'addons.connected': 'Подключено каналов', 'addons.branches': 'Филиалы',
    'addons.phone': 'Телефонный ИИ', 'addons.yours': 'Ваши дополнения', 'addons.autoRenew': 'продлевается вместе с подпиской', 'addons.cancel': 'Отключить', 'addons.resume': 'Возобновить',
    'addons.endsOn': 'Отключится {date}', 'addons.validUntil': 'Действует до {date}', 'addons.attached': 'Дополнение подключено и добавлено в вашу подписку',
    'addons.cancelConfirm': 'Отключить дополнение? Оно будет работать до конца оплаченного периода, дальше списаний не будет.', 'addons.cancelled': 'Дополнение отключится в конце периода', 'addons.resumed': 'Дополнение снова активно',
    'addons.confirmAttach': 'Добавить в текущую подписку: сегодня спишется €{now} с вашей карты (пропорционально до конца периода), далее {monthly} вместе с подпиской. Подтвердить?',
    'addons.confirmCheckout': 'Подписка на дополнение {monthly} с автопродлением. Сейчас откроется страница оплаты. Продолжить?',
    'mk.igTitle': 'Instagram: реакции на сторис', 'mk.storyReactHint': 'Когда клиент ставит реакцию (❤️ 🔥 😍) на вашу сторис, ИИ поблагодарит и начнёт диалог', 'mk.storyReactInfo': 'Что предложить в ответе', 'mk.storyReactPlaceholder': 'Например: до конца месяца скидка 20% на маникюр для новых клиентов', 'mk.storyReactTip': 'ИИ вплетёт эту информацию в ответ на языке клиента. Отвечает не чаще 1 раза в 6 часов на диалог.',
    'tabs.admin': 'Админ',
    'tabs.support': 'Поддержка',
    
    // Settings
    'settings.title': 'Настройки',
    'settings.subtitle': 'Настройте интеграции и вашего AI-помощника',
    'settings.languageTitle': 'Языковые настройки',
    'settings.uiLanguage': 'Язык интерфейса',
    'settings.uiLanguageDesc': 'Язык панели управления и меню',
    'settings.notificationLanguage': 'Язык уведомлений',
    'settings.notificationLanguageDesc': 'Язык email и Telegram уведомлений о заявках',
    'settings.notificationLanguageSuccess': 'Язык уведомлений обновлен',
    'settings.languageUpdateError': 'Ошибка обновления языка',
    'settings.notifications': 'Уведомления о заявках',
    'settings.emailTitle': 'Email уведомления',
    'settings.emailCheckbox': 'Получать заявки на email',
    'settings.emailRecipients': 'Куда отправлять уведомления (через запятую)',
    'settings.emailRecipientsDefault': 'по умолчанию: {email}',
    'settings.emailRecipientsHint': 'Оставьте пустым, чтобы получать на email аккаунта. Можно указать несколько адресов через запятую — уведомление придёт каждому.',
    'settings.emailWarning': '⚠️ Email функция доступна на продакшн окружении. В тестовом режиме используйте Telegram.',
    'settings.telegramTitle': 'Telegram уведомления',
    'settings.chatId': 'Chat ID группы',
    'settings.chatIdInstructions': 'Как получить Chat ID для уведомлений:',
    'settings.chatIdStep1': 'Найдите бота:',
    'settings.chatIdStep1Text': 'Откройте Telegram и найдите нашего бота',
    'settings.chatIdStep2': 'Добавьте в чат:',
    'settings.chatIdStep2Text': 'Добавьте бота в ваш личный чат или группу где хотите получать уведомления',
    'settings.chatIdStep3': 'Запустите команду:',
    'settings.chatIdStep3Text': 'Напишите команду',
    'settings.chatIdStep4': 'Скопируйте Chat ID:',
    'settings.chatIdStep4Text': 'Бот пришлёт ваш Chat ID (число вида: -1001234567890)',
    'settings.chatIdStep5': 'Вставьте и сохраните:',
    'settings.chatIdStep5Text': 'Вставьте Chat ID в поле выше и нажмите "Сохранить настройки"',
    'settings.chatIdSuccess': 'После сохранения вы будете получать уведомления о новых бронированиях прямо в Telegram!',
    'settings.balloonSettings': 'Всплывающая подсказка',
    'settings.balloonEnabled': 'Показывать подсказку',
    'settings.balloonEnabledDesc': 'Всплывающее сообщение привлекает внимание посетителей',
    'settings.balloonMessage': 'Текст подсказки',
    'settings.balloonMessagePlaceholder': 'Здравствуйте! Помогу записаться на услугу 👋',
    'settings.balloonDelay': 'Задержка (секунды)',
    'settings.balloonDelayDesc': 'Через сколько секунд показать подсказку',
    'settings.autoOpenEnabled': 'Автооткрытие чата',
    'settings.autoOpenEnabledDesc': 'Автоматически открыть чат если посетитель не кликнул',
    'settings.autoOpenDelay': 'Задержка автооткрытия (секунды)',
    'settings.autoOpenDelayDesc': 'Через сколько секунд автоматически открыть чат',
    'settings.analyzeWebsite': 'Анализировать сайт',
    'settings.analyzing': 'Анализируем',
    'settings.websiteAnalyzed': 'Сайт проанализирован! Информация загружена в базу знаний.',
    'settings.websiteAnalyzedSuccess': 'Сайт успешно проанализирован!',
    'settings.websiteUrlRequired': 'Укажите URL сайта в настройках бизнеса для автоматического анализа',
    'settings.aiChatbot': 'AI-помощник',
    'settings.primaryColor': 'Основной цвет',
    'settings.secondaryColor': 'Вторичный цвет',
    'settings.buttonColor': 'Цвет кнопки',
    'settings.botName': 'Имя бота',
    'settings.welcomeMessage': 'Приветственное сообщение',
    'settings.defaultBotName': 'Ассистент',
    'settings.defaultWelcomeMessage': 'Здравствуйте! Чем могу вам помочь?',
    'settings.businessInfo': 'Информация о вашем бизнесе',
    'settings.aiKnowledgeTitle': 'AI будет использовать эту информацию!',
    'settings.aiKnowledgeDesc': 'Укажите услуги, цены, график работы, адрес. AI будет консультировать клиентов на основе этих данных.',
    'settings.knowledgeBase': 'База знаний для AI',
    'settings.knowledgeBasePlaceholder': `Например:

Наши услуги:
- Стрижка - от 1500₽
- Укладка - от 1000₽
- Консультация - 500₽

График работы:
Пн-Пт: 10:00-20:00
Сб-Вс: 11:00-19:00

Адрес: Москва, ул. Примерная, д. 10
Телефон: +7 (999) 123-45-67`,
    'settings.knowledgeTip': 'Совет: Чем подробнее опишете услуги и цены, тем точнее AI будет консультировать клиентов',
    'settings.businessType': 'Тип вашего бизнеса',
    'settings.businessTypeHint': 'AI будет настроен под специфику вашей ниши',
    'settings.businessTypes.general': '🏢 Универсальный',
    'settings.businessTypes.medical': '🏥 Медицина / Клиника',
    'settings.businessTypes.beauty': '💅 Салон красоты',
    'settings.businessTypes.ecommerce': '🛍️ Интернет-магазин',
    'settings.businessTypes.restaurant': '🍽️ Ресторан / Кафе',
    'settings.businessTypes.services': '🔧 Услуги / Сервис',
    'settings.productFeedUrl': 'Ссылка на фид товаров (XML/JSON)',
    'settings.productFeedHint': 'AI будет консультировать клиентов по товарам из вашего каталога',
    'tilda.title': 'Интернет-магазин Tilda (MCP)', 'tilda.desc': 'ИИ будет отвечать клиентам по товарам, ценам и наличию из вашего каталога Tilda и направлять в магазин за покупкой.', 'tilda.step1': 'В Tilda откройте Профиль → «MCP server» → «New key»', 'tilda.step2': 'Выберите проект магазина, доступ «Limited» → отметьте только «Product catalog» (чтение) и срок «No expiration»', 'tilda.step3': 'Скопируйте ключ (показывается один раз) и вставьте ниже', 'tilda.keyLabel': 'Ключ Tilda MCP', 'tilda.connect': 'Подключить', 'tilda.checking': 'Проверяем…', 'tilda.help': 'Инструкция Tilda по MCP', 'tilda.connected': 'Tilda подключена, каталог загружен', 'tilda.synced': 'Каталог обновлён', 'tilda.disconnectConfirm': 'Отключить Tilda? Каталог товаров будет удалён из ИИ.', 'tilda.project': 'Проект', 'tilda.products': 'Товаров', 'tilda.syncedAt': 'Обновлено', 'tilda.currency': 'Валюта цен', 'tilda.key': 'Ключ', 'tilda.lastError': 'Последняя ошибка', 'tilda.sync': 'Обновить каталог', 'tilda.disconnect': 'Отключить', 'tilda.searchPh': 'Проверить товар в каталоге…', 'tilda.search': 'Найти', 'tilda.noResults': 'Ничего не найдено', 'tilda.autoSync': 'Каталог обновляется автоматически каждые 12 часов.', 'tilda.err.key': 'Ключ не принят Tilda. Проверьте ключ (начинается с mcp_tilda_) и срок его действия', 'tilda.err.noProjects': 'У ключа нет доступа ни к одному проекту', 'tilda.err.unreachable': 'Tilda недоступна, попробуйте позже', 'tilda.err.generic': 'Ошибка подключения',
    'subscription.cancelTitle': 'Отмена подписки', 'subscription.cancelDesc': 'Подписка и все дополнения (телефония, каналы, филиалы) отменяются сразу: ИИ остановится во всех каналах, списаний больше не будет.', 'subscription.lastPayment': 'Последний платёж', 'subscription.cancelBtn': 'Отменить подписку', 'subscription.cancelConfirm': 'Отменить подписку прямо сейчас? ИИ сразу остановится во всех каналах (сайт, WhatsApp, Instagram, телефон). Списаний больше не будет.', 'subscription.cancelDone': 'Подписка отменена. Списаний больше не будет.', 'subscription.cancelError': 'Не удалось изменить подписку. Напишите в поддержку.', 'subscription.cancelScheduled': 'Подписка отменена', 'subscription.cancelScheduledDesc': 'Доступ сохранится до {date}, затем ИИ остановится во всех каналах. Денег больше не списываем.', 'subscription.resumeBtn': 'Возобновить подписку', 'subscription.resumeDone': 'Подписка возобновлена',
    'cal.billingPaymentFailed': 'Оплата подписки не прошла — ИИ приостановлен во всех каналах (сайт, WhatsApp, Instagram, телефон). Клиенты остаются без ответа.', 'cal.billingUnpaid': 'Подписка неактивна — ИИ не отвечает клиентам ни в одном канале.', 'cal.billingFix': 'Исправить оплату',
    'tilda.sendLinks': 'Разрешить ИИ отправлять клиенту ссылку на товар', 'settings.aiKnowledgeDescEcom': 'Укажите условия доставки и оплаты, возврат, сроки, адрес самовывоза, контакты. Товары и цены ИИ берёт из подключённого каталога Tilda.',

    'settings.saveButton': 'Сохранить настройки',
    'settings.saving': 'Сохраняем…',
    'settings.saveSuccess': 'Настройки сохранены!',
    'settings.saveError': 'Ошибка сохранения настроек',
    
    // Bookings
    'bookings.title': 'История заявок',
    'bookings.subtitle': 'Все заявки от клиентов',
    'bookings.noBookings': 'Пока нет заявок',
    'bookings.service': 'Услуга',
    'bookings.preferredDate': 'Желаемая дата',
    'bookings.preferredTime': 'Желаемое время',
    
    // Analytics
    'analytics.upgradeToPro': 'Расширенная аналитика',
    'analytics.upgradeDescription': 'Обновите план до Professional или Unlimited для доступа к:',
    'analytics.feature1': 'Графики динамики заявок',
    'analytics.feature2': 'Источники трафика (UTM метки)',
    'analytics.feature3': 'Детальная статистика',
    'analytics.feature4': 'Экспорт данных',
    'analytics.upgradeButton': 'Обновить план',
    'analytics.channel': 'Канал',
    'analytics.campaign': 'Кампания',
    'miniBuilder.title': 'Конструктор мини-сайта',
    'miniBuilder.active.onTitle': 'Мини-сайт активен',
    'miniBuilder.active.offTitle': 'Мини-сайт выключен',
    'miniBuilder.active.onHint': 'Публичная страница работает. Посетители видят ваш мини-сайт по короткой ссылке.',
    'miniBuilder.active.offHint': 'Страница скрыта. По вашей короткой ссылке посетители увидят 404. Виджет и интеграции продолжают работать.',
    'miniBuilder.save': 'Сохранить',
    'miniBuilder.saving': 'Сохраняем...',
    'miniBuilder.loading': 'Загружаем...',
    'miniBuilder.noSlug': 'Сначала задайте короткую ссылку во вкладке Интеграции',
    'miniBuilder.upgradeDesc': 'Конструктор мини-сайта доступен на тарифах Professional и Unlimited.',
    'miniBuilder.upgradeBtn': 'Перейти на Professional',
    'miniBuilder.about.title': 'О нас',
    'miniBuilder.about.label': 'Текст «О нас»',
    'miniBuilder.about.aiBtn': 'Сгенерировать ИИ',
    'miniBuilder.about.generating': 'Генерируем...',
    'miniBuilder.about.placeholder': 'Коротко расскажите о вашем салоне: атмосфера, ценности, чем вы отличаетесь...',
    'miniBuilder.about.hint': 'ИИ использует данные из вашей базы знаний (описание салона, услуги, цены) во вкладке «Настройки».',
    'miniBuilder.seo.title': 'SEO-настройки',
    'miniBuilder.seo.hint': 'Эти поля видят поисковики (Google) и соцсети при шаринге ссылки. Если оставить пустыми — заполнятся автоматически из названия и блока «О нас».',
    'miniBuilder.seo.titleLabel': 'SEO-заголовок (title)',
    'miniBuilder.seo.titlePlaceholder': 'Маникюр и педикюр в Париже — салон «Люкс»',
    'miniBuilder.seo.titleHint': 'К заголовку автоматически добавится «— Chatity»',
    'miniBuilder.seo.descLabel': 'SEO-описание (description)',
    'miniBuilder.seo.descPlaceholder': 'Салон красоты в центре Парижа: маникюр, педикюр, брови. Запись онлайн 24/7.',
    'miniBuilder.seo.descHint': 'Показывается под заголовком в результатах поиска Google',
    'miniBuilder.seo.keywordsLabel': 'Ключевые слова (keywords)',
    'miniBuilder.seo.keywordsPlaceholder': 'маникюр париж, педикюр, салон красоты 11 округ',
    'miniBuilder.seo.keywordsHint': 'Через запятую. Необязательно — Google их почти не учитывает, но не помешает',
    'miniBuilder.cover.title': 'Обложка мини-сайта',
    'miniBuilder.cover.desc': 'Ссылка на картинку (Instagram / Imgur / Telegram / свой CDN). Если пусто — показывается градиент.',
    'miniBuilder.logo.title': 'Логотип / Аватар',
    'miniBuilder.logo.desc': 'Круглый логотип в шапке мини-сайта. Лучше квадрат 512×512 px (PNG с прозрачным фоном или JPG).',
    'miniBuilder.logo.hint': 'Логотип отображается рядом с названием бизнеса в Hero мини-сайта и в чат-виджете.',
    'miniBuilder.social.title': 'Соцсети и контакты',
    'miniBuilder.social.hint': 'Эти ссылки будут показаны посетителям на публичной странице мини-сайта.',
    'miniBuilder.services.title': 'Услуги и цены',
    'miniBuilder.photos.title': 'Галерея фото',
    'miniBuilder.phase2': 'скоро (фаза 2)',
    'miniBuilder.phase2Photos': 'скоро (фаза 2)',
    'miniBuilder.toast.saved': 'Мини-сайт сохранён',
    'miniBuilder.toast.saveFailed': 'Не удалось сохранить',
    'miniBuilder.toast.aiSuccess': 'ИИ сгенерировал описание 🤖',
    'miniBuilder.toast.aiFailed': 'Не удалось сгенерировать',
    'miniBuilder.address.label': 'Адрес',
    'miniBuilder.address.placeholder': 'Москва, ул. Тверская, 12',
    'miniBuilder.address.hint': 'Будет показан на публичном мини-сайте с интерактивной картой Google.',
    'miniBuilder.services.empty': 'Пока нет ни одной категории. Добавьте первую, чтобы клиенты увидели ваши услуги и цены.',
    'miniBuilder.services.addCategory': 'Добавить категорию',
    'miniBuilder.services.addService': 'Добавить услугу',
    'miniBuilder.services.categoryNamePlaceholder': 'Например: Стрижки и укладки',
    'miniBuilder.services.categoryDescPlaceholder': 'Короткое описание категории (необязательно)',
    'miniBuilder.services.serviceNamePlaceholder': 'Название услуги',
    'miniBuilder.services.durationPlaceholder': '60 мин',
    'miniBuilder.services.pricePlaceholder': '50',
    'miniBuilder.photos.empty': 'Пока нет фото. Добавьте ссылки на снимки интерьера, работ или команды.',
    'miniBuilder.photos.add': 'Добавить фото',
    'miniBuilder.photos.urlPlaceholder': 'https://i.imgur.com/photo.jpg',
    'miniBuilder.photos.altPlaceholder': 'Подпись (необязательно)',
    'miniBuilder.photos.hint': 'Лучший формат — горизонтальные фото 1200×800 px. До 6 фото, до 2 МБ каждое. Большие фото автоматически сжимаются в WebP.',
    'miniBuilder.photos.full': 'Достигнут лимит — 6 фото. Удалите одно, чтобы загрузить новое.',
    'uploader.trimmed': 'Можно загрузить ещё только {n} фото — остальные пропущены.',
    'miniBuilder.services.currencyLabel': 'Валюта',
    'miniBuilder.services.unnamedCategory': 'Без названия',
    'miniBuilder.titleField.label': 'Название бизнеса (заголовок страницы)',
    'miniBuilder.titleField.placeholder': 'Oui Beauté · Salon de Coiffure à Nice',
    'miniBuilder.titleField.hint': 'Попадёт в <title> вкладки браузера и в шапку мини-сайта. Если пусто — используется название салона из настроек.',
    'miniBuilder.tagline.label': 'Подзаголовок (тэглайн)',
    'miniBuilder.tagline.placeholder': 'Парикмахерская на Тверской · 8 лет опыта',
    'miniBuilder.tagline.hint': 'Короткая фраза под названием бизнеса. До 80 символов.',
    'uploader.btn': 'Загрузить',
    'uploader.dropzone': 'Перетащите фото сюда или нажмите, чтобы выбрать',
    'uploader.dropzoneMulti': 'Перетащите несколько фото или нажмите, чтобы выбрать',
    'uploader.hint': 'JPG / PNG / WebP, до 2 МБ',
    'uploader.uploading': 'Загружаю',
    'uploader.success': 'Фото загружено ✓',
    'uploader.successMulti': 'Загружено фото: {n}',
    'uploader.failed': 'Ошибка загрузки',
    'uploader.invalidType': 'Неподдерживаемый формат. Используйте JPG, PNG или WebP.',
    'uploader.tooBig': 'Файл слишком большой. Попробуйте фото поменьше.',
    'miniBuilder.hours.title': 'Часы работы',
    'miniBuilder.hours.label': 'Время работы салона',
    'miniBuilder.hours.placeholder': 'Пн-Пт: 09:00–19:00\nСб: 10:00–18:00\nВс: выходной',
    'miniBuilder.hours.hint': 'Свободный текст. Перенос строки = новая строка на сайте.',
    'tabs.minisite': 'Мини-сайт',
    'tabs.team': 'Команда',
    'tabs.calendar': 'Календарь',
    'cal.today': 'Сегодня', 'cal.day': 'День', 'cal.week': 'Неделя', 'cal.month': 'Месяц',
    'cal.allBranches': 'Все филиалы', 'cal.allMasters': 'Все мастера', 'cal.modeChips': 'Записи', 'cal.modeLoad': 'Загрузка',
    'cal.addClient': 'Записать клиента', 'cal.dashboard': 'Кабинет',
    'cal.newBooking': 'Новая запись', 'cal.clientName': 'Имя клиента', 'cal.phone': 'Телефон',
    'cal.service': 'Услуга', 'cal.master': 'Мастер', 'cal.date': 'Дата', 'cal.time': 'Время',
    'cal.book': 'Записать', 'cal.moved': 'Запись перенесена', 'cal.conflict': 'Это время занято или вне графика', 'cal.onlyMasterServices': 'Показаны только услуги этого мастера. Остальные — в карточке мастера (Команда)', 'cal.conflict.day_off': 'У мастера {master} выходной в этот день (или филиал закрыт)', 'cal.conflict.outside_schedule': 'Вне графика: {master} работает {window}, услуга занимает {duration_min} мин', 'cal.conflict.busy': 'У мастера {master} уже есть запись в это время {start_at}–{end_at}', 'cal.conflict.external_busy': 'Время занято у {master} во внешнем календаре', 'cal.conflict.master_not_found': 'Мастер не найден или у него нет графика', 'cal.conflict.master_does_not_offer_service': 'Мастер не выполняет эту услугу — отметьте её в карточке мастера', 'cal.conflict.no_master_for_service': 'Ни один мастер не выполняет эту услугу — отметьте её в карточках мастеров', 'cal.conflict.no_free_master': 'Нет свободного мастера на это время',
    'cal.unassigned': 'Нераспределённые', 'cal.assignTime': 'Назначить время',
    'ob.skip': 'Пропустить настройку', 'ob.skipConfirm': 'Выйти из настройки? Вы всегда сможете настроить всё позже в разделах кабинета.', 'ob.stepOf': 'Шаг {a} из {b}', 'ob.next': 'Продолжить', 'ob.back': 'Назад', 'ob.s1Title': 'Расскажите о себе', 'ob.s1Sub': '2 минуты — AI будет представляться вашим именем', 'ob.salonName': 'Название салона', 'ob.bizType': 'Тип бизнеса', 'ob.timezone': 'Часовой пояс', 'ob.nameRequired': 'Введите название', 'ob.s2Title': '7 дней бесплатно — полный доступ', 'ob.s2Sub': 'Привяжите карту сейчас, списание только через 7 дней', 'ob.s2Note': 'Сегодня 0 €. Первое списание через 7 дней. Отмена в один клик в любой момент.', 'ob.s2Cta': 'Привязать карту — 7 дней бесплатно', 'ob.s2Later': 'Позже', 'ob.recommended': 'Рекомендуем', 'ob.dialogsMo': 'диалогов/мес', 'ob.mo': 'мес', 'ob.cardOk': 'Карта привязана! 7 дней бесплатно активированы 🎉', 'ob.s3Title': 'Обучите вашего AI', 'ob.s3Sub': 'Услуги, цены и информация — AI будет отвечать клиентам именно этим', 'ob.kbLabel': 'О салоне своими словами', 'ob.kbPh': 'Адрес, парковка, правила отмены, акции — всё, что должен знать AI…', 'ob.services': 'Услуги', 'ob.svcName': 'Услуга (например, Маникюр)', 'ob.team': 'Команда', 'ob.masterName': 'Имя мастера', 'ob.masterAdd': 'Добавить', 'ob.solo': 'Я работаю одна / один', 'ob.soloName': 'Мастер', 'ob.s4Title': 'Подключите каналы', 'ob.s4Sub': 'WhatsApp, Instagram или виджет на сайт — хотя бы один, чтобы клиенты могли написать', 'ob.widgetTitle': 'Виджет на сайт', 'ob.widgetCopy': 'Скопировать код', 'ob.copied': 'Код скопирован!', 'ob.s5Title': 'Проверьте вашего AI', 'ob.s5Sub': 'Напишите как клиент — AI ответит вашими услугами и ценами', 'ob.testHint': 'Например: «Сколько стоит маникюр?»', 'ob.testPh': 'Напишите сообщение…', 'ob.finish': 'Запустить и перейти в календарь', 'ob.launched': 'Готово! Ваш AI-администратор запущен 🎉',
    'ob.promo': 'Промокод', 'ob.promoApply': 'Применить', 'ob.promoFree': 'мес. бесплатно', 'ob.promoRedeem': 'Активировать {n} мес. бесплатно — без карты', 'ob.promoAuto': 'Промокод применён',
    'ob.language': 'Язык интерфейса',
    'ob.widgetNoSite': 'Нет сайта? Вы получите его бесплатно — мини-сайт с онлайн-записью создастся автоматически после настройки услуг и команды в личном кабинете.',
    'cal.remindCall': 'Напомнить звонком', 'cal.remindCallDone': 'ИИ звонит клиенту ({lang})', 'cal.cancelled': 'Запись отменена', 'cal.created': 'Запись создана', 'cal.cancelBooking': 'Отменить запись',
    'cal.pendingConfirm': 'Запись создана ИИ — ожидает подтверждения',
    'cal.confirmBtn': 'Подтвердить', 'cal.confirmedSent': 'Подтверждено! Клиент получил уведомление',
    'cal.confirmedOk': 'Запись подтверждена',
    'cal.messages': 'Сообщения',
    'inbox.today': 'Сегодня', 'inbox.yesterday': 'Вчера', 'inbox.search': 'Поиск по имени, телефону…', 'inbox.empty': 'Пока нет диалогов',
    'inbox.pickDialog': 'Выберите диалог слева', 'inbox.client': 'Клиент',
    'inbox.reply': 'Написать ответ… (ИИ встанет на паузу на 6 ч)', 'inbox.you': 'Вы',
    'inbox.aiPaused': 'ИИ на паузе — отвечаете вы', 'inbox.resumeAi': 'Вернуть ИИ',
    'inbox.aiResumed': 'ИИ снова отвечает в этом диалоге', 'inbox.aiOn': 'Отвечает ИИ',
    'inbox.aiOff': 'ИИ выключен', 'inbox.aiOffBanner': 'ИИ выключен для этого диалога — отвечаете вы',
    'inbox.crashMsg': 'Не удалось отобразить диалог', 'inbox.reload': 'Обновить',
    'inbox.aiDisabledToast': 'ИИ выключен для этого контакта', 'inbox.aiEnabledToast': 'ИИ снова отвечает этому контакту',
    'inbox.newMessage': 'Новое сообщение',
    'team.permsTitle': 'Доступ администратора к разделам',
    'team.permsHint': 'Календарь и Сообщения доступны всегда. Виджет, мини-сайт, подписка и настройки — только владельцу.',
    'profile.title': 'Мой профиль', 'profile.name': 'Имя', 'profile.phone': 'Телефон',
    'profile.save': 'Сохранить', 'profile.saved': 'Профиль сохранён',
    'profile.emailTaken': 'Этот email уже используется', 'profile.uploadHint': 'Нажмите на фото, чтобы загрузить (JPG/PNG, до 2 МБ)',
    'cal.statCancels': 'Отмены', 'cal.statCalls': 'Звонки',
    'cal.email': 'Email', 'cal.duration': 'Длительность (мин)', 'cal.price': 'Цена', 'cal.total': 'Итого',
    'cal.save': 'Сохранить', 'cal.saved': 'Сохранено', 'cal.came': 'Пришёл', 'cal.noShow': 'Не пришёл',
    'cal.booking': 'Запись', 'cal.menu': 'Меню',
    'cal.whatDone': 'Что делали: услуга, лак/цвет, материал, формула', 'cal.whatDoneHint': 'Запишите, чтобы в следующий раз повторить результат', 'cal.attendanceRequired': 'Обязательно отметьте: клиент пришёл или не пришёл',
    'cal.needsCallback': 'Перезвонить клиенту',
    'cal.clientConfirmed': 'Клиент подтвердил запись', 'cal.clientConfirmedPhone': '✅ Подтверждено по телефону',
    'cal.newBooking': 'Новая запись',
    'cal.allDay': 'Весь день', 'cal.allDayHint': 'День мастера будет закрыт для записи', 'cal.repeat': 'Повторять', 'cal.repeatOn': 'Повторение включено', 'cal.repeatEvery': 'Повторять каждые', 'cal.unitWeeks': 'недели', 'cal.unitDays': 'дни', 'cal.onDays': 'по дням', 'cal.repeatEnd': 'Окончание', 'cal.endNever': 'Никогда', 'cal.endAfter': 'После', 'cal.endTimes': 'раз', 'cal.endOn': 'До', 'cal.endNeverHint': '«Никогда» = на год вперёд', 'cal.seriesCreated': 'Создано', 'cal.seriesSkipped': 'пропущено (занято)', 'cal.wd.mon': 'Пн', 'cal.wd.tue': 'Вт', 'cal.wd.wed': 'Ср', 'cal.wd.thu': 'Чт', 'cal.wd.fri': 'Пт', 'cal.wd.sat': 'Сб', 'cal.wd.sun': 'Вс',
    'cal.call': 'Позвонить', 'cal.write': 'Написать',
    'cal.lastVisit': 'Последний визит', 'cal.atMaster': 'у', 'cal.newClient': 'Новый клиент — прошлых визитов нет', 'cal.addComment': 'Добавить комментарий', 'cal.commentPlaceholder': 'Комментарий к визиту…',
    'cal.history': 'История посещений', 'cal.showMore': 'Показать ещё', 'cal.noHistory': 'Прошлых визитов нет',
    'cal.memVisits': 'визитов', 'cal.memEvery': 'каждые', 'cal.memDays': 'дн.', 'cal.memAvgCheck': 'средний чек', 'cal.memNoShows': 'неявки',
    'push.enable': 'Включить уведомления', 'push.enabled': 'Уведомления включены 🔔', 'push.denied': 'Разрешите уведомления в настройках браузера',
    'cal.note': 'Комментарий', 'cal.products': 'Товары / цвета / материалы',
    'cal.aiAdmin': 'ИИ-администратор', 'cal.aiActive': 'Активен', 'cal.aiPausedBilling': 'Приостановлен (оплата)', 'cal.aiConnect': 'Подключить',
    'cal.aiPromo': 'Салоны с ИИ-администратором получают на 30–40% больше записей', 'cal.dialogs': 'Диалогов',
    'cal.bookingsStat': 'Бронирований', 'cal.reschedules': 'Переносов', 'cal.statToday': 'Сегодня',
    'cal.statMonth': 'Месяц', 'cal.masters': 'Мастера', 'cal.dayOff': 'Выходной',
    'ms.book.title': 'Онлайн-запись', 'ms.book.service': 'Услуга', 'ms.book.branch': 'Филиал',
    'ms.book.master': 'Мастер', 'ms.book.anyMaster': 'Любой мастер', 'ms.book.from': 'от', 'ms.book.date': 'Дата', 'ms.book.time': 'Время',
    'ms.book.dayClosed': 'Выходной', 'ms.book.dayFull': 'Мест нет', 'ms.book.dayClosedLong': 'В этот день салон не работает', 'ms.book.otherCategory': 'Другое', 'ms.book.noSlots': 'Нет свободного времени в этот день', 'ms.book.name': 'Ваше имя', 'ms.book.phone': 'Телефон',
    'ms.book.submit': 'Записаться', 'ms.book.success': 'Вы записаны!', 'ms.book.successWa': 'Подтверждение отправлено в WhatsApp',
    'ms.book.taken': 'Это время только что заняли — выберите другое', 'ms.book.leadTitle': 'Оставить заявку',
    'ms.book.leadDate': 'Желаемые дата и время', 'ms.book.leadSent': 'Заявка отправлена! Мы скоро свяжемся с вами',
    'ms.book.minutes': 'мин', 'ms.book.another': 'Записаться ещё',
    'ms.book.stepOf': 'Шаг {n} из {total}', 'ms.book.back': 'Назад', 'ms.book.chooseBranch': 'Выберите филиал',
    'ms.book.chooseService': 'Выберите услугу', 'ms.book.chooseMaster': 'Выберите мастера', 'ms.book.chooseTime': 'Выберите дату и время',
    'ms.book.contact': 'Ваши контакты', 'ms.book.anyMasterHint': 'Запишем к свободному мастеру на выбранное время',
    'ms.book.phoneCheck': 'Проверьте номер — на него придёт напоминание о визите', 'ms.book.phoneLooksWrong': 'Похоже, номер неполный — проверьте, пожалуйста',
    'ms.book.consent': 'Согласен(на) с {policy} и получением напоминаний о визите (WhatsApp / SMS)', 'ms.book.policy': 'политикой конфиденциальности',
    'ms.book.addToCalendar': 'Добавить в календарь', 'ms.book.googleCal': 'Google Календарь', 'ms.book.writeWa': 'Написать в WhatsApp',
    'ms.book.reminderTo': 'Напоминание придёт на {phone}', 'ms.book.waHello': 'Здравствуйте! Я записан(а) на {service} {date} в {time}.',
    'ms.book.total': 'Итого', 'ms.book.noServicesHere': 'Для онлайн-записи здесь пока нет услуг — напишите нам в чат, и мы подберём время',
    'miniBuilder.autoTeam': 'Мастера подставляются автоматически из раздела «Команда»',
    'miniBuilder.autoServices': 'Услуги и цены подставляются автоматически из раздела «Команда»',
    'miniBuilder.autoOpen': 'Открыть «Команду»',
    'settings.calendarTitle': 'Календарь Chatity', 'settings.calendarHint': 'Выключите, если ведёте записи в своей CRM: ИИ не будет называть свободные слоты, а соберёт заявку (имя, телефон, желаемое время) и мгновенно пришлёт её вам',
    'settings.modeTitle': 'Режим работы', 'settings.modeHint': 'Как ИИ и календарь работают вместе',
    'settings.modeAutopilot': 'Автопилот', 'settings.modeAutopilotDesc': 'ИИ сам подбирает свободное время по мастерам и создаёт подтверждённую запись в календаре. Вы получаете уведомление о каждой брони.',
    'settings.modeManual': 'Календарь без ИИ', 'settings.modeManualDesc': 'Календарь включён, но ИИ не отвечает клиентам. Записи вы ведёте вручную. Сообщения клиентов сохраняются и приходят вам.',
    'settings.modeCrmOnly': 'Только заявки (без календаря)', 'settings.modeCrmOnlyDesc': 'Календаря нет. ИИ общается и собирает заявки (имя, телефон, пожелания), а записи вы ведёте в своей CRM.',
    'settings.timezone': "Часовой пояс салона", 'settings.timezoneMissing': "— не задан (считается Europe/Paris) —", 'settings.timezoneSaved': "Часовой пояс сохранён", 'settings.timezoneWarning': "Укажите часовой пояс: от него зависят часы работы ИИ, свободные слоты и напоминания.",
    'settings.aiScheduleScopeAll': "Одно расписание для всех каналов", 'settings.aiScheduleScopePerChannel': "Отдельно по каналам", 'settings.aiScheduleAppliesTo': "Действует для", 'settings.aiScheduleChannelsHint': "Снимите галочку с канала, чтобы ИИ отвечал в нём круглосуточно (например, виджет на сайте — всегда, WhatsApp — только вне рабочих часов).", 'settings.aiScheduleCh.widget': "Виджет на сайте", 'settings.aiScheduleCh.whatsapp': "WhatsApp", 'settings.aiScheduleCh.instagram': "Instagram", 'settings.aiScheduleCh.phone': "Телефон", 'settings.aiScheduleChEnabled': "Ограничить часы работы ИИ в канале «{channel}»", 'settings.aiSchedulePhoneHint': "Телефон: вне часов ИИ звонок сразу переводится на номер переадресации (если он задан).",
    'settings.aiScheduleTitle': 'Время работы ИИ-администратора', 'settings.aiScheduleHint': 'Вне этих часов ИИ не отвечает — сообщения сохраняются и приходят вам уведомлением. Время салона', 'settings.aiScheduleAlways': 'Круглосуточно', 'settings.aiScheduleOn': 'По расписанию', 'settings.aiScheduleDays': 'Пн,Вт,Ср,Чт,Пт,Сб,Вс', 'settings.aiScheduleOffMsg': 'Автоответ вне часов работы ИИ (необязательно)', 'settings.aiScheduleOffMsgPh': 'Например: Спасибо за сообщение! Администратор ответит вам в рабочее время 💛', 'settings.aiScheduleOffMsgHint': 'Отправляется один раз за 12 часов на диалог. Пусто — ИИ просто молчит.',
    'settings.deleteAccount': 'Удалить аккаунт Chatity', 'settings.deleteWarn': 'Будут безвозвратно удалены: салон, вся история диалогов во всех каналах, клиенты, записи, команда, подключения WhatsApp/Instagram (инстансы отключаются), подписка отменяется. Восстановить данные будет невозможно.', 'settings.deleteTypeHint': 'Для подтверждения введите DELETE:', 'settings.deleteConfirmBtn': 'Удалить всё навсегда', 'settings.deleteCancel': 'Отмена', 'settings.deleteDone': 'Аккаунт и все данные удалены',
    'settings.voiceTitle': 'Голосовые ответы ИИ', 'settings.voiceHint': 'ИИ может отвечать клиентам в WhatsApp и Instagram голосовым сообщением — в дополнение к тексту. Голос звучит на языке клиента.', 'settings.voiceMode_off': 'Выключено', 'settings.voiceMode_off_desc': 'Только текст', 'settings.voiceMode_voice_in': 'Голос на голос', 'settings.voiceMode_voice_in_desc': 'Если клиент прислал голосовое — отвечаем голосом (рекомендуем)', 'settings.voiceMode_always': 'Всегда', 'settings.voiceMode_always_desc': 'Каждый ответ ИИ дублируется голосовым сообщением', 'settings.voicePreview': 'Послушать', 'settings.voiceStop': 'Стоп', 'settings.voiceQuota': 'Символов в этом месяце',
    'settings.humanFirstTitle': "🙋 Сначала человек: задержка ответа ИИ в WhatsApp/Instagram", 'settings.humanFirstHint': "ИИ подождёт указанное время перед ответом. Если за это время администратор ответит сам (с телефона или из «Сообщений»), ИИ промолчит. Виджет на сайте отвечает сразу.", 'settings.humanFirst0': "Без задержки — ИИ отвечает сразу", 'settings.humanFirst30': "30 секунд", 'settings.humanFirst60': "1 минута", 'settings.humanFirst120': "2 минуты", 'settings.humanFirst300': "5 минут", 'settings.humanFirst600': "10 минут",
    'settings.manualPauseTitle': '⏸ Пауза ИИ после вашего ручного ответа', 'settings.manualPauseHint': 'Когда вы сами отвечаете клиенту (с телефона в WhatsApp/Instagram или из «Сообщений»), ИИ замолкает в этом диалоге на выбранное время. Вернуть ИИ раньше можно кнопкой в «Сообщениях».',
    'settings.manualPause1': '1 час', 'settings.manualPause6': '6 часов', 'settings.manualPause24': '24 часа', 'settings.manualPause72': '3 дня', 'settings.manualPause0': 'Пока не включу вручную',
    'settings.brandingTitle': 'Убрать брендинг Chatity', 'settings.brandingHint': 'ИИ не будет упоминать «Chatity» — представится нейтрально как виртуальный помощник вашего салона',
    'settings.introLabel': 'Как представляться клиентам', 'settings.introPlaceholder': 'Например: Здравствуйте! Я Мия — виртуальный администратор салона Oui Beauté 💛',
    'settings.introHint': 'Автоматически переводится на язык клиента. Оставьте пустым — будет стандартное приветствие.',
    'settings.languageTitle': 'Язык интерфейса',
    'subscription.freeForever': 'Вы на тарифе Free — календарь и мини-сайт бесплатны навсегда',
    'subscription.freeForeverHint': 'Подключите ИИ-администратора от €39/мес — он сам отвечает клиентам и записывает их',
    'team.loadError': 'Не удалось загрузить данные команды',
    'team.saved': 'Сохранено',
    'team.saveError': 'Не удалось сохранить',
    'team.deleted': 'Удалено',
    'team.inviteSent': 'Приглашение отправлено на email',
    'team.inviteError': 'Не удалось отправить приглашение',
    'team.branchesTitle': 'Филиалы',
    'team.addBranch': 'Добавить филиал',
    'team.branchesHint': 'AI видит филиалы и уточняет у клиента, куда его записать',
    'team.mainBranch': 'Основной',
    'team.editBranch': 'Редактировать филиал',
    'team.branchName': 'Название',
    'team.branchAddress': 'Адрес',
    'team.branchPhone': 'Телефон',
    'team.branchHours': 'Часы работы',
    'team.branchHoursHint': 'Часы филиала ограничивают графики мастеров — AI не предложит время вне этих часов',
    'team.staffTitle': 'Сотрудники',
    'team.addStaff': 'Добавить сотрудника',
    'team.noServicesWarning': 'Услуги не назначены — AI и календарь не смогут записать к этому мастеру. Нажмите, чтобы отметить услуги',
    'team.staffHint': 'Пригласите мастеров и администраторов по email — они получат одноразовый код для входа',
    'team.noStaff': 'Пока нет сотрудников — добавьте первого мастера',
    'team.roleAdmin': 'Администратор',
    'team.roleMaster': 'Мастер',
    'team.roleMasterDesc': 'видит только своё расписание',
    'team.roleAdminDesc': 'управляет записями филиала',
    'team.joined': 'В команде',
    'team.invited': 'Приглашён',
    'team.noEmail': 'без email',
    'team.invite': 'Пригласить',
    'team.resendAccess': 'Восстановить доступ', 'team.accessSent': 'Письмо для восстановления доступа отправлено', 'team.resendHint': 'Не получилось войти? Отправьте письмо заново — мастер задаст новый пароль по ссылке и коду из письма (действуют 24 часа).',
    'team.reinvite': 'Отправить снова',
    'team.schedule': 'График',
    'team.editStaff': 'Редактировать сотрудника',
    'team.staffName': 'Имя',
    'team.forInvite': 'для приглашения',
    'team.role': 'Роль',
    'team.branches': 'Филиалы',
    'team.staffServices': 'Услуги мастера',
    'team.addServicesFirst': 'Сначала добавьте услуги ниже',
    'team.color': 'Цвет в календаре',
    'team.planityTitle': 'Импорт графика из Planity', 'team.planityHint': 'Вставьте персональную ссылку iCal этого мастера из Planity — система будет автоматически учитывать его занятость и предлагать только реально свободное время.', 'team.planityCheck': 'Проверить', 'team.planityFound': 'найдено занятых слотов', 'team.planityError': 'Не удалось прочитать календарь',
    'team.scheduleFor': 'График —',
    'team.dayOff': 'Выходной',
    'team.photoUpload': 'Загрузить фото', 'team.photoChange': 'Заменить фото', 'team.photoRemove': 'Убрать', 'team.photoHint': 'JPG/PNG/WebP до 2 МБ — покажется на мини-сайте',
    'team.allBranches': 'Все филиалы', 'team.serviceBranches': 'Филиалы', 'team.serviceBranchesHint': 'Ничего не выбрано — услуга доступна во всех филиалах. Цена по филиалу перекрывает базовую; цены по уровню мастера — поверх.', 'team.priceIn': 'Цена в', 'team.duplicate': 'Дублировать', 'team.copySuffix': 'копия',
    'team.repeat': 'Периодичность графика', 'team.repeatHint': 'Например, мастер работает по этому графику раз в две недели. В «выходные» недели запись не предлагается.', 'team.repeatWeekly': 'Каждую неделю', 'team.repeatEveryN': 'Каждые {n} нед.', 'team.repeatAnchor': 'Первая рабочая неделя (любой её день)', 'team.repeatUntil': 'До (необязательно)',
    'team.acceptsLower': 'Принимает клиентов по более низким уровням, если есть окна', 'team.acceptsLowerHint': 'Онлайн-запись и ИИ сначала предлагают мастеров нужного уровня; если на желаемое время их нет — этого мастера по обычной (базовой) цене.', 'cal.priceAuto': 'Авто', 'ms.book.fallbackNote': 'На это время свободен только мастер более высокого уровня — запишем по обычной цене',
    'team.allServices': 'Все услуги',
    'team.staffServicesHint': 'Отметьте услуги мастера. ИИ и онлайн-запись записывают мастера ТОЛЬКО на отмеченные услуги (мастер без отмеченных услуг не бронируется). Для отмеченных можно задать свою длительность и цену — они перекроют общие (как в Planity).', 'team.ownDurationPrice': 'Своя длительность / цена у этого мастера',
    'team.category': 'Категория', 'team.categoryPlaceholder': 'Ногти / Брови / Волосы', 'team.noCategory': 'Без категории', 'team.wholeCategory': 'вся категория',
    'team.exceptions': 'Исключения: отпуск и особые дни', 'team.exceptionsHint': 'Эти дни важнее недельного графика: онлайн-запись, ИИ и телефон не предложат это время.',
    'team.excFrom': 'С', 'team.excTo': 'По', 'team.excDayOff': 'Выходной', 'team.excCustom': 'Особые часы', 'team.excNote': 'Заметка (например, отпуск)', 'team.excAdd': 'Добавить', 'team.excNone': 'Исключений нет', 'team.excAdded': 'Исключение добавлено', 'team.excRemoved': 'Исключение удалено',
    'cal.vacation': 'Не работает',
    'team.servicesTitle': 'Услуги и длительность', 'team.levels': 'Уровни мастеров', 'team.level': 'Уровень мастера', 'team.levelNone': 'Без уровня', 'team.priceByLevel': 'Цена по уровню мастера', 'team.priceByLevelHint': 'Оставьте пустым, если цена одинаковая. Заполните только те уровни, где цена отличается от базовой.', 'team.levelsTitle': 'Уровни мастеров', 'team.levelsHint': 'Названия и звёзды — как у вас в салоне. Показываются клиентам на мини-сайте, в записи и в ответах ИИ.', 'team.levelName': 'Название', 'team.addLevel': 'Добавить уровень',
    'team.addService': 'Добавить услугу',
    'team.servicesHint': 'Длительность нужна AI, чтобы предлагать клиентам свободные слоты',
    'team.noServices': 'Добавьте услуги с ценой и длительностью',
    'team.min': 'мин',
    'team.editService': 'Редактировать услугу',
    'team.serviceName': 'Название услуги',
    'team.servicePrice': 'Цена',
    'team.serviceDuration': 'Длительность (мин)',
    'team.save': 'Сохранить',
    'partner.meta.title': 'Партнёрская программа Chatity — 30% с каждого платежа',
    'partner.meta.description': 'Зарабатывайте 30% с каждого платежа приглашённых клиентов. Реферальные ссылки, аналитика, выплаты на карту.',
    'partner.nav.back': 'Chatity',
    'partner.nav.dashboard': 'Кабинет партнёра →',
    'partner.badge': 'Партнёрская программа',
    'partner.hero.title1': 'Зарабатывайте',
    'partner.hero.title2': 'с каждого платежа',
    'partner.hero.title3': 'ваших клиентов',
    'partner.hero.subtitle': 'Делитесь реферальной ссылкой, приводите салоны, клиники и студии — получайте процент пожизненно, пока они платят.',
    'partner.feature.commission.title': '30% с каждого платежа',
    'partner.feature.commission.desc': 'Recurring. Не только с первого месяца.',
    'partner.feature.link.title': 'Личный реферальный код',
    'partner.feature.link.desc': 'Атрибуция держится 30 дней по cookie.',
    'partner.feature.dashboard.title': 'Дашборд с аналитикой',
    'partner.feature.dashboard.desc': 'Клики, регистрации, платежи, баланс.',
    'partner.feature.payout.title': 'Вывод на карту / счёт',
    'partner.feature.payout.desc': 'От 20 €. Холд 14 дней.',
    'partner.form.title': 'Стать партнёром',
    'partner.form.subtitle': 'Заполните форму — мгновенно получите свою ссылку.',
    'partner.form.name': 'Имя',
    'partner.form.namePlaceholder': 'Иван Петров',
    'partner.form.email': 'Email',
    'partner.form.code': 'Желаемый код (необязательно)',
    'partner.form.channel': 'Как будете продвигать?',
    'partner.form.channelPlaceholder': 'Блог о маркетинге для салонов, Telegram-канал ...',
    'partner.form.submit': 'Получить мою ссылку',
    'partner.form.submitting': 'Отправка...',
    'partner.form.terms': 'Регистрируясь, вы принимаете условия партнёрской программы.',
    'partner.success.heading': 'Готово!',
    'partner.success.title': 'Ваша реферальная ссылка',
    'partner.success.copy': 'Скопировать ссылку',
    'partner.success.openDashboard': 'Открыть кабинет партнёра',
    'partner.success.hint': '💡 Чтобы видеть статистику, клики и баланс — войдите в аккаунт с тем же email',
    'partner.toast.exists': 'Вы уже зарегистрированы партнёром',
    'partner.toast.created': 'Заявка принята! Ваш реферальный код активен.',
    'partner.toast.error': 'Не удалось отправить заявку',
    'partner.toast.copied': 'Скопировано в буфер',
    'partner.dash.title': 'Кабинет партнёра',
    'partner.dash.loading': 'Загрузка...',
    'partner.dash.breadcrumb': 'Партнёрский кабинет',
    'partner.dash.backToClient': '← В кабинет клиента',
    'partner.dash.refLinkLabel': 'Ваша реферальная ссылка',
    'partner.dash.commissionInfo': 'Комиссия {pct}% • Холд {days} дней',
    'partner.dash.copy': 'Скопировать',
    'partner.dash.copied': 'Скопировано',
    'partner.dash.stat.clicks': 'Клики (всего)',
    'partner.dash.stat.clicks30d': 'за 30 дней: {n}',
    'partner.dash.stat.signups': 'Регистрации',
    'partner.dash.stat.paid': 'оплатили: {n}',
    'partner.dash.stat.earned': 'Всего заработано',
    'partner.dash.stat.pending': 'в холде: {amount}',
    'partner.dash.stat.available': 'К выплате',
    'partner.dash.stat.paidOut': 'выплачено: {amount}',
    'partner.dash.payout.title': 'Реквизиты для выплат',
    'partner.dash.payout.subtitle': 'Сохраните перед первой заявкой на вывод.',
    'partner.dash.payout.method': 'Способ',
    'partner.dash.payout.methodPlaceholder': 'Выберите метод',
    'partner.dash.payout.method.card_ru': 'Карта (Россия)',
    'partner.dash.payout.method.bank': 'Банковский перевод (ИП/ООО)',
    'partner.dash.payout.method.bank_ru': 'Реквизиты юр.лица (РФ)',
    'partner.dash.payout.method.sepa_eu': 'IBAN / SEPA перевод (Европа)',
    'partner.dash.payout.method.rib_eu': 'Банковские реквизиты RIB (Франция)',
    'partner.dash.payout.method.paypal': 'PayPal',
    'partner.dash.payout.method.crypto': 'Криптовалюта',
    'partner.dash.payout.region': 'Регион',
    'partner.dash.payout.region.ru': 'Международный вывод (EUR)',
    'partner.dash.payout.region.eu': 'Европа / международно (EUR, USD)',
    'partner.dash.payout.field.cardNumber': 'Номер карты',
    'partner.dash.payout.field.fullName': 'ФИО получателя',
    'partner.dash.payout.field.companyName': 'Название организации',
    'partner.dash.payout.field.inn': 'ИНН',
    'partner.dash.payout.field.kpp': 'КПП',
    'partner.dash.payout.field.bik': 'БИК банка',
    'partner.dash.payout.field.account': 'Расчётный счёт',
    'partner.dash.payout.field.bankName': 'Название банка',
    'partner.dash.payout.field.iban': 'IBAN',
    'partner.dash.payout.field.swift': 'SWIFT / BIC',
    'partner.dash.payout.field.ribBankCode': 'Code banque (5 цифр)',
    'partner.dash.payout.field.ribBranchCode': 'Code guichet (5 цифр)',
    'partner.dash.payout.field.ribAccount': 'Numéro de compte (11 цифр)',
    'partner.dash.payout.field.ribKey': 'Clé RIB (2 цифры)',
    'partner.dash.payout.field.paypalEmail': 'PayPal Email',
    'partner.dash.payout.field.walletAddress': 'Адрес кошелька',
    'partner.dash.payout.field.cryptoNetwork': 'Сеть',
    'partner.dash.payout.edit': 'Изменить реквизиты',
    'partner.dash.payout.savedSummary': 'Сохранено',
    'partner.dash.request.max': 'Макс',
    'partner.dash.request.maxHint': 'Указать максимальную сумму',
    'partner.dash.payout.details': 'Реквизиты',
    'partner.dash.payout.detailsPlaceholder': 'Номер карты / счёта / адрес кошелька + ФИО',
    'partner.dash.payout.save': 'Сохранить реквизиты',
    'partner.dash.payout.saved': 'Реквизиты сохранены',
    'partner.dash.payout.saveError': 'Не удалось сохранить',
    'partner.dash.payout.fillFirst': 'Заполните метод и реквизиты',
    'partner.dash.request.title': 'Запросить выплату',
    'partner.dash.request.available': 'Доступно',
    'partner.dash.request.min': 'мин. 20 €',
    'partner.dash.request.amount': 'Сумма',
    'partner.dash.request.currency': 'Валюта',
    'partner.dash.request.submit': 'Запросить выплату',
    'partner.dash.request.created': 'Заявка на выплату создана',
    'partner.dash.referrals.title': 'Ваши рефералы',
    'partner.dash.referrals.empty': 'Пока никто не зарегистрировался по вашей ссылке.',
    'partner.dash.referrals.email': 'Email',
    'partner.dash.referrals.business': 'Бизнес',
    'partner.dash.referrals.plan': 'План',
    'partner.dash.referrals.status': 'Статус',
    'partner.dash.referrals.payments': 'Платежей',
    'partner.dash.referrals.earned': 'Заработано',
    'partner.dash.referrals.paid': 'Платный',
    'partner.dash.referrals.trial': 'Trial',
    'partner.dash.payouts.title': 'История выплат',
    'partner.dash.payouts.empty': 'Пока нет заявок на выплату.',
    'partner.dash.payouts.date': 'Дата',
    'partner.dash.payouts.amount': 'Сумма',
    'partner.dash.payouts.method': 'Метод',
    'partner.dash.payouts.status': 'Статус',
    'partner.dash.payouts.note': 'Заметка',
    'partner.onboard.title': 'Партнёрская программа',
    'partner.onboard.subtitle': 'Приводите клиентов в Chatity и зарабатывайте 30% с каждого их платежа. Холд 14 дней, выплаты от 20 €.',
    'partner.onboard.name': 'Ваше имя',
    'partner.onboard.code': 'Желаемый код (необязательно)',
    'partner.onboard.submit': 'Стать партнёром',
    'partner.onboard.success': 'Готово! Вы партнёр.',
    'partner.onboard.error': 'Ошибка',
    'partner.cta.badge': 'Зарабатывайте на рекомендациях',
    'partner.cta.title': 'Станьте партнёром',
    'partner.cta.desc': 'Получайте 30% с каждого платежа приведённых клиентов',
    'partner.cta.button': 'Открыть программу',
    'partner.footer': 'Партнёрам',
    'shortLink.title': 'Короткая ссылка для бронирования',
    'shortLink.description': 'Дай клиентам прямую ссылку на чат-виджет. Идеально для Instagram bio, Linktree, визиток, рекламы. По клику открывается готовый чат с AI.',
    'shortLink.placeholder': 'oui-beaute',
    'shortLink.save': 'Сохранить',
    'shortLink.saving': 'Сохраняем...',
    'shortLink.copy': 'Копировать',
    'shortLink.open': 'Открыть',
    'shortLink.qr': 'QR-код',
    'shortLink.qr.title': 'Ваш QR-код',
    'shortLink.qr.hint': 'Разместите его на печатных материалах, визитках или в витрине — сканирование откроет ваш мини-сайт.',
    'shortLink.qr.download': 'Скачать PNG',
    'shortLink.qr.close': 'Закрыть',
    'shortLink.toast.qrDownloaded': 'QR-код скачан',
    'shortLink.toast.qrDownloadFailed': 'Не удалось скачать QR-код',
    'shortLink.status.checking': 'Проверяем...',
    'shortLink.status.available': 'Свободно',
    'shortLink.status.taken': 'Недоступно',
    'shortLink.status.currentLink': 'Это ваша текущая ссылка',
    'shortLink.status.error': 'Ошибка',
    'shortLink.reason.reserved': 'Этот slug зарезервирован системой',
    'shortLink.reason.alreadyTaken': 'Уже занят другим салоном',
    'shortLink.reason.tooShort': 'Минимум 3 символа',
    'shortLink.reason.tooLong': 'Максимум 50 символов',
    'shortLink.reason.invalidChars': 'Только латиница, цифры и дефис (без пробелов и спецсимволов)',
    'shortLink.toast.saved': 'Короткая ссылка сохранена',
    'shortLink.toast.saveFailed': 'Не удалось сохранить',
    'shortLink.toast.copied': 'Ссылка скопирована',
    'shortLink.badge.active': 'АКТИВНО',
    'shortLink.badge.notSet': 'НЕ НАСТРОЕНО',
    'notFound.title': 'Страница не найдена',
    'notFound.headline': 'Эта страница потерялась',
    'notFound.subtitle': 'Возможно, ссылка устарела или с опечаткой. Но AI Chatity никогда не теряется 😉',
    'notFound.cta.home': 'На главную',
    'notFound.cta.demo': 'Попробовать AI',
    'notFound.helpfulLinks': 'Или попробуйте',
    'notFound.link.blog': 'Блог',
    'notFound.link.partner': 'Стать партнёром',
    'notFound.link.login': 'Войти',
    'notFound.link.support': 'Поддержка',
    'miniSite.cta.chat': 'Получить консультацию',
    'miniSite.bookNow': 'Записаться',
    'miniSite.showPhone': 'Показать',
    'miniSite.section.team': 'Специалисты',
    'miniSite.onMap': 'На карте',
    'miniSite.services.viewAll': 'Показать все',
    'miniSite.services.collapse': 'Свернуть',
    'miniBuilder.colors.title': 'Цвет мини-сайта',
    'miniBuilder.colors.hint': 'Акцентный цвет кнопок, цен и заголовков на публичной странице.',
    'miniBuilder.colors.preview': 'превью кнопки',
    'miniBuilder.team.title': 'Специалисты',
    'miniBuilder.team.add': 'Добавить мастера',
    'miniBuilder.team.name': 'Имя мастера',
    'miniBuilder.team.role': 'Специализация (напр. Мастер маникюра)',
    'miniBuilder.team.empty': 'Добавьте мастеров — они появятся карточками на мини-сайте с кнопкой «Записаться».',
    'miniSite.section.about': 'О салоне',
    'miniSite.empty': 'Описание салона скоро появится. А пока — задайте любой вопрос AI справа 👉',
    'miniSite.section.services': 'Услуги и цены',
    'miniSite.section.gallery': 'Галерея',
    'miniSite.section.contacts': 'Контакты и адрес',
    'miniSite.contact.phone': 'Телефон',
    'miniSite.contact.address': 'Адрес',
    'miniSite.map.openInMaps': 'Открыть в Google Maps',
    'miniSite.section.hours': 'Часы работы',
    'miniSite.contact.whatsapp': 'WhatsApp',
    'miniSite.contact.email': 'Email',
    'miniSite.gallery.close': 'Закрыть (Esc)',
    'miniSite.gallery.prev': 'Предыдущее',
    'miniSite.gallery.next': 'Следующее',
    'miniSite.translate.byAi': 'Автоматически переведено AI',
    'miniSite.translate.showOriginal': 'Показать оригинал',
    'miniSite.translate.viewingOriginal': 'Вы видите оригинальную версию',
    'miniSite.translate.translateBack': 'Перевести на мой язык',
    'miniSite.translate.loading': 'Переводим автоматически…',
    'miniSite.translate.failed': 'Не удалось перевести страницу. Показываем оригинал.',
    'tabs.clients': 'Клиенты',
    'bookings.historyLimitBanner': 'Заявки старше 30 дней доступны на тарифе Professional',
    'clients.title': 'База клиентов',
    'clients.subtitle': 'Заявки автоматически объединены по номеру телефона (разные форматы номера склеиваются)',
    'clients.limitedNote': 'На тарифе Starter показаны клиенты за последние 30 дней. Полная история — на Professional',
    'clients.search': 'Поиск по имени или телефону',
    'clients.noClients': 'Пока нет клиентов',
    'clients.visits': 'заявок',
    'clients.firstVisit': 'Первый визит',
    'clients.lastVisit': 'Последний визит',
    'clients.phones': 'Все номера',
    'clients.services': 'Услуги',
    'clients.source': 'Источник',
    'clients.aiSummary': 'AI-сводка по клиенту', 'clients.aiSummaryBuild': 'Сделать сводку', 'clients.aiSummaryRefresh': 'Обновить', 'clients.aiSummaryBusy': 'Анализирую…', 'clients.aiSummaryHint': 'ИИ прочитает историю записей и переписки и коротко опишет клиента: ритм визитов, любимые услуги, предпочтения и что предложить дальше.', 'clients.aiRisk': 'Риск ухода', 'clients.aiRhythm': 'Ритм визитов', 'clients.aiFavorites': 'Любимые услуги', 'clients.aiNextOffer': 'Что предложить', 'clients.aiGenerated': 'Сформировано',
    'clients.history': 'История заявок',
    
    // Upgrade banners for features
    'upgrade.telegram.title': 'Уведомления в Telegram доступны на тарифах Professional и Unlimited',
    'upgrade.telegram.button': 'Обновить план',
    'upgrade.widget.title': 'Кастомизация виджета',
    'upgrade.widget.description': 'Настройте внешний вид виджета под ваш бренд на тарифах Professional или Unlimited:',
    'upgrade.widget.feature1': 'Изменение цветов виджета',
    'upgrade.widget.feature2': 'Настройка приветственного сообщения',
    'upgrade.widget.feature3': 'Персонализация имени бота',
    'upgrade.widget.button': 'Обновить план',
    'bookings.subtitle': 'Все заявки от клиентов',
    'bookings.autoUpdate': 'Автообновление каждые 10 сек',
    'bookings.period': 'Период',
    'bookings.today': 'Сегодня',
    'bookings.last7days': 'Последние 7 дней',
    'bookings.last30days': 'Последние 30 дней',
    'bookings.customDates': 'Выбрать даты',
    'bookings.from': 'От',
    'bookings.to': 'До',
    'bookings.refresh': 'Обновить',
    'bookings.todayCount': 'Заявок сегодня',
    'bookings.yesterdayCount': 'Заявок вчера',
    'bookings.growthPercent': 'Прирост к вчера',
    'bookings.dynamicsTitle': 'Динамика заявок',
    'bookings.dynamicsDescription': 'Количество заявок по дням',
    'bookings.topSourcesTitle': 'Топ источников трафика',
    'bookings.topSourcesDescription': 'Откуда приходят клиенты',
    'bookings.source': 'Источник',
    'bookings.bookingsCount': 'Заявок',
    'bookings.directVisit': 'Прямой заход',

    'bookings.refresh': 'Обновить',
    'bookings.noBookings': 'Пока нет заявок',
    'bookings.client': 'Клиент',
    'bookings.phone': 'Телефон',
    'bookings.service': 'Услуга',
    'bookings.date': 'Дата',
    'bookings.storageInfo': '📋 Заявки хранятся 30 дней',
    'bookings.unlimitedStorageInfo': 'Используйте экспорт в Excel для долгосрочного хранения истории заявок',
    'bookings.upgradeForExport': 'Обновитесь до тарифа Unlimited для экспорта заявок в Excel',
    'bookings.exportExcel': 'Экспорт в Excel',
    'bookings.exportSuccess': 'Заявки успешно экспортированы',
    'bookings.exportUnlimitedOnly': 'Экспорт доступен только для тарифа Unlimited',
    'bookings.exportError': 'Ошибка экспорта',
    'bookings.created': 'Заявка',
    'bookings.newBooking': 'Новая заявка! Всего:',
    
    // Widget
    'widget.title': 'Код виджета',
    'widget.subtitle': 'Вставьте этот код на ваш сайт перед закрывающим тегом',
    'widget.copy': 'Скопировать код',
    'widget.demo': 'Открыть демо',
    'widget.copied': 'Код скопирован в буфер обмена!',
    'widget.status.title': 'Статус установки виджета',
    'widget.status.unchecked': 'Нажмите "Проверить" для проверки установки',
    'widget.status.checking': 'Проверка...',
    'widget.status.active': 'Активен • Последняя активность: {time}',
    
    // Integrations
    'integrations.title': 'Интеграции',
    'integrations.subtitle': 'Интегрируйте Chatity виджет на ваш сайт',
    'integrations.yourWidgetKey': 'Ваш ключ виджета',
    'integrations.copyKey': 'Копировать ключ',
    'integrations.copyInstructions': 'Копировать инструкцию',
    'integrations.instructionsCopied': 'Инструкция скопирована!',
    'integrations.keyCopied': 'Ключ скопирован!',
    'integrations.sendToDeveloper': 'Отправить программисту',
    'integrations.developerEmail': 'Email программиста',
    'integrations.developerEmailPlaceholder': 'developer@example.com',
    'integrations.send': 'Отправить',
    'integrations.emailSent': 'Инструкция отправлена!',
    'integrations.wordpress.title': 'WordPress Plugin',
    'integrations.wordpress.description': 'Простая установка для WordPress сайтов. Просто установите плагин и введите ключ виджета.',
    'integrations.wordpress.download': 'Скачать плагин',
    'integrations.html.title': 'HTML / JavaScript',
    'integrations.html.description': 'Универсальный способ для любого сайта',
    'integrations.html.step1': 'Скопируйте код виджета выше',
    'integrations.html.step2': 'Вставьте код перед закрывающим тегом </body> на вашем сайте',
    'integrations.webflow.description': 'Для сайтов на Webflow',
    'integrations.webflow.step1': 'Откройте настройки вашего проекта Webflow',
    'integrations.webflow.step2': 'Перейдите в Custom Code → Footer Code',
    'integrations.webflow.step3': 'Вставьте скопированный код виджета',
    'integrations.twilio.title': 'Twilio Voice AI',
    'integrations.twilio.description': 'AI-ассистент для обработки входящих звонков',
    'integrations.twilio.phoneNumber': 'Ваш номер телефона',
    'integrations.twilio.status': 'Статус',
    'integrations.twilio.enabled': 'Включено',
    'integrations.twilio.disabled': 'Отключено',
    'integrations.twilio.enable': 'Включить',
    'integrations.twilio.disable': 'Отключить',
    'integrations.twilio.webhookUrl': 'Webhook URL для настройки Twilio',
    'integrations.twilio.instructions': 'Настройте webhook в вашем Twilio аккаунте',
    'integrations.twilio.credentials': 'Данные Twilio',
    'integrations.twilio.credentialsInfo': 'Введите ваши данные из Twilio Console',
    'integrations.twilio.credentialsRequired': 'Заполните все поля Twilio',
    'integrations.twilio.voiceLanguage': 'Язык голосового помощника',
    'integrations.twilio.voiceSpeed': 'Скорость речи',
    'integrations.twilio.howItWorks': 'Как это работает',
    'integrations.twilio.step1': '1. Клиент звонит на ваш номер',
    'integrations.twilio.step2': '2. AI отвечает и общается на языке клиента',
    'integrations.twilio.step3': '3. Собирает данные для бронирования',
    'integrations.twilio.step4': '4. Автоматически создает заявку в вашем кабинете',
    'integrations.webflow.step4': 'Сохраните и опубликуйте сайт',
    'integrations.shopify.description': 'Для интернет-магазинов на Shopify',
    'integrations.shopify.step1': 'Войдите в админ-панель Shopify',
    'integrations.shopify.step2': 'Перейдите в Online Store → Themes',
    'integrations.shopify.step3': 'Нажмите Actions → Edit code',
    'integrations.shopify.step4': 'Откройте файл theme.liquid в папке Layout',
    'integrations.shopify.step5': 'Вставьте код виджета перед закрывающим тегом </body> и сохраните',
    'integrations.wix.description': 'Для сайтов на Wix (требуется Premium)',
    'integrations.wix.step1': 'Откройте редактор сайта Wix',
    'integrations.wix.step2': 'Перейдите в Settings → Custom Code',
    'integrations.wix.step3': 'Нажмите + Add Custom Code',
    'integrations.wix.step4': 'Вставьте код виджета, выберите "Load code on each new page" и место "Body - end"',
    'integrations.tilda.description': 'Для сайтов на Tilda',
    'integrations.tilda.step1': 'Откройте настройки страницы в Tilda',
    'integrations.tilda.step2': 'Перейдите в раздел "Еще" → "HTML-код для сайта"',
    'integrations.tilda.step3': 'Вставьте код виджета в поле "Before </body>"',
    'integrations.tilda.step4': 'Сохраните и опубликуйте страницу',
    'integrations.squarespace.description': 'Для сайтов на Squarespace',
    'integrations.squarespace.step1': 'Войдите в админ-панель Squarespace',
    'integrations.squarespace.step2': 'Перейдите в Settings → Advanced → Code Injection',
    'integrations.squarespace.step3': 'Вставьте код виджета в поле Footer',
    'integrations.squarespace.step4': 'Нажмите Save',
    'integrations.gtm.description': 'Для продвинутых пользователей с Google Tag Manager',
    'integrations.gtm.step1': 'Войдите в Google Tag Manager',
    'integrations.gtm.step2': 'Создайте новый тег (Tag) → Custom HTML',
    'integrations.gtm.step3': 'Вставьте код виджета',
    'integrations.gtm.step4': 'Настройте триггер на All Pages',
    'integrations.gtm.step5': 'Сохраните, протестируйте и опубликуйте контейнер',
    'widget.status.configured': 'Настроен, ожидает первого сообщения',
    'widget.status.inactive': 'Не установлен или не работает',
    'widget.status.checkButton': '🔍 Проверить',
    'widget.status.checking': 'Проверка...',
    'widget.status.successToast': '✅ Виджет активен и работает!',
    'widget.status.configuredToast': '🟡 Виджет настроен, но пока нет активности',
    'widget.status.errorToast': '🔴 Виджет не установлен или не работает',
    
    // Admin
    'admin.title': 'Супер-Админ Панель',
    'admin.subtitle': 'Полная статистика платформы и все салоны',
    'admin.users': 'Пользователей',
    'admin.salons': 'Салонов',
    'admin.bookings': 'Заявок',
    'admin.allSalons': 'Все салоны платформы',
    'admin.registered': 'Зарегистрирован',
    'admin.loading': 'Загрузка...',
    'admin.allSalons': 'Все салоны',
    'admin.email': 'Email',
    'admin.plan': 'План',
    'admin.status': 'Статус',
    'admin.bookings': 'Заявок',
    'admin.registered': 'Регистрация',
    'admin.showingYourSalon': 'Показан только ваш салон (для демонстрации)',
    
    // Subscription
    'subscription.title': 'Управление подпиской',
    'subscription.subtitle': 'Выберите план, который подходит вашему бизнесу',
    'subscription.trialLeft': 'Пробный период:',
    'subscription.daysLeft': 'дней осталось',
    'subscription.price': '7 дней бесплатно, затем €39/месяц',
    'subscription.manageBilling': 'Управление подпиской',
    'subscription.manageBillingDesc': 'Отмена подписки, смена карты, скачивание счетов (инвойсов)',
    'subscription.manageBillingBtn': 'Открыть портал',
    'subscription.portalError': 'Не удалось открыть портал управления подпиской',
    'subscription.invoice': 'Инвойс',
    'subscription.invoiceUnavailable': 'Инвойс недоступен для этого платежа',
    'subscription.button': 'Подписаться',
    'subscription.error': 'Ошибка создания подписки',
    'subscription.currentPlan': 'Текущий план',
    'subscription.trialPeriod': 'Триальный период',
    'subscription.daysRemaining': 'до окончания',
    'subscription.day': 'день',
    'subscription.days': 'дней',
    'subscription.expired': 'Триальный период истек',
    'subscription.usage': 'Использование диалогов',
    'subscription.used': 'использовано',
    'subscription.selectPlan': 'Выбрать',
    'subscription.currentPlanBadge': 'Текущий план',
    'subscription.popular': 'Популярный',
    'subscription.idealForStart': 'Идеально для начала',
    'subscription.forGrowingBusiness': 'Для растущего бизнеса',
    'subscription.forLargeBusiness': 'Для крупного бизнеса',
    'subscription.conversationsPerMonth': 'диалогов в месяц',
    'subscription.unlimited': 'Безлимитные диалоги',
    'subscription.aiAssistant': 'AI-ассистент',
    'subscription.telegramNotifications': 'Telegram уведомления',
    'subscription.emailNotifications': 'Email уведомления',
    'subscription.widgetCustomization': 'Кастомизация виджета',
    'subscription.analytics': 'Аналитика',
    'subscription.extendedAnalytics': 'Расширенная аналитика',
    'subscription.prioritySupport': 'Приоритетная поддержка',
    'subscription.utmTracking': 'UTM отслеживание',
    'subscription.knowledgeBase': 'База знаний для AI',
    'subscription.securePayment': 'Безопасная оплата',
    'subscription.securePaymentInfo': 'Все платежи обрабатываются через Stripe. Мы не храним данные ваших карт.',
    'subscription.cancelAnytime': 'Отмена в любое время',
    'subscription.cancelInfo': 'Вы можете отменить подписку в любой момент.',
    'subscription.checkingPayment': 'Проверка статуса платежа...',
    'subscription.paymentSuccess': 'Оплата успешна! Ваш план обновлен',
    'subscription.paymentFailedTitle': 'Проблема с оплатой подписки',
    'subscription.paymentFailedText': 'Банк отклонил списание. AI-администратор приостановлен во всех каналах (сайт, WhatsApp, Instagram, телефон) до поступления оплаты. Обновите карту, чтобы возобновить работу.',
    'subscription.updateCardBtn': 'Обновить карту',
    'subscription.paymentCancelled': 'Оплата отменена',
    'subscription.paymentTimeout': 'Проверка платежа заняла слишком много времени',
    'subscription.sessionExpired': 'Сессия оплаты истекла',
    'subscription.paymentCheckError': 'Ошибка проверки статуса платежа',
    'subscription.checkoutError': 'Ошибка создания сессии оплаты',
    'subscription.paymentHistory': 'История платежей',
    'subscription.date': 'Дата',
    'subscription.plan': 'План',
    'subscription.amount': 'Сумма',
    'subscription.status': 'Статус',
    'subscription.paid': 'Оплачено',
    'subscription.pending': 'Ожидание',
    'subscription.failed': 'Ошибка',
    'subscription.monthly': 'Ежемесячно',
    'subscription.yearly': 'Ежегодно',
    'subscription.year': 'год',
    'subscription.save2Months': 'Экономия 2 месяца!',
    'subscription.upgradeToYearly': 'Перейти на годовой',
    'subscription.creditApplied': 'Применен кредит за оставшийся период',
    'subscription.renewalDate': 'Следующее продление',
    
    // Promocodes
    'promocode.title': 'Есть промокод?',
    'promocode.placeholder': 'ВВЕДИТЕ КОД',
    'promocode.apply': 'Применить',
    'promocode.remove': 'Удалить',
    'promocode.discount': 'скидка',
    'promocode.applied': 'Промокод применён!',
    'promocode.error': 'Неверный промокод',
    'promocode.enterCode': 'Введите промокод',
    'subscription.trialBannerTitle': 'Триальный период',
    'subscription.trialExpiredTitle': 'Триальный период истек',
    'subscription.selectPlanBeforeExpiry': 'Выберите тариф до окончания триала, чтобы продолжить использование',
    'subscription.payToContinue': 'Оплатите подписку для продолжения работы',
    'subscription.selectPlanButton': 'Выбрать тариф',
    'subscription.payButton': 'Оплатить',
    'subscription.activeSubscription': 'Подписка активна',
    'subscription.conversations': 'Диалоги',
    'subscription.remaining': 'осталось',
    'subscription.upgradePlan': 'Улучшить план',
    'tabs.subscription': 'Подписка',
    
    // Support Tickets
    'support.supportTickets': 'Тикеты поддержки',
    'support.askOurTeam': 'Задайте вопрос нашей команде',
    'support.createTicket': 'Создать тикет',
    'support.cancel': 'Отмена',
    'support.newTicket': 'Новый тикет',
    'support.subject': 'Тема',
    'support.subjectPlaceholder': 'Краткое описание проблемы',
    'support.priority': 'Приоритет',
    'support.priorityLow': 'Низкий',
    'support.priorityMedium': 'Средний',
    'support.priorityHigh': 'Высокий',
    'support.message': 'Сообщение',
    'support.messagePlaceholder': 'Опишите вашу проблему подробно...',
    'support.noTicketsYet': 'У вас пока нет тикетов',
    'support.createFirstTicket': 'Создайте первый тикет если у вас есть вопросы',
    'support.messagesCount': 'Сообщений',
    'support.statusOpen': 'Открыт',
    'support.statusInProgress': 'В работе',
    'support.statusClosed': 'Закрыт',
    'support.backToList': 'Назад к списку',
    'support.supportTeam': 'Поддержка',
    'support.you': 'Вы',
    'support.reply': 'Ответить',
    'support.enterYourMessage': 'Введите ваше сообщение...',
    'support.send': 'Отправить',
    'support.ticketClosed': 'Этот тикет закрыт',
    'support.errorLoadingTicket': 'Ошибка загрузки тикета',
    'support.fillAllFields': 'Заполните все поля',
    'support.ticketCreated': 'Тикет создан успешно!',
    'support.errorCreatingTicket': 'Ошибка создания тикета',
    'support.messageSent': 'Сообщение отправлено',
    'support.errorSendingMessage': 'Ошибка отправки сообщения',
    
    // Admin
    'admin.title': 'Супер-Админ Панель',
    'admin.subtitle': 'Полная статистика платформы',
    'admin.days': 'дней',
    'admin.allTime': 'Всё время',
    'admin.totalUsers': 'Пользователей',
    'admin.totalBookings': 'Заявок',
    'admin.paidVsTrial': 'Paid / Trial',
    'admin.conversion': 'Конверсия',
    'admin.periodStats': 'Статистика за период',
    'admin.newUsers': 'Новых пользователей',
    'admin.newSalons': 'Новых салонов',
    'admin.newBookings': 'Новых заявок',
    'admin.loading': 'Загрузка...',
    
    // Common
    'common.loading': 'Загрузка...',
    'common.error': 'Ошибка загрузки данных',
    
    // Landing Page
    'landing.home': 'Главная',
    'landing.hero.title': 'Больше записей. Больше выручки. Без пропущенных клиентов.',
    'landing.hero.subtitle': 'AI-администратор Chatity отвечает клиентам 24/7, обрабатывает обращения и превращает их в записи.',
    'landing.hero.benefit1': 'Больше заявок без увеличения штата',
    'landing.hero.benefit2': 'Ни одного пропущенного клиента',
    'landing.hero.benefit3': 'Установка за 5 минут на любой сайт',
    'landing.hero.cta': 'Начать бесплатно',
    'landing.hero2.eyebrow': 'AI-администратор для бьюти и wellness',
    'landing.hero2.title': 'Больше записей. Больше выручки. Без пропущенных клиентов.',
    'landing.hero2.subtitle': 'AI-администратор Chatity отвечает клиентам 24/7, обрабатывает обращения и превращает их в записи.',
    'landing.hero2.chWebsite': 'Сайт',
    'landing.hero2.chVoice': 'Голос',
    'landing.hero2.soon': 'скоро',
    'landing.hero2.demo': 'Как это работает',
    'landing.hero2.nocard': 'Без банковской карты · Настройка за 5 минут',
    'landing.hero2.hours': 'ч',
    'landing.hero2.stat1': 'больше записей',
    'landing.hero2.stat2': 'админ-работы в месяц',
    'landing.hero2.stat3': 'ни один клиент не потерян',
    'landing.hero2.newBooking': 'Новая запись!',
    'landing.cta2.eyebrow': 'Готовы получать больше записей?',
    'landing.cta2.title': 'Начните бесплатно сегодня',
    'landing.cta2.note': 'Без банковской карты · Настройка за 5 минут · Отмена в любой момент',
    'landing.cta2.join': 'Присоединяйтесь к сотням бьюти- и wellness-бизнесов',
    'landing.hero.trial': '7 дней бесплатно • Без карты',
    'landing.login': 'Войти',
    
    // Trust section
    'landing.trust.title': 'Нам доверяют',
    'landing.trust.subtitle': 'Уже используют Chatity для автоматизации записи:',
    'landing.trust.category1': 'Салоны красоты',
    'landing.trust.category2': 'Клиники и стоматологии',
    'landing.trust.category3': 'Йога и фитнес-студии',
    'landing.trust.category4': 'Онлайн-школы',
    'landing.trust.category5': 'Сервисные компании',
    'landing.trust.case1.niche': 'Салон красоты',
    'landing.trust.case1.metric': 'Заметный рост записей',
    'landing.trust.case1.description': 'Больше онлайн-записей через сайт',
    'landing.trust.case1.usecase': 'Чат отвечает на вопросы о процедурах, помогает выбрать услугу и упрощает запись',
    'landing.trust.case2.niche': 'Стоматология',
    'landing.trust.case2.metric': 'Заявки в нерабочее время',
    'landing.trust.case2.description': 'Большинство обращений приходят вечером и в выходные',
    'landing.trust.case2.usecase': 'Чат-бот фильтрует запросы, объясняет услуги и направляет пациентов правильно',
    'landing.trust.case3.niche': 'Йога-студия',
    'landing.trust.case3.metric': 'Меньше рутины',
    'landing.trust.case3.description': 'Сокращено время на повторяющиеся вопросы',
    'landing.trust.case3.usecase': 'Чат объясняет направления, расписание и цены, передавая теплые лиды сотрудникам',
    'landing.trust.case4.niche': 'Онлайн-школа',
    'landing.trust.case4.metric': 'Больше вовлеченности',
    'landing.trust.case4.description': 'Выше вовлеченность посетителей сайта',
    'landing.trust.case4.usecase': 'Чат отвечает на вопросы о курсах, ценах и записывает на пробные уроки',
    'landing.trust.case5.niche': 'Автосервис',
    'landing.trust.case5.metric': 'Стабильный рост заявок',
    'landing.trust.case5.description': 'Устойчивое увеличение запросов на запись',
    'landing.trust.case5.usecase': 'Чат собирает данные автомобиля, проблему и помогает организовать заявки на ремонт',
    'landing.trust.case6.niche': 'Ресторан',
    'landing.trust.case6.metric': 'Стабильные брони',
    'landing.trust.case6.description': 'Более последовательные бронирования столиков',
    'landing.trust.case6.usecase': 'Чат принимает заявки на бронь и отвечает на вопросы о меню и наличии мест',
    
    // Integrations section
    'landing.integrations.title': 'Легкая интеграция',
    'landing.integrations.subtitle': 'Установите чат на любую платформу за 5 минут',
    'landing.integrations.cta': 'Работает с любым конструктором сайтов и CMS',
    'landing.integrations.button': 'Начать бесплатно',
    
    // Business types for animation
    'landing.business.beautySalon': 'салон красоты',
    'landing.business.restaurant': 'ресторан',
    'landing.business.dentalClinic': 'стоматологию',
    'landing.business.medicalCenter': 'медицинский центр',
    'landing.business.barbershop': 'барбершоп',
    'landing.business.nailStudio': 'ногтевую студию',
    'landing.business.yogaStudio': 'йога-студию',
    'landing.business.carService': 'автосервис',
    
    'landing.features.title': 'Всё для автоматизации записи',
    'landing.feature1.title': 'AI Диалог',
    'landing.feature1.desc': 'Бот ведет естественную беседу, узнает услугу, дату, имя и телефон',
    'landing.feature2.title': 'Email & Telegram Уведомления',
    'landing.feature2.desc': 'Мгновенная отправка заявок на вашу почту или в вашу группу Telegram',
    'landing.feature3.title': 'Мультиязычность',
    'landing.feature3.desc': 'Автоматически общается на языке клиента (14+ языков)',
    'landing.feature4.title': 'Готовый Виджет',
    'landing.feature4.desc': 'Вставьте код на сайт - и всё работает',
    'landing.feature5.title': 'История Заявок',
    'landing.feature5.desc': 'Все заявки сохраняются в личном кабинете',
    'landing.feature6.title': 'Настройка Дизайна',
    'landing.feature6.desc': 'Цвета, тексты и стиль под ваш бренд',
    'landing.feature7.title': 'Website Builder',
    'landing.feature7.desc': 'Готовая страница chatity.io/ваш-адрес с услугами, фото и AI-чатом — идеально для Instagram и визиток',
    'landing.builder.badge': 'Новинка',
    'landing.builder.title': 'Website Builder — сайт салона за 5 минут',
    'landing.builder.subtitle': 'Не нужен отдельный сайт — создайте страницу вашего бизнеса прямо в Chatity, без дизайнеров и программистов',
    'landing.builder.point1': 'Своя страница chatity.io/ваш-салон с услугами, ценами, галереей и картой',
    'landing.builder.point2': 'Встроенный AI-чат отвечает клиентам и записывает их 24/7',
    'landing.builder.point3': 'QR-код и короткая ссылка для Instagram, визиток и витрины',
    'landing.builder.point4': 'Автоматический перевод страницы на язык посетителя',
    'landing.builder.cta': 'Создать сайт бесплатно',
    'landing.builder.mock.services': 'Услуги и цены',
    'landing.builder.mock.chat': 'Здравствуйте! Хотите записаться? 💬',
    'landing.partnerBlock.badge': 'Партнёрская программа',
    'landing.partnerBlock.title': 'Станьте партнёром — зарабатывайте 30%',
    'landing.partnerBlock.subtitle': 'Рекомендуйте Chatity и получайте 30% со всех платежей привлечённых клиентов. Персональная ссылка, статистика в реальном времени и выплаты по запросу.',
    'landing.partnerBlock.point1': '30% с каждого платежа приведённого клиента',
    'landing.partnerBlock.point2': 'Персональная реферальная ссылка и промокод',
    'landing.partnerBlock.point3': 'Кабинет партнёра со статистикой и балансом',
    'landing.partnerBlock.cta': 'Стать партнёром',
    'auth.referralCode': 'Реферальный код (необязательно)',
    'dashboard.partnerProgram': 'Партнёрка',
    'bookings.totalCount': 'Всего заявок',
    'bookings.uniqueClients': 'Уникальных клиентов',
    'bookings.repeatBadge': 'Повторная',
    'dashboard.affiliateBlock.title': 'Партнёрская программа',
    'dashboard.affiliateBlock.desc': 'Приглашайте другие салоны и получайте 30% со всех их платежей на ваш баланс. Вывод — на карту или IBAN (Европа).',
    'dashboard.affiliateBlock.cta': 'Открыть кабинет партнёра',
    'partner.dash.payout.method.card_eu': 'Банковская карта (Европа)',
    'partner.dash.payout.subtitleEu': 'Выплаты только по Европе: банковская карта или IBAN/SEPA (EUR).',
    
    'landing.howItWorks.title': 'Как это работает',
    'landing.step1.title': 'Регистрация',
    'landing.step1.desc': 'Создайте аккаунт за 30 секунд',
    'landing.step2.title': 'Настройка',
    'landing.step2.desc': 'Подключите Email/Telegram и настройте дизайн',
    'landing.step3.title': 'Встройка',
    'landing.step3.desc': 'Вставьте код виджета на ваш сайт',
    'landing.step4.title': 'Заявки',
    'landing.step4.desc': 'Получайте заявки автоматически',
    
    'landing.pricing.title': 'Выберите свой тариф',
    'landing.pricing.subtitle': '7 дней бесплатно на любом тарифе',
    'landing.price.perMonth': 'в месяц',
    'landing.price.feature1': 'ИИ отвечает на языке клиента',
    'landing.price.calendar': 'Календарь записей + онлайн-запись',
    'landing.price.feature2': 'Email уведомления',
    'landing.price.feature3': 'История заявок (30 дней)',
    'landing.price.feature4': 'База знаний для AI',
    'landing.price.feature5': 'Базовая аналитика',
    'landing.price.cta': 'Начать бесплатно',
    
    'landing.plan.popular': 'ПОПУЛЯРНЫЙ',
    'landing.plan.starter.name': 'Starter',
    'landing.plan.starter.desc': 'Для независимых мастеров',
    'landing.plan.starter.limit': '100 диалогов/месяц',
    'landing.plan.professional.name': 'Professional',
    'landing.plan.professional.desc': 'Для растущих салонов',
    'landing.plan.professional.limit': '1,000 диалогов/месяц',
    'landing.plan.free.name': 'Free', 'landing.plan.free.desc': 'Календарь, онлайн-запись, мини-сайт',
    'landing.plan.free.limit': '1 мастер · 1 локация',
    'landing.plan.free.f1': 'Календарь записей', 'landing.plan.free.f2': 'Онлайн-запись на мини-сайте',
    'landing.plan.free.f3': 'Мини-сайт салона', 'landing.plan.free.f4': 'Email и Telegram уведомления',
    'landing.plan.starter.tagline': 'ИИ сам отвечает клиентам и записывает их',
    'landing.plan.starter.channels': '1 канал (WhatsApp / Instagram / Telegram) + веб-виджет',
    'landing.plan.professional.tagline': 'ИИ ведёт диалоги во всех ваших каналах',
    'landing.plan.professional.channels': 'Все каналы: WhatsApp + Instagram + Telegram + виджет',
    'landing.plan.addons': 'Дополнительно: канал +€19/мес · +100 диалогов +€10/мес · локация +50% тарифа',
    'landing.freecrm.badge': 'START FREE TODAY', 'landing.freecrm.title': 'Бесплатная CRM для бьюти',
    'landing.freecrm.subtitle': 'Календарь, онлайн-запись и мини-сайт — €0. Навсегда. Без карты.',
    'landing.freecrm.f1.title': 'Календарь', 'landing.freecrm.f1.desc': 'Записи, мастера, графики и история клиентов',
    'landing.freecrm.f2.title': 'Онлайн-запись', 'landing.freecrm.f2.desc': 'Клиенты сами выбирают свободные слоты 24/7',
    'landing.freecrm.f3.title': 'Мини-сайт', 'landing.freecrm.f3.desc': 'Страница салона с услугами и ценами за 2 минуты',
    'landing.freecrm.note': 'Нужен ИИ-администратор? Подключите канал от €39/мес',
    'landing.freecrm.button': 'Начать бесплатно сегодня',
    'landing.plan.professional.feature1': 'Telegram уведомления',
    'landing.plan.professional.feature2': 'Расширенная аналитика',
    'landing.plan.professional.feature3': 'UTM отслеживание',
    'landing.plan.professional.feature4': 'Website Builder — конструктор сайта + QR-ссылка',
    'landing.plan.professional.extraFeature': 'Настройка виджета',
    'landing.plan.unlimited.name': 'Unlimited',
    'landing.plan.unlimited.desc': 'Для крупного бизнеса',
    'landing.plan.unlimited.limit': '∞ Безлимит диалогов',
    'landing.plan.unlimited.feature1': 'Экспорт заявок в Excel',
    'landing.plan.unlimited.feature2': 'Расширенная кастомизация',
    'landing.plan.unlimited.extraFeature1': 'Приоритетная поддержка',
    'landing.plan.unlimited.extraFeature2': 'Индивидуальные настройки',
    
    'landing.cta.title': 'Готовы автоматизировать запись?',
    'landing.cta.subtitle': 'Присоединяйтесь к сотням бизнесов, которые уже используют Chatity',
    'landing.cta.button': 'Начать бесплатный период',
    
    'landing.footer.product': 'Продукт',
    'landing.footer.features': 'Возможности',
    'landing.footer.pricing': 'Цены',
    'landing.footer.docs': 'Документация',
    'landing.footer.company': 'Компания',
    'landing.footer.about': 'О нас',
    'landing.footer.contact': 'Контакты',
    'landing.footer.rights': '© 2025 Chatity. Все права защищены.',

    // Footer
    'footer.description': 'AI-ресепшн для бьюти и wellness',
    'footer.product': 'Продукт',
    'footer.features': 'Возможности',
    'footer.pricing': 'Цены',
    'footer.getStarted': 'Начать',
    'footer.legal': 'Правовая информация',
    'footer.privacyPolicy': 'Политика конфиденциальности',
    'footer.termsOfService': 'Условия использования',
    'footer.cookiePolicy': 'Политика cookie',
    'footer.contact': 'Контакты',
    'footer.address': '7 Avenue de Fabron, 06200 Nice, France',
    'footer.allRightsReserved': 'Все права защищены.',
    
    // Cookie Consent
    'cookies.title': '🍪 Мы используем cookies',
    'cookies.description': 'Мы используем файлы cookie для улучшения работы сайта, анализа трафика и персонализации контента. Продолжая использовать сайт, вы соглашаетесь с использованием cookie.',
    'cookies.learnMore': 'Узнать больше',
    'cookies.accept': 'Принять все',
    'cookies.decline': 'Только необходимые',
    
    // Admin Actions
    'admin.grantUnlimited': 'Назначить безлимит',
    'admin.deleteAccount': 'Удалить аккаунт',
    'admin.confirmDelete': 'Вы уверены, что хотите удалить этот аккаунт? Все данные пользователя будут безвозвратно удалены.',
    'admin.confirmGrant': 'Назначить безлимитный план этому пользователю?',
    'admin.unlimitedGranted': 'Безлимитный план успешно назначен',
    'admin.accountDeleted': 'Аккаунт успешно удален',
    'admin.error': 'Ошибка выполнения операции',

    // Blog
    'blog.title': 'Блог',
    'blog.subtitle': 'Полезные статьи об автоматизации бизнеса и AI-технологиях',
    'blog.readMore': 'Читать далее',
    'blog.minRead': 'мин чтения',
    'blog.noPosts': 'Статьи скоро появятся',
    'blog.backToBlog': 'Назад к блогу',
    'blog.notFound': 'Статья не найдена',
    'blog.relatedPosts': 'Похожие статьи',
    'blog.ctaTitle': 'Готовы автоматизировать свой бизнес?',
    'blog.ctaDescription': 'Попробуйте Chatity бесплатно в течение 7 дней. Без привязки карты.',
    'blog.ctaButton': 'Начать бесплатно',

    // Green API (WhatsApp by QR)
    'greenapi.title': 'WhatsApp по QR-коду',
    'greenapi.badgeConnected': 'Подключено',
    'greenapi.badgeWaiting': 'Ожидает скан QR',
    'greenapi.badgeNotConnected': 'Не подключено',
    'greenapi.description': 'Самый простой способ: отсканируйте QR-код в приложении WhatsApp — как WhatsApp Web. Номер остаётся в телефоне, AI начнёт отвечать клиентам сразу.',
    'greenapi.connectedPhone': '✅ Подключён номер: +{phone}',
    'greenapi.importBtn': '📥 Импортировать клиентов из WhatsApp',
    'greenapi.refreshChats': 'Обновить', 'greenapi.syncingChats': 'Список чатов подтягивается из WhatsApp — после сканирования QR это занимает 1–2 минуты. Нажмите «Обновить».',
    'greenapi.importHint': 'Выберите, какие чаты импортировать в раздел «Клиенты» — личные контакты можно пропустить. AI будет знать историю переписки и продолжит диалог в контексте.',
    'greenapi.qrHint': 'WhatsApp → Настройки → Связанные устройства → Привязка устройства → сканируйте',
    'greenapi.qrNotWorking': 'QR не сканируется? Обновить QR-код', 'greenapi.qrRefreshing': 'Перезапускаем подключение — новый QR появится через 1–2 минуты', 'greenapi.qrRefreshFailed': 'Не удалось обновить QR, попробуйте ещё раз',
    'greenapi.qrStarting': '⏳ Инстанс запускается, QR появится в течение минуты…',
    'greenapi.connectBtn': 'Подключить по QR',
    'greenapi.disconnectBtn': 'Отключить',
    'greenapi.confirmDisconnect': 'Отключить WhatsApp? Инстанс будет удалён.',
    'greenapi.toastCreated': 'Инстанс создан — через ~1 минуту появится QR-код',
    'greenapi.toastCreateFail': 'Не удалось создать подключение',
    'greenapi.toastDisconnected': 'WhatsApp отключён',
    'greenapi.toastDisconnectFail': 'Не удалось отключить',
    'greenapi.toastImported': 'Импортировано новых клиентов: {imported}',
    'greenapi.toastImportFail': 'Не удалось импортировать чаты',
    'greenapi.selectTitle': 'Какие чаты импортировать?',
    'greenapi.selectHint': 'Отметьте клиентов для импорта. Личные контакты можно снять — они не попадут в базу.',
    'greenapi.searchPlaceholder': 'Поиск по имени или номеру…',
    'greenapi.selectAll': 'Выбрать все',
    'greenapi.deselectAll': 'Снять все',
    'greenapi.alreadyImported': 'уже в базе',
    'greenapi.importSelected': 'Импортировать выбранные ({n})',
    'greenapi.loadingChats': 'Загружаем чаты…',
    'greenapi.noChats': 'Личных чатов не найдено',
    'greenapi.importing': 'Импортируем…',
    'greenapi.aiOn': '🤖 AI отвечает',
    'greenapi.aiOff': '🚫 Личный — AI молчит',
    'greenapi.contactsTitle': 'Контакты WhatsApp',
    'greenapi.contactsHint': 'Выберите, с кем AI общается, а с кем нет (личные чаты)',
    'greenapi.aiReplies': 'AI отвечает',
    'greenapi.aiSilent': 'AI молчит',
    'greenapi.disableAllAi': 'Отключить AI для всех',
    'greenapi.enableAllAi': 'Включить AI для всех',
    'greenapi.personalHint': 'Нажмите на кнопку «AI» у чата, чтобы запретить AI отвечать в личной переписке. Если вы сами ответите клиенту с телефона — AI замолчит в этом чате на 6 часов.',
    'greenapi.toastPersonalOn': 'AI больше не будет отвечать в этом чате',
    'greenapi.toastPersonalOff': 'AI снова отвечает в этом чате',
    'greenapi.stepCreated': 'Инстанс создан',
    'greenapi.stepStarting': 'Запускается на серверах WhatsApp — обычно 1–3 минуты, иногда до 5',
    'greenapi.stepQr': 'QR-код появится здесь автоматически',
    'greenapi.elapsed': 'Прошло: {time}',
    'greenapi.takingLong': 'Запуск идёт дольше обычного — такое бывает при нагрузке на серверы Green API. Подождите ещё немного или нажмите «Отключить» и создайте подключение заново.',
    'integrations.cat.website': 'Сайт',
    'integrations.cat.websiteDesc': 'WordPress, HTML, Tilda, Shopify и другие',
    'integrations.cat.whatsappDesc': 'Подключение по QR-коду',
    'integrations.cat.instagramDesc': 'AI отвечает в Direct',
    'integrations.cat.identDesc': 'Заявки в вашу CRM IDENT',
    'integrations.cat.altegioDesc': 'Журнал записи и CRM Altegio',
    'integrations.cat.vk': 'ВКонтакте',
    'integrations.cat.vkDesc': 'AI в сообщениях сообщества',
    'integrations.cat.voice': 'Телефония',
    'integrations.cat.voiceDesc': 'AI-приём звонков',
    'settings.jobReply': 'Ответ на вопросы о трудоустройстве',
    'settings.jobReplyPlaceholder': 'Например: «Отправьте резюме на hello@salon.fr — владелец лично рассмотрит и свяжется с вами»',
    'settings.jobReplyTip': 'Если оставить пустым — AI вежливо примет контакт кандидата и передаст вам. О жалобах и кандидатах вы получите уведомление в Telegram/email.',
    'settings.crmImportTitle': 'Импорт услуг из CRM (Planity/Booksy/Fresha)',
    'settings.crmImportHint': 'Вставьте ссылку на вашу публичную страницу записи — мы подтянем услуги и цены прямо в базу знаний AI.',
    'settings.crmImportFetch': 'Найти услуги',
    'settings.crmImportEmpty': 'Не удалось найти услуги с ценами по этой ссылке. Проверьте, что страница публичная.',
    'settings.crmImportFound': 'Найдено услуг: {count}',
    'settings.crmImportConfirm': 'Добавить в базу знаний ({count})',
    'settings.crmImportSuccess': 'Импортировано услуг: {count}',
    'settings.crmImportNote': 'Отмеченные услуги добавятся в базу знаний. Повторный импорт заменит ранее импортированный блок.',

    // Onboarding Guide
    'onboarding.title': 'Быстрый старт',
    'onboarding.subtitle': 'Выполните 4 шага, чтобы AI начал принимать записи',
    'onboarding.step1': 'База знаний',
    'onboarding.step1Desc': 'Расскажите AI об услугах, ценах и графике работы',
    'onboarding.step2': 'Подключите канал',
    'onboarding.step2Desc': 'WhatsApp, виджет на сайте или мини-сайт',
    'onboarding.step3': 'Привяжите карту',
    'onboarding.step3Desc': 'Выберите тариф, чтобы AI работал без перерывов',
    'onboarding.step4': 'Тестовое сообщение',
    'onboarding.step4Desc': 'Напишите вашему AI и проверьте ответ',
    'onboarding.dismiss': 'Скрыть',
    'settings.revenueTitle': 'Выручка для отчёта',
    'settings.revenueHint': 'Мы берём цены услуг из вашей базы знаний. Средний чек используется, если цена услуги не указана — так в отчёте считается выручка, привлечённая Chatity.',
    'settings.avgTicket': 'Средний чек',
    'settings.currency': 'Валюта',
    'settings.reactivationTitle': 'Реактивация клиентов',
    'settings.reactivationHint': 'Автонапоминание «спящим» клиентам записаться снова + подсчёт вернувшихся и выручки в отчёте',
    'settings.reactivationDays': 'Напоминать через (дней)',
    'settings.reactivationChannel': 'Канал',
    'settings.reactivationMessage': 'Текст сообщения',
    'settings.reactivationPlaceholder': 'Здравствуйте, {name}! Давно вас не видели 💐 Будем рады снова видеть вас. Хотите записаться?',
    'settings.reactivationTip': 'Используйте {name} — подставится имя клиента. Отправляется автоматически раз в сутки.',

  },
  
  en: {
    // Auth Page
    'auth.title': 'Chatity',
    'auth.subtitle': 'AI front desk for beauty & wellness',
    'landing.value.title': 'Your customers are messaging. Chatity handles it.',
    'landing.value.subtitle': 'Every unanswered message is a lost booking. Chatity replies instantly, books appointments, takes payments and brings clients back — while you focus on your craft.',
    'landing.value.c1': 'Capture every inquiry',
    'landing.value.c1d': 'Instant replies on WhatsApp, Instagram and your website — 24/7, even after hours.',
    'landing.value.c2': 'Book appointments',
    'landing.value.c2d': 'AI offers available slots, books and confirms — no receptionist needed.',
    'landing.value.c3': 'Take payments',
    'landing.value.c3d': 'Deposits and prepayments right in the chat — fewer no-shows.',
    'landing.value.c4': 'Bring clients back',
    'landing.value.c4d': 'Smart reminders and personal invitations to dormant clients.',
    'auth.login': 'Login',
    'auth.register': 'Register',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.salonName': 'Salon Name',
    'auth.companyName': 'Company Name',
    'auth.companyNamePlaceholder': 'e.g., Beauty Studio',
    'auth.companyWebsite': 'Company Website (optional)',
    'auth.websiteImportant': '💡 Important: Enter the correct website address so the AI can read basic information to use when communicating with clients',
    'auth.loginButton': 'Sign In',
    'auth.registerButton': 'Sign Up',
    'auth.termsAccept': "I accept the",
    'auth.termsLink': "Terms of Service",
    'auth.termsAnd': "and the",
    'auth.privacyLink': "Privacy Policy",
    'ms.book.privacyNotice': "By booking, the information you provide is used by {business} to process your request and manage your appointment (including reminders). Chatity is the technical provider and processes this data on behalf of the business.",
    'ms.book.learnMore': "Learn more",
    'ms.book.optional': "optional",
    'ms.book.marketingConsent': "I agree to receive offers and news from {business} by e-mail, SMS or messaging apps",
    'privacy.title': "Privacy & legal",
    'privacy.intro': "Under GDPR you are the controller of your clients' data and Chatity (MINDUNITE SAS) is the processor. These details are shown to clients in the privacy notice on your mini-site and chat widget.",
    'privacy.legalName': "Legal business name",
    'privacy.address': "Registered address",
    'privacy.email': "Contact email",
    'privacy.privacyEmail': "Email for data requests",
    'privacy.phone': "Phone",
    'privacy.policyUrl': "Link to your own privacy policy (optional)",
    'privacy.marketingTitle': "Marketing messages",
    'privacy.marketingEnabled': "Allow marketing messages to clients (win-back, promotions)",
    'privacy.marketingHint': "A separate, unticked consent checkbox appears on the booking form. Without consent no promotional message is sent; appointment reminders always work.",
    'privacy.existingCustomers': "Existing-customer exception",
    'privacy.existingCustomersHint': "Send offers about similar services to clients who already visited you, unless they opted out (STOP). Make sure this is permitted under your law.",
    'privacy.retentionTitle': "Retention periods",
    'privacy.chatRetention': "Client conversations, days",
    'privacy.bookingRetention': "Booking history & client records",
    'privacy.retention.active': "While the client is active (3 years after last visit)",
    'privacy.retention.2y': "2 years after last visit",
    'privacy.retention.1y': "1 year after last visit",
    'privacy.retentionHint': "Automatic deletion/anonymisation according to these periods runs as a daily job.",
    'privacy.healthTitle': "Health data",
    'privacy.healthEnabled': "Health-data mode (PMU, aesthetic medicine)",
    'privacy.healthHint': "By default the AI never asks for or stores medical information and hands such questions to the administrator. A dedicated secure health-data workflow is in development.",
    'privacy.save': "Save privacy settings",
    'privacy.saved': "Privacy settings saved",
    'auth.loading': 'Loading...',
    'auth.loginSuccess': 'Login successful!',
    'auth.registerSuccess': 'Registration successful!',
    'auth.error': 'Authentication error',
    'auth.websiteUrl': 'Website URL',
    'auth.forgotPassword': 'Forgot password?',
    'auth.loginWithCode': 'Sign in with email code (no password)',
    'auth.loginWithPassword': 'Sign in with password',
    'auth.sendCode': 'Send sign-in code',
    'auth.verifyCode': 'Sign in',
    'auth.enterCode': 'Code from email',
    'auth.codeSentInfo': 'Code sent to your email',
    'auth.codeSentHint': 'Code and sign-in button sent to your email (check Spam folder)',
    'auth.resendCode': 'Resend code',
    'auth.magicLoginError': 'Link is invalid or expired',
    'auth.magicLoggingIn': 'Signing in...',
    'auth.backToLogin': 'Back to login',
    
    // Forgot Password
    'forgot.title': 'Password Recovery',
    'forgot.subtitle': 'Enter your email to receive recovery code',
    'forgot.enterCode': 'Enter code from email and new password',
    'forgot.sendCode': 'Send Code',
    'forgot.resetCode': 'Recovery Code',
    'forgot.newPassword': 'New Password',
    'forgot.confirmPassword': 'Confirm Password',
    'forgot.resetPassword': 'Reset Password',
    'forgot.resendCode': 'Resend code',
    'forgot.backToLogin': 'Back to login',
    'forgot.codeSent': 'Code sent to email',
    'forgot.success': 'Password successfully changed!',
    'forgot.error': 'Password recovery error',
    'forgot.passwordMismatch': 'Passwords do not match',
    'forgot.passwordTooShort': 'Password must be at least 6 characters',
    
    // Dashboard
    'dashboard.title': 'Chatity',
    'dashboard.logout': 'Logout',
    'dashboard.logoutSuccess': 'Logged out',
    
    // Tabs
    'tabs.settings': 'Settings',
    'tabs.bookings': 'Bookings',
    'tabs.widget': 'Integrations',
    'tabs.marketing': 'Marketing', 'tabs.analytics': 'Analytics',
    'mk.triggersTitle': 'Keyword triggers',
    'mk.triggersHint': 'Client sends a code word (e.g. from your ad) — the bot instantly replies with your offer. Works in Instagram, WhatsApp and the widget.',
    'mk.keyword': 'Keyword',
    'mk.response': 'Reply to send',
    'mk.responsePh': 'E.g.: Congrats! 🎁 You get a free treatment with any booking. Tell us when you would like to come!',
    'mk.addTrigger': 'Add keyword',
    'mk.active': 'Active',
    'mk.save': 'Save',
    'mk.saved': 'Saved ✓', 'clients.language': 'Client language (WhatsApp/Instagram notifications)', 'clients.langAuto': 'Auto by country code', 'clients.langAutoUnknown': 'Auto (from chat)', 'clients.langHint': 'Reminders and confirmations are sent in this language. Auto: by the phone country code (+33 — French, +7 — Russian…), otherwise from the chat.', 'clients.langSaved': 'Client language saved', 'mk.remindersTitle': 'Visit reminders to clients', 'mk.remindersHint': 'Sent automatically via WhatsApp. If the client has no WhatsApp — AI call 24h before (requires a connected phone).', 'mk.remindersNoWhatsapp': 'WhatsApp is not connected — WhatsApp reminders will not be sent.', 'mk.remindersNoPhone': 'Phone is not connected — call reminders (for clients without WhatsApp) will not work.', 'mk.remindersConnect': 'Connect', 'mk.remindersChannelsOk': 'WhatsApp and phone are connected — reminders are working.', 'mk.remindersTextLabel': 'Custom text (optional)', 'mk.reminder24hTitle': '24 hours before', 'mk.reminder24hHint': 'The day before — client can reschedule or cancel by replying', 'mk.reminder24hPh': '{name}, a reminder about your appointment tomorrow ✨ {service}{master} — {when}. See you!', 'mk.reminder2hTitle': '2 hours before', 'mk.reminder2hHint': 'Short reminder on the day of the visit', 'mk.reminder2hPh': '{name}, see you today at {time} ⏰ {service}{master}.', 'mk.remindersPlaceholders': 'Placeholders: {name}, {service}, {master} — " with …", {when} — date & time, {date}, {time}', 'mk.remindersLogTitle': 'Recent sends', 'mk.remindersUpcoming': 'Awaiting reminder: {n}', 'mk.remindersLogEmpty': 'Nothing sent yet — reminders go out automatically before upcoming visits', 'mk.remindersNotDelivered': 'not delivered',
    'addons.title': 'Add-ons', 'addons.subtitle': 'Channels, branches and phone AI are added to your subscription and renew with it — no need to re-enter your card. Dialog packs are a one-time purchase valid until the end of the paid month.',
    'addons.dialogs': 'Dialog pack', 'addons.dialogsHint': '+100 dialogs for €10. Buy several — consumed after the plan limit, expire at the end of the paid month.',
    'addons.channel': 'Extra channel', 'addons.channelHint': '1 channel included in the plan (WhatsApp or Instagram). Each extra — €19/mo. Widget & mini-site are always free.',
    'addons.branch': 'Extra branch', 'addons.branchHint': '1 branch included in the plan. Each extra — 50% of your plan price per month.',
    'addons.buy': 'Buy', 'addons.mo': 'mo', 'addons.active': 'Active', 'addons.connected': 'Channels connected', 'addons.branches': 'Branches',
    'addons.phone': 'Phone AI', 'addons.yours': 'Your add-ons', 'addons.autoRenew': 'renews with your subscription', 'addons.cancel': 'Turn off', 'addons.resume': 'Resume',
    'addons.endsOn': 'Ends on {date}', 'addons.validUntil': 'Valid until {date}', 'addons.attached': 'Add-on activated and added to your subscription',
    'addons.cancelConfirm': 'Turn off this add-on? It stays active until the end of the paid period, then no further charges.', 'addons.cancelled': 'Add-on will end at the end of the period', 'addons.resumed': 'Add-on is active again',
    'addons.confirmAttach': 'Add to your current subscription: €{now} will be charged to your card today (prorated to the end of the period), then {monthly} together with your plan. Confirm?',
    'addons.confirmCheckout': 'Add-on subscription {monthly}, auto-renewing. The payment page will open now. Continue?',
    'mk.igTitle': 'Instagram: story reactions', 'mk.storyReactHint': 'When a client reacts (❤️ 🔥 😍) to your story, the AI thanks them and starts a conversation', 'mk.storyReactInfo': 'What to offer in the reply', 'mk.storyReactPlaceholder': 'E.g.: 20% off manicure for new clients until the end of the month', 'mk.storyReactTip': 'The AI weaves this info into the reply in the client\'s language. Replies at most once per 6 hours per dialog.',
    'tabs.admin': 'Admin',
    'tabs.support': 'Support',
    
    // Settings
    'settings.title': 'Settings',
    'settings.subtitle': 'Configure integrations and your AI assistant',
    'settings.languageTitle': 'Language Settings',
    'settings.uiLanguage': 'Interface Language',
    'settings.uiLanguageDesc': 'Language for dashboard and menus',
    'settings.notificationLanguage': 'Notification Language',
    'settings.notificationLanguageDesc': 'Language for email and Telegram booking notifications',
    'settings.notificationLanguageSuccess': 'Notification language updated',
    'settings.languageUpdateError': 'Error updating language',
    'settings.notifications': 'Booking Notifications',
    'settings.emailTitle': 'Email Notifications',
    'settings.emailCheckbox': 'Receive bookings via email',
    'settings.emailRecipients': 'Where to send notifications (comma-separated)',
    'settings.emailRecipientsDefault': 'default: {email}',
    'settings.emailRecipientsHint': 'Leave empty to receive them at your account email. You can list several addresses separated by commas — each one will get the notification.',
    'settings.emailWarning': '⚠️ Email feature is available in production. Use Telegram in test mode.',
    'settings.telegramTitle': 'Telegram Notifications',
    'settings.chatId': 'Group Chat ID',
    'settings.chatIdInstructions': 'How to get Chat ID for notifications:',
    'settings.chatIdStep1': 'Find the bot:',
    'settings.chatIdStep1Text': 'Open Telegram and find our bot',
    'settings.chatIdStep2': 'Add to chat:',
    'settings.chatIdStep2Text': 'Add the bot to your personal chat or group where you want to receive notifications',
    'settings.chatIdStep3': 'Run command:',
    'settings.chatIdStep3Text': 'Send the command',
    'settings.chatIdStep4': 'Copy Chat ID:',
    'settings.chatIdStep4Text': 'The bot will send your Chat ID (number like: -1001234567890)',
    'settings.chatIdStep5': 'Paste and save:',
    'settings.chatIdStep5Text': 'Paste the Chat ID in the field above and click "Save Settings"',
    'settings.chatIdSuccess': 'After saving, you will receive notifications about new bookings directly in Telegram!',
    'settings.balloonSettings': 'Balloon Tooltip',
    'settings.balloonEnabled': 'Show tooltip',
    'settings.balloonEnabledDesc': 'Pop-up message attracts visitors attention',
    'settings.balloonMessage': 'Tooltip text',
    'settings.balloonMessagePlaceholder': 'Hello! I can help you book an appointment 👋',
    'settings.balloonDelay': 'Delay (seconds)',
    'settings.balloonDelayDesc': 'After how many seconds to show the tooltip',
    'settings.autoOpenEnabled': 'Auto-open chat',
    'settings.autoOpenEnabledDesc': 'Automatically open chat if visitor did not click',
    'settings.autoOpenDelay': 'Auto-open delay (seconds)',
    'settings.autoOpenDelayDesc': 'After how many seconds to auto-open the chat',
    'settings.analyzeWebsite': 'Analyze Website',
    'settings.analyzing': 'Analyzing',
    'settings.websiteAnalyzed': 'Website analyzed! Information loaded into knowledge base.',
    'settings.websiteAnalyzedSuccess': 'Website analyzed successfully!',
    'settings.websiteUrlRequired': 'Please specify website URL in business settings for automatic analysis',
    'settings.aiChatbot': 'AI Assistant',
    'settings.primaryColor': 'Primary Color',
    'settings.secondaryColor': 'Secondary Color',
    'settings.buttonColor': 'Button Color',
    'settings.botName': 'Bot Name',
    'settings.welcomeMessage': 'Welcome Message',
    'settings.defaultBotName': 'Assistant',
    'settings.defaultWelcomeMessage': 'Hello! How can I help you?',
    'settings.businessInfo': 'Your Business Information',
    'settings.aiKnowledgeTitle': 'AI will use this information!',
    'settings.aiKnowledgeDesc': 'Specify your services, prices, working hours, address. AI will consult clients based on this data.',
    'settings.knowledgeBase': 'AI Knowledge Base',
    'settings.knowledgeBasePlaceholder': `Example:

Our services:
- Haircut - from €50
- Styling - from €40
- Consultation - €20

Working hours:
Mon-Fri: 10:00-20:00
Sat-Sun: 11:00-19:00

Address: 123 Main St, New York
Phone: +1 (555) 123-4567`,
    'settings.knowledgeTip': 'Tip: The more detailed you describe services and prices, the more accurate AI will consult clients',
    'settings.businessType': 'Your Business Type',
    'settings.businessTypeHint': 'AI will be configured for your niche specifics',
    'settings.businessTypes.general': '🏢 General',
    'settings.businessTypes.medical': '🏥 Medical / Clinic',
    'settings.businessTypes.beauty': '💅 Beauty Salon',
    'settings.businessTypes.ecommerce': '🛍️ E-commerce',
    'settings.businessTypes.restaurant': '🍽️ Restaurant / Cafe',
    'settings.businessTypes.services': '🔧 Services',
    'settings.productFeedUrl': 'Product Feed URL (XML/JSON)',
    'settings.productFeedHint': 'AI will consult clients about products from your catalog',
    'tilda.title': 'Tilda online store (MCP)', 'tilda.desc': 'The AI will answer clients about products, prices and availability from your Tilda catalog and send them to the store to buy.', 'tilda.step1': 'In Tilda open Profile → “MCP server” → “New key”', 'tilda.step2': 'Pick the store project, access “Limited” → tick only “Product catalog” (read) and “No expiration”', 'tilda.step3': 'Copy the key (shown once) and paste it below', 'tilda.keyLabel': 'Tilda MCP key', 'tilda.connect': 'Connect', 'tilda.checking': 'Checking…', 'tilda.help': 'Tilda MCP guide', 'tilda.connected': 'Tilda connected, catalog loaded', 'tilda.synced': 'Catalog refreshed', 'tilda.disconnectConfirm': 'Disconnect Tilda? The product catalog will be removed from the AI.', 'tilda.project': 'Project', 'tilda.products': 'Products', 'tilda.syncedAt': 'Updated', 'tilda.currency': 'Price currency', 'tilda.key': 'Key', 'tilda.lastError': 'Last error', 'tilda.sync': 'Refresh catalog', 'tilda.disconnect': 'Disconnect', 'tilda.searchPh': 'Check a product in the catalog…', 'tilda.search': 'Search', 'tilda.noResults': 'Nothing found', 'tilda.autoSync': 'The catalog refreshes automatically every 12 hours.', 'tilda.err.key': 'Tilda rejected the key. Check the key (starts with mcp_tilda_) and its expiration', 'tilda.err.noProjects': 'This key has no access to any project', 'tilda.err.unreachable': 'Tilda is unreachable, try again later', 'tilda.err.generic': 'Connection error',
    'subscription.cancelTitle': 'Cancel subscription', 'subscription.cancelDesc': 'The plan and all add-ons (phone, channels, branches) are cancelled immediately: the AI stops in all channels, no further charges.', 'subscription.lastPayment': 'Last payment', 'subscription.cancelBtn': 'Cancel subscription', 'subscription.cancelConfirm': 'Cancel the subscription now? The AI stops immediately in all channels (website, WhatsApp, Instagram, phone). No more charges.', 'subscription.cancelDone': 'Subscription cancelled. No more charges.', 'subscription.cancelError': 'Could not update the subscription. Please contact support.', 'subscription.cancelScheduled': 'Subscription cancelled', 'subscription.cancelScheduledDesc': 'Access remains until {date}, then the AI stops in all channels. You will not be charged again.', 'subscription.resumeBtn': 'Resume subscription', 'subscription.resumeDone': 'Subscription resumed',
    'cal.billingPaymentFailed': 'Subscription payment failed — the AI is paused in all channels (website, WhatsApp, Instagram, phone). Clients are left unanswered.', 'cal.billingUnpaid': 'Subscription inactive — the AI is not answering clients in any channel.', 'cal.billingFix': 'Fix payment',
    'tilda.sendLinks': 'Allow the AI to send clients a direct product link', 'settings.aiKnowledgeDescEcom': 'Describe delivery and payment terms, returns, lead times, pickup address, contacts. Products and prices come from the connected Tilda catalog.',

    'settings.saveButton': 'Save Settings',
    'settings.saving': 'Saving…',
    'settings.saveSuccess': 'Settings saved!',
    'settings.saveError': 'Error saving settings',
    
    // Bookings
    'bookings.title': 'Booking History',
    'bookings.subtitle': 'All client bookings',
    'bookings.noBookings': 'No bookings yet',
    'bookings.service': 'Service',
    'bookings.preferredDate': 'Preferred date',
    'bookings.preferredTime': 'Preferred time',
    'bookings.period': 'Period',
    'bookings.today': 'Today',
    'bookings.last7days': 'Last 7 days',
    'bookings.last30days': 'Last 30 days',
    'bookings.customDates': 'Custom dates',
    'bookings.from': 'From',
    'bookings.to': 'To',
    'bookings.refresh': 'Refresh',
    'bookings.todayCount': 'Bookings today',
    'bookings.yesterdayCount': 'Bookings yesterday',
    'bookings.growthPercent': 'Growth vs yesterday',
    'bookings.dynamicsTitle': 'Booking dynamics',
    'bookings.dynamicsDescription': 'Number of bookings per day',
    'bookings.topSourcesTitle': 'Top traffic sources',
    'bookings.topSourcesDescription': 'Where clients come from',
    'bookings.source': 'Source',
    'bookings.bookingsCount': 'Bookings',
    'bookings.directVisit': 'Direct visit',

    
    // Analytics
    'analytics.upgradeToPro': 'Advanced Analytics',
    'analytics.upgradeDescription': 'Upgrade to Professional or Unlimited plan for access to:',
    'analytics.feature1': 'Booking dynamics charts',
    'analytics.feature2': 'Traffic sources (UTM tags)',
    'analytics.feature3': 'Detailed statistics',
    'analytics.feature4': 'Data export',
    'analytics.upgradeButton': 'Upgrade Plan',
    'analytics.channel': 'Channel',
    'analytics.campaign': 'Campaign',
    'miniBuilder.title': 'Mini-site Builder',
    'miniBuilder.active.onTitle': 'Mini-site is live',
    'miniBuilder.active.offTitle': 'Mini-site is disabled',
    'miniBuilder.active.onHint': 'Your public page is live. Visitors will see your mini-site at your short link.',
    'miniBuilder.active.offHint': 'Page is hidden. Visitors will get a 404 on your short link. Widget and integrations keep working.',
    'miniBuilder.save': 'Save',
    'miniBuilder.saving': 'Saving...',
    'miniBuilder.loading': 'Loading...',
    'miniBuilder.noSlug': 'Please set your short link first in the Integrations tab',
    'miniBuilder.upgradeDesc': 'The Mini-site Builder is available on Professional and Unlimited plans.',
    'miniBuilder.upgradeBtn': 'Upgrade to Professional',
    'miniBuilder.about.title': 'About',
    'miniBuilder.about.label': 'About text',
    'miniBuilder.about.aiBtn': 'Generate with AI',
    'miniBuilder.about.generating': 'Generating...',
    'miniBuilder.about.placeholder': 'Briefly describe your salon: atmosphere, values, what makes you unique...',
    'miniBuilder.about.hint': 'AI uses data from your Knowledge Base (salon info, services, prices) set on the Settings tab.',
    'miniBuilder.seo.title': 'SEO settings',
    'miniBuilder.seo.hint': 'These fields are what Google and social networks see when your page is shared. Leave empty to auto-fill from your name and "About" text.',
    'miniBuilder.seo.titleLabel': 'SEO title',
    'miniBuilder.seo.titlePlaceholder': 'Manicure & Pedicure in Paris — Lux Salon',
    'miniBuilder.seo.titleHint': '"— Chatity" is automatically appended to the title',
    'miniBuilder.seo.descLabel': 'SEO description',
    'miniBuilder.seo.descPlaceholder': 'Beauty salon in central Paris: manicure, pedicure, brows. Book online 24/7.',
    'miniBuilder.seo.descHint': 'Shown under the title in Google search results',
    'miniBuilder.seo.keywordsLabel': 'Keywords',
    'miniBuilder.seo.keywordsPlaceholder': 'manicure paris, pedicure, beauty salon 11th arrondissement',
    'miniBuilder.seo.keywordsHint': 'Comma-separated. Optional — Google mostly ignores them, but it does not hurt',
    'miniBuilder.cover.title': 'Mini-site cover photo',
    'miniBuilder.cover.desc': 'Image URL (Instagram / Imgur / Telegram / your CDN). If empty — a gradient is shown.',
    'miniBuilder.logo.title': 'Logo / Avatar',
    'miniBuilder.logo.desc': 'Round logo in the mini-site hero. Square 512×512 px works best (PNG with transparent bg or JPG).',
    'miniBuilder.logo.hint': 'The logo is displayed next to your business name in the hero and inside the chat widget.',
    'miniBuilder.social.title': 'Social & contacts',
    'miniBuilder.social.hint': 'These links will be shown to visitors on your public mini-site.',
    'miniBuilder.services.title': 'Services & prices',
    'miniBuilder.photos.title': 'Photo gallery',
    'miniBuilder.phase2': 'coming soon (phase 2)',
    'miniBuilder.phase2Photos': 'coming soon (phase 2)',
    'miniBuilder.toast.saved': 'Mini-site saved',
    'miniBuilder.toast.saveFailed': 'Failed to save',
    'miniBuilder.toast.aiSuccess': 'AI generated the About 🤖',
    'miniBuilder.toast.aiFailed': 'Failed to generate',
    'miniBuilder.address.label': 'Address',
    'miniBuilder.address.placeholder': '7 Avenue de Fabron, 06200 Nice, France',
    'miniBuilder.address.hint': 'Will be shown on your public mini-site with an interactive Google map.',
    'miniBuilder.services.empty': 'No categories yet. Add the first one so clients can see your services and prices.',
    'miniBuilder.services.addCategory': 'Add category',
    'miniBuilder.services.addService': 'Add service',
    'miniBuilder.services.categoryNamePlaceholder': 'e.g. Haircuts & styling',
    'miniBuilder.services.categoryDescPlaceholder': 'Short category description (optional)',
    'miniBuilder.services.serviceNamePlaceholder': 'Service name',
    'miniBuilder.services.durationPlaceholder': '60 min',
    'miniBuilder.services.pricePlaceholder': '50',
    'miniBuilder.photos.empty': 'No photos yet. Add links to interior shots, work or team photos.',
    'miniBuilder.photos.add': 'Add photo',
    'miniBuilder.photos.urlPlaceholder': 'https://i.imgur.com/photo.jpg',
    'miniBuilder.photos.altPlaceholder': 'Caption (optional)',
    'miniBuilder.photos.hint': 'Best format — horizontal photos 1200×800 px. Up to 6 photos, max 2 MB each. Large photos are auto-compressed to WebP.',
    'miniBuilder.photos.full': 'Gallery is full — 6 photos max. Remove one to add a new photo.',
    'uploader.trimmed': 'Only {n} more photo(s) can be added — others were skipped.',
    'miniBuilder.services.currencyLabel': 'Currency',
    'miniBuilder.services.unnamedCategory': 'Untitled',
    'miniBuilder.titleField.label': 'Business name (page title)',
    'miniBuilder.titleField.placeholder': 'Oui Beauté · Hair Salon in Nice',
    'miniBuilder.titleField.hint': 'Used as <title> in the browser tab and the mini-site header. If empty — uses your salon name from settings.',
    'miniBuilder.tagline.label': 'Subtitle (tagline)',
    'miniBuilder.tagline.placeholder': 'Hair salon on Tverskaya · 8 years of experience',
    'miniBuilder.tagline.hint': 'A short line under the business name. Up to 80 characters.',
    'uploader.btn': 'Upload',
    'uploader.dropzone': 'Drop a photo here or click to choose',
    'uploader.dropzoneMulti': 'Drop multiple photos here or click to choose',
    'uploader.hint': 'JPG / PNG / WebP, up to 2 MB',
    'uploader.uploading': 'Uploading',
    'uploader.success': 'Photo uploaded ✓',
    'uploader.successMulti': '{n} photos uploaded',
    'uploader.failed': 'Upload failed',
    'uploader.invalidType': 'Unsupported format. Use JPG, PNG or WebP.',
    'uploader.tooBig': 'File is too large. Try a smaller photo.',
    'miniBuilder.hours.title': 'Working hours',
    'miniBuilder.hours.label': 'Salon opening hours',
    'miniBuilder.hours.placeholder': 'Mon-Fri: 09:00–19:00\nSat: 10:00–18:00\nSun: closed',
    'miniBuilder.hours.hint': 'Free-text. Each new line shows on a new line on the public page.',
    'tabs.minisite': 'Mini-site',
    'tabs.team': 'Team',
    'tabs.calendar': 'Calendar',
    'cal.today': 'Today', 'cal.day': 'Day', 'cal.week': 'Week', 'cal.month': 'Month',
    'cal.allBranches': 'All branches', 'cal.allMasters': 'All masters', 'cal.modeChips': 'Bookings', 'cal.modeLoad': 'Load',
    'cal.addClient': 'Book a client', 'cal.dashboard': 'Dashboard',
    'cal.newBooking': 'New booking', 'cal.clientName': 'Client name', 'cal.phone': 'Phone',
    'cal.service': 'Service', 'cal.master': 'Master', 'cal.date': 'Date', 'cal.time': 'Time',
    'cal.book': 'Book', 'cal.moved': 'Booking moved', 'cal.conflict': 'This time is busy or outside working hours', 'cal.onlyMasterServices': 'Only this master\'s services are shown. Edit them on the master card (Team)', 'cal.conflict.day_off': '{master} has a day off (or the branch is closed)', 'cal.conflict.outside_schedule': 'Outside schedule: {master} works {window}, the service takes {duration_min} min', 'cal.conflict.busy': '{master} already has a booking at {start_at}–{end_at}', 'cal.conflict.external_busy': '{master} is busy in the external calendar', 'cal.conflict.master_not_found': 'Master not found or has no schedule', 'cal.conflict.master_does_not_offer_service': 'This master does not offer the service — tick it on the master card', 'cal.conflict.no_master_for_service': 'No master offers this service — tick it on the master cards', 'cal.conflict.no_free_master': 'No free master at this time',
    'cal.unassigned': 'Unassigned', 'cal.assignTime': 'Assign time',
    'ob.skip': 'Skip setup', 'ob.skipConfirm': 'Exit setup? You can always configure everything later in your dashboard.', 'ob.stepOf': 'Step {a} of {b}', 'ob.next': 'Continue', 'ob.back': 'Back', 'ob.s1Title': 'Tell us about yourself', 'ob.s1Sub': '2 minutes — your AI will introduce itself with your name', 'ob.salonName': 'Salon name', 'ob.bizType': 'Business type', 'ob.timezone': 'Timezone', 'ob.nameRequired': 'Please enter a name', 'ob.s2Title': '7 days free — full access', 'ob.s2Sub': 'Add your card now, first charge only after 7 days', 'ob.s2Note': '€0 today. First charge in 7 days. Cancel anytime in one click.', 'ob.s2Cta': 'Add card — 7 days free', 'ob.s2Later': 'Later', 'ob.recommended': 'Recommended', 'ob.dialogsMo': 'dialogs/mo', 'ob.mo': 'mo', 'ob.cardOk': 'Card added! 7 free days activated 🎉', 'ob.s3Title': 'Train your AI', 'ob.s3Sub': 'Services, prices and info — this is exactly what AI will tell your clients', 'ob.kbLabel': 'About your salon in your own words', 'ob.kbPh': 'Address, parking, cancellation policy, promos — everything AI should know…', 'ob.services': 'Services', 'ob.svcName': 'Service (e.g., Manicure)', 'ob.team': 'Team', 'ob.masterName': 'Master name', 'ob.masterAdd': 'Add', 'ob.solo': 'I work alone', 'ob.soloName': 'Master', 'ob.s4Title': 'Connect channels', 'ob.s4Sub': 'WhatsApp, Instagram or website widget — at least one so clients can reach you', 'ob.widgetTitle': 'Website widget', 'ob.widgetCopy': 'Copy code', 'ob.copied': 'Code copied!', 'ob.s5Title': 'Test your AI', 'ob.s5Sub': 'Write as a client — AI will answer with your services and prices', 'ob.testHint': 'E.g.: "How much is a manicure?"', 'ob.testPh': 'Type a message…', 'ob.finish': 'Launch & go to calendar', 'ob.launched': 'Done! Your AI receptionist is live 🎉',
    'ob.promo': 'Promo code', 'ob.promoApply': 'Apply', 'ob.promoFree': 'mo free', 'ob.promoRedeem': 'Activate {n} free months — no card needed', 'ob.promoAuto': 'Promo code applied',
    'ob.language': 'Interface language',
    'ob.widgetNoSite': 'No website? You get one for free — a mini-site with online booking is created automatically once you set up your services and team in the dashboard.',
    'cal.remindCall': 'Remind by call', 'cal.remindCallDone': 'AI is calling the client ({lang})', 'cal.cancelled': 'Booking cancelled', 'cal.created': 'Booking created', 'cal.cancelBooking': 'Cancel booking',
    'cal.pendingConfirm': 'Booked by AI — awaiting confirmation',
    'cal.confirmBtn': 'Confirm', 'cal.confirmedSent': 'Confirmed! Client has been notified',
    'cal.confirmedOk': 'Booking confirmed',
    'cal.messages': 'Messages',
    'inbox.today': 'Today', 'inbox.yesterday': 'Yesterday', 'inbox.search': 'Search by name, phone…', 'inbox.empty': 'No dialogs yet',
    'inbox.pickDialog': 'Pick a dialog on the left', 'inbox.client': 'Client',
    'inbox.reply': 'Write a reply… (AI pauses for 6h)', 'inbox.you': 'You',
    'inbox.aiPaused': 'AI paused — you are replying', 'inbox.resumeAi': 'Resume AI',
    'inbox.aiResumed': 'AI is answering this dialog again', 'inbox.aiOn': 'AI replying',
    'inbox.aiOff': 'AI is off', 'inbox.aiOffBanner': 'AI is off for this dialog — you are replying',
    'inbox.crashMsg': 'Failed to display the dialog', 'inbox.reload': 'Reload',
    'inbox.aiDisabledToast': 'AI disabled for this contact', 'inbox.aiEnabledToast': 'AI is replying to this contact again',
    'inbox.newMessage': 'New message',
    'team.permsTitle': 'Admin section access',
    'team.permsHint': 'Calendar and Messages are always available. Widget, mini-site, subscription and settings — owner only.',
    'profile.title': 'My profile', 'profile.name': 'Name', 'profile.phone': 'Phone',
    'profile.save': 'Save', 'profile.saved': 'Profile saved',
    'profile.emailTaken': 'This email is already in use', 'profile.uploadHint': 'Click the photo to upload (JPG/PNG, up to 2 MB)',
    'cal.statCancels': 'Cancellations', 'cal.statCalls': 'Calls',
    'cal.email': 'Email', 'cal.duration': 'Duration (min)', 'cal.price': 'Price', 'cal.total': 'Total',
    'cal.save': 'Save', 'cal.saved': 'Saved', 'cal.came': 'Came', 'cal.noShow': 'No-show',
    'cal.booking': 'Appointment', 'cal.menu': 'Menu',
    'cal.whatDone': 'What was done: service, polish/color, materials, formula', 'cal.whatDoneHint': 'Write it down to reproduce the result next time', 'cal.attendanceRequired': 'Please mark whether the client came or was a no-show',
    'cal.needsCallback': 'Call the client back',
    'cal.clientConfirmed': 'Client confirmed the appointment', 'cal.clientConfirmedPhone': '✅ Confirmed by phone',
    'cal.newBooking': 'New booking',
    'cal.allDay': 'All day', 'cal.allDayHint': "The master's day will be closed for bookings", 'cal.repeat': 'Repeat', 'cal.repeatOn': 'Repeat on', 'cal.repeatEvery': 'Repeat every', 'cal.unitWeeks': 'weeks', 'cal.unitDays': 'days', 'cal.onDays': 'on', 'cal.repeatEnd': 'Ends', 'cal.endNever': 'Never', 'cal.endAfter': 'After', 'cal.endTimes': 'times', 'cal.endOn': 'On', 'cal.endNeverHint': '“Never” = one year ahead', 'cal.seriesCreated': 'Created', 'cal.seriesSkipped': 'skipped (busy)', 'cal.wd.mon': 'Mo', 'cal.wd.tue': 'Tu', 'cal.wd.wed': 'We', 'cal.wd.thu': 'Th', 'cal.wd.fri': 'Fr', 'cal.wd.sat': 'Sa', 'cal.wd.sun': 'Su',
    'cal.call': 'Call', 'cal.write': 'Email',
    'cal.lastVisit': 'Last visit', 'cal.atMaster': 'with', 'cal.newClient': 'New client — no past visits', 'cal.addComment': 'Add comment', 'cal.commentPlaceholder': 'Comment on this visit…',
    'cal.history': 'Visit history', 'cal.showMore': 'Show more', 'cal.noHistory': 'No past visits',
    'cal.memVisits': 'visits', 'cal.memEvery': 'every', 'cal.memDays': 'days', 'cal.memAvgCheck': 'avg check', 'cal.memNoShows': 'no-shows',
    'push.enable': 'Enable notifications', 'push.enabled': 'Notifications enabled 🔔', 'push.denied': 'Please allow notifications in your browser',
    'cal.note': 'Comment', 'cal.products': 'Products / colors / materials',
    'cal.aiAdmin': 'AI Administrator', 'cal.aiActive': 'Active', 'cal.aiPausedBilling': 'Paused (billing)', 'cal.aiConnect': 'Connect',
    'cal.aiPromo': 'Salons with an AI administrator get 30–40% more bookings', 'cal.dialogs': 'Dialogs',
    'cal.bookingsStat': 'Bookings', 'cal.reschedules': 'Reschedules', 'cal.statToday': 'Today',
    'cal.statMonth': 'Month', 'cal.masters': 'Staff', 'cal.dayOff': 'Day off',
    'ms.book.title': 'Online booking', 'ms.book.service': 'Service', 'ms.book.branch': 'Location',
    'ms.book.master': 'Specialist', 'ms.book.anyMaster': 'Any specialist', 'ms.book.from': 'from', 'ms.book.date': 'Date', 'ms.book.time': 'Time',
    'ms.book.dayClosed': 'Closed', 'ms.book.dayFull': 'Fully booked', 'ms.book.dayClosedLong': 'The salon is closed on this day', 'ms.book.otherCategory': 'Other', 'ms.book.noSlots': 'No free slots on this day', 'ms.book.name': 'Your name', 'ms.book.phone': 'Phone',
    'ms.book.submit': 'Book', 'ms.book.success': 'You are booked!', 'ms.book.successWa': 'Confirmation sent to WhatsApp',
    'ms.book.taken': 'This time was just taken — pick another', 'ms.book.leadTitle': 'Leave a request',
    'ms.book.leadDate': 'Preferred date & time', 'ms.book.leadSent': 'Request sent! We will contact you shortly',
    'ms.book.minutes': 'min', 'ms.book.another': 'Book again',
    'ms.book.stepOf': 'Step {n} of {total}', 'ms.book.back': 'Back', 'ms.book.chooseBranch': 'Choose a location',
    'ms.book.chooseService': 'Choose a service', 'ms.book.chooseMaster': 'Choose a specialist', 'ms.book.chooseTime': 'Choose date & time',
    'ms.book.contact': 'Your details', 'ms.book.anyMasterHint': 'We will assign an available specialist for your time',
    'ms.book.phoneCheck': 'Please double-check your number — we will send your visit reminder there', 'ms.book.phoneLooksWrong': 'This number looks incomplete — please check it',
    'ms.book.consent': 'I agree to the {policy} and to receive visit reminders (WhatsApp / SMS)', 'ms.book.policy': 'privacy policy',
    'ms.book.addToCalendar': 'Add to calendar', 'ms.book.googleCal': 'Google Calendar', 'ms.book.writeWa': 'Message on WhatsApp',
    'ms.book.reminderTo': 'Your reminder will be sent to {phone}', 'ms.book.waHello': 'Hello! I have booked {service} on {date} at {time}.',
    'ms.book.total': 'Total', 'ms.book.noServicesHere': 'No services are available for online booking here yet — message us in the chat and we will find a time',
    'miniBuilder.autoTeam': 'Specialists are filled in automatically from the Team section',
    'miniBuilder.autoServices': 'Services & prices are filled in automatically from the Team section',
    'miniBuilder.autoOpen': 'Open Team',
    'settings.calendarTitle': 'Chatity Calendar', 'settings.calendarHint': 'Turn off if you keep bookings in your own CRM: the AI will not quote free slots — it will collect a request (name, phone, preferred time) and send it to you instantly',
    'settings.modeTitle': 'Operating mode', 'settings.modeHint': 'How the AI and the calendar work together',
    'settings.modeAutopilot': 'Autopilot', 'settings.modeAutopilotDesc': 'The AI picks free time per master and creates a confirmed booking in the calendar. You get a notification for every booking.',
    'settings.modeManual': 'Calendar without AI', 'settings.modeManualDesc': 'Calendar is on but the AI does not reply to clients. You manage bookings manually. Client messages are saved and delivered to you.',
    'settings.modeCrmOnly': 'Leads only (no calendar)', 'settings.modeCrmOnlyDesc': 'No calendar. The AI chats and collects requests (name, phone, wishes); you keep bookings in your own CRM.',
    'settings.timezone': "Salon time zone", 'settings.timezoneMissing': "— not set (Europe/Paris assumed) —", 'settings.timezoneSaved': "Time zone saved", 'settings.timezoneWarning': "Set your time zone: AI working hours, free slots and reminders depend on it.",
    'settings.aiScheduleScopeAll': "One schedule for all channels", 'settings.aiScheduleScopePerChannel': "Per channel", 'settings.aiScheduleAppliesTo': "Applies to", 'settings.aiScheduleChannelsHint': "Untick a channel to let the AI answer there 24/7 (e.g. website widget always, WhatsApp only outside business hours).", 'settings.aiScheduleCh.widget': "Website widget", 'settings.aiScheduleCh.whatsapp': "WhatsApp", 'settings.aiScheduleCh.instagram': "Instagram", 'settings.aiScheduleCh.phone': "Phone", 'settings.aiScheduleChEnabled': "Limit AI hours in \"{channel}\"", 'settings.aiSchedulePhoneHint': "Phone: outside AI hours the call is transferred to your transfer number (if set).",
    'settings.aiScheduleTitle': 'AI receptionist working hours', 'settings.aiScheduleHint': 'Outside these hours the AI stays silent — messages are saved and you get a notification. Salon time', 'settings.aiScheduleAlways': '24/7', 'settings.aiScheduleOn': 'On schedule', 'settings.aiScheduleDays': 'Mon,Tue,Wed,Thu,Fri,Sat,Sun', 'settings.aiScheduleOffMsg': 'Auto-reply outside AI hours (optional)', 'settings.aiScheduleOffMsgPh': 'E.g.: Thanks for your message! Our administrator will reply during working hours 💛', 'settings.aiScheduleOffMsgHint': 'Sent once per 12 hours per dialog. Leave empty and the AI simply stays silent.',
    'settings.deleteAccount': 'Delete Chatity account', 'settings.deleteWarn': 'Permanently deleted: your salon, the entire dialog history in all channels, clients, bookings, team, WhatsApp/Instagram connections (instances are disconnected); the subscription is cancelled. Data cannot be recovered.', 'settings.deleteTypeHint': 'Type DELETE to confirm:', 'settings.deleteConfirmBtn': 'Delete everything forever', 'settings.deleteCancel': 'Cancel', 'settings.deleteDone': 'Account and all data deleted',
    'settings.voiceTitle': 'AI voice replies', 'settings.voiceHint': 'The AI can answer clients in WhatsApp and Instagram with a voice message in addition to text. The voice speaks the client\'s language.', 'settings.voiceMode_off': 'Off', 'settings.voiceMode_off_desc': 'Text only', 'settings.voiceMode_voice_in': 'Voice for voice', 'settings.voiceMode_voice_in_desc': 'When a client sends a voice note, we reply with voice (recommended)', 'settings.voiceMode_always': 'Always', 'settings.voiceMode_always_desc': 'Every AI reply is also sent as a voice message', 'settings.voicePreview': 'Listen', 'settings.voiceStop': 'Stop', 'settings.voiceQuota': 'Characters this month',
    'settings.humanFirstTitle': "🙋 Human first: AI reply delay in WhatsApp/Instagram", 'settings.humanFirstHint': "The AI waits for the selected time before answering. If your team replies within that window (from the phone or from Messages), the AI stays silent. The website widget always answers instantly.", 'settings.humanFirst0': "No delay — AI answers immediately", 'settings.humanFirst30': "30 seconds", 'settings.humanFirst60': "1 minute", 'settings.humanFirst120': "2 minutes", 'settings.humanFirst300': "5 minutes", 'settings.humanFirst600': "10 minutes",
    'settings.manualPauseTitle': '⏸ AI pause after your manual reply', 'settings.manualPauseHint': 'When you reply to a client yourself (from your phone in WhatsApp/Instagram or from Messages), the AI goes silent in that dialog for the selected time. You can bring the AI back earlier from Messages.',
    'settings.manualPause1': '1 hour', 'settings.manualPause6': '6 hours', 'settings.manualPause24': '24 hours', 'settings.manualPause72': '3 days', 'settings.manualPause0': 'Until I re-enable it',
    'settings.brandingTitle': 'Remove Chatity branding', 'settings.brandingHint': 'The AI will not mention "Chatity" — it introduces itself neutrally as your salon\'s virtual assistant',
    'settings.introLabel': 'How the AI introduces itself', 'settings.introPlaceholder': 'E.g.: Hello! I\'m Mia — the virtual receptionist of Oui Beauté 💛',
    'settings.introHint': 'Automatically translated into the client\'s language. Leave empty for the default greeting.',
    'settings.languageTitle': 'Interface language',
    'subscription.freeForever': 'You are on the Free plan — calendar and mini-site are free forever',
    'subscription.freeForeverHint': 'Add the AI receptionist from €39/mo — it answers clients and books them for you',
    'team.loadError': 'Failed to load team data',
    'team.saved': 'Saved',
    'team.saveError': 'Failed to save',
    'team.deleted': 'Deleted',
    'team.inviteSent': 'Invitation sent by email',
    'team.inviteError': 'Failed to send invitation',
    'team.branchesTitle': 'Branches',
    'team.addBranch': 'Add branch',
    'team.branchesHint': 'AI sees your branches and asks the client which one to book',
    'team.mainBranch': 'Main',
    'team.editBranch': 'Edit branch',
    'team.branchName': 'Name',
    'team.branchAddress': 'Address',
    'team.branchPhone': 'Phone',
    'team.branchHours': 'Working hours',
    'team.branchHoursHint': 'Branch hours cap master schedules — AI will never offer slots outside them',
    'team.staffTitle': 'Team members',
    'team.addStaff': 'Add member',
    'team.noServicesWarning': 'No services assigned — AI and the calendar cannot book this master. Click to tick services',
    'team.staffHint': 'Invite masters and admins by email — they receive a one-time code to join',
    'team.noStaff': 'No team members yet — add your first master',
    'team.roleAdmin': 'Admin',
    'team.roleMaster': 'Master',
    'team.roleMasterDesc': 'sees only their own schedule',
    'team.roleAdminDesc': 'manages branch bookings',
    'team.joined': 'Joined',
    'team.invited': 'Invited',
    'team.noEmail': 'no email',
    'team.invite': 'Invite',
    'team.resendAccess': 'Restore access', 'team.accessSent': 'Access recovery email sent', 'team.resendHint': "Can't log in? Resend the email — the master sets a new password via the link and code (valid 24 hours).",
    'team.reinvite': 'Resend',
    'team.schedule': 'Schedule',
    'team.editStaff': 'Edit member',
    'team.staffName': 'Name',
    'team.forInvite': 'for invitation',
    'team.role': 'Role',
    'team.branches': 'Branches',
    'team.staffServices': 'Services',
    'team.addServicesFirst': 'Add services below first',
    'team.color': 'Calendar color',
    'team.planityTitle': 'Import schedule from Planity', 'team.planityHint': 'Paste this master\'s personal Planity iCal link — the system will automatically account for their busy time and only offer genuinely free slots.', 'team.planityCheck': 'Check', 'team.planityFound': 'busy slots found', 'team.planityError': 'Could not read the calendar',
    'team.scheduleFor': 'Schedule —',
    'team.dayOff': 'Day off',
    'team.photoUpload': 'Upload photo', 'team.photoChange': 'Change photo', 'team.photoRemove': 'Remove', 'team.photoHint': 'JPG/PNG/WebP up to 2 MB — shown on the mini-site',
    'team.allBranches': 'All branches', 'team.serviceBranches': 'Branches', 'team.serviceBranchesHint': 'Nothing selected — the service is offered in every branch. A branch price overrides the base price; master-level prices apply on top.', 'team.priceIn': 'Price in', 'team.duplicate': 'Duplicate', 'team.copySuffix': 'copy',
    'team.repeat': 'Schedule frequency', 'team.repeatHint': 'E.g. the master works this schedule every other week. No bookings are offered on the off weeks.', 'team.repeatWeekly': 'Every week', 'team.repeatEveryN': 'Every {n} weeks', 'team.repeatAnchor': 'First working week (any day of it)', 'team.repeatUntil': 'Until (optional)',
    'team.acceptsLower': 'Takes clients at lower levels when there are free slots', 'team.acceptsLowerHint': 'Online booking and the AI first offer masters of the requested level; if none is free at the wanted time — this master at the regular (base) price.', 'cal.priceAuto': 'Auto', 'ms.book.fallbackNote': 'Only a higher-level specialist is free at this time — we will book you at the regular price',
    'team.allServices': 'All services',
    'team.staffServicesHint': 'Tick the services this master provides. The AI and online booking book this master ONLY for ticked services (a master with none ticked cannot be booked). For ticked ones you can set their own duration and price — they override the service defaults.', 'team.ownDurationPrice': 'Own duration / price for this master',
    'team.category': 'Category', 'team.categoryPlaceholder': 'Nails / Brows / Hair', 'team.noCategory': 'No category', 'team.wholeCategory': 'whole category',
    'team.exceptions': 'Exceptions: vacation & special days', 'team.exceptionsHint': 'These days override the weekly schedule: online booking, AI and phone will not offer this time.',
    'team.excFrom': 'From', 'team.excTo': 'To', 'team.excDayOff': 'Day off', 'team.excCustom': 'Custom hours', 'team.excNote': 'Note (e.g. vacation)', 'team.excAdd': 'Add', 'team.excNone': 'No exceptions', 'team.excAdded': 'Exception added', 'team.excRemoved': 'Exception removed',
    'cal.vacation': 'Not working',
    'team.servicesTitle': 'Services & duration', 'team.levels': 'Master levels', 'team.level': 'Master level', 'team.levelNone': 'No level', 'team.priceByLevel': 'Price by master level', 'team.priceByLevelHint': 'Leave empty if the price is the same. Fill only the levels whose price differs from the base.', 'team.levelsTitle': 'Master levels', 'team.levelsHint': 'Names and stars as used in your salon. Shown to clients on the mini-site, in booking and in AI replies.', 'team.levelName': 'Name', 'team.addLevel': 'Add level',
    'team.addService': 'Add service',
    'team.servicesHint': 'Duration lets the AI offer real available time slots',
    'team.noServices': 'Add services with price and duration',
    'team.min': 'min',
    'team.editService': 'Edit service',
    'team.serviceName': 'Service name',
    'team.servicePrice': 'Price',
    'team.serviceDuration': 'Duration (min)',
    'team.save': 'Save',

    'partner.meta.title': 'Chatity Affiliate Program — 30% on every payment',
    'partner.meta.description': 'Earn 30% on every payment from referred customers. Affiliate links, analytics, payouts to your card.',
    'partner.nav.back': 'Chatity',
    'partner.nav.dashboard': 'Partner area →',
    'partner.badge': 'Affiliate program',
    'partner.hero.title1': 'Earn',
    'partner.hero.title2': 'on every payment from',
    'partner.hero.title3': 'your customers',
    'partner.hero.subtitle': 'Share your affiliate link, refer salons, clinics and studios — receive your share for life, as long as they pay.',
    'partner.feature.commission.title': '30% on every payment',
    'partner.feature.commission.desc': 'Recurring. Not just the first month.',
    'partner.feature.link.title': 'Your own referral code',
    'partner.feature.link.desc': 'Attribution lasts 30 days via cookie.',
    'partner.feature.dashboard.title': 'Analytics dashboard',
    'partner.feature.dashboard.desc': 'Clicks, signups, payments, balance.',
    'partner.feature.payout.title': 'Payouts to card / account',
    'partner.feature.payout.desc': 'From €20 / $25. 14-day hold.',
    'partner.form.title': 'Become a partner',
    'partner.form.subtitle': 'Fill in the form — get your link instantly.',
    'partner.form.name': 'Name',
    'partner.form.namePlaceholder': 'John Smith',
    'partner.form.email': 'Email',
    'partner.form.code': 'Desired code (optional)',
    'partner.form.channel': 'How will you promote?',
    'partner.form.channelPlaceholder': 'Marketing blog for salons, Telegram channel ...',
    'partner.form.submit': 'Get my link',
    'partner.form.submitting': 'Sending...',
    'partner.form.terms': 'By registering, you accept the affiliate program terms.',
    'partner.success.heading': 'Done!',
    'partner.success.title': 'Your affiliate link',
    'partner.success.copy': 'Copy link',
    'partner.success.openDashboard': 'Open partner dashboard',
    'partner.success.hint': '💡 To see stats, clicks and balance — sign in with the same email',
    'partner.toast.exists': 'You are already registered as a partner',
    'partner.toast.created': 'Application accepted! Your affiliate code is active.',
    'partner.toast.error': 'Could not submit application',
    'partner.toast.copied': 'Copied to clipboard',
    'partner.dash.title': 'Partner Dashboard',
    'partner.dash.loading': 'Loading...',
    'partner.dash.breadcrumb': 'Partner area',
    'partner.dash.backToClient': '← Back to client area',
    'partner.dash.refLinkLabel': 'Your affiliate link',
    'partner.dash.commissionInfo': 'Commission {pct}% • Hold {days} days',
    'partner.dash.copy': 'Copy',
    'partner.dash.copied': 'Copied',
    'partner.dash.stat.clicks': 'Clicks (total)',
    'partner.dash.stat.clicks30d': 'last 30 days: {n}',
    'partner.dash.stat.signups': 'Signups',
    'partner.dash.stat.paid': 'paying: {n}',
    'partner.dash.stat.earned': 'Total earned',
    'partner.dash.stat.pending': 'on hold: {amount}',
    'partner.dash.stat.available': 'Available',
    'partner.dash.stat.paidOut': 'paid out: {amount}',
    'partner.dash.payout.title': 'Payout details',
    'partner.dash.payout.subtitle': 'Fill in before your first payout request.',
    'partner.dash.payout.method': 'Method',
    'partner.dash.payout.methodPlaceholder': 'Choose method',
    'partner.dash.payout.method.card_ru': 'Card (Russia)',
    'partner.dash.payout.method.bank': 'Bank transfer',
    'partner.dash.payout.method.bank_ru': 'Legal entity (Russia)',
    'partner.dash.payout.method.sepa_eu': 'IBAN / SEPA transfer (Europe)',
    'partner.dash.payout.method.rib_eu': 'Bank details RIB (France)',
    'partner.dash.payout.method.paypal': 'PayPal',
    'partner.dash.payout.method.crypto': 'Cryptocurrency',
    'partner.dash.payout.region': 'Region',
    'partner.dash.payout.region.ru': 'International payout (EUR)',
    'partner.dash.payout.region.eu': 'Europe / International (EUR, USD)',
    'partner.dash.payout.field.cardNumber': 'Card number',
    'partner.dash.payout.field.fullName': 'Full name',
    'partner.dash.payout.field.companyName': 'Company name',
    'partner.dash.payout.field.inn': 'INN (tax ID)',
    'partner.dash.payout.field.kpp': 'KPP',
    'partner.dash.payout.field.bik': 'Bank BIK',
    'partner.dash.payout.field.account': 'Account number',
    'partner.dash.payout.field.bankName': 'Bank name',
    'partner.dash.payout.field.iban': 'IBAN',
    'partner.dash.payout.field.swift': 'SWIFT / BIC',
    'partner.dash.payout.field.ribBankCode': 'Bank code (5 digits)',
    'partner.dash.payout.field.ribBranchCode': 'Branch code (5 digits)',
    'partner.dash.payout.field.ribAccount': 'Account number (11 digits)',
    'partner.dash.payout.field.ribKey': 'RIB key (2 digits)',
    'partner.dash.payout.field.paypalEmail': 'PayPal Email',
    'partner.dash.payout.field.walletAddress': 'Wallet address',
    'partner.dash.payout.field.cryptoNetwork': 'Network',
    'partner.dash.payout.edit': 'Edit details',
    'partner.dash.payout.savedSummary': 'Saved',
    'partner.dash.request.max': 'Max',
    'partner.dash.request.maxHint': 'Use maximum available amount',
    'partner.dash.payout.details': 'Details',
    'partner.dash.payout.detailsPlaceholder': 'Card / account number / wallet address + full name',
    'partner.dash.payout.save': 'Save details',
    'partner.dash.payout.saved': 'Details saved',
    'partner.dash.payout.saveError': 'Could not save',
    'partner.dash.payout.fillFirst': 'Fill in method and details first',
    'partner.dash.request.title': 'Request payout',
    'partner.dash.request.available': 'Available',
    'partner.dash.request.min': 'min. €20',
    'partner.dash.request.amount': 'Amount',
    'partner.dash.request.currency': 'Currency',
    'partner.dash.request.submit': 'Request payout',
    'partner.dash.request.created': 'Payout request created',
    'partner.dash.referrals.title': 'Your referrals',
    'partner.dash.referrals.empty': 'No one has signed up via your link yet.',
    'partner.dash.referrals.email': 'Email',
    'partner.dash.referrals.business': 'Business',
    'partner.dash.referrals.plan': 'Plan',
    'partner.dash.referrals.status': 'Status',
    'partner.dash.referrals.payments': 'Payments',
    'partner.dash.referrals.earned': 'Earned',
    'partner.dash.referrals.paid': 'Paid',
    'partner.dash.referrals.trial': 'Trial',
    'partner.dash.payouts.title': 'Payout history',
    'partner.dash.payouts.empty': 'No payout requests yet.',
    'partner.dash.payouts.date': 'Date',
    'partner.dash.payouts.amount': 'Amount',
    'partner.dash.payouts.method': 'Method',
    'partner.dash.payouts.status': 'Status',
    'partner.dash.payouts.note': 'Note',
    'partner.onboard.title': 'Affiliate program',
    'partner.onboard.subtitle': 'Bring customers to Chatity and earn 30% on every payment they make. 14-day hold, payouts from €20.',
    'partner.onboard.name': 'Your name',
    'partner.onboard.code': 'Desired code (optional)',
    'partner.onboard.submit': 'Become a partner',
    'partner.onboard.success': 'Done! You are a partner.',
    'partner.onboard.error': 'Error',
    'partner.cta.badge': 'Earn from referrals',
    'partner.cta.title': 'Become a partner',
    'partner.cta.desc': 'Get 30% on every payment from customers you bring in',
    'partner.cta.button': 'Open program',
    'partner.footer': 'Partners',
    'shortLink.title': 'Short booking link',
    'shortLink.description': 'Give your clients a direct link to the chat widget. Perfect for Instagram bio, Linktree, business cards, ads. One click opens the AI chat instantly.',
    'shortLink.placeholder': 'oui-beaute',
    'shortLink.save': 'Save',
    'shortLink.saving': 'Saving...',
    'shortLink.copy': 'Copy',
    'shortLink.open': 'Open',
    'shortLink.qr': 'QR-code',
    'shortLink.qr.title': 'Your QR-code',
    'shortLink.qr.hint': 'Place it on print materials, business cards or shop window — scanning opens your mini-site.',
    'shortLink.qr.download': 'Download PNG',
    'shortLink.qr.close': 'Close',
    'shortLink.toast.qrDownloaded': 'QR-code downloaded',
    'shortLink.toast.qrDownloadFailed': 'Failed to download QR-code',
    'shortLink.status.checking': 'Checking...',
    'shortLink.status.available': 'Available',
    'shortLink.status.taken': 'Not available',
    'shortLink.status.currentLink': 'This is your current link',
    'shortLink.status.error': 'Error',
    'shortLink.reason.reserved': 'This slug is reserved by the system',
    'shortLink.reason.alreadyTaken': 'Already taken by another salon',
    'shortLink.reason.tooShort': 'Minimum 3 characters',
    'shortLink.reason.tooLong': 'Maximum 50 characters',
    'shortLink.reason.invalidChars': 'Only letters, digits and hyphens (no spaces or special characters)',
    'shortLink.toast.saved': 'Short link saved',
    'shortLink.toast.saveFailed': 'Failed to save',
    'shortLink.toast.copied': 'Link copied',
    'shortLink.badge.active': 'ACTIVE',
    'shortLink.badge.notSet': 'NOT SET',
    'notFound.title': 'Page not found',
    'notFound.headline': 'This page got lost',
    'notFound.subtitle': 'Maybe the link expired or has a typo. But Chatity AI never gets lost 😉',
    'notFound.cta.home': 'Go home',
    'notFound.cta.demo': 'Try AI demo',
    'notFound.helpfulLinks': 'Or try',
    'notFound.link.blog': 'Blog',
    'notFound.link.partner': 'Become a partner',
    'notFound.link.login': 'Log in',
    'notFound.link.support': 'Support',
    'miniSite.cta.chat': 'Get a consultation',
    'miniSite.bookNow': 'Book now',
    'miniSite.showPhone': 'Show',
    'miniSite.section.team': 'Specialists',
    'miniSite.onMap': 'On the map',
    'miniSite.services.viewAll': 'View all',
    'miniSite.services.collapse': 'Collapse',
    'miniBuilder.colors.title': 'Mini-site color',
    'miniBuilder.colors.hint': 'Accent color for buttons, prices and headings on the public page.',
    'miniBuilder.colors.preview': 'button preview',
    'miniBuilder.team.title': 'Specialists',
    'miniBuilder.team.add': 'Add specialist',
    'miniBuilder.team.name': 'Specialist name',
    'miniBuilder.team.role': 'Specialty (e.g. Nail master)',
    'miniBuilder.team.empty': 'Add your specialists — they will appear as cards on the mini-site with a "Book now" button.',
    'miniSite.section.about': 'About',
    'miniSite.empty': 'Salon description coming soon. Meanwhile — ask the AI on the right 👉',
    'miniSite.section.services': 'Services & prices',
    'miniSite.section.gallery': 'Gallery',
    'miniSite.section.contacts': 'Contacts & address',
    'miniSite.contact.phone': 'Phone',
    'miniSite.contact.address': 'Address',
    'miniSite.map.openInMaps': 'Open in Google Maps',
    'miniSite.section.hours': 'Working hours',
    'miniSite.contact.whatsapp': 'WhatsApp',
    'miniSite.contact.email': 'Email',
    'miniSite.gallery.close': 'Close (Esc)',
    'miniSite.gallery.prev': 'Previous',
    'miniSite.gallery.next': 'Next',
    'miniSite.translate.byAi': 'Translated automatically by AI',
    'miniSite.translate.showOriginal': 'Show original',
    'miniSite.translate.viewingOriginal': 'Viewing original',
    'miniSite.translate.translateBack': 'Translate to my language',
    'miniSite.translate.loading': 'Auto-translating…',
    'miniSite.translate.failed': 'Auto-translation failed. Showing original.',
    'tabs.clients': 'Clients',
    'bookings.historyLimitBanner': 'Bookings older than 30 days are available on the Professional plan',
    'clients.title': 'Client base',
    'clients.subtitle': 'Bookings are automatically merged by phone number (different formats are combined)',
    'clients.limitedNote': 'Starter plan shows clients from the last 30 days. Full history — on Professional',
    'clients.search': 'Search by name or phone',
    'clients.noClients': 'No clients yet',
    'clients.visits': 'bookings',
    'clients.firstVisit': 'First visit',
    'clients.lastVisit': 'Last visit',
    'clients.phones': 'All numbers',
    'clients.services': 'Services',
    'clients.source': 'Source',
    'clients.aiSummary': 'AI client summary', 'clients.aiSummaryBuild': 'Build summary', 'clients.aiSummaryRefresh': 'Refresh', 'clients.aiSummaryBusy': 'Analysing…', 'clients.aiSummaryHint': 'The AI reads the booking and chat history and describes the client briefly: visit rhythm, favourite services, preferences and what to offer next.', 'clients.aiRisk': 'Churn risk', 'clients.aiRhythm': 'Visit rhythm', 'clients.aiFavorites': 'Favourite services', 'clients.aiNextOffer': 'What to offer', 'clients.aiGenerated': 'Generated',
    'clients.history': 'Booking history',
    
    // Upgrade banners for features
    'upgrade.telegram.title': 'Telegram notifications available on Professional and Unlimited plans',
    'upgrade.telegram.button': 'Upgrade Plan',
    'upgrade.widget.title': 'Widget Customization',
    'upgrade.widget.description': 'Customize widget appearance for your brand on Professional or Unlimited plans:',
    'upgrade.widget.feature1': 'Change widget colors',
    'upgrade.widget.feature2': 'Customize welcome message',
    'upgrade.widget.feature3': 'Personalize bot name',
    'upgrade.widget.button': 'Upgrade Plan',
    'bookings.subtitle': 'All client bookings',
    'bookings.autoUpdate': 'Auto-update every 10 sec',
    'bookings.refresh': 'Refresh',
    'bookings.noBookings': 'No bookings yet',
    'bookings.client': 'Client',
    'bookings.phone': 'Phone',
    'bookings.service': 'Service',
    'bookings.date': 'Date',
    'bookings.created': 'Booking',
    'bookings.newBooking': 'New booking! Total:',
    'bookings.storageInfo': '📋 Bookings stored for 30 days',
    'bookings.unlimitedStorageInfo': 'Use Excel export for long-term storage of booking history',
    'bookings.upgradeForExport': 'Upgrade to Unlimited plan to export bookings to Excel',
    'bookings.exportExcel': 'Export to Excel',
    'bookings.exportSuccess': 'Bookings exported successfully',
    'bookings.exportUnlimitedOnly': 'Export is only available for Unlimited plan',
    'bookings.exportError': 'Export error',
    
    // Widget
    'widget.title': 'Widget Code',
    'widget.subtitle': 'Insert this code on your site before closing tag',
    'widget.copy': 'Copy Code',
    'widget.demo': 'Open Demo',
    'widget.copied': 'Code copied to clipboard!',
    'widget.status.title': 'Widget Installation Status',
    'widget.status.unchecked': 'Click "Check" to verify installation',
    'widget.status.checking': 'Checking...',
    'widget.status.active': 'Active • Last activity: {time}',
    'widget.status.configured': 'Configured, waiting for first message',
    'widget.status.inactive': 'Not installed or not working',
    'widget.status.checkButton': '🔍 Check',
    'widget.status.successToast': '✅ Widget is active and working!',
    'widget.status.configuredToast': '🟡 Widget configured, but no activity yet',
    'widget.status.errorToast': '🔴 Widget not installed or not working',
    
    // Integrations
    'integrations.title': 'Integrations',
    'integrations.subtitle': 'Integrate Chatity widget on your website',
    'integrations.yourWidgetKey': 'Your Widget Key',
    'integrations.copyKey': 'Copy Key',
    'integrations.copyInstructions': 'Copy Instructions',
    'integrations.instructionsCopied': 'Instructions copied!',
    'integrations.keyCopied': 'Key copied!',
    'integrations.sendToDeveloper': 'Send to Developer',
    'integrations.developerEmail': 'Developer Email',
    'integrations.developerEmailPlaceholder': 'developer@example.com',
    'integrations.send': 'Send',
    'integrations.emailSent': 'Instructions sent!',
    'integrations.wordpress.title': 'WordPress Plugin',
    'integrations.wordpress.description': 'Easy installation for WordPress websites. Just install the plugin and enter your widget key.',
    'integrations.wordpress.download': 'Download Plugin',
    'integrations.html.title': 'HTML / JavaScript',
    'integrations.html.description': 'Universal method for any website',
    'integrations.html.step1': 'Copy the widget code above',
    'integrations.html.step2': 'Paste the code before the closing </body> tag on your website',
    'integrations.webflow.description': 'For Webflow websites',
    'integrations.webflow.step1': 'Open your Webflow project settings',
    'integrations.webflow.step2': 'Go to Custom Code → Footer Code',
    'integrations.webflow.step3': 'Paste the copied widget code',
    'integrations.webflow.step4': 'Save and publish your site',
    'integrations.twilio.title': 'Twilio Voice AI',
    'integrations.twilio.description': 'AI assistant for handling incoming calls',
    'integrations.twilio.phoneNumber': 'Your phone number',
    'integrations.twilio.status': 'Status',
    'integrations.twilio.enabled': 'Enabled',
    'integrations.twilio.disabled': 'Disabled',
    'integrations.twilio.enable': 'Enable',
    'integrations.twilio.disable': 'Disable',
    'integrations.twilio.webhookUrl': 'Webhook URL for Twilio setup',
    'integrations.twilio.instructions': 'Configure webhook in your Twilio account',
    'integrations.twilio.credentials': 'Twilio Credentials',
    'integrations.twilio.credentialsInfo': 'Enter your credentials from Twilio Console',
    'integrations.twilio.credentialsRequired': 'Please fill in all Twilio fields',
    'integrations.twilio.voiceLanguage': 'Voice Assistant Language',
    'integrations.twilio.voiceSpeed': 'Speech Rate',
    'integrations.twilio.howItWorks': 'How it works',
    'integrations.twilio.step1': '1. Client calls your number',
    'integrations.twilio.step2': "2. AI answers in the client's language",
    'integrations.twilio.step3': '3. Collects booking information',
    'integrations.twilio.step4': '4. Automatically creates booking in your dashboard',
    'integrations.shopify.description': 'For Shopify online stores',
    'integrations.shopify.step1': 'Login to your Shopify admin panel',
    'integrations.shopify.step2': 'Go to Online Store → Themes',
    'integrations.shopify.step3': 'Click Actions → Edit code',
    'integrations.shopify.step4': 'Open theme.liquid file in Layout folder',
    'integrations.shopify.step5': 'Paste the widget code before the closing </body> tag and save',
    'integrations.wix.description': 'For Wix websites (Premium required)',
    'integrations.wix.step1': 'Open your Wix site editor',
    'integrations.wix.step2': 'Go to Settings → Custom Code',
    'integrations.wix.step3': 'Click + Add Custom Code',
    'integrations.wix.step4': 'Paste the widget code, select "Load code on each new page" and place "Body - end"',
    'integrations.tilda.description': 'For Tilda websites',
    'integrations.tilda.step1': 'Open page settings in Tilda',
    'integrations.tilda.step2': 'Go to "More" → "HTML code for website"',
    'integrations.tilda.step3': 'Paste the widget code in "Before </body>" field',
    'integrations.tilda.step4': 'Save and publish the page',
    'integrations.squarespace.description': 'For Squarespace websites',
    'integrations.squarespace.step1': 'Login to your Squarespace admin panel',
    'integrations.squarespace.step2': 'Go to Settings → Advanced → Code Injection',
    'integrations.squarespace.step3': 'Paste the widget code in the Footer field',
    'integrations.squarespace.step4': 'Click Save',
    'integrations.gtm.description': 'For advanced users with Google Tag Manager',
    'integrations.gtm.step1': 'Login to Google Tag Manager',
    'integrations.gtm.step2': 'Create a new Tag → Custom HTML',
    'integrations.gtm.step3': 'Paste the widget code',
    'integrations.gtm.step4': 'Set trigger to All Pages',
    'integrations.gtm.step5': 'Save, test and publish the container',
    
    // Admin
    'admin.title': 'Super-Admin Panel',
    'admin.subtitle': 'Platform statistics and all salons',
    'admin.users': 'Users',
    'admin.salons': 'Salons',
    'admin.bookings': 'Bookings',
    'admin.allSalons': 'All platform salons',
    'admin.registered': 'Registered',
    'admin.loading': 'Loading...',
    'admin.allSalons': 'All Salons',
    'admin.email': 'Email',
    'admin.plan': 'Plan',
    'admin.status': 'Status',
    'admin.bookings': 'Bookings',
    'admin.registered': 'Registered',
    'admin.showingYourSalon': 'Showing only your salon (for demo)',
    
    // Subscription
    'subscription.title': 'Subscription Management',
    'subscription.subtitle': 'Choose a plan that fits your business',
    'subscription.trialLeft': 'Trial period:',
    'subscription.daysLeft': 'days left',
    'subscription.price': '7 days free, then €39/month',
    'subscription.manageBilling': 'Manage subscription',
    'subscription.manageBillingDesc': 'Cancel subscription, update card, download invoices',
    'subscription.manageBillingBtn': 'Open portal',
    'subscription.portalError': 'Failed to open the billing portal',
    'subscription.invoice': 'Invoice',
    'subscription.invoiceUnavailable': 'Invoice is not available for this payment',
    'subscription.button': 'Subscribe',
    'subscription.error': 'Subscription error',
    'subscription.currentPlan': 'Current Plan',
    'subscription.trialPeriod': 'Trial Period',
    'subscription.daysRemaining': 'remaining',
    'subscription.day': 'day',
    'subscription.days': 'days',
    'subscription.expired': 'Trial period expired',
    'subscription.usage': 'Conversation Usage',
    'subscription.used': 'used',
    'subscription.selectPlan': 'Select',
    'subscription.currentPlanBadge': 'Current Plan',
    'subscription.popular': 'Popular',
    'subscription.idealForStart': 'Perfect for starting',
    'subscription.forGrowingBusiness': 'For growing business',
    'subscription.forLargeBusiness': 'For large business',
    'subscription.conversationsPerMonth': 'conversations per month',
    'subscription.unlimited': 'Unlimited conversations',
    'subscription.aiAssistant': 'AI Assistant',
    'subscription.telegramNotifications': 'Telegram notifications',
    'subscription.emailNotifications': 'Email notifications',
    'subscription.widgetCustomization': 'Widget customization',
    'subscription.analytics': 'Analytics',
    'subscription.extendedAnalytics': 'Extended analytics',
    'subscription.prioritySupport': 'Priority support',
    'subscription.utmTracking': 'UTM tracking',
    'subscription.knowledgeBase': 'AI Knowledge Base',
    'subscription.securePayment': 'Secure Payment',
    'subscription.securePaymentInfo': 'All payments are processed through Stripe. We do not store your card data.',
    'subscription.cancelAnytime': 'Cancel anytime',
    'subscription.cancelInfo': 'You can cancel your subscription at any time.',
    'subscription.checkingPayment': 'Checking payment status...',
    'subscription.paymentSuccess': 'Payment successful! Your plan has been upgraded',
    'subscription.paymentFailedTitle': 'Subscription payment issue',
    'subscription.paymentFailedText': 'Your bank declined the charge. The AI receptionist is paused in all channels (website, WhatsApp, Instagram, phone) until the payment goes through. Update your card to resume.',
    'subscription.updateCardBtn': 'Update card',
    'subscription.paymentCancelled': 'Payment cancelled',
    'subscription.paymentTimeout': 'Payment check took too long',
    'subscription.sessionExpired': 'Payment session expired',
    'subscription.paymentCheckError': 'Error checking payment status',
    'subscription.checkoutError': 'Error creating checkout session',
    'subscription.paymentHistory': 'Payment History',
    'subscription.date': 'Date',
    'subscription.plan': 'Plan',
    'subscription.amount': 'Amount',
    'subscription.status': 'Status',
    'subscription.paid': 'Paid',
    'subscription.pending': 'Pending',
    'subscription.failed': 'Failed',
    'subscription.monthly': 'Monthly',
    'subscription.yearly': 'Yearly',
    'subscription.year': 'year',
    'subscription.save2Months': 'Save 2 months!',
    'subscription.upgradeToYearly': 'Upgrade to Yearly',
    'subscription.creditApplied': 'Credit applied for remaining period',
    'subscription.renewalDate': 'Next renewal',
    
    // Promocodes
    'promocode.title': 'Have a promo code?',
    'promocode.placeholder': 'ENTER CODE',
    'promocode.apply': 'Apply',
    'promocode.remove': 'Remove',
    'promocode.discount': 'discount',
    'promocode.applied': 'Promo code applied!',
    'promocode.error': 'Invalid promo code',
    'promocode.enterCode': 'Enter promo code',
    'subscription.trialBannerTitle': 'Trial Period',
    'subscription.trialExpiredTitle': 'Trial Period Expired',
    'subscription.selectPlanBeforeExpiry': 'Select a plan before trial expires to continue using',
    'subscription.payToContinue': 'Pay for subscription to continue',
    'subscription.selectPlanButton': 'Select Plan',
    'subscription.payButton': 'Pay',
    'subscription.activeSubscription': 'Subscription Active',
    'subscription.conversations': 'Conversations',
    'subscription.remaining': 'remaining',
    'subscription.upgradePlan': 'Upgrade Plan',
    'tabs.subscription': 'Subscription',
    
    // Support Tickets
    'support.supportTickets': 'Support Tickets',
    'support.askOurTeam': 'Ask our team a question',
    'support.createTicket': 'Create Ticket',
    'support.cancel': 'Cancel',
    'support.newTicket': 'New Ticket',
    'support.subject': 'Subject',
    'support.subjectPlaceholder': 'Brief description of the issue',
    'support.priority': 'Priority',
    'support.priorityLow': 'Low',
    'support.priorityMedium': 'Medium',
    'support.priorityHigh': 'High',
    'support.message': 'Message',
    'support.messagePlaceholder': 'Describe your problem in detail...',
    'support.noTicketsYet': "You don't have any tickets yet",
    'support.createFirstTicket': 'Create your first ticket if you have questions',
    'support.messagesCount': 'Messages',
    'support.statusOpen': 'Open',
    'support.statusInProgress': 'In Progress',
    'support.statusClosed': 'Closed',
    'support.backToList': 'Back to list',
    'support.supportTeam': 'Support',
    'support.you': 'You',
    'support.reply': 'Reply',
    'support.enterYourMessage': 'Enter your message...',
    'support.send': 'Send',
    'support.ticketClosed': 'This ticket is closed',
    'support.errorLoadingTicket': 'Error loading ticket',
    'support.fillAllFields': 'Fill in all fields',
    'support.ticketCreated': 'Ticket created successfully!',
    'support.errorCreatingTicket': 'Error creating ticket',
    'support.messageSent': 'Message sent',
    'support.errorSendingMessage': 'Error sending message',
    
    // Admin
    'admin.title': 'Super Admin Panel',
    'admin.subtitle': 'Complete platform statistics',
    'admin.days': 'days',
    'admin.allTime': 'All Time',
    'admin.totalUsers': 'Total Users',
    'admin.totalBookings': 'Total Bookings',
    'admin.paidVsTrial': 'Paid / Trial',
    'admin.conversion': 'Conversion',
    'admin.periodStats': 'Period Statistics',
    'admin.newUsers': 'New Users',
    'admin.newSalons': 'New Salons',
    'admin.newBookings': 'New Bookings',
    'admin.loading': 'Loading...',
    
    // Common
    'common.loading': 'Loading...',
    'common.error': 'Error loading data',
    
    // Landing Page
    'landing.home': 'Home',
    'landing.hero.title': 'More bookings. More revenue. No missed clients.',
    'landing.hero.subtitle': 'Chatity\'s AI receptionist replies to clients 24/7, handles every inquiry and turns them into bookings.',
    'landing.hero.benefit1': 'More leads without hiring staff',
    'landing.hero.benefit2': 'Zero missed opportunities',
    'landing.hero.benefit3': 'Setup in 5 minutes on any website',
    'landing.hero.cta': 'Start Free',
    'landing.hero2.eyebrow': 'AI front desk for beauty & wellness',
    'landing.hero2.title': 'More bookings. More revenue. No missed clients.',
    'landing.hero2.subtitle': 'Chatity\'s AI receptionist replies to clients 24/7, handles every inquiry and turns it into a booking.',
    'landing.hero2.chWebsite': 'Website',
    'landing.hero2.chVoice': 'Voice',
    'landing.hero2.soon': 'coming soon',
    'landing.hero2.demo': 'See how it works',
    'landing.hero2.nocard': 'No credit card required · Setup in 5 minutes',
    'landing.hero2.hours': 'h',
    'landing.hero2.stat1': 'more bookings',
    'landing.hero2.stat2': 'admin work / month',
    'landing.hero2.stat3': 'never miss a client',
    'landing.hero2.newBooking': 'New booking!',
    'landing.cta2.eyebrow': 'Ready to get more bookings?',
    'landing.cta2.title': 'Start free today',
    'landing.cta2.note': 'No credit card required · Setup in 5 minutes · Cancel anytime',
    'landing.cta2.join': 'Join hundreds of beauty and wellness businesses',
    'landing.hero.trial': '7 days free • No card required',
    'landing.login': 'Login',
    
    // Trust section
    'landing.trust.title': 'Trusted By',
    'landing.trust.subtitle': 'Already using Chatity for booking automation:',
    'landing.trust.category1': 'Beauty Salons',
    'landing.trust.category2': 'Clinics & Dental',
    'landing.trust.category3': 'Yoga & Fitness Studios',
    'landing.trust.category4': 'Online Schools',
    'landing.trust.category5': 'Service Companies',
    'landing.trust.case1.niche': 'Beauty Salon',
    'landing.trust.case1.metric': 'Noticeable increase in bookings',
    'landing.trust.case1.description': 'More online appointments through the website',
    'landing.trust.case1.usecase': 'Chat helped answer procedure questions, guide clients, and streamline appointment requests',
    'landing.trust.case2.niche': 'Dental Clinic',
    'landing.trust.case2.metric': 'After-hours inquiries',
    'landing.trust.case2.description': 'Most new inquiries arrive outside business hours',
    'landing.trust.case2.usecase': 'The AI assistant helps filter requests, explain services, and route patients correctly',
    'landing.trust.case3.niche': 'Yoga Studio',
    'landing.trust.case3.metric': 'Less repetitive work',
    'landing.trust.case3.description': 'Reduced time spent on repetitive inquiries',
    'landing.trust.case3.usecase': 'Chat explains classes, schedules, and pricing before passing warm leads to staff',
    'landing.trust.case4.niche': 'Online School',
    'landing.trust.case4.metric': 'Higher engagement',
    'landing.trust.case4.description': 'Higher lead engagement from website visitors',
    'landing.trust.case4.usecase': 'Chat answers questions about courses, pricing, and trial lessons',
    'landing.trust.case5.niche': 'Auto Service',
    'landing.trust.case5.metric': 'Steady growth',
    'landing.trust.case5.description': 'Steady increase in booking requests',
    'landing.trust.case5.usecase': 'Chat collects vehicle details, issues, and helps organize service requests',
    'landing.trust.case6.niche': 'Restaurant',
    'landing.trust.case6.metric': 'More consistent bookings',
    'landing.trust.case6.description': 'More consistent table reservations',
    'landing.trust.case6.usecase': 'Chat accepts booking requests and answers menu and availability questions',
    
    // Integrations section
    'landing.integrations.title': 'Easy Integration',
    'landing.integrations.subtitle': 'Install the chat on any platform in 5 minutes',
    'landing.integrations.cta': 'Works with any website builder and CMS',
    'landing.integrations.button': 'Start Free',
    
    // Business types for animation
    'landing.business.beautySalon': 'beauty salon',
    'landing.business.restaurant': 'restaurant',
    'landing.business.dentalClinic': 'dental clinic',
    'landing.business.medicalCenter': 'medical center',
    'landing.business.barbershop': 'barbershop',
    'landing.business.nailStudio': 'nail studio',
    'landing.business.yogaStudio': 'yoga studio',
    'landing.business.carService': 'car service',
    
    'landing.features.title': 'Everything for booking automation',
    'landing.feature1.title': 'AI Conversation',
    'landing.feature1.desc': 'Bot has natural conversations, learns service, date, name and phone',
    'landing.feature2.title': 'Email & Telegram Notifications',
    'landing.feature2.desc': 'Instant booking notifications to your Email or Telegram group',
    'landing.feature3.title': 'Multilingual',
    'landing.feature3.desc': 'Automatically speaks client\'s language (14+ languages)',
    'landing.feature4.title': 'Ready Widget',
    'landing.feature4.desc': 'Insert code on website - and it works',
    'landing.feature5.title': 'Booking History',
    'landing.feature5.desc': 'All bookings saved in dashboard',
    'landing.feature6.title': 'Design Customization',
    'landing.feature6.desc': 'Colors, texts and style for your brand',
    'landing.feature7.title': 'Website Builder',
    'landing.feature7.desc': 'A ready-made chatity.io/your-name page with services, photos and AI chat — perfect for Instagram and business cards',
    'landing.builder.badge': 'New',
    'landing.builder.title': 'Website Builder — your salon site in 5 minutes',
    'landing.builder.subtitle': 'No separate website needed — build your business page right inside Chatity, no designers or developers required',
    'landing.builder.point1': 'Your own chatity.io/your-salon page with services, prices, gallery and map',
    'landing.builder.point2': 'Built-in AI chat answers clients and books appointments 24/7',
    'landing.builder.point3': 'QR code and short link for Instagram, business cards and your shop window',
    'landing.builder.point4': 'Automatic page translation into the visitor\'s language',
    'landing.builder.cta': 'Create your website free',
    'landing.builder.mock.services': 'Services & prices',
    'landing.builder.mock.chat': 'Hi! Would you like to book? 💬',
    'landing.partnerBlock.badge': 'Affiliate program',
    'landing.partnerBlock.title': 'Become a partner — earn 30%',
    'landing.partnerBlock.subtitle': 'Recommend Chatity and earn 30% of every payment made by clients you refer. Personal link, real-time stats and payouts on request.',
    'landing.partnerBlock.point1': '30% of every payment from referred clients',
    'landing.partnerBlock.point2': 'Personal referral link and promo code',
    'landing.partnerBlock.point3': 'Partner dashboard with stats and balance',
    'landing.partnerBlock.cta': 'Become a partner',
    'auth.referralCode': 'Referral code (optional)',
    'dashboard.partnerProgram': 'Affiliate',
    'bookings.totalCount': 'Total requests',
    'bookings.uniqueClients': 'Unique clients',
    'bookings.repeatBadge': 'Repeat',
    'dashboard.affiliateBlock.title': 'Affiliate program',
    'dashboard.affiliateBlock.desc': 'Refer other salons and earn 30% of all their payments to your balance. Payouts to card or IBAN (Europe).',
    'dashboard.affiliateBlock.cta': 'Open partner dashboard',
    'partner.dash.payout.method.card_eu': 'Bank card (Europe)',
    'partner.dash.payout.subtitleEu': 'Payouts in Europe only: bank card or IBAN/SEPA (EUR).',
    'landing.howItWorks.title': 'How it works',
    'landing.step1.title': 'Register',
    'landing.step1.desc': 'Create account in 30 seconds',
    'landing.step2.title': 'Setup',
    'landing.step2.desc': 'Connect Email/Telegram and customize design',
    'landing.step3.title': 'Embed',
    'landing.step3.desc': 'Insert widget code on your site',
    'landing.step4.title': 'Bookings',
    'landing.step4.desc': 'Receive bookings automatically',
    'landing.pricing.title': 'Choose Your Plan',
    'landing.pricing.subtitle': '7 days free trial on any plan',
    'landing.price.perMonth': 'per month',
    'landing.price.feature1': "AI speaks your client's language",
    'landing.price.calendar': 'Booking calendar + online booking',
    'landing.price.feature2': 'Email notifications',
    'landing.price.feature3': 'Booking history (30 days)',
    'landing.price.feature4': 'AI Knowledge Base',
    'landing.price.feature5': 'Basic analytics',
    'landing.price.cta': 'Start Free Trial',
    
    'landing.plan.popular': 'POPULAR',
    'landing.plan.starter.name': 'Starter',
    'landing.plan.starter.desc': 'For independent professionals',
    'landing.plan.starter.limit': '100 conversations/month',
    'landing.plan.professional.name': 'Professional',
    'landing.plan.professional.desc': 'For growing salons',
    'landing.plan.professional.limit': '1,000 conversations/month',
    'landing.plan.free.name': 'Free', 'landing.plan.free.desc': 'Calendar, online booking, mini-site',
    'landing.plan.free.limit': '1 staff member · 1 location',
    'landing.plan.free.f1': 'Booking calendar', 'landing.plan.free.f2': 'Online booking on your mini-site',
    'landing.plan.free.f3': 'Salon mini-site', 'landing.plan.free.f4': 'Email & Telegram notifications',
    'landing.plan.starter.tagline': 'AI handles your client messages and bookings',
    'landing.plan.starter.channels': '1 channel (WhatsApp / Instagram / Telegram) + web widget',
    'landing.plan.professional.tagline': 'Let AI manage conversations across all your channels',
    'landing.plan.professional.channels': 'All channels: WhatsApp + Instagram + Telegram + widget',
    'landing.plan.addons': 'Add-ons: extra channel +€19/mo · +100 conversations +€10/mo · extra location +50% of plan',
    'landing.freecrm.badge': 'START FREE TODAY', 'landing.freecrm.title': 'Free CRM for beauty',
    'landing.freecrm.subtitle': 'Calendar, online booking and a mini-site — €0. Forever. No card required.',
    'landing.freecrm.f1.title': 'Calendar', 'landing.freecrm.f1.desc': 'Bookings, staff, schedules and client history',
    'landing.freecrm.f2.title': 'Online booking', 'landing.freecrm.f2.desc': 'Clients pick free slots themselves 24/7',
    'landing.freecrm.f3.title': 'Mini-site', 'landing.freecrm.f3.desc': 'Your salon page with services and prices in 2 minutes',
    'landing.freecrm.note': 'Need the AI receptionist? Add a channel from €39/mo',
    'landing.freecrm.button': 'Start free today',
    'landing.plan.professional.feature1': 'Telegram notifications',
    'landing.plan.professional.feature2': 'Advanced analytics',
    'landing.plan.professional.feature3': 'UTM tracking',
    'landing.plan.professional.feature4': 'Website Builder + QR link',
    'landing.plan.professional.extraFeature': 'Widget customization',
    'landing.plan.unlimited.name': 'Unlimited',
    'landing.plan.unlimited.desc': 'For large business',
    'landing.plan.unlimited.limit': '∞ Unlimited conversations',
    'landing.plan.unlimited.feature1': 'Excel export',
    'landing.plan.unlimited.feature2': 'Extended customization',
    'landing.plan.unlimited.extraFeature1': 'Priority support',
    'landing.plan.unlimited.extraFeature2': 'Custom settings',
    'landing.cta.title': 'Ready to automate bookings?',
    'landing.cta.subtitle': 'Join hundreds of businesses already using Chatity',
    'landing.cta.button': 'Start free trial',
    'landing.footer.product': 'Product',
    'landing.footer.features': 'Features',
    'landing.footer.pricing': 'Pricing',
    'landing.footer.docs': 'Documentation',
    'landing.footer.company': 'Company',
    'landing.footer.about': 'About',
    'landing.footer.contact': 'Contact',
    'landing.footer.rights': '© 2025 Chatity. All rights reserved.',

    // Footer
    'footer.description': 'AI front desk for beauty & wellness',
    'footer.product': 'Product',
    'footer.features': 'Features',
    'footer.pricing': 'Pricing',
    'footer.getStarted': 'Get Started',
    'footer.legal': 'Legal',
    'footer.privacyPolicy': 'Privacy Policy',
    'footer.termsOfService': 'Terms of Service',
    'footer.cookiePolicy': 'Cookie Policy',
    'footer.contact': 'Contact',
    'footer.address': '7 Avenue de Fabron, 06200 Nice, France',
    'footer.allRightsReserved': 'All rights reserved.',
    
    // Cookie Consent
    'cookies.title': '🍪 We use cookies',
    'cookies.description': 'We use cookies to improve site performance, analyze traffic, and personalize content. By continuing to use the site, you agree to the use of cookies.',
    'cookies.learnMore': 'Learn more',
    'cookies.accept': 'Accept all',
    'cookies.decline': 'Essential only',
    
    // Admin Actions
    'admin.grantUnlimited': 'Grant Unlimited',
    'admin.deleteAccount': 'Delete Account',
    'admin.confirmDelete': 'Are you sure you want to delete this account? All user data will be permanently deleted.',
    'admin.confirmGrant': 'Grant unlimited plan to this user?',
    'admin.unlimitedGranted': 'Unlimited plan granted successfully',
    'admin.accountDeleted': 'Account deleted successfully',
    'admin.error': 'Error performing operation',

    // Blog
    'blog.title': 'Blog',
    'blog.subtitle': 'Useful articles about business automation and AI technologies',
    'blog.readMore': 'Read more',
    'blog.minRead': 'min read',
    'blog.noPosts': 'Articles coming soon',
    'blog.backToBlog': 'Back to blog',
    'blog.notFound': 'Article not found',
    'blog.relatedPosts': 'Related articles',
    'blog.ctaTitle': 'Ready to automate your business?',
    'blog.ctaDescription': 'Try Chatity free for 7 days. No credit card required.',
    'blog.ctaButton': 'Start free trial',

    // Green API (WhatsApp by QR)
    'greenapi.title': 'WhatsApp via QR code',
    'greenapi.badgeConnected': 'Connected',
    'greenapi.badgeWaiting': 'Waiting for QR scan',
    'greenapi.badgeNotConnected': 'Not connected',
    'greenapi.description': 'The easiest way: scan a QR code in the WhatsApp app — just like WhatsApp Web. The number stays on your phone, the AI starts replying to clients right away.',
    'greenapi.connectedPhone': '✅ Connected number: +{phone}',
    'greenapi.importBtn': '📥 Import clients from WhatsApp',
    'greenapi.refreshChats': 'Refresh', 'greenapi.syncingChats': 'The chat list is syncing from WhatsApp — it takes 1–2 minutes after scanning the QR. Press “Refresh”.',
    'greenapi.importHint': 'Choose which chats to import into “Clients” — you can skip personal contacts. The AI will know the chat history and continue conversations in context.',
    'greenapi.qrHint': 'WhatsApp → Settings → Linked devices → Link a device → scan',
    'greenapi.qrNotWorking': 'QR not scanning? Refresh the QR code', 'greenapi.qrRefreshing': 'Restarting the connection — a new QR appears in 1–2 minutes', 'greenapi.qrRefreshFailed': 'Could not refresh the QR, please try again',
    'greenapi.qrStarting': '⏳ Instance is starting, the QR will appear within a minute…',
    'greenapi.connectBtn': 'Connect via QR',
    'greenapi.disconnectBtn': 'Disconnect',
    'greenapi.confirmDisconnect': 'Disconnect WhatsApp? The instance will be deleted.',
    'greenapi.toastCreated': 'Instance created — the QR code will appear in ~1 minute',
    'greenapi.toastCreateFail': 'Failed to create the connection',
    'greenapi.toastDisconnected': 'WhatsApp disconnected',
    'greenapi.toastDisconnectFail': 'Failed to disconnect',
    'greenapi.toastImported': 'New clients imported: {imported}',
    'greenapi.toastImportFail': 'Failed to import chats',
    'greenapi.selectTitle': 'Which chats to import?',
    'greenapi.selectHint': 'Check the clients you want to import. Uncheck personal contacts — they will not be added.',
    'greenapi.searchPlaceholder': 'Search by name or number…',
    'greenapi.selectAll': 'Select all',
    'greenapi.deselectAll': 'Deselect all',
    'greenapi.alreadyImported': 'already imported',
    'greenapi.importSelected': 'Import selected ({n})',
    'greenapi.loadingChats': 'Loading chats…',
    'greenapi.noChats': 'No personal chats found',
    'greenapi.importing': 'Importing…',
    'greenapi.aiOn': '🤖 AI replies',
    'greenapi.aiOff': '🚫 Personal — AI muted',
    'greenapi.contactsTitle': 'WhatsApp contacts',
    'greenapi.contactsHint': 'Choose who the AI talks to and who it stays silent with (personal chats)',
    'greenapi.aiReplies': 'AI replies',
    'greenapi.aiSilent': 'AI muted',
    'greenapi.disableAllAi': 'Disable AI for all',
    'greenapi.enableAllAi': 'Enable AI for all',
    'greenapi.personalHint': 'Click the “AI” button next to a chat to stop the AI from replying in personal conversations. If you reply to a client manually from your phone, the AI stays silent in that chat for 6 hours.',
    'greenapi.toastPersonalOn': 'The AI will no longer reply in this chat',
    'greenapi.toastPersonalOff': 'The AI replies in this chat again',
    'greenapi.stepCreated': 'Instance created',
    'greenapi.stepStarting': 'Starting on WhatsApp servers — usually 1–3 minutes, sometimes up to 5',
    'greenapi.stepQr': 'The QR code will appear here automatically',
    'greenapi.elapsed': 'Elapsed: {time}',
    'greenapi.takingLong': 'Startup is taking longer than usual — this happens when Green API servers are busy. Wait a bit more, or click “Disconnect” and create the connection again.',
    'integrations.cat.website': 'Website',
    'integrations.cat.websiteDesc': 'WordPress, HTML, Tilda, Shopify & more',
    'integrations.cat.whatsappDesc': 'Connect via QR code',
    'integrations.cat.instagramDesc': 'AI replies in Direct',
    'integrations.cat.identDesc': 'Bookings into your IDENT CRM',
    'integrations.cat.altegioDesc': 'Altegio journal & CRM sync',
    'integrations.cat.vk': 'VK',
    'integrations.cat.vkDesc': 'AI in community messages',
    'integrations.cat.voice': 'Voice',
    'integrations.cat.voiceDesc': 'AI call answering',
    'settings.jobReply': 'Reply to job / employment inquiries',
    'settings.jobReplyPlaceholder': 'E.g.: “Send your CV to hello@salon.fr — the owner will personally review it and get back to you”',
    'settings.jobReplyTip': 'If left empty, the AI politely collects the applicant\'s contact and forwards it to you. You get a Telegram/email alert about complaints and applicants.',
    'settings.crmImportTitle': 'Import services from CRM (Planity/Booksy/Fresha)',
    'settings.crmImportHint': 'Paste your public booking page link — we\'ll pull services and prices straight into the AI knowledge base.',
    'settings.crmImportFetch': 'Find services',
    'settings.crmImportEmpty': 'Could not find services with prices at this link. Make sure the page is public.',
    'settings.crmImportFound': 'Services found: {count}',
    'settings.crmImportConfirm': 'Add to knowledge base ({count})',
    'settings.crmImportSuccess': 'Services imported: {count}',
    'settings.crmImportNote': 'Selected services will be added to the knowledge base. Re-importing replaces the previously imported block.',

    // Onboarding Guide
    'onboarding.title': 'Quick Start',
    'onboarding.subtitle': 'Complete 4 steps so your AI can start taking bookings',
    'onboarding.step1': 'Knowledge Base',
    'onboarding.step1Desc': 'Tell the AI about your services, prices and hours',
    'onboarding.step2': 'Connect a Channel',
    'onboarding.step2Desc': 'WhatsApp, website widget or mini-site',
    'onboarding.step3': 'Add a Card',
    'onboarding.step3Desc': 'Pick a plan so the AI runs without interruptions',
    'onboarding.step4': 'Test Message',
    'onboarding.step4Desc': 'Message your AI and check the reply',
    'onboarding.dismiss': 'Hide',
    'settings.revenueTitle': 'Revenue for reports',
    'settings.revenueHint': 'We use service prices from your knowledge base. The average ticket is used when a service has no listed price — this is how the report estimates revenue generated by Chatity.',
    'settings.avgTicket': 'Average ticket',
    'settings.currency': 'Currency',
    'settings.reactivationTitle': 'Client reactivation',
    'settings.reactivationHint': 'Auto-remind sleeping clients to book again + count returns and revenue in the report',
    'settings.reactivationDays': 'Remind after (days)',
    'settings.reactivationChannel': 'Channel',
    'settings.reactivationMessage': 'Message text',
    'settings.reactivationPlaceholder': 'Hi {name}! We miss you 💐 We\'d love to see you again. Want to book a visit?',
    'settings.reactivationTip': 'Use {name} to insert the client\'s name. Sent automatically once a day.',

  },
  
  fr: {
    // Auth Page
    'auth.title': 'Chatity',
    'auth.subtitle': 'Accueil IA pour beauté & bien-être',
    'landing.value.title': 'Vos clients vous écrivent. Chatity s\'en occupe.',
    'landing.value.subtitle': 'Chaque message sans réponse est une réservation perdue. Chatity répond instantanément, prend les rendez-vous, encaisse les paiements et fait revenir vos clients.',
    'landing.value.c1': 'Ne manquez aucune demande',
    'landing.value.c1d': 'Réponses instantanées sur WhatsApp, Instagram et votre site — 24h/24, 7j/7.',
    'landing.value.c2': 'Prenez les rendez-vous',
    'landing.value.c2d': 'L\'IA propose les créneaux, réserve et confirme — sans réceptionniste.',
    'landing.value.c3': 'Encaissez les paiements',
    'landing.value.c3d': 'Acomptes et prépaiements directement dans la conversation — moins de no-shows.',
    'landing.value.c4': 'Faites revenir vos clients',
    'landing.value.c4d': 'Rappels intelligents et invitations personnalisées aux clients inactifs.',
    'auth.login': 'Connexion',
    'auth.register': 'Inscription',
    'auth.email': 'Email',
    'auth.password': 'Mot de passe',
    'auth.salonName': 'Nom du salon',
    'auth.companyName': 'Nom de l\'entreprise',
    'auth.companyNamePlaceholder': 'par ex., Beauty Studio',
    'auth.companyWebsite': 'Site web de l\'entreprise (facultatif)',
    'auth.websiteImportant': '💡 Important : Entrez la bonne adresse du site pour que l\'IA puisse lire les informations de base à utiliser lors de la communication avec les clients',
    'auth.loginButton': 'Se connecter',
    'auth.registerButton': "S'inscrire",
    'auth.termsAccept': "J'accepte les",
    'auth.termsLink': "Conditions d'utilisation",
    'auth.termsAnd': "et la",
    'auth.privacyLink': "Politique de confidentialité",
    'ms.book.privacyNotice': "En réservant, les informations que vous fournissez sont utilisées par {business} afin de traiter votre demande et gérer votre rendez-vous (rappels inclus). Chatity fournit la technologie et traite ces données pour le compte du professionnel.",
    'ms.book.learnMore': "En savoir plus",
    'ms.book.optional': "facultatif",
    'ms.book.marketingConsent': "J'accepte de recevoir les offres et actualités de {business} par e-mail, SMS ou messagerie",
    'privacy.title': "Confidentialité et mentions légales",
    'privacy.intro': "Selon le RGPD, vous êtes responsable du traitement des données de vos clients et Chatity (MINDUNITE SAS) est sous-traitant. Ces informations sont affichées dans la notice de confidentialité de votre mini-site et du widget.",
    'privacy.legalName': "Raison sociale",
    'privacy.address': "Adresse du siège",
    'privacy.email': "E-mail de contact",
    'privacy.privacyEmail': "E-mail pour les demandes relatives aux données",
    'privacy.phone': "Téléphone",
    'privacy.policyUrl': "Lien vers votre propre politique de confidentialité (facultatif)",
    'privacy.marketingTitle': "Messages marketing",
    'privacy.marketingEnabled': "Autoriser les messages marketing aux clients (relance, promotions)",
    'privacy.marketingHint': "Une case de consentement distincte, non cochée, apparaît sur le formulaire de réservation. Sans consentement, aucun message promotionnel n'est envoyé ; les rappels de rendez-vous fonctionnent toujours.",
    'privacy.existingCustomers': "Exception clients existants",
    'privacy.existingCustomersHint': "Envoyer des offres sur des services similaires aux clients déjà venus, sauf désinscription (STOP). Vérifiez que votre législation l'autorise.",
    'privacy.retentionTitle': "Durées de conservation",
    'privacy.chatRetention': "Conversations clients, jours",
    'privacy.bookingRetention': "Historique des rendez-vous et fiches clients",
    'privacy.retention.active': "Tant que le client est actif (3 ans après la dernière visite)",
    'privacy.retention.2y': "2 ans après la dernière visite",
    'privacy.retention.1y': "1 an après la dernière visite",
    'privacy.retentionHint': "La suppression/anonymisation automatique selon ces durées est exécutée par une tâche quotidienne.",
    'privacy.healthTitle': "Données de santé",
    'privacy.healthEnabled': "Mode données de santé (maquillage permanent, médecine esthétique)",
    'privacy.healthHint': "Par défaut, l'IA ne demande ni n'enregistre d'informations médicales et transmet ces questions au responsable. Un processus sécurisé dédié est en préparation.",
    'privacy.save': "Enregistrer les paramètres de confidentialité",
    'privacy.saved': "Paramètres de confidentialité enregistrés",
    'auth.loading': 'Chargement...',
    'auth.loginSuccess': 'Connexion réussie!',
    'auth.registerSuccess': 'Inscription réussie!',
    'auth.error': "Erreur d'authentification",
    'auth.websiteUrl': 'URL du site',
    'auth.forgotPassword': 'Mot de passe oublié?',
    'auth.loginWithCode': 'Connexion par code email (sans mot de passe)',
    'auth.loginWithPassword': 'Connexion avec mot de passe',
    'auth.sendCode': 'Recevoir le code de connexion',
    'auth.verifyCode': 'Se connecter',
    'auth.enterCode': 'Code reçu par email',
    'auth.codeSentInfo': 'Code envoyé à votre email',
    'auth.codeSentHint': 'Le code et le bouton de connexion ont été envoyés par email (vérifiez les spams)',
    'auth.resendCode': 'Renvoyer le code',
    'auth.magicLoginError': 'Lien invalide ou expiré',
    'auth.magicLoggingIn': 'Connexion...',
    'auth.backToLogin': 'Retour à la connexion',
    
    // Forgot Password
    'forgot.title': 'Récupération mot de passe',
    'forgot.subtitle': 'Entrez votre email pour recevoir le code',
    'forgot.enterCode': 'Entrez le code et le nouveau mot de passe',
    'forgot.sendCode': 'Envoyer le code',
    'forgot.resetCode': 'Code de récupération',
    'forgot.newPassword': 'Nouveau mot de passe',
    'forgot.confirmPassword': 'Confirmer mot de passe',
    'forgot.resetPassword': 'Réinitialiser',
    'forgot.resendCode': 'Renvoyer le code',
    'forgot.backToLogin': 'Retour connexion',
    'forgot.codeSent': 'Code envoyé par email',
    'forgot.success': 'Mot de passe changé avec succès!',
    'forgot.error': 'Erreur de récupération',
    'forgot.passwordMismatch': 'Les mots de passe ne correspondent pas',
    'forgot.passwordTooShort': 'Le mot de passe doit contenir au moins 6 caractères',
    
    // Dashboard
    'dashboard.title': 'Chatity',
    'dashboard.logout': 'Déconnexion',
    'dashboard.logoutSuccess': 'Déconnecté',
    
    // Tabs
    'tabs.settings': 'Paramètres',
    'tabs.bookings': 'Réservations',
    'tabs.widget': 'Intégrations',
    'tabs.marketing': 'Marketing', 'tabs.analytics': 'Statistiques',
    'mk.triggersTitle': 'Mots déclencheurs',
    'mk.triggersHint': "Le client envoie un mot code (ex. de votre pub) — le bot répond aussitôt avec votre offre. Fonctionne sur Instagram, WhatsApp et le widget.",
    'mk.keyword': 'Mot code',
    'mk.response': 'Réponse à envoyer',
    'mk.responsePh': "Ex. : Félicitations ! 🎁 Un soin offert pour toute réservation. Dites-nous quand vous souhaitez venir !",
    'mk.addTrigger': 'Ajouter un mot',
    'mk.active': 'Actif',
    'mk.save': 'Enregistrer',
    'mk.saved': 'Enregistré ✓', 'clients.language': 'Langue du client (notifications WhatsApp/Instagram)', 'clients.langAuto': 'Auto selon l\'indicatif', 'clients.langAutoUnknown': 'Auto (selon la conversation)', 'clients.langHint': 'Rappels et confirmations sont envoyés dans cette langue. Auto : selon l\'indicatif du numéro (+33 — français, +7 — russe…), sinon selon la conversation.', 'clients.langSaved': 'Langue du client enregistrée', 'mk.remindersTitle': 'Rappels de rendez-vous aux clients', 'mk.remindersHint': 'Envoyés automatiquement via WhatsApp. Si le client n\'a pas WhatsApp — appel IA 24 h avant (téléphone connecté requis).', 'mk.remindersNoWhatsapp': 'WhatsApp n\'est pas connecté — les rappels WhatsApp ne partiront pas.', 'mk.remindersNoPhone': 'Téléphone non connecté — le rappel par appel (clients sans WhatsApp) ne fonctionnera pas.', 'mk.remindersConnect': 'Connecter', 'mk.remindersChannelsOk': 'WhatsApp et téléphone connectés — les rappels fonctionnent.', 'mk.remindersTextLabel': 'Texte personnalisé (optionnel)', 'mk.reminder24hTitle': '24 heures avant', 'mk.reminder24hHint': 'La veille — le client peut déplacer ou annuler en répondant', 'mk.reminder24hPh': '{name}, rappel de votre rendez-vous demain ✨ {service}{master} — {when}. À bientôt !', 'mk.reminder2hTitle': '2 heures avant', 'mk.reminder2hHint': 'Court rappel le jour du rendez-vous', 'mk.reminder2hPh': '{name}, on vous attend aujourd\'hui à {time} ⏰ {service}{master}.', 'mk.remindersPlaceholders': 'Variables : {name}, {service}, {master} — « avec … », {when} — date et heure, {date}, {time}', 'mk.remindersLogTitle': 'Derniers envois', 'mk.remindersUpcoming': 'En attente de rappel : {n}', 'mk.remindersLogEmpty': 'Rien envoyé pour l\'instant — les rappels partent automatiquement avant les prochains rendez-vous', 'mk.remindersNotDelivered': 'non livré',
    'addons.title': 'Options', 'addons.subtitle': 'Canaux, établissements et IA téléphonique s\'ajoutent à votre abonnement et se renouvellent avec lui — sans ressaisir votre carte. Les packs de dialogues sont un achat ponctuel valable jusqu\'à la fin du mois payé.',
    'addons.dialogs': 'Pack de dialogues', 'addons.dialogsHint': '+100 dialogues pour 10 €. Achetez-en plusieurs — consommés après la limite du plan, expirent à la fin du mois payé.',
    'addons.channel': 'Canal supplémentaire', 'addons.channelHint': '1 canal inclus dans le plan (WhatsApp ou Instagram). Chaque canal en plus — 19 €/mois. Widget et mini-site toujours gratuits.',
    'addons.branch': 'Établissement supplémentaire', 'addons.branchHint': '1 établissement inclus. Chaque supplémentaire — 50 % du prix de votre plan par mois.',
    'addons.buy': 'Acheter', 'addons.mo': 'mois', 'addons.active': 'Actif', 'addons.connected': 'Canaux connectés', 'addons.branches': 'Établissements',
    'addons.phone': 'IA téléphonique', 'addons.yours': 'Vos options', 'addons.autoRenew': 'renouvelée avec votre abonnement', 'addons.cancel': 'Désactiver', 'addons.resume': 'Reprendre',
    'addons.endsOn': 'Se termine le {date}', 'addons.validUntil': 'Valable jusqu\'au {date}', 'addons.attached': 'Option activée et ajoutée à votre abonnement',
    'addons.cancelConfirm': 'Désactiver cette option ? Elle reste active jusqu\'à la fin de la période payée, puis plus aucun prélèvement.', 'addons.cancelled': 'L\'option se terminera à la fin de la période', 'addons.resumed': 'Option de nouveau active',
    'addons.confirmAttach': 'Ajouter à votre abonnement actuel : €{now} seront prélevés aujourd\'hui sur votre carte (au prorata jusqu\'à la fin de la période), puis {monthly} avec votre forfait. Confirmer ?',
    'addons.confirmCheckout': 'Abonnement à l\'option {monthly}, renouvellement automatique. La page de paiement va s\'ouvrir. Continuer ?',
    'mk.igTitle': 'Instagram : réactions aux stories', 'mk.storyReactHint': 'Quand un client réagit (❤️ 🔥 😍) à votre story, l\'IA le remercie et engage la conversation', 'mk.storyReactInfo': 'Quoi proposer dans la réponse', 'mk.storyReactPlaceholder': 'Ex. : -20% sur la manucure pour les nouveaux clients jusqu\'à la fin du mois', 'mk.storyReactTip': 'L\'IA intègre cette info dans la réponse, dans la langue du client. Au max 1 réponse toutes les 6 h par dialogue.',
    'tabs.admin': 'Admin',
    'tabs.support': 'Assistance',
    
    // Settings
    'settings.title': 'Paramètres',
    'settings.subtitle': 'Configurez les intégrations et votre assistant IA',
    'settings.languageTitle': 'Paramètres de langue',
    'settings.uiLanguage': 'Langue interface',
    'settings.uiLanguageDesc': 'Langue pour tableau de bord et menus',
    'settings.notificationLanguage': 'Langue notifications',
    'settings.notificationLanguageDesc': 'Langue pour notifications email et Telegram',
    'settings.notificationLanguageSuccess': 'Langue notifications mise à jour',
    'settings.languageUpdateError': 'Erreur mise à jour langue',
    'settings.notifications': 'Notifications de réservation',
    'settings.emailTitle': 'Notifications par email',
    'settings.emailCheckbox': 'Recevoir les réservations par email',
    'settings.emailRecipients': 'Où envoyer les notifications (séparées par des virgules)',
    'settings.emailRecipientsDefault': 'par défaut : {email}',
    'settings.emailRecipientsHint': 'Laissez vide pour les recevoir sur l\'email du compte. Vous pouvez indiquer plusieurs adresses séparées par des virgules — chacune recevra la notification.',
    'settings.emailWarning': '⚠️ Fonction email disponible en production. Utilisez Telegram en test.',
    'settings.telegramTitle': 'Notifications Telegram',
    'settings.chatId': 'ID du groupe',
    'settings.chatIdInstructions': 'Comment obtenir le Chat ID pour les notifications:',
    'settings.chatIdStep1': 'Trouver le bot:',
    'settings.chatIdStep1Text': 'Ouvrez Telegram et trouvez notre bot',
    'settings.chatIdStep2': 'Ajouter au chat:',
    'settings.chatIdStep2Text': 'Ajoutez le bot à votre chat personnel ou groupe où vous souhaitez recevoir les notifications',
    'settings.chatIdStep3': 'Exécuter la commande:',
    'settings.chatIdStep3Text': 'Envoyez la commande',
    'settings.chatIdStep4': 'Copier le Chat ID:',
    'settings.chatIdStep4Text': 'Le bot vous enverra votre Chat ID (nombre comme: -1001234567890)',
    'settings.chatIdStep5': 'Coller et enregistrer:',
    'settings.chatIdStep5Text': 'Collez le Chat ID dans le champ ci-dessus et cliquez sur "Enregistrer les paramètres"',
    'settings.chatIdSuccess': 'Après l\'enregistrement, vous recevrez des notifications sur les nouvelles réservations directement dans Telegram!',
    'settings.balloonSettings': 'Infobulle',
    'settings.balloonEnabled': 'Afficher l\'infobulle',
    'settings.balloonEnabledDesc': 'Le message contextuel attire l\'attention des visiteurs',
    'settings.balloonMessage': 'Texte de l\'infobulle',
    'settings.balloonMessagePlaceholder': 'Bonjour! Je peux vous aider à prendre rendez-vous 👋',
    'settings.balloonDelay': 'Délai (secondes)',
    'settings.balloonDelayDesc': 'Après combien de secondes afficher l\'infobulle',
    'settings.autoOpenEnabled': 'Ouverture automatique du chat',
    'settings.autoOpenEnabledDesc': 'Ouvrir automatiquement le chat si le visiteur n\'a pas cliqué',
    'settings.autoOpenDelay': 'Délai d\'ouverture automatique (secondes)',
    'settings.autoOpenDelayDesc': 'Après combien de secondes ouvrir automatiquement le chat',
    'settings.analyzeWebsite': 'Analyser le site',
    'settings.analyzing': 'Analyse en cours',
    'settings.websiteAnalyzed': 'Site analysé! Informations chargées dans la base de connaissances.',
    'settings.websiteAnalyzedSuccess': 'Site analysé avec succès!',
    'settings.websiteUrlRequired': 'Veuillez spécifier l\'URL du site dans les paramètres commerciaux pour une analyse automatique',
    'settings.aiChatbot': 'Assistant IA',
    'settings.primaryColor': 'Couleur principale',
    'settings.secondaryColor': 'Couleur secondaire',
    'settings.buttonColor': 'Couleur du bouton',
    'settings.botName': 'Nom du bot',
    'settings.welcomeMessage': 'Message de bienvenue',
    'settings.defaultBotName': 'Assistant',
    'settings.defaultWelcomeMessage': 'Bonjour ! Comment puis-je vous aider ?',
    'settings.businessInfo': 'Informations sur votre entreprise',
    'settings.aiKnowledgeTitle': 'L\'IA utilisera ces informations!',
    'settings.aiKnowledgeDesc': 'Spécifiez vos services, prix, horaires, adresse. L\'IA conseillera les clients sur la base de ces données.',
    'settings.knowledgeBase': 'Base de connaissances IA',
    'settings.knowledgeBasePlaceholder': `Exemple:

Nos services:
- Coupe - à partir de 50€
- Coiffure - à partir de 40€
- Consultation - 20€

Horaires d'ouverture:
Lun-Ven: 10:00-20:00
Sam-Dim: 11:00-19:00

Adresse: 123 Rue Principale, Paris
Téléphone: +33 1 23 45 67 89`,
    'settings.knowledgeTip': 'Conseil: Plus vous décrivez les services et les prix en détail, plus l\'IA conseillera les clients avec précision',
    'settings.saveButton': 'Enregistrer',
    'settings.saving': 'Enregistrement…',
    'settings.saveSuccess': 'Paramètres enregistrés!',
    'settings.saveError': "Erreur d'enregistrement",
    'settings.businessType': 'Type de votre entreprise',
    'settings.businessTypeHint': "L'IA sera configurée pour les spécificités de votre niche",
    'settings.businessTypes.general': '🏢 Général',
    'settings.businessTypes.medical': '🏥 Médical / Clinique',
    'settings.businessTypes.beauty': '💅 Salon de beauté',
    'settings.businessTypes.ecommerce': '🛍️ E-commerce',
    'settings.businessTypes.restaurant': '🍽️ Restaurant / Café',
    'settings.businessTypes.services': '🔧 Services',
    'settings.productFeedUrl': 'URL du flux de produits (XML/JSON)',
    'settings.productFeedHint': "L'IA conseillera les clients sur les produits de votre catalogue",
    'tilda.title': 'Boutique en ligne Tilda (MCP)', 'tilda.desc': "L'IA répondra aux clients sur les produits, prix et disponibilités de votre catalogue Tilda et les orientera vers la boutique.", 'tilda.step1': 'Dans Tilda, ouvrez Profil → « MCP server » → « New key »', 'tilda.step2': 'Choisissez le projet de la boutique, accès « Limited » → cochez uniquement « Product catalog » (lecture) et « No expiration »', 'tilda.step3': 'Copiez la clé (affichée une seule fois) et collez-la ci-dessous', 'tilda.keyLabel': 'Clé Tilda MCP', 'tilda.connect': 'Connecter', 'tilda.checking': 'Vérification…', 'tilda.help': 'Guide Tilda MCP', 'tilda.connected': 'Tilda connectée, catalogue chargé', 'tilda.synced': 'Catalogue mis à jour', 'tilda.disconnectConfirm': "Déconnecter Tilda ? Le catalogue sera retiré de l'IA.", 'tilda.project': 'Projet', 'tilda.products': 'Produits', 'tilda.syncedAt': 'Mis à jour', 'tilda.currency': 'Devise des prix', 'tilda.key': 'Clé', 'tilda.lastError': 'Dernière erreur', 'tilda.sync': 'Actualiser le catalogue', 'tilda.disconnect': 'Déconnecter', 'tilda.searchPh': 'Vérifier un produit du catalogue…', 'tilda.search': 'Chercher', 'tilda.noResults': 'Aucun résultat', 'tilda.autoSync': 'Le catalogue se met à jour automatiquement toutes les 12 heures.', 'tilda.err.key': 'Clé refusée par Tilda. Vérifiez la clé (commence par mcp_tilda_) et sa validité', 'tilda.err.noProjects': "Cette clé n'a accès à aucun projet", 'tilda.err.unreachable': 'Tilda est injoignable, réessayez plus tard', 'tilda.err.generic': 'Erreur de connexion',
    'subscription.cancelTitle': "Résilier l'abonnement", 'subscription.cancelDesc': "L'abonnement et toutes les options (téléphonie, canaux, établissements) sont résiliés immédiatement : l'IA s'arrête sur tous les canaux, plus aucun prélèvement.", 'subscription.lastPayment': 'Dernier paiement', 'subscription.cancelBtn': "Résilier l'abonnement", 'subscription.cancelConfirm': "Résilier l'abonnement maintenant ? L'IA s'arrête immédiatement sur tous les canaux (site, WhatsApp, Instagram, téléphone). Plus aucun prélèvement.", 'subscription.cancelDone': 'Abonnement résilié. Plus aucun prélèvement.', 'subscription.cancelError': "Impossible de modifier l'abonnement. Contactez le support.", 'subscription.cancelScheduled': 'Abonnement résilié', 'subscription.cancelScheduledDesc': "L'accès reste actif jusqu'au {date}, puis l'IA s'arrête sur tous les canaux. Aucun nouveau prélèvement.", 'subscription.resumeBtn': "Reprendre l'abonnement", 'subscription.resumeDone': 'Abonnement repris',
    'cal.billingPaymentFailed': "Paiement de l'abonnement refusé — l'IA est en pause sur tous les canaux (site, WhatsApp, Instagram, téléphone). Les clients restent sans réponse.", 'cal.billingUnpaid': "Abonnement inactif — l'IA ne répond plus aux clients sur aucun canal.", 'cal.billingFix': 'Régler le paiement',
    'tilda.sendLinks': "Autoriser l'IA à envoyer au client le lien direct du produit", 'settings.aiKnowledgeDescEcom': 'Indiquez les conditions de livraison et de paiement, retours, délais, adresse de retrait, contacts. Les produits et prix proviennent du catalogue Tilda connecté.',

    
    // Bookings
    'bookings.title': 'Historique des réservations',
    'bookings.subtitle': 'Toutes les réservations clients',
    'bookings.noBookings': 'Pas encore de réservations',
    'bookings.service': 'Service',
    'bookings.preferredDate': 'Date souhaitée',
    'bookings.preferredTime': 'Heure souhaitée',
    'bookings.period': 'Période',
    'bookings.today': "Aujourd'hui",
    'bookings.last7days': '7 derniers jours',
    'bookings.last30days': '30 derniers jours',
    'bookings.customDates': 'Dates personnalisées',
    'bookings.from': 'De',
    'bookings.to': 'À',
    'bookings.refresh': 'Actualiser',
    'bookings.todayCount': "Réservations aujourd'hui",
    'bookings.yesterdayCount': 'Réservations hier',
    'bookings.growthPercent': 'Croissance vs hier',
    'bookings.dynamicsTitle': 'Dynamique des réservations',
    'bookings.dynamicsDescription': 'Nombre de réservations par jour',
    'bookings.topSourcesTitle': 'Principales sources de trafic',
    'bookings.topSourcesDescription': "D'où viennent les clients",
    'bookings.source': 'Source',
    'bookings.bookingsCount': 'Réservations',
    'bookings.directVisit': 'Visite directe',

    
    // Analytics
    'analytics.upgradeToPro': 'Analytique avancée',
    'analytics.upgradeDescription': 'Passez au plan Professional ou Unlimited pour accéder à:',
    'analytics.feature1': 'Graphiques de dynamique des réservations',
    'analytics.feature2': 'Sources de trafic (balises UTM)',
    'analytics.feature3': 'Statistiques détaillées',
    'analytics.feature4': 'Export de données',
    'analytics.upgradeButton': 'Mettre à niveau',
    'analytics.channel': 'Canal',
    'analytics.campaign': 'Campagne',
    'miniBuilder.title': 'Constructeur de mini-site',
    'miniBuilder.active.onTitle': 'Mini-site activé',
    'miniBuilder.active.offTitle': 'Mini-site désactivé',
    'miniBuilder.active.onHint': 'Votre page publique est en ligne. Les visiteurs verront votre mini-site via le lien court.',
    'miniBuilder.active.offHint': 'La page est masquée. Les visiteurs verront une 404 sur votre lien court. Le widget et les intégrations continuent de fonctionner.',
    'miniBuilder.save': 'Enregistrer',
    'miniBuilder.saving': 'Enregistrement...',
    'miniBuilder.loading': 'Chargement...',
    'miniBuilder.noSlug': 'Définissez d\'abord votre lien court dans l\'onglet Intégrations',
    'miniBuilder.upgradeDesc': 'Le constructeur de mini-site est disponible sur les forfaits Professional et Unlimited.',
    'miniBuilder.upgradeBtn': 'Passer à Professional',
    'miniBuilder.about.title': 'À propos',
    'miniBuilder.about.label': 'Texte « À propos »',
    'miniBuilder.about.aiBtn': 'Générer avec l\'IA',
    'miniBuilder.about.generating': 'Génération...',
    'miniBuilder.about.placeholder': 'Décrivez brièvement votre salon : ambiance, valeurs, ce qui vous différencie...',
    'miniBuilder.about.hint': 'L\'IA utilise les données de votre base de connaissances (infos salon, services, prix) définies dans l\'onglet Paramètres.',
    'miniBuilder.seo.title': 'Paramètres SEO',
    'miniBuilder.seo.hint': 'Ces champs sont lus par Google et les réseaux sociaux lors du partage. Laissez vide pour un remplissage automatique depuis le nom et le texte « À propos ».',
    'miniBuilder.seo.titleLabel': 'Titre SEO',
    'miniBuilder.seo.titlePlaceholder': 'Manucure et pédicure à Paris — Salon Lux',
    'miniBuilder.seo.titleHint': '« — Chatity » est ajouté automatiquement au titre',
    'miniBuilder.seo.descLabel': 'Description SEO',
    'miniBuilder.seo.descPlaceholder': 'Salon de beauté au centre de Paris : manucure, pédicure, sourcils. Réservation en ligne 24h/24.',
    'miniBuilder.seo.descHint': 'Affichée sous le titre dans les résultats de recherche Google',
    'miniBuilder.seo.keywordsLabel': 'Mots-clés',
    'miniBuilder.seo.keywordsPlaceholder': 'manucure paris, pédicure, salon de beauté 11e',
    'miniBuilder.seo.keywordsHint': 'Séparés par des virgules. Facultatif — Google les ignore presque, mais cela ne nuit pas',
    'miniBuilder.cover.title': 'Photo de couverture du mini-site',
    'miniBuilder.cover.desc': 'URL de l\'image (Instagram / Imgur / Telegram / votre CDN). Si vide — un dégradé est affiché.',
    'miniBuilder.logo.title': 'Logo / Avatar',
    'miniBuilder.logo.desc': 'Logo rond dans l\'en-tête du mini-site. Carré 512×512 px recommandé (PNG transparent ou JPG).',
    'miniBuilder.logo.hint': 'Le logo apparaît à côté du nom de votre entreprise dans le hero et dans le widget de chat.',
    'miniBuilder.social.title': 'Réseaux sociaux & contacts',
    'miniBuilder.social.hint': 'Ces liens seront visibles par les visiteurs sur votre mini-site public.',
    'miniBuilder.services.title': 'Services & tarifs',
    'miniBuilder.photos.title': 'Galerie photo',
    'miniBuilder.phase2': 'bientôt (phase 2)',
    'miniBuilder.phase2Photos': 'bientôt (phase 2)',
    'miniBuilder.toast.saved': 'Mini-site enregistré',
    'miniBuilder.toast.saveFailed': 'Échec de l\'enregistrement',
    'miniBuilder.toast.aiSuccess': 'L\'IA a généré l\'À propos 🤖',
    'miniBuilder.toast.aiFailed': 'Échec de la génération',
    'miniBuilder.address.label': 'Adresse',
    'miniBuilder.address.placeholder': '7 Avenue de Fabron, 06200 Nice, France',
    'miniBuilder.address.hint': 'Sera affichée sur votre mini-site public avec une carte Google interactive.',
    'miniBuilder.services.empty': 'Aucune catégorie pour le moment. Ajoutez la première pour que les clients voient vos services et tarifs.',
    'miniBuilder.services.addCategory': 'Ajouter une catégorie',
    'miniBuilder.services.addService': 'Ajouter un service',
    'miniBuilder.services.categoryNamePlaceholder': 'Ex. : Coupes & coiffures',
    'miniBuilder.services.categoryDescPlaceholder': 'Courte description de la catégorie (facultatif)',
    'miniBuilder.services.serviceNamePlaceholder': 'Nom du service',
    'miniBuilder.services.durationPlaceholder': '60 min',
    'miniBuilder.services.pricePlaceholder': '50',
    'miniBuilder.photos.empty': 'Aucune photo pour le moment. Ajoutez des liens vers les photos d\'intérieur, de travaux ou d\'équipe.',
    'miniBuilder.photos.add': 'Ajouter une photo',
    'miniBuilder.photos.urlPlaceholder': 'https://i.imgur.com/photo.jpg',
    'miniBuilder.photos.altPlaceholder': 'Légende (facultatif)',
    'miniBuilder.photos.hint': 'Format optimal — photos horizontales 1200×800 px. Jusqu\'à 6 photos, max 2 Mo chacune. Les grandes photos sont compressées automatiquement en WebP.',
    'miniBuilder.photos.full': 'La galerie est pleine — 6 photos max. Supprimez-en une pour en ajouter une nouvelle.',
    'uploader.trimmed': 'Vous ne pouvez ajouter que {n} photo(s) supplémentaire(s) — les autres ont été ignorées.',
    'miniBuilder.services.currencyLabel': 'Devise',
    'miniBuilder.services.unnamedCategory': 'Sans nom',
    'miniBuilder.titleField.label': 'Nom du business (titre de page)',
    'miniBuilder.titleField.placeholder': 'Oui Beauté · Salon de Coiffure à Nice',
    'miniBuilder.titleField.hint': 'Utilisé dans le <title> de l\'onglet et l\'en-tête du mini-site. Si vide — utilise le nom du salon des paramètres.',
    'miniBuilder.tagline.label': 'Sous-titre (slogan)',
    'miniBuilder.tagline.placeholder': 'Salon de coiffure à Nice · 8 ans d\'expérience',
    'miniBuilder.tagline.hint': 'Une courte ligne sous le nom de l\'entreprise. Jusqu\'à 80 caractères.',
    'uploader.btn': 'Téléverser',
    'uploader.dropzone': 'Déposez une photo ici ou cliquez pour choisir',
    'uploader.dropzoneMulti': 'Déposez plusieurs photos ici ou cliquez pour choisir',
    'uploader.hint': 'JPG / PNG / WebP, jusqu\'à 2 Mo',
    'uploader.uploading': 'Envoi',
    'uploader.success': 'Photo téléversée ✓',
    'uploader.successMulti': '{n} photos téléversées',
    'uploader.failed': 'Échec du téléversement',
    'uploader.invalidType': 'Format non supporté. Utilisez JPG, PNG ou WebP.',
    'uploader.tooBig': 'Le fichier est trop volumineux. Essayez une photo plus petite.',
    'miniBuilder.hours.title': 'Horaires d\'ouverture',
    'miniBuilder.hours.label': 'Horaires du salon',
    'miniBuilder.hours.placeholder': 'Lun-Ven : 09h00–19h00\nSam : 10h00–18h00\nDim : fermé',
    'miniBuilder.hours.hint': 'Texte libre. Chaque saut de ligne est rendu tel quel sur la page publique.',
    'tabs.minisite': 'Mini-site',
    'tabs.team': 'Équipe',
    'tabs.calendar': 'Calendrier',
    'cal.today': "Aujourd'hui", 'cal.day': 'Jour', 'cal.week': 'Semaine', 'cal.month': 'Mois',
    'cal.allBranches': 'Tous les établissements', 'cal.allMasters': 'Tous les praticiens', 'cal.modeChips': 'Rendez-vous', 'cal.modeLoad': 'Charge',
    'cal.addClient': 'Réserver un client', 'cal.dashboard': 'Tableau de bord',
    'cal.newBooking': 'Nouvelle réservation', 'cal.clientName': 'Nom du client', 'cal.phone': 'Téléphone',
    'cal.service': 'Prestation', 'cal.master': 'Praticien', 'cal.date': 'Date', 'cal.time': 'Heure',
    'cal.book': 'Réserver', 'cal.moved': 'Réservation déplacée', 'cal.conflict': 'Créneau occupé ou hors horaires', 'cal.onlyMasterServices': 'Seules les prestations de ce praticien sont affichées. Modifiez-les sur sa fiche (Équipe)', 'cal.conflict.day_off': '{master} ne travaille pas ce jour (ou le salon est fermé)', 'cal.conflict.outside_schedule': 'Hors horaires : {master} travaille {window}, la prestation dure {duration_min} min', 'cal.conflict.busy': '{master} a déjà un rendez-vous à {start_at}–{end_at}', 'cal.conflict.external_busy': '{master} est occupé(e) dans le calendrier externe', 'cal.conflict.master_not_found': 'Praticien introuvable ou sans planning', 'cal.conflict.master_does_not_offer_service': 'Ce praticien ne propose pas cette prestation — cochez-la sur sa fiche', 'cal.conflict.no_master_for_service': 'Aucun praticien ne propose cette prestation — cochez-la sur les fiches', 'cal.conflict.no_free_master': 'Aucun praticien libre à cette heure',
    'cal.unassigned': 'Non attribuées', 'cal.assignTime': 'Attribuer un créneau',
    'ob.skip': 'Passer la configuration', 'ob.skipConfirm': 'Quitter la configuration ? Vous pourrez tout configurer plus tard dans votre espace.', 'ob.stepOf': 'Étape {a} sur {b}', 'ob.next': 'Continuer', 'ob.back': 'Retour', 'ob.s1Title': 'Parlez-nous de vous', 'ob.s1Sub': '2 minutes — votre IA se présentera avec votre nom', 'ob.salonName': 'Nom du salon', 'ob.bizType': 'Type d\'activité', 'ob.timezone': 'Fuseau horaire', 'ob.nameRequired': 'Veuillez saisir un nom', 'ob.s2Title': '7 jours gratuits — accès complet', 'ob.s2Sub': 'Ajoutez votre carte maintenant, premier prélèvement seulement après 7 jours', 'ob.s2Note': '0 € aujourd\'hui. Premier prélèvement dans 7 jours. Annulation en un clic à tout moment.', 'ob.s2Cta': 'Ajouter la carte — 7 jours gratuits', 'ob.s2Later': 'Plus tard', 'ob.recommended': 'Recommandé', 'ob.dialogsMo': 'dialogues/mois', 'ob.mo': 'mois', 'ob.cardOk': 'Carte ajoutée ! 7 jours gratuits activés 🎉', 'ob.s3Title': 'Entraînez votre IA', 'ob.s3Sub': 'Services, prix et infos — c\'est exactement ce que l\'IA dira à vos clients', 'ob.kbLabel': 'Votre salon en quelques mots', 'ob.kbPh': 'Adresse, parking, politique d\'annulation, promos — tout ce que l\'IA doit savoir…', 'ob.services': 'Services', 'ob.svcName': 'Service (ex. Manucure)', 'ob.team': 'Équipe', 'ob.masterName': 'Nom du praticien', 'ob.masterAdd': 'Ajouter', 'ob.solo': 'Je travaille seul(e)', 'ob.soloName': 'Praticien', 'ob.s4Title': 'Connectez vos canaux', 'ob.s4Sub': 'WhatsApp, Instagram ou widget web — au moins un pour que vos clients vous écrivent', 'ob.widgetTitle': 'Widget site web', 'ob.widgetCopy': 'Copier le code', 'ob.copied': 'Code copié !', 'ob.s5Title': 'Testez votre IA', 'ob.s5Sub': 'Écrivez comme un client — l\'IA répondra avec vos services et vos prix', 'ob.testHint': 'Ex. : « Combien coûte une manucure ? »', 'ob.testPh': 'Écrivez un message…', 'ob.finish': 'Lancer et aller au calendrier', 'ob.launched': 'C\'est parti ! Votre réceptionniste IA est en ligne 🎉',
    'ob.promo': 'Code promo', 'ob.promoApply': 'Appliquer', 'ob.promoFree': 'mois gratuits', 'ob.promoRedeem': 'Activer {n} mois gratuits — sans carte', 'ob.promoAuto': 'Code promo appliqué',
    'ob.language': 'Langue de l\'interface',
    'ob.widgetNoSite': 'Pas de site web ? Vous en recevez un gratuitement — un mini-site avec réservation en ligne est créé automatiquement après la configuration de vos services et de votre équipe dans votre espace.',
    'cal.remindCall': 'Rappel par appel', 'cal.remindCallDone': 'L’IA appelle le client ({lang})', 'cal.cancelled': 'Réservation annulée', 'cal.created': 'Réservation créée', 'cal.cancelBooking': 'Annuler la réservation',
    'cal.pendingConfirm': "Créé par l'IA — en attente de confirmation",
    'cal.confirmBtn': 'Confirmer', 'cal.confirmedSent': 'Confirmé ! Le client a été notifié',
    'cal.confirmedOk': 'Réservation confirmée',
    'cal.messages': 'Messages',
    'inbox.today': "Aujourd'hui", 'inbox.yesterday': 'Hier', 'inbox.search': 'Recherche par nom, téléphone…', 'inbox.empty': 'Pas encore de dialogues',
    'inbox.pickDialog': 'Choisissez un dialogue à gauche', 'inbox.client': 'Client',
    'inbox.reply': "Écrire une réponse… (l'IA se met en pause 6h)", 'inbox.you': 'Vous',
    'inbox.aiPaused': "IA en pause — c'est vous qui répondez", 'inbox.resumeAi': "Réactiver l'IA",
    'inbox.aiResumed': "L'IA répond à nouveau dans ce dialogue", 'inbox.aiOn': "L'IA répond",
    'inbox.aiOff': 'IA désactivée', 'inbox.aiOffBanner': "L'IA est désactivée pour ce dialogue — c'est vous qui répondez",
    'inbox.crashMsg': "Impossible d'afficher le dialogue", 'inbox.reload': 'Recharger',
    'inbox.aiDisabledToast': 'IA désactivée pour ce contact', 'inbox.aiEnabledToast': "L'IA répond à nouveau à ce contact",
    'inbox.newMessage': 'Nouveau message',
    'team.permsTitle': "Accès de l'administrateur aux sections",
    'team.permsHint': 'Calendrier et Messages toujours disponibles. Widget, mini-site, abonnement et réglages — propriétaire uniquement.',
    'profile.title': 'Mon profil', 'profile.name': 'Nom', 'profile.phone': 'Téléphone',
    'profile.save': 'Enregistrer', 'profile.saved': 'Profil enregistré',
    'profile.emailTaken': 'Cet email est déjà utilisé', 'profile.uploadHint': 'Cliquez sur la photo pour télécharger (JPG/PNG, max 2 Mo)',
    'cal.statCancels': 'Annulations', 'cal.statCalls': 'Appels',
    'cal.email': 'Email', 'cal.duration': 'Durée (min)', 'cal.price': 'Prix', 'cal.total': 'Total',
    'cal.save': 'Enregistrer', 'cal.saved': 'Enregistré', 'cal.came': 'Venu(e)', 'cal.noShow': 'Pas venu(e)',
    'cal.booking': 'Rendez-vous', 'cal.menu': 'Menu',
    'cal.whatDone': 'Ce qui a été fait : prestation, vernis/couleur, produits, formule', 'cal.whatDoneHint': 'Notez-le pour reproduire le résultat la prochaine fois', 'cal.attendanceRequired': 'Indiquez obligatoirement : client venu ou absent',
    'cal.needsCallback': 'Rappeler le client',
    'cal.clientConfirmed': 'Le client a confirmé le rendez-vous', 'cal.clientConfirmedPhone': '✅ Confirmé par téléphone',
    'cal.newBooking': 'Nouveau rendez-vous',
    'cal.allDay': 'Jour entier', 'cal.allDayHint': 'La journée du praticien sera fermée aux réservations', 'cal.repeat': 'Répéter', 'cal.repeatOn': 'Répétition activée', 'cal.repeatEvery': 'Répéter toutes les', 'cal.unitWeeks': 'semaines', 'cal.unitDays': 'jours', 'cal.onDays': 'le(s)', 'cal.repeatEnd': 'Fin de la répétition', 'cal.endNever': 'Jamais', 'cal.endAfter': 'Après', 'cal.endTimes': 'fois', 'cal.endOn': 'Le', 'cal.endNeverHint': '« Jamais » = un an à l’avance', 'cal.seriesCreated': 'Créé', 'cal.seriesSkipped': 'ignoré (occupé)', 'cal.wd.mon': 'L', 'cal.wd.tue': 'M', 'cal.wd.wed': 'M', 'cal.wd.thu': 'J', 'cal.wd.fri': 'V', 'cal.wd.sat': 'S', 'cal.wd.sun': 'D',
    'cal.call': 'Appeler', 'cal.write': 'Écrire',
    'cal.lastVisit': 'Dernière visite', 'cal.atMaster': 'chez', 'cal.newClient': 'Nouveau client — aucune visite passée', 'cal.addComment': 'Ajouter un commentaire', 'cal.commentPlaceholder': 'Commentaire sur cette visite…',
    'cal.history': 'Historique des visites', 'cal.showMore': 'Afficher plus', 'cal.noHistory': 'Aucune visite passée',
    'cal.memVisits': 'visites', 'cal.memEvery': 'tous les', 'cal.memDays': 'jours', 'cal.memAvgCheck': 'panier moyen', 'cal.memNoShows': 'absences',
    'push.enable': 'Activer les notifications', 'push.enabled': 'Notifications activées 🔔', 'push.denied': 'Autorisez les notifications dans le navigateur',
    'cal.note': 'Commentaire', 'cal.products': 'Produits / couleurs / matériaux',
    'cal.aiAdmin': 'Administrateur IA', 'cal.aiActive': 'Actif', 'cal.aiPausedBilling': 'En pause (paiement)', 'cal.aiConnect': 'Connecter',
    'cal.aiPromo': "Les salons avec un administrateur IA obtiennent 30 à 40% de réservations en plus", 'cal.dialogs': 'Dialogues',
    'cal.bookingsStat': 'Réservations', 'cal.reschedules': 'Reports', 'cal.statToday': "Aujourd'hui",
    'cal.statMonth': 'Mois', 'cal.masters': 'Équipe', 'cal.dayOff': 'Repos',
    'ms.book.title': 'Réservation en ligne', 'ms.book.service': 'Prestation', 'ms.book.branch': 'Établissement',
    'ms.book.master': 'Spécialiste', 'ms.book.anyMaster': 'Peu importe', 'ms.book.from': 'à partir de', 'ms.book.date': 'Date', 'ms.book.time': 'Heure',
    'ms.book.dayClosed': 'Fermé', 'ms.book.dayFull': 'Complet', 'ms.book.dayClosedLong': 'Le salon est fermé ce jour-là', 'ms.book.otherCategory': 'Autres', 'ms.book.noSlots': 'Aucun créneau libre ce jour-là', 'ms.book.name': 'Votre nom', 'ms.book.phone': 'Téléphone',
    'ms.book.submit': 'Réserver', 'ms.book.success': 'Rendez-vous confirmé !', 'ms.book.successWa': 'Confirmation envoyée sur WhatsApp',
    'ms.book.taken': 'Ce créneau vient d\'être pris — choisissez-en un autre', 'ms.book.leadTitle': 'Laisser une demande',
    'ms.book.leadDate': 'Date et heure souhaitées', 'ms.book.leadSent': 'Demande envoyée ! Nous vous contacterons rapidement',
    'ms.book.minutes': 'min', 'ms.book.another': 'Réserver encore',
    'ms.book.stepOf': 'Étape {n} sur {total}', 'ms.book.back': 'Retour', 'ms.book.chooseBranch': 'Choisissez un établissement',
    'ms.book.chooseService': 'Choisissez une prestation', 'ms.book.chooseMaster': 'Choisissez un(e) spécialiste', 'ms.book.chooseTime': 'Choisissez la date et l’heure',
    'ms.book.contact': 'Vos coordonnées', 'ms.book.anyMasterHint': 'Nous vous attribuerons un(e) spécialiste disponible',
    'ms.book.phoneCheck': 'Vérifiez votre numéro — nous y enverrons le rappel de votre rendez-vous', 'ms.book.phoneLooksWrong': 'Ce numéro semble incomplet — merci de le vérifier',
    'ms.book.consent': 'J’accepte la {policy} et de recevoir des rappels de rendez-vous (WhatsApp / SMS)', 'ms.book.policy': 'politique de confidentialité',
    'ms.book.addToCalendar': 'Ajouter au calendrier', 'ms.book.googleCal': 'Google Agenda', 'ms.book.writeWa': 'Écrire sur WhatsApp',
    'ms.book.reminderTo': 'Le rappel sera envoyé au {phone}', 'ms.book.waHello': 'Bonjour ! J’ai réservé {service} le {date} à {time}.',
    'ms.book.total': 'Total', 'ms.book.noServicesHere': 'Aucune prestation n’est encore réservable en ligne ici — écrivez-nous dans le chat et nous trouverons un créneau',
    'miniBuilder.autoTeam': 'Les spécialistes sont remplis automatiquement depuis la section Équipe',
    'miniBuilder.autoServices': 'Les prestations et prix sont remplis automatiquement depuis la section Équipe',
    'miniBuilder.autoOpen': 'Ouvrir Équipe',
    'settings.calendarTitle': 'Calendrier Chatity', 'settings.calendarHint': 'Désactivez si vous gérez les rendez-vous dans votre propre CRM : l\'IA ne citera pas de créneaux libres — elle collectera une demande (nom, téléphone, horaire souhaité) et vous l\'enverra instantanément',
    'settings.modeTitle': 'Mode de fonctionnement', 'settings.modeHint': 'Comment l\'IA et le calendrier fonctionnent ensemble',
    'settings.modeAutopilot': 'Pilote automatique', 'settings.modeAutopilotDesc': 'L\'IA choisit un créneau libre par praticien et crée un rendez-vous confirmé dans le calendrier. Vous êtes notifié à chaque réservation.',
    'settings.modeManual': 'Calendrier sans IA', 'settings.modeManualDesc': 'Le calendrier est activé mais l\'IA ne répond pas aux clients. Vous gérez les rendez-vous manuellement. Les messages des clients sont enregistrés et vous sont transmis.',
    'settings.modeCrmOnly': 'Demandes uniquement (sans calendrier)', 'settings.modeCrmOnlyDesc': 'Pas de calendrier. L\'IA discute et collecte les demandes (nom, téléphone, souhaits) ; vous gérez les rendez-vous dans votre CRM.',
    'settings.timezone': "Fuseau horaire du salon", 'settings.timezoneMissing': "— non défini (Europe/Paris par défaut) —", 'settings.timezoneSaved': "Fuseau horaire enregistré", 'settings.timezoneWarning': "Indiquez votre fuseau horaire : les horaires de l'IA, les créneaux et les rappels en dépendent.",
    'settings.aiScheduleScopeAll': "Un planning pour tous les canaux", 'settings.aiScheduleScopePerChannel': "Par canal", 'settings.aiScheduleAppliesTo': "S'applique à", 'settings.aiScheduleChannelsHint': "Décochez un canal pour que l'IA y réponde 24h/24 (ex. widget du site toujours, WhatsApp seulement hors horaires).", 'settings.aiScheduleCh.widget': "Widget du site", 'settings.aiScheduleCh.whatsapp': "WhatsApp", 'settings.aiScheduleCh.instagram': "Instagram", 'settings.aiScheduleCh.phone': "Téléphone", 'settings.aiScheduleChEnabled': "Limiter les horaires de l'IA sur « {channel} »", 'settings.aiSchedulePhoneHint': "Téléphone : hors horaires de l'IA, l'appel est transféré vers votre numéro de transfert (s'il est défini).",
    'settings.aiScheduleTitle': 'Horaires de l\'IA réceptionniste', 'settings.aiScheduleHint': 'En dehors de ces horaires, l\'IA ne répond pas — les messages sont enregistrés et vous recevez une notification. Heure du salon', 'settings.aiScheduleAlways': '24h/24', 'settings.aiScheduleOn': 'Selon planning', 'settings.aiScheduleDays': 'Lun,Mar,Mer,Jeu,Ven,Sam,Dim', 'settings.aiScheduleOffMsg': 'Réponse automatique hors horaires de l\'IA (optionnel)', 'settings.aiScheduleOffMsgPh': 'Ex. : Merci pour votre message ! Notre équipe vous répondra pendant les heures d\'ouverture 💛', 'settings.aiScheduleOffMsgHint': 'Envoyée une fois par 12 h et par dialogue. Vide — l\'IA reste simplement silencieuse.',
    'settings.deleteAccount': 'Supprimer le compte Chatity', 'settings.deleteWarn': 'Suppression définitive : votre salon, tout l\'historique des dialogues sur tous les canaux, clients, rendez-vous, équipe, connexions WhatsApp/Instagram (instances déconnectées) ; l\'abonnement est annulé. Les données ne pourront pas être récupérées.', 'settings.deleteTypeHint': 'Tapez DELETE pour confirmer :', 'settings.deleteConfirmBtn': 'Tout supprimer définitivement', 'settings.deleteCancel': 'Annuler', 'settings.deleteDone': 'Compte et données supprimés',
    'settings.voiceTitle': 'Réponses vocales de l\'IA', 'settings.voiceHint': 'L\'IA peut répondre aux clients sur WhatsApp et Instagram par un message vocal, en plus du texte. La voix parle la langue du client.', 'settings.voiceMode_off': 'Désactivé', 'settings.voiceMode_off_desc': 'Texte uniquement', 'settings.voiceMode_voice_in': 'Vocal pour vocal', 'settings.voiceMode_voice_in_desc': 'Si le client envoie un vocal, on répond en vocal (recommandé)', 'settings.voiceMode_always': 'Toujours', 'settings.voiceMode_always_desc': 'Chaque réponse de l\'IA est aussi envoyée en vocal', 'settings.voicePreview': 'Écouter', 'settings.voiceStop': 'Stop', 'settings.voiceQuota': 'Caractères ce mois-ci',
    'settings.humanFirstTitle': "🙋 L'humain d'abord : délai de réponse de l'IA sur WhatsApp/Instagram", 'settings.humanFirstHint': "L'IA attend le délai choisi avant de répondre. Si votre équipe répond pendant ce temps (depuis le téléphone ou Messages), l'IA reste silencieuse. Le widget du site répond toujours immédiatement.", 'settings.humanFirst0': "Sans délai — l'IA répond immédiatement", 'settings.humanFirst30': "30 secondes", 'settings.humanFirst60': "1 minute", 'settings.humanFirst120': "2 minutes", 'settings.humanFirst300': "5 minutes", 'settings.humanFirst600': "10 minutes",
    'settings.manualPauseTitle': '⏸ Pause de l\'IA après votre réponse manuelle', 'settings.manualPauseHint': 'Quand vous répondez vous-même à un client (depuis votre téléphone sur WhatsApp/Instagram ou depuis Messages), l\'IA se tait dans ce dialogue pendant la durée choisie. Vous pouvez réactiver l\'IA plus tôt depuis Messages.',
    'settings.manualPause1': '1 heure', 'settings.manualPause6': '6 heures', 'settings.manualPause24': '24 heures', 'settings.manualPause72': '3 jours', 'settings.manualPause0': 'Jusqu\'à réactivation manuelle',
    'settings.brandingTitle': 'Supprimer la marque Chatity', 'settings.brandingHint': 'L\'IA ne mentionnera pas « Chatity » — elle se présentera comme l\'assistant virtuel de votre salon',
    'settings.introLabel': 'Comment l\'IA se présente', 'settings.introPlaceholder': 'Ex. : Bonjour ! Je suis Mia — la réceptionniste virtuelle de Oui Beauté 💛',
    'settings.introHint': 'Traduit automatiquement dans la langue du client. Laissez vide pour le message par défaut.',
    'settings.languageTitle': "Langue de l'interface",
    'subscription.freeForever': 'Vous êtes sur le plan Free — calendrier et mini-site gratuits pour toujours',
    'subscription.freeForeverHint': "Ajoutez l'administrateur IA dès 39€/mois — il répond aux clients et prend les rendez-vous",
    'team.loadError': 'Impossible de charger les données',
    'team.saved': 'Enregistré',
    'team.saveError': 'Échec de l\'enregistrement',
    'team.deleted': 'Supprimé',
    'team.inviteSent': 'Invitation envoyée par e-mail',
    'team.inviteError': 'Échec de l\'envoi de l\'invitation',
    'team.branchesTitle': 'Établissements',
    'team.addBranch': 'Ajouter un établissement',
    'team.branchesHint': 'L\'IA voit vos établissements et demande au client lequel réserver',
    'team.mainBranch': 'Principal',
    'team.editBranch': 'Modifier l\'établissement',
    'team.branchName': 'Nom',
    'team.branchAddress': 'Adresse',
    'team.branchPhone': 'Téléphone',
    'team.branchHours': 'Horaires',
    'team.branchHoursHint': "Les horaires limitent les plannings — l'IA ne proposera jamais de créneaux en dehors",
    'team.staffTitle': 'Membres de l\'équipe',
    'team.addStaff': 'Ajouter un membre',
    'team.noServicesWarning': 'Aucune prestation assignée — l\'IA et l\'agenda ne peuvent pas réserver ce praticien. Cliquez pour cocher les prestations',
    'team.staffHint': 'Invitez les praticiens et admins par e-mail — ils reçoivent un code unique',
    'team.noStaff': 'Aucun membre — ajoutez votre premier praticien',
    'team.roleAdmin': 'Admin',
    'team.roleMaster': 'Praticien',
    'team.roleMasterDesc': 'voit uniquement son planning',
    'team.roleAdminDesc': 'gère les réservations',
    'team.joined': 'Actif',
    'team.invited': 'Invité',
    'team.noEmail': 'sans e-mail',
    'team.invite': 'Inviter',
    'team.resendAccess': 'Rétablir l’accès', 'team.accessSent': 'E-mail de récupération d’accès envoyé', 'team.resendHint': 'Connexion impossible ? Renvoyez l’e-mail — le praticien définit un nouveau mot de passe via le lien et le code (valables 24 h).',
    'team.reinvite': 'Renvoyer',
    'team.schedule': 'Planning',
    'team.editStaff': 'Modifier le membre',
    'team.staffName': 'Nom',
    'team.forInvite': 'pour l\'invitation',
    'team.role': 'Rôle',
    'team.branches': 'Établissements',
    'team.staffServices': 'Prestations',
    'team.addServicesFirst': 'Ajoutez d\'abord des prestations',
    'team.color': 'Couleur du calendrier',
    'team.planityTitle': 'Importer le planning depuis Planity', 'team.planityHint': 'Collez le lien iCal Planity personnel de ce praticien — le système prendra automatiquement en compte ses créneaux occupés et ne proposera que les horaires réellement libres.', 'team.planityCheck': 'Vérifier', 'team.planityFound': 'créneaux occupés trouvés', 'team.planityError': 'Impossible de lire le calendrier',
    'team.scheduleFor': 'Planning —',
    'team.dayOff': 'Repos',
    'team.photoUpload': 'Ajouter une photo', 'team.photoChange': 'Changer la photo', 'team.photoRemove': 'Retirer', 'team.photoHint': 'JPG/PNG/WebP jusqu\'à 2 Mo — visible sur le mini-site',
    'team.allBranches': 'Tous les établissements', 'team.serviceBranches': 'Établissements', 'team.serviceBranchesHint': 'Rien de sélectionné — la prestation est proposée partout. Le prix par établissement remplace le prix de base ; les prix par niveau s\'appliquent par-dessus.', 'team.priceIn': 'Prix à', 'team.duplicate': 'Dupliquer', 'team.copySuffix': 'copie',
    'team.repeat': 'Périodicité de l\'horaire', 'team.repeatHint': 'Ex. : le praticien travaille selon cet horaire une semaine sur deux. Aucune réservation n\'est proposée les semaines off.', 'team.repeatWeekly': 'Chaque semaine', 'team.repeatEveryN': 'Toutes les {n} sem.', 'team.repeatAnchor': 'Première semaine travaillée (un jour quelconque)', 'team.repeatUntil': 'Jusqu\'au (facultatif)',
    'team.acceptsLower': 'Accepte des clients aux niveaux inférieurs s\'il y a des créneaux libres', 'team.acceptsLowerHint': 'La réservation en ligne et l\'IA proposent d\'abord les praticiens du niveau demandé ; s\'il n\'y en a pas à l\'heure voulue — ce praticien au prix de base.', 'cal.priceAuto': 'Auto', 'ms.book.fallbackNote': 'Seul un praticien de niveau supérieur est libre à cette heure — réservation au prix normal',
    'team.allServices': 'Toutes les prestations',
    'team.staffServicesHint': 'Cochez les prestations du praticien. L’IA et la réservation en ligne ne réservent ce praticien QUE pour les prestations cochées (sans case cochée, il n’est pas réservable). Pour celles cochées, définissez une durée et un prix propres — ils remplacent les valeurs par défaut.', 'team.ownDurationPrice': 'Durée / prix propres à ce praticien',
    'team.category': 'Catégorie', 'team.categoryPlaceholder': 'Ongles / Sourcils / Cheveux', 'team.noCategory': 'Sans catégorie', 'team.wholeCategory': 'toute la catégorie',
    'team.exceptions': 'Exceptions : congés et jours particuliers', 'team.exceptionsHint': 'Ces jours priment sur l\'horaire hebdomadaire : la réservation en ligne, l\'IA et le téléphone ne proposeront pas ces créneaux.',
    'team.excFrom': 'Du', 'team.excTo': 'Au', 'team.excDayOff': 'Repos', 'team.excCustom': 'Horaires spéciaux', 'team.excNote': 'Note (ex. congés)', 'team.excAdd': 'Ajouter', 'team.excNone': 'Aucune exception', 'team.excAdded': 'Exception ajoutée', 'team.excRemoved': 'Exception supprimée',
    'cal.vacation': 'Absent(e)',
    'team.servicesTitle': 'Prestations et durée', 'team.levels': 'Niveaux des praticiens', 'team.level': 'Niveau', 'team.levelNone': 'Sans niveau', 'team.priceByLevel': 'Prix selon le niveau', 'team.priceByLevelHint': 'Laissez vide si le prix est identique. Remplissez seulement les niveaux dont le prix diffère du prix de base.', 'team.levelsTitle': 'Niveaux des praticiens', 'team.levelsHint': 'Noms et étoiles comme dans votre salon. Visibles sur le mini-site, à la réservation et dans les réponses de l’IA.', 'team.levelName': 'Nom', 'team.addLevel': 'Ajouter un niveau',
    'team.addService': 'Ajouter une prestation',
    'team.servicesHint': 'La durée permet à l\'IA de proposer de vrais créneaux libres',
    'team.noServices': 'Ajoutez des prestations avec prix et durée',
    'team.min': 'min',
    'team.editService': 'Modifier la prestation',
    'team.serviceName': 'Nom de la prestation',
    'team.servicePrice': 'Prix',
    'team.serviceDuration': 'Durée (min)',
    'team.save': 'Enregistrer',

    'partner.meta.title': 'Programme d\'affiliation Chatity — 30% sur chaque paiement',
    'partner.meta.description': 'Gagnez 30% sur chaque paiement des clients référés. Liens d\'affiliation, analyses, paiements sur carte.',
    'partner.nav.back': 'Chatity',
    'partner.nav.dashboard': 'Espace partenaire →',
    'partner.badge': 'Programme d\'affiliation',
    'partner.hero.title1': 'Gagnez',
    'partner.hero.title2': 'sur chaque paiement de',
    'partner.hero.title3': 'vos clients',
    'partner.hero.subtitle': 'Partagez votre lien d\'affiliation, recommandez des salons, cliniques et studios — recevez votre commission à vie, tant qu\'ils paient.',
    'partner.feature.commission.title': '30% sur chaque paiement',
    'partner.feature.commission.desc': 'Récurrent. Pas seulement le premier mois.',
    'partner.feature.link.title': 'Votre code de parrainage',
    'partner.feature.link.desc': 'Attribution valable 30 jours via cookie.',
    'partner.feature.dashboard.title': 'Tableau de bord analytique',
    'partner.feature.dashboard.desc': 'Clics, inscriptions, paiements, solde.',
    'partner.feature.payout.title': 'Versements carte / compte',
    'partner.feature.payout.desc': 'Dès 20 €. Délai de 14 jours.',
    'partner.form.title': 'Devenir partenaire',
    'partner.form.subtitle': 'Remplissez le formulaire — obtenez votre lien instantanément.',
    'partner.form.name': 'Nom',
    'partner.form.namePlaceholder': 'Jean Dupont',
    'partner.form.email': 'Email',
    'partner.form.code': 'Code souhaité (optionnel)',
    'partner.form.channel': 'Comment allez-vous promouvoir?',
    'partner.form.channelPlaceholder': 'Blog marketing pour salons, chaîne Telegram ...',
    'partner.form.submit': 'Obtenir mon lien',
    'partner.form.submitting': 'Envoi...',
    'partner.form.terms': 'En vous inscrivant, vous acceptez les conditions du programme.',
    'partner.success.heading': 'C\'est fait!',
    'partner.success.title': 'Votre lien d\'affiliation',
    'partner.success.copy': 'Copier le lien',
    'partner.success.openDashboard': 'Ouvrir l\'espace partenaire',
    'partner.success.hint': '💡 Pour voir les stats, clics et solde — connectez-vous avec le même email',
    'partner.toast.exists': 'Vous êtes déjà inscrit comme partenaire',
    'partner.toast.created': 'Candidature acceptée! Votre code est actif.',
    'partner.toast.error': 'Impossible d\'envoyer la candidature',
    'partner.toast.copied': 'Copié dans le presse-papiers',
    'partner.dash.title': 'Espace partenaire',
    'partner.dash.loading': 'Chargement...',
    'partner.dash.breadcrumb': 'Espace partenaire',
    'partner.dash.backToClient': '← Retour à l\'espace client',
    'partner.dash.refLinkLabel': 'Votre lien d\'affiliation',
    'partner.dash.commissionInfo': 'Commission {pct}% • Délai {days} jours',
    'partner.dash.copy': 'Copier',
    'partner.dash.copied': 'Copié',
    'partner.dash.stat.clicks': 'Clics (total)',
    'partner.dash.stat.clicks30d': '30 derniers jours: {n}',
    'partner.dash.stat.signups': 'Inscriptions',
    'partner.dash.stat.paid': 'payants: {n}',
    'partner.dash.stat.earned': 'Total gagné',
    'partner.dash.stat.pending': 'en attente: {amount}',
    'partner.dash.stat.available': 'Disponible',
    'partner.dash.stat.paidOut': 'versé: {amount}',
    'partner.dash.payout.title': 'Détails de paiement',
    'partner.dash.payout.subtitle': 'À remplir avant la première demande.',
    'partner.dash.payout.method': 'Méthode',
    'partner.dash.payout.methodPlaceholder': 'Choisir une méthode',
    'partner.dash.payout.method.card_ru': 'Carte (Russie)',
    'partner.dash.payout.method.bank': 'Virement bancaire',
    'partner.dash.payout.method.paypal': 'PayPal',
    'partner.dash.payout.method.crypto': 'USDT (TRC-20)',
    'partner.dash.payout.details': 'Détails',
    'partner.dash.payout.detailsPlaceholder': 'N° de carte / compte / adresse + nom complet',
    'partner.dash.payout.save': 'Enregistrer',
    'partner.dash.payout.saved': 'Détails enregistrés',
    'partner.dash.payout.saveError': 'Impossible d\'enregistrer',
    'partner.dash.payout.fillFirst': 'Remplissez d\'abord méthode et détails',
    'partner.dash.request.title': 'Demander un versement',
    'partner.dash.request.available': 'Disponible',
    'partner.dash.request.min': 'min. 20 €',
    'partner.dash.request.amount': 'Montant',
    'partner.dash.request.currency': 'Devise',
    'partner.dash.request.submit': 'Demander le versement',
    'partner.dash.request.created': 'Demande de versement créée',
    'partner.dash.referrals.title': 'Vos références',
    'partner.dash.referrals.empty': 'Personne ne s\'est encore inscrit via votre lien.',
    'partner.dash.referrals.email': 'Email',
    'partner.dash.referrals.business': 'Entreprise',
    'partner.dash.referrals.plan': 'Plan',
    'partner.dash.referrals.status': 'Statut',
    'partner.dash.referrals.payments': 'Paiements',
    'partner.dash.referrals.earned': 'Gagné',
    'partner.dash.referrals.paid': 'Payant',
    'partner.dash.referrals.trial': 'Trial',
    'partner.dash.payouts.title': 'Historique des versements',
    'partner.dash.payouts.empty': 'Aucune demande pour l\'instant.',
    'partner.dash.payouts.date': 'Date',
    'partner.dash.payouts.amount': 'Montant',
    'partner.dash.payouts.method': 'Méthode',
    'partner.dash.payouts.status': 'Statut',
    'partner.dash.payouts.note': 'Note',
    'partner.onboard.title': 'Programme d\'affiliation',
    'partner.onboard.subtitle': 'Amenez des clients à Chatity et gagnez 30% sur chaque paiement. Délai 14 jours, versements dès 20 €.',
    'partner.onboard.name': 'Votre nom',
    'partner.onboard.code': 'Code souhaité (optionnel)',
    'partner.onboard.submit': 'Devenir partenaire',
    'partner.onboard.success': 'Bravo! Vous êtes partenaire.',
    'partner.onboard.error': 'Erreur',
    'partner.cta.badge': 'Gagnez avec le parrainage',
    'partner.cta.title': 'Devenez partenaire',
    'partner.cta.desc': 'Recevez 30% sur chaque paiement des clients que vous amenez',
    'partner.cta.button': 'Ouvrir le programme',
    'partner.footer': 'Partenaires',
    'shortLink.title': 'Lien court de réservation',
    'shortLink.description': 'Donnez à vos clients un lien direct vers le chat. Idéal pour la bio Instagram, Linktree, cartes de visite, pubs. Un clic ouvre le chat IA prêt à l\'emploi.',
    'shortLink.placeholder': 'oui-beaute',
    'shortLink.save': 'Enregistrer',
    'shortLink.saving': 'Enregistrement...',
    'shortLink.copy': 'Copier',
    'shortLink.open': 'Ouvrir',
    'shortLink.qr': 'QR-code',
    'shortLink.qr.title': 'Votre QR-code',
    'shortLink.qr.hint': 'Placez-le sur vos supports imprimés, cartes de visite ou en vitrine — le scan ouvre votre mini-site.',
    'shortLink.qr.download': 'Télécharger PNG',
    'shortLink.qr.close': 'Fermer',
    'shortLink.toast.qrDownloaded': 'QR-code téléchargé',
    'shortLink.toast.qrDownloadFailed': 'Échec du téléchargement du QR-code',
    'shortLink.status.checking': 'Vérification...',
    'shortLink.status.available': 'Disponible',
    'shortLink.status.taken': 'Indisponible',
    'shortLink.status.currentLink': 'C\'est votre lien actuel',
    'shortLink.status.error': 'Erreur',
    'shortLink.reason.reserved': 'Ce slug est réservé par le système',
    'shortLink.reason.alreadyTaken': 'Déjà pris par un autre salon',
    'shortLink.reason.tooShort': 'Minimum 3 caractères',
    'shortLink.reason.tooLong': 'Maximum 50 caractères',
    'shortLink.reason.invalidChars': 'Uniquement lettres, chiffres et tirets (pas d\'espaces ni de caractères spéciaux)',
    'shortLink.toast.saved': 'Lien court enregistré',
    'shortLink.toast.saveFailed': 'Échec de l\'enregistrement',
    'shortLink.toast.copied': 'Lien copié',
    'shortLink.badge.active': 'ACTIF',
    'shortLink.badge.notSet': 'NON CONFIGURÉ',
    'notFound.title': 'Page introuvable',
    'notFound.headline': 'Cette page s\'est perdue',
    'notFound.subtitle': 'Peut-être que le lien a expiré ou contient une faute. Mais l\'IA Chatity ne se perd jamais 😉',
    'notFound.cta.home': 'Accueil',
    'notFound.cta.demo': 'Essayer l\'IA',
    'notFound.helpfulLinks': 'Ou essayez',
    'notFound.link.blog': 'Blog',
    'notFound.link.partner': 'Devenir partenaire',
    'notFound.link.login': 'Se connecter',
    'notFound.link.support': 'Support',
    'miniSite.cta.chat': 'Obtenir une consultation',
    'miniSite.bookNow': 'Réserver',
    'miniSite.showPhone': 'Afficher',
    'miniSite.section.team': 'Spécialistes',
    'miniSite.onMap': 'Sur la carte',
    'miniSite.services.viewAll': 'Voir tout',
    'miniSite.services.collapse': 'Réduire',
    'miniBuilder.colors.title': 'Couleur du mini-site',
    'miniBuilder.colors.hint': 'Couleur d\'accent des boutons, prix et titres sur la page publique.',
    'miniBuilder.colors.preview': 'aperçu du bouton',
    'miniBuilder.team.title': 'Spécialistes',
    'miniBuilder.team.add': 'Ajouter un spécialiste',
    'miniBuilder.team.name': 'Nom du spécialiste',
    'miniBuilder.team.role': 'Spécialité (ex. Prothésiste ongulaire)',
    'miniBuilder.team.empty': 'Ajoutez vos spécialistes — ils apparaîtront en cartes sur le mini-site avec un bouton « Réserver ».',
    'miniSite.section.about': 'À propos',
    'miniSite.empty': 'Description du salon à venir. En attendant — posez vos questions à l\'IA à droite 👉',
    'miniSite.section.services': 'Services & tarifs',
    'miniSite.section.gallery': 'Galerie',
    'miniSite.section.contacts': 'Contacts & adresse',
    'miniSite.contact.phone': 'Téléphone',
    'miniSite.contact.address': 'Adresse',
    'miniSite.map.openInMaps': 'Ouvrir dans Google Maps',
    'miniSite.section.hours': 'Horaires d\'ouverture',
    'miniSite.contact.whatsapp': 'WhatsApp',
    'miniSite.contact.email': 'Email',
    'miniSite.gallery.close': 'Fermer (Esc)',
    'miniSite.gallery.prev': 'Précédent',
    'miniSite.gallery.next': 'Suivant',
    'miniSite.translate.byAi': 'Traduit automatiquement par IA',
    'miniSite.translate.showOriginal': 'Voir l\'original',
    'miniSite.translate.viewingOriginal': 'Version originale affichée',
    'miniSite.translate.translateBack': 'Traduire dans ma langue',
    'miniSite.translate.loading': 'Traduction automatique…',
    'miniSite.translate.failed': 'Échec de la traduction automatique. Version originale affichée.',
    'tabs.clients': 'Clients',
    'bookings.historyLimitBanner': 'Les demandes de plus de 30 jours sont disponibles avec le plan Professional',
    'clients.title': 'Base clients',
    'clients.subtitle': 'Les demandes sont automatiquement regroupées par numéro de téléphone (formats différents fusionnés)',
    'clients.limitedNote': 'Le plan Starter affiche les clients des 30 derniers jours. Historique complet — sur Professional',
    'clients.search': 'Recherche par nom ou téléphone',
    'clients.noClients': 'Pas encore de clients',
    'clients.visits': 'demandes',
    'clients.firstVisit': 'Première visite',
    'clients.lastVisit': 'Dernière visite',
    'clients.phones': 'Tous les numéros',
    'clients.services': 'Services',
    'clients.source': 'Source',
    'clients.aiSummary': 'Synthèse IA du client', 'clients.aiSummaryBuild': 'Générer la synthèse', 'clients.aiSummaryRefresh': 'Actualiser', 'clients.aiSummaryBusy': 'Analyse…', 'clients.aiSummaryHint': 'L\'IA lit l\'historique des rendez-vous et des échanges et décrit le client en bref : rythme de visites, prestations préférées, préférences et quoi proposer ensuite.', 'clients.aiRisk': 'Risque de départ', 'clients.aiRhythm': 'Rythme de visites', 'clients.aiFavorites': 'Prestations préférées', 'clients.aiNextOffer': 'Quoi proposer', 'clients.aiGenerated': 'Générée le',
    'clients.history': 'Historique des demandes',
    
    // Upgrade banners for features
    'upgrade.telegram.title': 'Notifications Telegram disponibles sur les plans Professional et Unlimited',
    'upgrade.telegram.button': 'Mettre à niveau',
    'upgrade.widget.title': 'Personnalisation du widget',
    'upgrade.widget.description': 'Personnalisez l\'apparence du widget pour votre marque sur les plans Professional ou Unlimited:',
    'upgrade.widget.feature1': 'Changer les couleurs du widget',
    'upgrade.widget.feature2': 'Personnaliser le message de bienvenue',
    'upgrade.widget.feature3': 'Personnaliser le nom du bot',
    'upgrade.widget.button': 'Mettre à niveau',
    'bookings.subtitle': 'Toutes les réservations clients',
    'bookings.autoUpdate': 'Mise à jour auto toutes les 10 sec',
    'bookings.refresh': 'Actualiser',
    'bookings.noBookings': 'Pas encore de réservations',
    'bookings.client': 'Client',
    'bookings.phone': 'Téléphone',
    'bookings.service': 'Service',
    'bookings.date': 'Date',
    'bookings.created': 'Réservation',
    'bookings.newBooking': 'Nouvelle réservation! Total:',
    'bookings.storageInfo': '📋 Réservations conservées 30 jours',
    'bookings.unlimitedStorageInfo': 'Utilisez l\'export Excel pour le stockage à long terme de l\'historique',
    'bookings.upgradeForExport': 'Passez au plan Unlimited pour exporter les réservations vers Excel',
    'bookings.exportExcel': 'Exporter vers Excel',
    'bookings.exportSuccess': 'Réservations exportées avec succès',
    'bookings.exportUnlimitedOnly': 'L\'export n\'est disponible que pour le plan Unlimited',
    'bookings.exportError': 'Erreur d\'export',
    
    // Widget
    'widget.title': 'Code du widget',
    'widget.subtitle': 'Insérez ce code sur votre site avant la balise de fermeture',
    'widget.copy': 'Copier le code',
    'widget.demo': 'Ouvrir la démo',
    'widget.copied': 'Code copié!',
    'widget.status.title': 'État d\'installation du widget',
    'widget.status.unchecked': 'Cliquez sur "Vérifier" pour vérifier l\'installation',
    'widget.status.checking': 'Vérification...',
    'widget.status.active': 'Actif • Dernière activité: {time}',
    'widget.status.configured': 'Configuré, en attente du premier message',
    'widget.status.inactive': 'Non installé ou ne fonctionne pas',
    'widget.status.checkButton': '🔍 Vérifier',
    'widget.status.successToast': '✅ Widget actif et fonctionnel!',
    'widget.status.configuredToast': '🟡 Widget configuré, mais pas encore d\'activité',
    'widget.status.errorToast': '🔴 Widget non installé ou ne fonctionne pas',
    
    // Integrations
    'integrations.title': 'Intégrations',
    'integrations.subtitle': 'Intégrez le widget Chatity sur votre site',
    'integrations.yourWidgetKey': 'Votre clé de widget',
    'integrations.copyKey': 'Copier la clé',
    'integrations.copyInstructions': 'Copier les instructions',
    'integrations.instructionsCopied': 'Instructions copiées!',
    'integrations.keyCopied': 'Clé copiée!',
    'integrations.sendToDeveloper': 'Envoyer au développeur',
    'integrations.developerEmail': 'Email du développeur',
    'integrations.developerEmailPlaceholder': 'developer@example.com',
    'integrations.send': 'Envoyer',
    'integrations.emailSent': 'Instructions envoyées!',
    'integrations.wordpress.title': 'Plugin WordPress',
    'integrations.wordpress.description': 'Installation facile pour les sites WordPress. Il suffit d\'installer le plugin et d\'entrer votre clé.',
    'integrations.wordpress.download': 'Télécharger le plugin',
    'integrations.html.title': 'HTML / JavaScript',
    'integrations.html.description': 'Méthode universelle pour tout site web',
    'integrations.html.step1': 'Copiez le code du widget ci-dessus',
    'integrations.html.step2': 'Collez le code avant la balise de fermeture </body> sur votre site',
    'integrations.webflow.description': 'Pour les sites Webflow',
    'integrations.webflow.step1': 'Ouvrez les paramètres de votre projet Webflow',
    'integrations.webflow.step2': 'Allez dans Custom Code → Footer Code',
    'integrations.webflow.step3': 'Collez le code du widget copié',
    'integrations.webflow.step4': 'Enregistrez et publiez votre site',
    'integrations.twilio.title': 'Twilio Voice AI',
    'integrations.twilio.description': 'Assistant IA pour gérer les appels entrants',
    'integrations.twilio.phoneNumber': 'Votre numéro de téléphone',
    'integrations.twilio.status': 'Statut',
    'integrations.twilio.enabled': 'Activé',
    'integrations.twilio.disabled': 'Désactivé',
    'integrations.twilio.enable': 'Activer',
    'integrations.twilio.disable': 'Désactiver',
    'integrations.twilio.webhookUrl': 'URL Webhook pour configuration Twilio',
    'integrations.twilio.instructions': 'Configurez le webhook dans votre compte Twilio',
    'integrations.twilio.credentials': 'Identifiants Twilio',
    'integrations.twilio.credentialsInfo': 'Entrez vos identifiants depuis la Console Twilio',
    'integrations.twilio.credentialsRequired': 'Veuillez remplir tous les champs Twilio',
    'integrations.twilio.voiceLanguage': 'Langue de l\'assistant vocal',
    'integrations.twilio.voiceSpeed': 'Vitesse de parole',
    'integrations.twilio.howItWorks': 'Comment ça marche',
    'integrations.twilio.step1': '1. Le client appelle votre numéro',
    'integrations.twilio.step2': "2. L'IA répond dans la langue du client",
    'integrations.twilio.step3': '3. Collecte les informations de réservation',
    'integrations.twilio.step4': '4. Crée automatiquement la réservation dans votre tableau de bord',
    'integrations.shopify.description': 'Pour les boutiques en ligne Shopify',
    'integrations.shopify.step1': 'Connectez-vous à votre panneau d\'administration Shopify',
    'integrations.shopify.step2': 'Allez dans Boutique en ligne → Thèmes',
    'integrations.shopify.step3': 'Cliquez sur Actions → Modifier le code',
    'integrations.shopify.step4': 'Ouvrez le fichier theme.liquid dans le dossier Layout',
    'integrations.shopify.step5': 'Collez le code du widget avant la balise </body> et enregistrez',
    'integrations.wix.description': 'Pour les sites Wix (Premium requis)',
    'integrations.wix.step1': 'Ouvrez l\'éditeur de votre site Wix',
    'integrations.wix.step2': 'Allez dans Paramètres → Code personnalisé',
    'integrations.wix.step3': 'Cliquez sur + Ajouter du code personnalisé',
    'integrations.wix.step4': 'Collez le code du widget, sélectionnez "Charger le code sur chaque nouvelle page" et placez "Corps - fin"',
    'integrations.tilda.description': 'Pour les sites Tilda',
    'integrations.tilda.step1': 'Ouvrez les paramètres de la page dans Tilda',
    'integrations.tilda.step2': 'Allez dans "Plus" → "Code HTML pour le site"',
    'integrations.tilda.step3': 'Collez le code du widget dans le champ "Avant </body>"',
    'integrations.tilda.step4': 'Enregistrez et publiez la page',
    'integrations.squarespace.description': 'Pour les sites Squarespace',
    'integrations.squarespace.step1': 'Connectez-vous à votre panneau d\'administration Squarespace',
    'integrations.squarespace.step2': 'Allez dans Paramètres → Avancé → Injection de code',
    'integrations.squarespace.step3': 'Collez le code du widget dans le champ Pied de page',
    'integrations.squarespace.step4': 'Cliquez sur Enregistrer',
    'integrations.gtm.description': 'Pour les utilisateurs avancés avec Google Tag Manager',
    'integrations.gtm.step1': 'Connectez-vous à Google Tag Manager',
    'integrations.gtm.step2': 'Créez une nouvelle balise → HTML personnalisé',
    'integrations.gtm.step3': 'Collez le code du widget',
    'integrations.gtm.step4': 'Définissez le déclencheur sur Toutes les pages',
    'integrations.gtm.step5': 'Enregistrez, testez et publiez le conteneur',
    
    // Admin
    'admin.title': 'Panneau Super-Admin',
    'admin.subtitle': 'Statistiques de la plateforme et tous les salons',
    'admin.users': 'Utilisateurs',
    'admin.salons': 'Salons',
    'admin.bookings': 'Réservations',
    'admin.allSalons': 'Tous les salons',
    'admin.registered': 'Inscrit',
    'admin.loading': 'Chargement...',
    'admin.allSalons': 'Tous les salons',
    'admin.email': 'Email',
    'admin.plan': 'Plan',
    'admin.status': 'Statut',
    'admin.bookings': 'Réservations',
    'admin.registered': 'Inscription',
    'admin.showingYourSalon': 'Affichage uniquement de votre salon (pour démo)',
    
    // Subscription
    'subscription.title': 'Gestion de l\'abonnement',
    'subscription.subtitle': 'Choisissez un plan qui correspond à votre entreprise',
    'subscription.trialLeft': "Période d'essai:",
    'subscription.daysLeft': 'jours restants',
    'subscription.price': '7 jours gratuits, puis 39€/mois',
    'subscription.manageBilling': 'Gérer l\'abonnement',
    'subscription.manageBillingDesc': 'Annuler l\'abonnement, changer de carte, télécharger les factures',
    'subscription.manageBillingBtn': 'Ouvrir le portail',
    'subscription.portalError': 'Impossible d\'ouvrir le portail de facturation',
    'subscription.invoice': 'Facture',
    'subscription.invoiceUnavailable': 'Facture indisponible pour ce paiement',
    'subscription.button': "S'abonner",
    'subscription.error': "Erreur d'abonnement",
    'subscription.currentPlan': 'Plan actuel',
    'subscription.trialPeriod': 'Période d\'essai',
    'subscription.daysRemaining': 'restants',
    'subscription.day': 'jour',
    'subscription.days': 'jours',
    'subscription.expired': 'Période d\'essai expirée',
    'subscription.usage': 'Utilisation des conversations',
    'subscription.used': 'utilisé',
    'subscription.selectPlan': 'Sélectionner',
    'subscription.currentPlanBadge': 'Plan actuel',
    'subscription.popular': 'Populaire',
    'subscription.idealForStart': 'Parfait pour commencer',
    'subscription.forGrowingBusiness': 'Pour entreprise en croissance',
    'subscription.forLargeBusiness': 'Pour grande entreprise',
    'subscription.conversationsPerMonth': 'conversations par mois',
    'subscription.unlimited': 'Conversations illimitées',
    'subscription.aiAssistant': 'Assistant IA',
    'subscription.telegramNotifications': 'Notifications Telegram',
    'subscription.emailNotifications': 'Notifications email',
    'subscription.widgetCustomization': 'Personnalisation du widget',
    'subscription.analytics': 'Analytique',
    'subscription.extendedAnalytics': 'Analytique étendue',
    'subscription.prioritySupport': 'Support prioritaire',
    'subscription.utmTracking': 'Suivi UTM',
    'subscription.knowledgeBase': 'Base de connaissances IA',
    'subscription.securePayment': 'Paiement sécurisé',
    'subscription.securePaymentInfo': 'Tous les paiements sont traités via Stripe. Nous ne stockons pas vos données de carte.',
    'subscription.cancelAnytime': 'Annuler à tout moment',
    'subscription.cancelInfo': 'Vous pouvez annuler votre abonnement à tout moment.',
    'subscription.checkingPayment': 'Vérification du statut du paiement...',
    'subscription.paymentSuccess': 'Paiement réussi! Votre plan a été mis à niveau',
    'subscription.paymentFailedTitle': 'Problème de paiement de l\'abonnement',
    'subscription.paymentFailedText': 'Votre banque a refusé le prélèvement. La réceptionniste IA est en pause sur tous les canaux (site, WhatsApp, Instagram, téléphone) jusqu\'à réception du paiement. Mettez à jour votre carte pour reprendre.',
    'subscription.updateCardBtn': 'Mettre à jour la carte',
    'subscription.paymentCancelled': 'Paiement annulé',
    'subscription.paymentTimeout': 'La vérification du paiement a pris trop de temps',
    'subscription.sessionExpired': 'Session de paiement expirée',
    'subscription.paymentCheckError': 'Erreur lors de la vérification du statut du paiement',
    'subscription.checkoutError': 'Erreur lors de la création de la session de paiement',
    'subscription.paymentHistory': 'Historique des paiements',
    'subscription.date': 'Date',
    'subscription.plan': 'Plan',
    'subscription.amount': 'Montant',
    'subscription.status': 'Statut',
    'subscription.paid': 'Payé',
    'subscription.pending': 'En attente',
    'subscription.failed': 'Échoué',
    'subscription.monthly': 'Mensuel',
    'subscription.yearly': 'Annuel',
    'subscription.year': 'an',
    'subscription.save2Months': 'Économisez 2 mois!',
    'subscription.upgradeToYearly': 'Passer à l\'annuel',
    'subscription.creditApplied': 'Crédit appliqué pour la période restante',
    'subscription.renewalDate': 'Prochain renouvellement',
    
    // Promocodes
    'promocode.title': 'Avez-vous un code promo?',
    'promocode.placeholder': 'ENTREZ LE CODE',
    'promocode.apply': 'Appliquer',
    'promocode.remove': 'Supprimer',
    'promocode.discount': 'réduction',
    'promocode.applied': 'Code promo appliqué!',
    'promocode.error': 'Code promo invalide',
    'promocode.enterCode': 'Entrez le code promo',
    
    'subscription.trialBannerTitle': 'Période d\'essai',
    'subscription.trialExpiredTitle': 'Période d\'essai expirée',
    'subscription.selectPlanBeforeExpiry': 'Sélectionnez un plan avant l\'expiration de l\'essai pour continuer',
    'subscription.payToContinue': 'Payez l\'abonnement pour continuer',
    'subscription.selectPlanButton': 'Sélectionner un plan',
    'subscription.payButton': 'Payer',
    'subscription.activeSubscription': 'Abonnement actif',
    'subscription.conversations': 'Conversations',
    'subscription.remaining': 'restants',
    'subscription.upgradePlan': 'Améliorer le plan',
    'tabs.subscription': 'Abonnement',
    
    // Support Tickets
    'support.supportTickets': 'Tickets d\'assistance',
    'support.askOurTeam': 'Posez une question à notre équipe',
    'support.createTicket': 'Créer un ticket',
    'support.cancel': 'Annuler',
    'support.newTicket': 'Nouveau ticket',
    'support.subject': 'Sujet',
    'support.subjectPlaceholder': 'Brève description du problème',
    'support.priority': 'Priorité',
    'support.priorityLow': 'Faible',
    'support.priorityMedium': 'Moyenne',
    'support.priorityHigh': 'Haute',
    'support.message': 'Message',
    'support.messagePlaceholder': 'Décrivez votre problème en détail...',
    'support.noTicketsYet': 'Vous n\'avez pas encore de tickets',
    'support.createFirstTicket': 'Créez votre premier ticket si vous avez des questions',
    'support.messagesCount': 'Messages',
    'support.statusOpen': 'Ouvert',
    'support.statusInProgress': 'En cours',
    'support.statusClosed': 'Fermé',
    'support.backToList': 'Retour à la liste',
    'support.supportTeam': 'Assistance',
    'support.you': 'Vous',
    'support.reply': 'Répondre',
    'support.enterYourMessage': 'Entrez votre message...',
    'support.send': 'Envoyer',
    'support.ticketClosed': 'Ce ticket est fermé',
    'support.errorLoadingTicket': 'Erreur de chargement du ticket',
    'support.fillAllFields': 'Remplissez tous les champs',
    'support.ticketCreated': 'Ticket créé avec succès!',
    'support.errorCreatingTicket': 'Erreur lors de la création du ticket',
    'support.messageSent': 'Message envoyé',
    'support.errorSendingMessage': 'Erreur lors de l\'envoi du message',
    
    // Admin
    'admin.title': 'Panneau Super Admin',
    'admin.subtitle': 'Statistiques complètes de la plateforme',
    'admin.days': 'jours',
    'admin.allTime': 'Tout le temps',
    'admin.totalUsers': 'Total utilisateurs',
    'admin.totalBookings': 'Total réservations',
    'admin.paidVsTrial': 'Payé / Essai',
    'admin.conversion': 'Conversion',
    'admin.periodStats': 'Statistiques de période',
    'admin.newUsers': 'Nouveaux utilisateurs',
    'admin.newSalons': 'Nouveaux salons',
    'admin.newBookings': 'Nouvelles réservations',
    'admin.loading': 'Chargement...',
    
    // Common
    'common.loading': 'Chargement...',
    'common.error': 'Erreur de chargement',
    
    // Landing Page
    'landing.home': 'Accueil',
    'landing.hero.title': 'Plus de rendez-vous. Plus de revenus. Aucun client manqué.',
    'landing.hero.subtitle': 'L\'administratrice IA Chatity répond aux clients 24h/24, traite chaque demande et la transforme en rendez-vous.',
    'landing.hero.benefit1': 'Plus de prospects sans embaucher',
    'landing.hero.benefit2': 'Zéro opportunité manquée',
    'landing.hero.benefit3': 'Installation en 5 minutes sur tout site',
    'landing.hero.cta': 'Commencer gratuitement',
    'landing.hero2.eyebrow': 'Accueil IA pour beauté & bien-être',
    'landing.hero2.title': 'Plus de rendez-vous. Plus de revenus. Aucun client manqué.',
    'landing.hero2.subtitle': 'L\'administratrice IA Chatity répond aux clients 24h/24, traite chaque demande et la transforme en rendez-vous.',
    'landing.hero2.chWebsite': 'Site web',
    'landing.hero2.chVoice': 'Voix',
    'landing.hero2.soon': 'bientôt',
    'landing.hero2.demo': 'Voir comment ça marche',
    'landing.hero2.nocard': 'Sans carte bancaire · Installation en 5 minutes',
    'landing.hero2.hours': 'h',
    'landing.hero2.stat1': 'de réservations en plus',
    'landing.hero2.stat2': 'de travail admin / mois',
    'landing.hero2.stat3': 'aucun client manqué',
    'landing.hero2.newBooking': 'Nouvelle réservation !',
    'landing.cta2.eyebrow': 'Prêt à obtenir plus de réservations ?',
    'landing.cta2.title': 'Commencez gratuitement',
    'landing.cta2.note': 'Sans carte bancaire · Installation en 5 minutes · Annulation à tout moment',
    'landing.cta2.join': 'Rejoignez des centaines d\'entreprises beauté et bien-être',
    'landing.hero.trial': '7 jours gratuits • Sans carte',
    'landing.login': 'Connexion',
    
    // Trust section
    'landing.trust.title': 'Ils nous font confiance',
    'landing.trust.subtitle': 'Utilisent déjà Chatity pour automatiser les réservations:',
    'landing.trust.category1': 'Salons de beauté',
    'landing.trust.category2': 'Cliniques et dentistes',
    'landing.trust.category3': 'Studios de yoga et fitness',
    'landing.trust.category4': 'Écoles en ligne',
    'landing.trust.category5': 'Entreprises de services',
    'landing.trust.case1.niche': 'Salon de beauté',
    'landing.trust.case1.metric': 'Augmentation notable',
    'landing.trust.case1.description': 'Plus de rendez-vous en ligne via le site',
    'landing.trust.case1.usecase': 'Le chat répond aux questions sur les procédures, guide les clients et simplifie les demandes de rendez-vous',
    'landing.trust.case2.niche': 'Clinique dentaire',
    'landing.trust.case2.metric': 'Demandes hors horaires',
    'landing.trust.case2.description': 'La plupart des nouvelles demandes arrivent en dehors des heures d\'ouverture',
    'landing.trust.case2.usecase': 'L\'assistant IA aide à filtrer les demandes, expliquer les services et orienter correctement les patients',
    'landing.trust.case3.niche': 'Studio de yoga',
    'landing.trust.case3.metric': 'Moins de routine',
    'landing.trust.case3.description': 'Temps réduit sur les questions répétitives',
    'landing.trust.case3.usecase': 'Le chat explique les cours, horaires et tarifs avant de transmettre les prospects qualifiés au personnel',
    'landing.trust.case4.niche': 'École en ligne',
    'landing.trust.case4.metric': 'Plus d\'engagement',
    'landing.trust.case4.description': 'Meilleur engagement des visiteurs du site',
    'landing.trust.case4.usecase': 'Le chat répond aux questions sur les cours, les prix et les leçons d\'essai',
    'landing.trust.case5.niche': 'Service auto',
    'landing.trust.case5.metric': 'Croissance stable',
    'landing.trust.case5.description': 'Augmentation constante des demandes de réservation',
    'landing.trust.case5.usecase': 'Le chat collecte les détails du véhicule, les problèmes et aide à organiser les demandes de service',
    'landing.trust.case6.niche': 'Restaurant',
    'landing.trust.case6.metric': 'Réservations régulières',
    'landing.trust.case6.description': 'Réservations de tables plus cohérentes',
    'landing.trust.case6.usecase': 'Le chat accepte les demandes de réservation et répond aux questions sur le menu et la disponibilité',
    
    // Integrations section
    'landing.integrations.title': 'Intégration facile',
    'landing.integrations.subtitle': 'Installez le chat sur n\'importe quelle plateforme en 5 minutes',
    'landing.integrations.cta': 'Fonctionne avec n\'importe quel constructeur de site et CMS',
    'landing.integrations.button': 'Commencer gratuitement',
    
    // Business types for animation
    'landing.business.beautySalon': 'salon de beauté',
    'landing.business.restaurant': 'restaurant',
    'landing.business.dentalClinic': 'clinique dentaire',
    'landing.business.medicalCenter': 'centre médical',
    'landing.business.barbershop': 'barbier',
    'landing.business.nailStudio': 'studio d\'ongles',
    'landing.business.yogaStudio': 'studio de yoga',
    'landing.business.carService': 'service auto',
    
    'landing.features.title': 'Tout pour l\'automatisation des réservations',
    'landing.feature1.title': 'Conversation IA',
    'landing.feature1.desc': 'Le bot a des conversations naturelles, connaît le service, la date, le nom et le téléphone',
    'landing.feature2.title': 'Notifications Email & Telegram',
    'landing.feature2.desc': 'Notifications instantanées de réservation par Email ou dans votre groupe Telegram',
    'landing.feature3.title': 'Multilingue',
    'landing.feature3.desc': 'Parle automatiquement la langue du client (14+ langues)',
    'landing.feature4.title': 'Widget prêt',
    'landing.feature4.desc': 'Insérez le code sur le site - et ça marche',
    'landing.feature5.title': 'Historique réservations',
    'landing.feature5.desc': 'Toutes les réservations sauvegardées dans le tableau de bord',
    'landing.feature6.title': 'Personnalisation design',
    'landing.feature6.desc': 'Couleurs, textes et style pour votre marque',
    'landing.feature7.title': 'Website Builder',
    'landing.feature7.desc': 'Une page chatity.io/votre-nom prête à l\'emploi avec services, photos et chat IA — parfait pour Instagram et cartes de visite',
    'landing.builder.badge': 'Nouveau',
    'landing.builder.title': 'Website Builder — votre site en 5 minutes',
    'landing.builder.subtitle': 'Pas besoin de site séparé — créez la page de votre salon directement dans Chatity, sans designer ni développeur',
    'landing.builder.point1': 'Votre page chatity.io/votre-salon avec services, prix, galerie et carte',
    'landing.builder.point2': 'Le chat IA intégré répond aux clients et prend les rendez-vous 24h/24',
    'landing.builder.point3': 'QR code et lien court pour Instagram, cartes de visite et vitrine',
    'landing.builder.point4': 'Traduction automatique de la page dans la langue du visiteur',
    'landing.builder.cta': 'Créer mon site gratuitement',
    'landing.builder.mock.services': 'Services et tarifs',
    'landing.builder.mock.chat': 'Bonjour ! Souhaitez-vous prendre rendez-vous ? 💬',
    'landing.partnerBlock.badge': 'Programme d\'affiliation',
    'landing.partnerBlock.title': 'Devenez partenaire — gagnez 30%',
    'landing.partnerBlock.subtitle': 'Recommandez Chatity et gagnez 30% de chaque paiement des clients que vous parrainez. Lien personnel, statistiques en temps réel et paiements sur demande.',
    'landing.partnerBlock.point1': '30% de chaque paiement des clients parrainés',
    'landing.partnerBlock.point2': 'Lien de parrainage et code promo personnels',
    'landing.partnerBlock.point3': 'Tableau de bord partenaire avec statistiques et solde',
    'landing.partnerBlock.cta': 'Devenir partenaire',
    'auth.referralCode': 'Code de parrainage (optionnel)',
    'dashboard.partnerProgram': 'Affiliation',
    'bookings.totalCount': 'Total des demandes',
    'bookings.uniqueClients': 'Clients uniques',
    'bookings.repeatBadge': 'Répétée',
    'dashboard.affiliateBlock.title': 'Programme d\'affiliation',
    'dashboard.affiliateBlock.desc': 'Recommandez d\'autres salons et gagnez 30% de tous leurs paiements sur votre solde. Paiements par carte ou IBAN (Europe).',
    'dashboard.affiliateBlock.cta': 'Ouvrir l\'espace partenaire',
    'partner.dash.payout.method.card_eu': 'Carte bancaire (Europe)',
    'partner.dash.payout.method.sepa_eu': 'Virement IBAN / SEPA (Europe)',
    'partner.dash.payout.subtitleEu': 'Paiements en Europe uniquement : carte bancaire ou IBAN/SEPA (EUR).',
    
    'landing.howItWorks.title': 'Comment ça marche',
    'landing.step1.title': 'Inscription',
    'landing.step1.desc': 'Créez un compte en 30 secondes',
    'landing.step2.title': 'Configuration',
    'landing.step2.desc': 'Connectez Email/Telegram et personnalisez le design',
    'landing.step3.title': 'Intégration',
    'landing.step3.desc': 'Insérez le code widget sur votre site',
    'landing.step4.title': 'Réservations',
    'landing.step4.desc': 'Recevez les réservations automatiquement',
    
    'landing.pricing.title': 'Choisissez votre plan',
    'landing.pricing.subtitle': '7 jours gratuits sur tous les plans',
    'landing.price.perMonth': 'par mois',
    'landing.price.feature1': "L'IA parle la langue de vos clients",
    'landing.price.calendar': 'Calendrier + réservation en ligne',
    'landing.price.feature2': 'Notifications par email',
    'landing.price.feature3': 'Historique (30 jours)',
    'landing.price.feature4': 'Base de connaissances IA',
    'landing.price.feature5': 'Analytique de base',
    'landing.price.cta': 'Essai gratuit',
    
    'landing.plan.popular': 'POPULAIRE',
    'landing.plan.starter.name': 'Starter',
    'landing.plan.starter.desc': 'Pour les professionnels indépendants',
    'landing.plan.starter.limit': '100 conversations/mois',
    'landing.plan.professional.name': 'Professional',
    'landing.plan.professional.desc': 'Pour les salons en croissance',
    'landing.plan.professional.limit': '1,000 conversations/mois',
    'landing.plan.free.name': 'Free', 'landing.plan.free.desc': 'Calendrier, réservation en ligne, mini-site',
    'landing.plan.free.limit': '1 spécialiste · 1 établissement',
    'landing.plan.free.f1': 'Calendrier de rendez-vous', 'landing.plan.free.f2': 'Réservation en ligne sur votre mini-site',
    'landing.plan.free.f3': 'Mini-site de votre salon', 'landing.plan.free.f4': 'Notifications Email & Telegram',
    'landing.plan.starter.tagline': "L'IA répond à vos clients et gère les réservations",
    'landing.plan.starter.channels': '1 canal (WhatsApp / Instagram / Telegram) + widget web',
    'landing.plan.professional.tagline': "Laissez l'IA gérer les conversations sur tous vos canaux",
    'landing.plan.professional.channels': 'Tous les canaux : WhatsApp + Instagram + Telegram + widget',
    'landing.plan.addons': 'Options : canal +19€/mois · +100 conversations +10€/mois · établissement +50% du tarif',
    'landing.freecrm.badge': 'START FREE TODAY', 'landing.freecrm.title': 'CRM gratuit pour la beauté',
    'landing.freecrm.subtitle': 'Calendrier, réservation en ligne et mini-site — 0€. Pour toujours. Sans carte.',
    'landing.freecrm.f1.title': 'Calendrier', 'landing.freecrm.f1.desc': 'Rendez-vous, équipe, plannings et historique clients',
    'landing.freecrm.f2.title': 'Réservation en ligne', 'landing.freecrm.f2.desc': 'Vos clients choisissent leurs créneaux 24h/24',
    'landing.freecrm.f3.title': 'Mini-site', 'landing.freecrm.f3.desc': 'La page de votre salon avec services et prix en 2 minutes',
    'landing.freecrm.note': "Besoin de l'administrateur IA ? Ajoutez un canal dès 39€/mois",
    'landing.freecrm.button': 'Commencer gratuitement',
    'landing.plan.professional.feature1': 'Notifications Telegram',
    'landing.plan.professional.feature2': 'Analytique avancée',
    'landing.plan.professional.feature3': 'Suivi UTM',
    'landing.plan.professional.feature4': 'Website Builder (créateur de site) + lien QR',
    'landing.plan.professional.extraFeature': 'Personnalisation widget',
    'landing.plan.unlimited.name': 'Unlimited',
    'landing.plan.unlimited.desc': 'Pour grande entreprise',
    'landing.plan.unlimited.limit': '∞ Conversations illimitées',
    'landing.plan.unlimited.feature1': 'Export Excel',
    'landing.plan.unlimited.feature2': 'Personnalisation étendue',
    'landing.plan.unlimited.extraFeature1': 'Support prioritaire',
    'landing.plan.unlimited.extraFeature2': 'Paramètres personnalisés',
    
    'landing.cta.title': 'Prêt à automatiser les réservations?',
    'landing.cta.subtitle': 'Rejoignez des centaines d\'entreprises utilisant déjà Chatity',
    'landing.cta.button': 'Commencer l\'essai gratuit',
    
    'landing.footer.product': 'Produit',
    'landing.footer.features': 'Fonctionnalités',
    'landing.footer.pricing': 'Tarifs',
    'landing.footer.docs': 'Documentation',
    'landing.footer.company': 'Société',
    'landing.footer.about': 'À propos',
    'landing.footer.contact': 'Contact',
    'landing.footer.rights': '© 2025 Chatity. Tous droits réservés.',

    // Footer
    'footer.description': 'Accueil IA pour beauté & bien-être',
    'footer.product': 'Produit',
    'footer.features': 'Fonctionnalités',
    'footer.pricing': 'Tarifs',
    'footer.getStarted': 'Commencer',
    'footer.legal': 'Juridique',
    'footer.privacyPolicy': 'Politique de confidentialité',
    'footer.termsOfService': 'Conditions d\'utilisation',
    'footer.cookiePolicy': 'Politique des cookies',
    'footer.contact': 'Contact',
    'footer.address': '7 Avenue de Fabron, 06200 Nice, France',
    'footer.allRightsReserved': 'Tous droits réservés.',
    
    // Cookie Consent
    'cookies.title': '🍪 Nous utilisons des cookies',
    'cookies.description': 'Nous utilisons des cookies pour améliorer les performances du site, analyser le trafic et personnaliser le contenu. En continuant à utiliser le site, vous acceptez l\'utilisation de cookies.',
    'cookies.learnMore': 'En savoir plus',
    'cookies.accept': 'Tout accepter',
    'cookies.decline': 'Essentiels uniquement',
    
    // Admin Actions
    'admin.grantUnlimited': 'Accorder illimité',
    'admin.deleteAccount': 'Supprimer compte',
    'admin.confirmDelete': 'Êtes-vous sûr de vouloir supprimer ce compte? Toutes les données utilisateur seront définitivement supprimées.',
    'admin.confirmGrant': 'Accorder un plan illimité à cet utilisateur?',
    'admin.unlimitedGranted': 'Plan illimité accordé avec succès',
    'admin.accountDeleted': 'Compte supprimé avec succès',
    'admin.error': 'Erreur lors de l\'opération',

    // Blog
    'blog.title': 'Blog',
    'blog.subtitle': 'Articles utiles sur l\'automatisation des affaires et les technologies IA',
    'blog.readMore': 'Lire la suite',
    'blog.minRead': 'min de lecture',
    'blog.noPosts': 'Articles à venir bientôt',
    'blog.backToBlog': 'Retour au blog',
    'blog.notFound': 'Article non trouvé',
    'blog.relatedPosts': 'Articles connexes',
    'blog.ctaTitle': 'Prêt à automatiser votre entreprise?',
    'blog.ctaDescription': 'Essayez Chatity gratuitement pendant 7 jours. Aucune carte de crédit requise.',
    'blog.ctaButton': 'Commencer l\'essai gratuit',

    // Green API (WhatsApp by QR)
    'greenapi.title': 'WhatsApp par QR code',
    'greenapi.badgeConnected': 'Connecté',
    'greenapi.badgeWaiting': 'En attente du scan QR',
    'greenapi.badgeNotConnected': 'Non connecté',
    'greenapi.description': 'Le moyen le plus simple : scannez un QR code dans l\'application WhatsApp — comme WhatsApp Web. Le numéro reste sur votre téléphone, l\'IA répond aux clients immédiatement.',
    'greenapi.connectedPhone': '✅ Numéro connecté : +{phone}',
    'greenapi.importBtn': '📥 Importer les clients depuis WhatsApp',
    'greenapi.refreshChats': 'Actualiser', 'greenapi.syncingChats': 'La liste des chats se synchronise depuis WhatsApp — cela prend 1 à 2 minutes après le scan du QR. Cliquez sur « Actualiser ».',
    'greenapi.importHint': 'Choisissez les chats à importer dans « Clients » — vous pouvez ignorer les contacts personnels. L\'IA connaîtra l\'historique et poursuivra les conversations en contexte.',
    'greenapi.qrHint': 'WhatsApp → Réglages → Appareils connectés → Connecter un appareil → scannez',
    'greenapi.qrNotWorking': 'Le QR ne se scanne pas ? Actualiser le QR code', 'greenapi.qrRefreshing': 'Redémarrage de la connexion — un nouveau QR apparaît dans 1 à 2 minutes', 'greenapi.qrRefreshFailed': "Impossible d'actualiser le QR, réessayez",
    'greenapi.qrStarting': '⏳ L\'instance démarre, le QR apparaîtra dans une minute…',
    'greenapi.connectBtn': 'Connecter par QR',
    'greenapi.disconnectBtn': 'Déconnecter',
    'greenapi.confirmDisconnect': 'Déconnecter WhatsApp ? L\'instance sera supprimée.',
    'greenapi.toastCreated': 'Instance créée — le QR code apparaîtra dans ~1 minute',
    'greenapi.toastCreateFail': 'Impossible de créer la connexion',
    'greenapi.toastDisconnected': 'WhatsApp déconnecté',
    'greenapi.toastDisconnectFail': 'Impossible de déconnecter',
    'greenapi.toastImported': 'Nouveaux clients importés : {imported}',
    'greenapi.toastImportFail': 'Impossible d\'importer les chats',
    'greenapi.selectTitle': 'Quels chats importer ?',
    'greenapi.selectHint': 'Cochez les clients à importer. Décochez les contacts personnels — ils ne seront pas ajoutés.',
    'greenapi.searchPlaceholder': 'Rechercher par nom ou numéro…',
    'greenapi.selectAll': 'Tout sélectionner',
    'greenapi.deselectAll': 'Tout désélectionner',
    'greenapi.alreadyImported': 'déjà importé',
    'greenapi.importSelected': 'Importer la sélection ({n})',
    'greenapi.loadingChats': 'Chargement des chats…',
    'greenapi.noChats': 'Aucun chat personnel trouvé',
    'greenapi.importing': 'Importation…',
    'greenapi.aiOn': '🤖 IA répond',
    'greenapi.aiOff': '🚫 Personnel — IA muette',
    'greenapi.contactsTitle': 'Contacts WhatsApp',
    'greenapi.contactsHint': 'Choisissez avec qui l\'IA échange et avec qui elle reste silencieuse (chats personnels)',
    'greenapi.aiReplies': 'IA répond',
    'greenapi.aiSilent': 'IA muette',
    'greenapi.disableAllAi': 'Désactiver l\'IA pour tous',
    'greenapi.enableAllAi': 'Activer l\'IA pour tous',
    'greenapi.personalHint': 'Cliquez sur le bouton « IA » à côté d\'un chat pour empêcher l\'IA de répondre dans les conversations personnelles. Si vous répondez manuellement depuis votre téléphone, l\'IA reste muette dans ce chat pendant 6 heures.',
    'greenapi.toastPersonalOn': 'L\'IA ne répondra plus dans ce chat',
    'greenapi.toastPersonalOff': 'L\'IA répond à nouveau dans ce chat',
    'greenapi.stepCreated': 'Instance créée',
    'greenapi.stepStarting': 'Démarrage sur les serveurs WhatsApp — généralement 1 à 3 minutes, parfois jusqu\'à 5',
    'greenapi.stepQr': 'Le QR code apparaîtra ici automatiquement',
    'greenapi.elapsed': 'Écoulé : {time}',
    'greenapi.takingLong': 'Le démarrage prend plus de temps que d\'habitude — cela arrive quand les serveurs Green API sont chargés. Patientez encore un peu, ou cliquez sur « Déconnecter » et recréez la connexion.',
    'integrations.cat.website': 'Site web',
    'integrations.cat.websiteDesc': 'WordPress, HTML, Tilda, Shopify…',
    'integrations.cat.whatsappDesc': 'Connexion par QR code',
    'integrations.cat.instagramDesc': 'L\'IA répond en Direct',
    'integrations.cat.identDesc': 'Réservations vers votre CRM IDENT',
    'integrations.cat.altegioDesc': 'Agenda et CRM Altegio',
    'integrations.cat.vk': 'VK',
    'integrations.cat.vkDesc': 'IA dans les messages de communauté',
    'integrations.cat.voice': 'Téléphonie',
    'integrations.cat.voiceDesc': 'Réponse aux appels par IA',
    'settings.jobReply': 'Réponse aux questions d\'emploi',
    'settings.jobReplyPlaceholder': 'Ex. : « Envoyez votre CV à hello@salon.fr — le propriétaire l\'examinera personnellement et vous recontactera »',
    'settings.jobReplyTip': 'Si vide, l\'IA recueille poliment le contact du candidat et vous le transmet. Vous recevez une alerte Telegram/email pour les réclamations et candidatures.',
    'settings.crmImportTitle': 'Importer les services depuis le CRM (Planity/Booksy/Fresha)',
    'settings.crmImportHint': 'Collez le lien de votre page de réservation publique — nous récupérons services et prix directement dans la base de connaissances de l\'IA.',
    'settings.crmImportFetch': 'Trouver les services',
    'settings.crmImportEmpty': 'Impossible de trouver des services avec prix sur ce lien. Vérifiez que la page est publique.',
    'settings.crmImportFound': 'Services trouvés : {count}',
    'settings.crmImportConfirm': 'Ajouter à la base ({count})',
    'settings.crmImportSuccess': 'Services importés : {count}',
    'settings.crmImportNote': 'Les services cochés seront ajoutés à la base de connaissances. Réimporter remplace le bloc précédemment importé.',

    // Onboarding Guide
    'onboarding.title': 'Démarrage rapide',
    'onboarding.subtitle': 'Complétez 4 étapes pour que votre IA prenne des rendez-vous',
    'onboarding.step1': 'Base de connaissances',
    'onboarding.step1Desc': 'Décrivez vos services, tarifs et horaires à l\'IA',
    'onboarding.step2': 'Connectez un canal',
    'onboarding.step2Desc': 'WhatsApp, widget de site ou mini-site',
    'onboarding.step3': 'Ajoutez une carte',
    'onboarding.step3Desc': 'Choisissez un forfait pour un service sans interruption',
    'onboarding.step4': 'Message de test',
    'onboarding.step4Desc': 'Écrivez à votre IA et vérifiez la réponse',
    'onboarding.dismiss': 'Masquer',
    'settings.revenueTitle': 'Chiffre d\'affaires pour les rapports',
    'settings.revenueHint': 'Nous utilisons les prix des services de votre base de connaissances. Le panier moyen sert de secours si un service n\'a pas de prix — c\'est ainsi que le rapport estime le CA généré par Chatity.',
    'settings.avgTicket': 'Panier moyen',
    'settings.currency': 'Devise',
    'settings.reactivationTitle': 'Réactivation clients',
    'settings.reactivationHint': 'Rappel automatique aux clients inactifs de reprendre rendez-vous + comptage des retours et du CA dans le rapport',
    'settings.reactivationDays': 'Rappeler après (jours)',
    'settings.reactivationChannel': 'Canal',
    'settings.reactivationMessage': 'Texte du message',
    'settings.reactivationPlaceholder': 'Bonjour {name} ! Vous nous manquez 💐 Envie de reprendre rendez-vous ?',
    'settings.reactivationTip': 'Utilisez {name} pour insérer le nom du client. Envoyé automatiquement une fois par jour.',

  },
  
  tr: {
    // Auth Page
    'auth.title': 'Chatity',
    'auth.subtitle': 'Güzellik ve wellness için AI resepsiyon',
    'landing.value.title': 'Müşterileriniz size yazıyor. Chatity hallediyor.',
    'landing.value.subtitle': 'Yanıtsız her mesaj kayıp bir randevudur. Chatity anında yanıtlar, randevu alır, ödeme tahsil eder ve müşterileri geri getirir.',
    'landing.value.c1': 'Hiçbir talebi kaçırmayın',
    'landing.value.c1d': 'WhatsApp, Instagram ve web sitenizde anında yanıtlar — 7/24.',
    'landing.value.c2': 'Randevu alın',
    'landing.value.c2d': 'AI uygun saatleri önerir, rezerve eder ve onaylar — resepsiyonist gerekmez.',
    'landing.value.c3': 'Ödeme alın',
    'landing.value.c3d': 'Sohbet içinde kapora ve ön ödemeler — daha az no-show.',
    'landing.value.c4': 'Müşterileri geri getirin',
    'landing.value.c4d': 'Akıllı hatırlatmalar ve pasif müşterilere kişisel davetler.',
    'auth.login': 'Giriş',
    'auth.register': 'Kayıt',
    'auth.email': 'E-posta',
    'auth.password': 'Şifre',
    'auth.salonName': 'Salon Adı',
    'auth.companyName': 'Şirket Adı',
    'auth.companyNamePlaceholder': 'örn., Beauty Studio',
    'auth.companyWebsite': 'Şirket Web Sitesi (isteğe bağlı)',
    'auth.websiteImportant': '💡 Önemli: AI\'nın müşterilerle iletişim kurarken kullanması için doğru web sitesi adresini girin',
    'auth.loginButton': 'Giriş Yap',
    'auth.registerButton': 'Kayıt Ol',
    'auth.termsAccept': "Kabul ediyorum:",
    'auth.termsLink': "Kullanım Koşulları",
    'auth.termsAnd': "ve",
    'auth.privacyLink': "Gizlilik Politikası",
    'ms.book.privacyNotice': "Randevu alarak verdiğiniz bilgiler, talebinizi işlemek ve randevunuzu yönetmek (hatırlatmalar dahil) için {business} tarafından kullanılır. Chatity teknik sağlayıcıdır ve bu verileri işletme adına işler.",
    'ms.book.learnMore': "Daha fazla",
    'ms.book.optional': "isteğe bağlı",
    'ms.book.marketingConsent': "{business} teklif ve haberlerini e-posta, SMS veya mesajlaşma uygulamalarıyla almayı kabul ediyorum",
    'privacy.title': "Gizlilik ve yasal bilgiler",
    'privacy.intro': "GDPR kapsamında müşterilerinizin verilerinin sorumlusu sizsiniz, Chatity (MINDUNITE SAS) veri işleyendir. Bu bilgiler mini sitenizdeki ve sohbet widget'ındaki gizlilik bildiriminde gösterilir.",
    'privacy.legalName': "Yasal işletme adı",
    'privacy.address': "Kayıtlı adres",
    'privacy.email': "İletişim e-postası",
    'privacy.privacyEmail': "Veri talepleri için e-posta",
    'privacy.phone': "Telefon",
    'privacy.policyUrl': "Kendi gizlilik politikanızın bağlantısı (isteğe bağlı)",
    'privacy.marketingTitle': "Pazarlama mesajları",
    'privacy.marketingEnabled': "Müşterilere pazarlama mesajlarına izin ver (geri kazanım, kampanyalar)",
    'privacy.marketingHint': "Randevu formunda ayrı, işaretsiz bir onay kutusu görünür. Onay olmadan promosyon mesajı gönderilmez; randevu hatırlatmaları her zaman çalışır.",
    'privacy.existingCustomers': "Mevcut müşteri istisnası",
    'privacy.existingCustomersHint': "Daha önce gelmiş müşterilere, abonelikten çıkmadıkları sürece (STOP) benzer hizmet teklifleri gönder. Mevzuatınızın buna izin verdiğinden emin olun.",
    'privacy.retentionTitle': "Saklama süreleri",
    'privacy.chatRetention': "Müşteri yazışmaları, gün",
    'privacy.bookingRetention': "Randevu geçmişi ve müşteri kartları",
    'privacy.retention.active': "Müşteri aktifken (son ziyaretten 3 yıl sonra)",
    'privacy.retention.2y': "Son ziyaretten 2 yıl sonra",
    'privacy.retention.1y': "Son ziyaretten 1 yıl sonra",
    'privacy.retentionHint': "Bu sürelere göre otomatik silme/anonimleştirme günlük bir görevle yapılır.",
    'privacy.healthTitle': "Sağlık verileri",
    'privacy.healthEnabled': "Sağlık verisi modu (kalıcı makyaj, estetik tıp)",
    'privacy.healthHint': "Varsayılan olarak yapay zeka tıbbi bilgi istemez ve saklamaz; bu soruları yöneticiye iletir. Özel güvenli süreç hazırlanıyor.",
    'privacy.save': "Gizlilik ayarlarını kaydet",
    'privacy.saved': "Gizlilik ayarları kaydedildi",
    'auth.loading': 'Yükleniyor...',
    'auth.loginSuccess': 'Giriş başarılı!',
    'auth.registerSuccess': 'Kayıt başarılı!',
    'auth.error': 'Kimlik doğrulama hatası',
    'auth.websiteUrl': 'Web Sitesi URL',
    'auth.forgotPassword': 'Şifremi unuttum?',
    'auth.loginWithCode': 'E-posta koduyla giriş (şifresiz)',
    'auth.loginWithPassword': 'Şifre ile giriş',
    'auth.sendCode': 'Giriş kodu gönder',
    'auth.verifyCode': 'Giriş yap',
    'auth.enterCode': 'E-postadaki kod',
    'auth.codeSentInfo': 'Kod e-postanıza gönderildi',
    'auth.codeSentHint': 'Kod ve giriş düğmesi e-postanıza gönderildi (Spam klasörünü kontrol edin)',
    'auth.resendCode': 'Kodu tekrar gönder',
    'auth.magicLoginError': 'Bağlantı geçersiz veya süresi dolmuş',
    'auth.magicLoggingIn': 'Giriş yapılıyor...',
    'auth.backToLogin': 'Girişe geri dön',
    
    // Forgot Password
    'forgot.title': 'Şifre Kurtarma',
    'forgot.subtitle': 'Kurtarma kodu almak için e-postanızı girin',
    'forgot.enterCode': 'E-postadan gelen kodu ve yeni şifrenizi girin',
    'forgot.sendCode': 'Kod Gönder',
    'forgot.resetCode': 'Kurtarma Kodu',
    'forgot.newPassword': 'Yeni Şifre',
    'forgot.confirmPassword': 'Şifreyi Onayla',
    'forgot.resetPassword': 'Şifreyi Sıfırla',
    'forgot.resendCode': 'Kodu tekrar gönder',
    'forgot.backToLogin': 'Girişe dön',
    'forgot.codeSent': 'Kod e-postaya gönderildi',
    'forgot.success': 'Şifre başarıyla değiştirildi!',
    'forgot.error': 'Şifre kurtarma hatası',
    'forgot.passwordMismatch': 'Şifreler eşleşmiyor',
    'forgot.passwordTooShort': 'Şifre en az 6 karakter olmalıdır',
    
    // Dashboard
    'dashboard.title': 'Chatity',
    'dashboard.logout': 'Çıkış',
    'dashboard.logoutSuccess': 'Çıkış yapıldı',
    
    // Tabs
    'tabs.settings': 'Ayarlar',
    'tabs.bookings': 'Rezervasyonlar',
    'tabs.widget': 'Entegrasyonlar',
    'tabs.marketing': 'Pazarlama', 'tabs.analytics': 'Analitik',
    'mk.triggersTitle': 'Tetikleyici kelimeler',
    'mk.triggersHint': 'Müşteri kod kelimeyi yazar (örn. reklamdan) — bot anında teklifinizi gönderir. Instagram, WhatsApp ve widget içinde çalışır.',
    'mk.keyword': 'Kod kelime',
    'mk.response': 'Gönderilecek yanıt',
    'mk.responsePh': 'Örn.: Tebrikler! 🎁 Herhangi bir randevuda bakım hediye. Ne zaman gelmek istersiniz?',
    'mk.addTrigger': 'Kelime ekle',
    'mk.active': 'Aktif',
    'mk.save': 'Kaydet',
    'mk.saved': 'Kaydedildi ✓', 'clients.language': 'Müşteri dili (WhatsApp/Instagram bildirimleri)', 'clients.langAuto': 'Ülke koduna göre otomatik', 'clients.langAutoUnknown': 'Otomatik (sohbete göre)', 'clients.langHint': 'Hatırlatmalar ve onaylar bu dilde gönderilir. Otomatik: numaranın ülke koduna göre (+33 — Fransızca, +7 — Rusça…), yoksa sohbete göre.', 'clients.langSaved': 'Müşteri dili kaydedildi', 'mk.remindersTitle': 'Müşterilere randevu hatırlatmaları', 'mk.remindersHint': 'WhatsApp üzerinden otomatik. Müşterinin WhatsApp\'ı yoksa — 24 saat önce AI araması (bağlı telefon gerekir).', 'mk.remindersNoWhatsapp': 'WhatsApp bağlı değil — WhatsApp hatırlatmaları gönderilmez.', 'mk.remindersNoPhone': 'Telefon bağlı değil — aramayla hatırlatma (WhatsApp\'ı olmayan müşteriler için) çalışmaz.', 'mk.remindersConnect': 'Bağla', 'mk.remindersChannelsOk': 'WhatsApp ve telefon bağlı — hatırlatmalar çalışıyor.', 'mk.remindersTextLabel': 'Özel metin (isteğe bağlı)', 'mk.reminder24hTitle': '24 saat önce', 'mk.reminder24hHint': 'Bir gün önce — müşteri yanıtlayarak erteleyebilir veya iptal edebilir', 'mk.reminder24hPh': '{name}, yarınki randevunuzu hatırlatırız ✨ {service}{master} — {when}. Görüşmek üzere!', 'mk.reminder2hTitle': '2 saat önce', 'mk.reminder2hHint': 'Randevu günü kısa hatırlatma', 'mk.reminder2hPh': '{name}, bugün {time} görüşüyoruz ⏰ {service}{master}.', 'mk.remindersPlaceholders': 'Değişkenler: {name}, {service}, {master}, {when} — tarih ve saat, {date}, {time}', 'mk.remindersLogTitle': 'Son gönderimler', 'mk.remindersUpcoming': 'Hatırlatma bekleyen: {n}', 'mk.remindersLogEmpty': 'Henüz gönderim yok — hatırlatmalar yaklaşan randevulardan önce otomatik gider', 'mk.remindersNotDelivered': 'iletilmedi',
    'addons.title': 'Ek paketler', 'addons.subtitle': 'Kanallar, şubeler ve telefon AI aboneliğinize eklenir ve onunla birlikte yenilenir — kartı yeniden girmeye gerek yok. Diyalog paketleri ödenen ayın sonuna kadar geçerli tek seferlik satın alımdır.',
    'addons.dialogs': 'Diyalog paketi', 'addons.dialogsHint': '10 €\'ya +100 diyalog. Birden fazla alınabilir — plan limitinden sonra kullanılır, ödenen ayın sonunda sona erer.',
    'addons.channel': 'Ek kanal', 'addons.channelHint': 'Planda 1 kanal dahil (WhatsApp veya Instagram). Her ek kanal — 19 €/ay. Widget ve mini site her zaman ücretsiz.',
    'addons.branch': 'Ek şube', 'addons.branchHint': 'Planda 1 şube dahil. Her ek şube — plan fiyatının %50\'si/ay.',
    'addons.buy': 'Satın al', 'addons.mo': 'ay', 'addons.active': 'Aktif', 'addons.connected': 'Bağlı kanallar', 'addons.branches': 'Şubeler',
    'addons.phone': 'Telefon AI', 'addons.yours': 'Ek paketleriniz', 'addons.autoRenew': 'aboneliğinizle birlikte yenilenir', 'addons.cancel': 'Kapat', 'addons.resume': 'Devam ettir',
    'addons.endsOn': '{date} tarihinde sona erer', 'addons.validUntil': '{date} tarihine kadar geçerli', 'addons.attached': 'Ek paket etkinleştirildi ve aboneliğinize eklendi',
    'addons.cancelConfirm': 'Bu ek paket kapatılsın mı? Ödenen dönemin sonuna kadar aktif kalır, sonra ücret alınmaz.', 'addons.cancelled': 'Ek paket dönem sonunda sona erecek', 'addons.resumed': 'Ek paket yeniden aktif',
    'addons.confirmAttach': 'Mevcut aboneliğinize ekle: bugün kartınızdan €{now} çekilecek (dönem sonuna kadar orantılı), ardından planınızla birlikte {monthly}. Onaylıyor musunuz?',
    'addons.confirmCheckout': 'Ek paket aboneliği {monthly}, otomatik yenilenir. Ödeme sayfası şimdi açılacak. Devam edilsin mi?',
    'mk.igTitle': 'Instagram: hikaye tepkileri', 'mk.storyReactHint': 'Müşteri hikayenize tepki verdiğinde (❤️ 🔥 😍) AI teşekkür eder ve sohbet başlatır', 'mk.storyReactInfo': 'Yanıtta ne önerilsin', 'mk.storyReactPlaceholder': 'Örn.: Ay sonuna kadar yeni müşterilere manikürde %20 indirim', 'mk.storyReactTip': 'AI bu bilgiyi müşterinin dilinde yanıta ekler. Diyalog başına 6 saatte en fazla 1 yanıt.',
    'tabs.admin': 'Yönetici',
    'tabs.support': 'Destek',
    'tabs.subscription': 'Abonelik',
    
    // Settings
    'settings.title': 'Ayarlar',
    'settings.subtitle': 'Entegrasyonları ve AI asistanınızı yapılandırın',
    'settings.languageTitle': 'Dil Ayarları',
    'settings.uiLanguage': 'Arayüz Dili',
    'settings.uiLanguageDesc': 'Kontrol paneli ve menüler için dil',
    'settings.notificationLanguage': 'Bildirim Dili',
    'settings.notificationLanguageDesc': 'E-posta ve Telegram rezervasyon bildirimleri için dil',
    'settings.notificationLanguageSuccess': 'Bildirim dili güncellendi',
    'settings.languageUpdateError': 'Dil güncellenirken hata',
    'settings.notifications': 'Rezervasyon Bildirimleri',
    'settings.emailTitle': 'E-posta Bildirimleri',
    'settings.emailCheckbox': 'Rezervasyonları e-posta ile al',
    'settings.emailRecipients': 'Bildirimlerin gönderileceği adresler (virgülle ayırın)',
    'settings.emailRecipientsDefault': 'varsayılan: {email}',
    'settings.emailRecipientsHint': 'Hesap e-postanıza almak için boş bırakın. Virgülle ayırarak birden fazla adres girebilirsiniz — bildirim her birine gider.',
    'settings.emailWarning': '⚠️ E-posta özelliği production ortamında kullanılabilir. Test modunda Telegram kullanın.',
    'settings.telegramTitle': 'Telegram Bildirimleri',
    'settings.chatId': 'Grup Chat ID',
    'settings.chatIdInstructions': 'Bildirimler için Chat ID nasıl alınır:',
    'settings.chatIdStep1': 'Botu bulun:',
    'settings.chatIdStep1Text': 'Telegram\'ı açın ve botumuzu bulun',
    'settings.chatIdStep2': 'Sohbete ekleyin:',
    'settings.chatIdStep2Text': 'Botu bildirim almak istediğiniz kişisel sohbetinize veya grubunuza ekleyin',
    'settings.chatIdStep3': 'Komutu çalıştırın:',
    'settings.chatIdStep3Text': 'Komutu gönderin',
    'settings.chatIdStep4': 'Chat ID\'yi kopyalayın:',
    'settings.chatIdStep4Text': 'Bot Chat ID\'nizi gönderecek (şu şekilde: -1001234567890)',
    'settings.chatIdStep5': 'Yapıştırın ve kaydedin:',
    'settings.chatIdStep5Text': 'Chat ID\'yi yukarıdaki alana yapıştırın ve "Ayarları Kaydet" düğmesine tıklayın',
    'settings.chatIdSuccess': 'Kaydettikten sonra, yeni rezervasyonlar hakkında bildirimleri doğrudan Telegram\'da alacaksınız!',
    'settings.balloonSettings': 'Balon İpucu',
    'settings.balloonEnabled': 'İpucu göster',
    'settings.balloonEnabledDesc': 'Açılır mesaj ziyaretçilerin dikkatini çeker',
    'settings.balloonMessage': 'İpucu metni',
    'settings.balloonMessagePlaceholder': 'Merhaba! Randevu almanıza yardımcı olabilirim 👋',
    'settings.balloonDelay': 'Gecikme (saniye)',
    'settings.balloonDelayDesc': 'İpucu kaç saniye sonra gösterilsin',
    'settings.autoOpenEnabled': 'Sohbeti otomatik aç',
    'settings.autoOpenEnabledDesc': 'Ziyaretçi tıklamazsa sohbeti otomatik olarak aç',
    'settings.autoOpenDelay': 'Otomatik açma gecikmesi (saniye)',
    'settings.autoOpenDelayDesc': 'Sohbet kaç saniye sonra otomatik açılsın',
    'settings.analyzeWebsite': 'Web Sitesini Analiz Et',
    'settings.analyzing': 'Analiz ediliyor',
    'settings.websiteAnalyzed': 'Web sitesi analiz edildi! Bilgi bilgi tabanına yüklendi.',
    'settings.websiteAnalyzedSuccess': 'Web sitesi başarıyla analiz edildi!',
    'settings.websiteUrlRequired': 'Otomatik analiz için lütfen işletme ayarlarında web sitesi URL\'sini belirtin',
    'settings.aiChatbot': 'AI Asistan',
    'settings.primaryColor': 'Ana Renk',
    'settings.secondaryColor': 'İkincil Renk',
    'settings.buttonColor': 'Düğme Rengi',
    'settings.botName': 'Bot Adı',
    'settings.welcomeMessage': 'Hoş Geldin Mesajı',
    'settings.defaultBotName': 'Asistan',
    'settings.defaultWelcomeMessage': 'Merhaba! Size nasıl yardımcı olabilirim?',
    'settings.businessInfo': 'İşletme Bilginiz',
    'settings.aiKnowledgeTitle': 'AI bu bilgiyi kullanacak!',
    'settings.aiKnowledgeDesc': 'Hizmetlerinizi, fiyatlarınızı, çalışma saatlerinizi, adresinizi belirtin. AI bu verilere dayanarak müşterilere danışmanlık yapacak.',
    'settings.knowledgeBase': 'AI Bilgi Tabanı',
    'settings.knowledgeBasePlaceholder': `Örnek:

Hizmetlerimiz:
- Saç kesimi - 500₺\'den başlayan fiyatlarla
- Saç şekillendirme - 400₺\'den başlayan fiyatlarla
- Danışmanlık - 100₺

Çalışma saatleri:
Pzt-Cum: 10:00-20:00
Cmt-Paz: 11:00-19:00

Adres: İstanbul, Örnek Sokak, No: 10
Telefon: +90 (555) 123-45-67`,
    'settings.knowledgeTip': 'İpucu: Hizmetleri ve fiyatları ne kadar ayrıntılı açıklarsanız, AI müşterilere o kadar doğru danışmanlık yapacak',
    'settings.businessType': 'İşletme Türünüz',
    'settings.businessTypeHint': 'AI, nişinize göre yapılandırılacak',
    'settings.businessTypes.general': '🏢 Genel',
    'settings.businessTypes.medical': '🏥 Tıbbi / Klinik',
    'settings.businessTypes.beauty': '💅 Güzellik Salonu',
    'settings.businessTypes.ecommerce': '🛍️ E-ticaret',
    'settings.businessTypes.restaurant': '🍽️ Restoran / Kafe',
    'settings.businessTypes.services': '🔧 Hizmetler',
    'settings.productFeedUrl': 'Ürün Feed URL (XML/JSON)',
    'settings.productFeedHint': 'AI, kataloğunuzdaki ürünler hakkında müşterilere danışmanlık yapacak',
    'tilda.title': 'Tilda online mağaza (MCP)', 'tilda.desc': 'Yapay zeka, Tilda kataloğunuzdaki ürünler, fiyatlar ve stok hakkında müşterilere yanıt verir ve satın alma için mağazaya yönlendirir.', 'tilda.step1': "Tilda'da Profil → “MCP server” → “New key” açın", 'tilda.step2': 'Mağaza projesini seçin, erişim “Limited” → yalnızca “Product catalog” (okuma) ve “No expiration” işaretleyin', 'tilda.step3': 'Anahtarı kopyalayın (bir kez gösterilir) ve aşağıya yapıştırın', 'tilda.keyLabel': 'Tilda MCP anahtarı', 'tilda.connect': 'Bağlan', 'tilda.checking': 'Kontrol ediliyor…', 'tilda.help': 'Tilda MCP kılavuzu', 'tilda.connected': 'Tilda bağlandı, katalog yüklendi', 'tilda.synced': 'Katalog güncellendi', 'tilda.disconnectConfirm': 'Tilda bağlantısı kesilsin mi? Ürün kataloğu yapay zekadan kaldırılacak.', 'tilda.project': 'Proje', 'tilda.products': 'Ürün', 'tilda.syncedAt': 'Güncellendi', 'tilda.currency': 'Fiyat para birimi', 'tilda.key': 'Anahtar', 'tilda.lastError': 'Son hata', 'tilda.sync': 'Kataloğu yenile', 'tilda.disconnect': 'Bağlantıyı kes', 'tilda.searchPh': 'Katalogda ürün kontrol et…', 'tilda.search': 'Ara', 'tilda.noResults': 'Sonuç yok', 'tilda.autoSync': 'Katalog her 12 saatte bir otomatik güncellenir.', 'tilda.err.key': 'Tilda anahtarı kabul etmedi. Anahtarı (mcp_tilda_ ile başlar) ve süresini kontrol edin', 'tilda.err.noProjects': 'Bu anahtarın hiçbir projeye erişimi yok', 'tilda.err.unreachable': "Tilda'ya ulaşılamıyor, daha sonra deneyin", 'tilda.err.generic': 'Bağlantı hatası',
    'subscription.cancelTitle': 'Aboneliği iptal et', 'subscription.cancelDesc': 'Plan ve tüm eklentiler (telefon, kanallar, şubeler) hemen iptal edilir: AI tüm kanallarda durur, başka ücret alınmaz.', 'subscription.lastPayment': 'Son ödeme', 'subscription.cancelBtn': 'Aboneliği iptal et', 'subscription.cancelConfirm': 'Abonelik şimdi iptal edilsin mi? AI tüm kanallarda (web sitesi, WhatsApp, Instagram, telefon) hemen durur. Başka ücret alınmaz.', 'subscription.cancelDone': 'Abonelik iptal edildi. Başka ücret alınmayacak.', 'subscription.cancelError': 'Abonelik güncellenemedi. Lütfen destekle iletişime geçin.', 'subscription.cancelScheduled': 'Abonelik iptal edildi', 'subscription.cancelScheduledDesc': 'Erişim {date} tarihine kadar devam eder, sonra AI tüm kanallarda durur. Tekrar ücret alınmayacak.', 'subscription.resumeBtn': 'Aboneliği sürdür', 'subscription.resumeDone': 'Abonelik sürdürüldü',
    'cal.billingPaymentFailed': 'Abonelik ödemesi başarısız — AI tüm kanallarda (web sitesi, WhatsApp, Instagram, telefon) duraklatıldı. Müşteriler yanıtsız kalıyor.', 'cal.billingUnpaid': 'Abonelik etkin değil — AI hiçbir kanalda müşterilere yanıt vermiyor.', 'cal.billingFix': 'Ödemeyi düzelt',
    'tilda.sendLinks': 'Yapay zekanın müşteriye doğrudan ürün bağlantısı göndermesine izin ver', 'settings.aiKnowledgeDescEcom': 'Teslimat ve ödeme koşullarını, iadeleri, süreleri, teslim alma adresini, iletişim bilgilerini belirtin. Ürünler ve fiyatlar bağlı Tilda kataloğundan alınır.',
    'settings.saveButton': 'Ayarları Kaydet',
    'settings.saving': 'Kaydediliyor…',
    'settings.saveSuccess': 'Ayarlar kaydedildi!',
    'settings.saveError': 'Ayarlar kaydedilirken hata',
    
    // Bookings
    'bookings.title': 'Rezervasyon Geçmişi',
    'bookings.subtitle': 'Tüm müşteri rezervasyonları',
    'bookings.noBookings': 'Henüz rezervasyon yok',
    'bookings.service': 'Hizmet',
    'bookings.preferredDate': 'Tercih edilen tarih',
    'bookings.preferredTime': 'Tercih edilen saat',
    'bookings.period': 'Dönem',
    'bookings.today': 'Bugün',
    'bookings.last7days': 'Son 7 gün',
    'bookings.last30days': 'Son 30 gün',
    'bookings.customDates': 'Özel tarihler',
    'bookings.from': 'Başlangıç',
    'bookings.to': 'Bitiş',
    'bookings.refresh': 'Yenile',
    'bookings.todayCount': 'Bugünkü rezervasyonlar',
    'bookings.yesterdayCount': 'Dünkü rezervasyonlar',
    'bookings.growthPercent': 'Düne göre büyüme',
    'bookings.dynamicsTitle': 'Rezervasyon dinamikleri',
    'bookings.dynamicsDescription': 'Günlük rezervasyon sayısı',
    'bookings.topSourcesTitle': 'En iyi trafik kaynakları',
    'bookings.topSourcesDescription': 'Müşteriler nereden geliyor',
    'bookings.source': 'Kaynak',
    'bookings.bookingsCount': 'Rezervasyonlar',
    'bookings.directVisit': 'Doğrudan ziyaret',
    'bookings.autoUpdate': 'Her 10 saniyede otomatik güncelleme',
    'bookings.client': 'Müşteri',
    'bookings.phone': 'Telefon',
    'bookings.date': 'Tarih',
    'bookings.created': 'Rezervasyon',
    'bookings.newBooking': 'Yeni rezervasyon! Toplam:',
    'bookings.storageInfo': '📋 Rezervasyonlar 30 gün saklanır',
    'bookings.unlimitedStorageInfo': 'Rezervasyon geçmişini uzun vadeli saklamak için Excel dışa aktarma işlevini kullanın',
    'bookings.upgradeForExport': 'Rezervasyonları Excel\'e aktarmak için Unlimited planına yükseltin',
    'bookings.exportExcel': 'Excel\'e Aktar',
    'bookings.exportSuccess': 'Rezervasyonlar başarıyla aktarıldı',
    'bookings.exportUnlimitedOnly': 'Dışa aktarma yalnızca Unlimited planı için kullanılabilir',
    'bookings.exportError': 'Dışa aktarma hatası',
    
    // Analytics
    'analytics.upgradeToPro': 'Gelişmiş Analitik',
    'analytics.upgradeDescription': 'Erişim için Professional veya Unlimited planına yükseltin:',
    'analytics.feature1': 'Rezervasyon dinamikleri grafikleri',
    'analytics.feature2': 'Trafik kaynakları (UTM etiketleri)',
    'analytics.feature3': 'Ayrıntılı istatistikler',
    'analytics.feature4': 'Veri dışa aktarma',
    'analytics.upgradeButton': 'Planı Yükselt',
    'analytics.channel': 'Kanal',
    'analytics.campaign': 'Kampanya',
    'miniBuilder.title': 'Mini-site Oluşturucu',
    'miniBuilder.active.onTitle': 'Mini-site yayında',
    'miniBuilder.active.offTitle': 'Mini-site devre dışı',
    'miniBuilder.active.onHint': 'Herkese açık sayfanız yayında. Ziyaretçiler kısa bağlantınızdan mini-sitenizi görür.',
    'miniBuilder.active.offHint': 'Sayfa gizli. Ziyaretçiler kısa bağlantınızda 404 görür. Widget ve entegrasyonlar çalışmaya devam eder.',
    'miniBuilder.save': 'Kaydet',
    'miniBuilder.saving': 'Kaydediliyor...',
    'miniBuilder.loading': 'Yükleniyor...',
    'miniBuilder.noSlug': 'Önce Entegrasyonlar sekmesinde kısa bağlantınızı belirleyin',
    'miniBuilder.upgradeDesc': 'Mini-site Oluşturucu Professional ve Unlimited planlarında mevcuttur.',
    'miniBuilder.upgradeBtn': 'Professional\'a Yükselt',
    'miniBuilder.about.title': 'Hakkında',
    'miniBuilder.about.label': 'Hakkında metni',
    'miniBuilder.about.aiBtn': 'AI ile oluştur',
    'miniBuilder.about.generating': 'Oluşturuluyor...',
    'miniBuilder.about.placeholder': 'Salonunuzu kısaca anlatın: atmosfer, değerler, sizi farklı kılan unsurlar...',
    'miniBuilder.about.hint': 'AI, Ayarlar sekmesindeki bilgi tabanınızdan (salon bilgileri, hizmetler, fiyatlar) yararlanır.',
    'miniBuilder.seo.title': 'SEO ayarları',
    'miniBuilder.seo.hint': 'Bu alanları Google ve sosyal ağlar görür. Boş bırakırsanız ad ve «Hakkımızda» metninden otomatik doldurulur.',
    'miniBuilder.seo.titleLabel': 'SEO başlığı',
    'miniBuilder.seo.titlePlaceholder': 'Paris\'te manikür ve pedikür — Lux Salon',
    'miniBuilder.seo.titleHint': 'Başlığa otomatik olarak «— Chatity» eklenir',
    'miniBuilder.seo.descLabel': 'SEO açıklaması',
    'miniBuilder.seo.descPlaceholder': 'Paris merkezinde güzellik salonu: manikür, pedikür, kaş. 7/24 online randevu.',
    'miniBuilder.seo.descHint': 'Google arama sonuçlarında başlığın altında gösterilir',
    'miniBuilder.seo.keywordsLabel': 'Anahtar kelimeler',
    'miniBuilder.seo.keywordsPlaceholder': 'manikür paris, pedikür, güzellik salonu',
    'miniBuilder.seo.keywordsHint': 'Virgülle ayırın. İsteğe bağlı — Google çoğunlukla dikkate almaz ama zararı olmaz',
    'miniBuilder.cover.title': 'Mini-site kapak fotoğrafı',
    'miniBuilder.cover.desc': 'Resim URL\'si (Instagram / Imgur / Telegram / kendi CDN\'iniz). Boşsa — gradyan gösterilir.',
    'miniBuilder.logo.title': 'Logo / Avatar',
    'miniBuilder.logo.desc': 'Mini-site başlığında yuvarlak logo. 512×512 px kare en iyisi (şeffaf arka planlı PNG veya JPG).',
    'miniBuilder.logo.hint': 'Logo, hero bölümünde işletme adınızın yanında ve sohbet widget\'ında gösterilir.',
    'miniBuilder.social.title': 'Sosyal medya & iletişim',
    'miniBuilder.social.hint': 'Bu bağlantılar herkese açık mini-sitenizde ziyaretçilere gösterilecektir.',
    'miniBuilder.services.title': 'Hizmetler & fiyatlar',
    'miniBuilder.photos.title': 'Fotoğraf galerisi',
    'miniBuilder.phase2': 'yakında (faz 2)',
    'miniBuilder.phase2Photos': 'yakında (faz 2)',
    'miniBuilder.toast.saved': 'Mini-site kaydedildi',
    'miniBuilder.toast.saveFailed': 'Kaydedilemedi',
    'miniBuilder.toast.aiSuccess': 'AI Hakkında metnini oluşturdu 🤖',
    'miniBuilder.toast.aiFailed': 'Oluşturulamadı',
    'miniBuilder.address.label': 'Adres',
    'miniBuilder.address.placeholder': 'İstiklal Caddesi 12, Beyoğlu, İstanbul',
    'miniBuilder.address.hint': 'Etkileşimli Google haritasıyla herkese açık mini-sitenizde gösterilecektir.',
    'miniBuilder.services.empty': 'Henüz kategori yok. Müşterilerin hizmetlerinizi ve fiyatlarınızı görebilmesi için ilkini ekleyin.',
    'miniBuilder.services.addCategory': 'Kategori ekle',
    'miniBuilder.services.addService': 'Hizmet ekle',
    'miniBuilder.services.categoryNamePlaceholder': 'Örn: Saç kesim ve şekillendirme',
    'miniBuilder.services.categoryDescPlaceholder': 'Kısa kategori açıklaması (isteğe bağlı)',
    'miniBuilder.services.serviceNamePlaceholder': 'Hizmet adı',
    'miniBuilder.services.durationPlaceholder': '60 dk',
    'miniBuilder.services.pricePlaceholder': '50',
    'miniBuilder.photos.empty': 'Henüz fotoğraf yok. İç mekan, iş veya ekip fotoğraflarının bağlantılarını ekleyin.',
    'miniBuilder.photos.add': 'Fotoğraf ekle',
    'miniBuilder.photos.urlPlaceholder': 'https://i.imgur.com/photo.jpg',
    'miniBuilder.photos.altPlaceholder': 'Açıklama (isteğe bağlı)',
    'miniBuilder.photos.hint': 'En iyi format — yatay fotoğraflar 1200×800 px. En fazla 6 fotoğraf, her biri en fazla 2 MB. Büyük fotoğraflar otomatik olarak WebP\'ye sıkıştırılır.',
    'miniBuilder.photos.full': 'Galeri dolu — en fazla 6 fotoğraf. Yeni eklemek için birini kaldırın.',
    'uploader.trimmed': 'Yalnızca {n} fotoğraf daha ekleyebilirsiniz — diğerleri atlandı.',
    'miniBuilder.services.currencyLabel': 'Para birimi',
    'miniBuilder.services.unnamedCategory': 'İsimsiz',
    'miniBuilder.titleField.label': 'İşletme adı (sayfa başlığı)',
    'miniBuilder.titleField.placeholder': 'Oui Beauté · Nice\'te Kuaför Salonu',
    'miniBuilder.titleField.hint': 'Tarayıcı sekmesinin <title> alanında ve mini-site başlığında kullanılır. Boşsa — ayarlardan salon adı kullanılır.',
    'miniBuilder.tagline.label': 'Alt başlık (slogan)',
    'miniBuilder.tagline.placeholder': 'Beyoğlu\'nda kuaför · 8 yıl deneyim',
    'miniBuilder.tagline.hint': 'İşletme adının altında kısa bir satır. En fazla 80 karakter.',
    'uploader.btn': 'Yükle',
    'uploader.dropzone': 'Fotoğrafı buraya bırakın veya seçmek için tıklayın',
    'uploader.dropzoneMulti': 'Birden fazla fotoğrafı buraya bırakın veya tıklayın',
    'uploader.hint': 'JPG / PNG / WebP, en fazla 2 MB',
    'uploader.uploading': 'Yükleniyor',
    'uploader.success': 'Fotoğraf yüklendi ✓',
    'uploader.successMulti': '{n} fotoğraf yüklendi',
    'uploader.failed': 'Yükleme başarısız',
    'uploader.invalidType': 'Desteklenmeyen format. JPG, PNG veya WebP kullanın.',
    'uploader.tooBig': 'Dosya çok büyük. Daha küçük bir fotoğraf deneyin.',
    'miniBuilder.hours.title': 'Çalışma saatleri',
    'miniBuilder.hours.label': 'Salon çalışma saatleri',
    'miniBuilder.hours.placeholder': 'Pzt-Cum: 09:00–19:00\nCmt: 10:00–18:00\nPaz: kapalı',
    'miniBuilder.hours.hint': 'Serbest metin. Her satır sonu herkese açık sayfada yeni bir satır olur.',
    'tabs.minisite': 'Mini-site',
    'tabs.team': 'Ekip',
    'tabs.calendar': 'Takvim',
    'cal.today': 'Bugün', 'cal.day': 'Gün', 'cal.week': 'Hafta', 'cal.month': 'Ay', 'cal.modeChips': 'Randevular', 'cal.modeLoad': 'Doluluk',
    'cal.allBranches': 'Tüm şubeler', 'cal.allMasters': 'Tüm ustalar',
    'cal.addClient': 'Müşteri kaydet', 'cal.dashboard': 'Panel',
    'cal.newBooking': 'Yeni randevu', 'cal.clientName': 'Müşteri adı', 'cal.phone': 'Telefon',
    'cal.service': 'Hizmet', 'cal.master': 'Usta', 'cal.date': 'Tarih', 'cal.time': 'Saat',
    'cal.book': 'Kaydet', 'cal.moved': 'Randevu taşındı', 'cal.conflict': 'Bu saat dolu veya çalışma saatleri dışında', 'cal.onlyMasterServices': 'Yalnızca bu ustanın hizmetleri gösteriliyor. Usta kartında (Ekip) düzenleyin', 'cal.conflict.day_off': '{master} bu gün izinli (veya şube kapalı)', 'cal.conflict.outside_schedule': 'Program dışı: {master} {window} çalışıyor, hizmet {duration_min} dk sürüyor', 'cal.conflict.busy': '{master} bu saatte zaten randevulu ({start_at}–{end_at})', 'cal.conflict.external_busy': '{master} harici takvimde dolu', 'cal.conflict.master_not_found': 'Usta bulunamadı veya programı yok', 'cal.conflict.master_does_not_offer_service': 'Bu usta bu hizmeti vermiyor — usta kartında işaretleyin', 'cal.conflict.no_master_for_service': 'Hiçbir usta bu hizmeti vermiyor — usta kartlarında işaretleyin', 'cal.conflict.no_free_master': 'Bu saatte boş usta yok',
    'cal.unassigned': 'Atanmamış', 'cal.assignTime': 'Zaman ata',
    'cal.remindCall': 'Arayarak hatırlat', 'cal.remindCallDone': 'Yapay zeka müşteriyi arıyor ({lang})', 'cal.cancelled': 'Randevu iptal edildi', 'cal.created': 'Randevu oluşturuldu', 'cal.cancelBooking': 'Randevuyu iptal et',
    'cal.pendingConfirm': 'AI tarafından oluşturuldu — onay bekliyor',
    'cal.confirmBtn': 'Onayla', 'cal.confirmedSent': 'Onaylandı! Müşteri bilgilendirildi',
    'cal.confirmedOk': 'Randevu onaylandı',
    'cal.messages': 'Mesajlar',
    'inbox.today': 'Bugün', 'inbox.yesterday': 'Dün', 'inbox.search': 'İsim, telefon ile ara…', 'inbox.empty': 'Henüz diyalog yok',
    'inbox.pickDialog': 'Soldan bir diyalog seçin', 'inbox.client': 'Müşteri',
    'inbox.reply': 'Yanıt yazın… (AI 6 saat duraklar)', 'inbox.you': 'Siz',
    'inbox.aiPaused': 'AI duraklatıldı — siz yanıtlıyorsunuz', 'inbox.resumeAi': "AI'yı geri getir",
    'inbox.aiResumed': 'AI bu diyalogda tekrar yanıtlıyor', 'inbox.aiOn': 'AI yanıtlıyor',
    'inbox.aiOff': 'AI kapalı', 'inbox.aiOffBanner': 'Bu diyalog için AI kapalı — siz yanıtlıyorsunuz',
    'inbox.crashMsg': 'Diyalog görüntülenemedi', 'inbox.reload': 'Yenile',
    'inbox.aiDisabledToast': 'Bu kişi için AI kapatıldı', 'inbox.aiEnabledToast': 'AI bu kişiye tekrar yanıt veriyor',
    'inbox.newMessage': 'Yeni mesaj',
    'team.permsTitle': 'Yönetici bölüm erişimi',
    'team.permsHint': 'Takvim ve Mesajlar her zaman erişilebilir. Widget, mini site, abonelik ve ayarlar — yalnızca sahibi.',
    'profile.title': 'Profilim', 'profile.name': 'İsim', 'profile.phone': 'Telefon',
    'profile.save': 'Kaydet', 'profile.saved': 'Profil kaydedildi',
    'profile.emailTaken': 'Bu e-posta zaten kullanımda', 'profile.uploadHint': 'Yüklemek için fotoğrafa tıklayın (JPG/PNG, en fazla 2 MB)',
    'cal.statCancels': 'İptaller', 'cal.statCalls': 'Aramalar',
    'cal.email': 'E-posta', 'cal.duration': 'Süre (dk)', 'cal.price': 'Fiyat', 'cal.total': 'Toplam',
    'cal.save': 'Kaydet', 'cal.saved': 'Kaydedildi', 'cal.came': 'Geldi', 'cal.noShow': 'Gelmedi',
    'cal.booking': 'Randevu', 'cal.menu': 'Menü',
    'cal.whatDone': 'Ne yapıldı: hizmet, oje/renk, malzeme, formül', 'cal.whatDoneHint': 'Bir dahaki sefere aynı sonucu almak için not edin', 'cal.attendanceRequired': 'Lütfen işaretleyin: müşteri geldi mi gelmedi mi',
    'cal.needsCallback': 'Müşteriyi geri ara',
    'cal.clientConfirmed': 'Müşteri randevuyu onayladı', 'cal.clientConfirmedPhone': '✅ Telefonla onaylandı',
    'cal.newBooking': 'Yeni randevu',
    'cal.allDay': 'Tüm gün', 'cal.allDayHint': 'Ustanın günü randevuya kapatılacak', 'cal.repeat': 'Tekrarla', 'cal.repeatOn': 'Tekrar açık', 'cal.repeatEvery': 'Her', 'cal.unitWeeks': 'hafta', 'cal.unitDays': 'gün', 'cal.onDays': 'günler', 'cal.repeatEnd': 'Bitiş', 'cal.endNever': 'Asla', 'cal.endAfter': 'Sonra', 'cal.endTimes': 'kez', 'cal.endOn': 'Tarih', 'cal.endNeverHint': '“Asla” = bir yıl ileri', 'cal.seriesCreated': 'Oluşturuldu', 'cal.seriesSkipped': 'atlandı (dolu)', 'cal.wd.mon': 'Pt', 'cal.wd.tue': 'Sa', 'cal.wd.wed': 'Ça', 'cal.wd.thu': 'Pe', 'cal.wd.fri': 'Cu', 'cal.wd.sat': 'Ct', 'cal.wd.sun': 'Pa',
    'cal.call': 'Ara', 'cal.write': 'Yaz',
    'cal.lastVisit': 'Son ziyaret', 'cal.atMaster': '—', 'cal.newClient': 'Yeni müşteri — geçmiş ziyaret yok', 'cal.addComment': 'Yorum ekle', 'cal.commentPlaceholder': 'Bu ziyaret hakkında yorum…',
    'cal.history': 'Ziyaret geçmişi', 'cal.showMore': 'Daha fazla göster', 'cal.noHistory': 'Geçmiş ziyaret yok',
    'cal.memVisits': 'ziyaret', 'cal.memEvery': 'her', 'cal.memDays': 'günde', 'cal.memAvgCheck': 'ort. harcama', 'cal.memNoShows': 'gelmedi',
    'push.enable': 'Bildirimleri aç', 'push.enabled': 'Bildirimler açıldı 🔔', 'push.denied': 'Tarayıcıda bildirimlere izin verin',
    'cal.note': 'Yorum', 'cal.products': 'Ürünler / renkler / malzemeler',
    'cal.aiAdmin': 'AI Yönetici', 'cal.aiActive': 'Aktif', 'cal.aiPausedBilling': 'Duraklatıldı (ödeme)', 'cal.aiConnect': 'Bağla',
    'cal.aiPromo': 'AI yöneticisi olan salonlar %30–40 daha fazla randevu alır', 'cal.dialogs': 'Diyalog',
    'cal.bookingsStat': 'Rezervasyon', 'cal.reschedules': 'Erteleme', 'cal.statToday': 'Bugün',
    'cal.statMonth': 'Ay', 'cal.masters': 'Ekip', 'cal.dayOff': 'Tatil',
    'ms.book.title': 'Online randevu', 'ms.book.service': 'Hizmet', 'ms.book.branch': 'Şube',
    'ms.book.master': 'Uzman', 'ms.book.anyMaster': 'Fark etmez', 'ms.book.from': 'başlangıç', 'ms.book.date': 'Tarih', 'ms.book.time': 'Saat',
    'ms.book.dayClosed': 'Kapalı', 'ms.book.dayFull': 'Dolu', 'ms.book.dayClosedLong': 'Salon bu gün kapalı', 'ms.book.otherCategory': 'Diğer', 'ms.book.noSlots': 'Bu gün boş saat yok', 'ms.book.name': 'Adınız', 'ms.book.phone': 'Telefon',
    'ms.book.submit': 'Randevu al', 'ms.book.success': 'Randevunuz alındı!', 'ms.book.successWa': 'Onay WhatsApp\'a gönderildi',
    'ms.book.taken': 'Bu saat az önce doldu — başka bir saat seçin', 'ms.book.leadTitle': 'Talep bırakın',
    'ms.book.leadDate': 'İstenen tarih ve saat', 'ms.book.leadSent': 'Talep gönderildi! En kısa sürede sizinle iletişime geçeceğiz',
    'ms.book.minutes': 'dk', 'ms.book.another': 'Tekrar randevu al',
    'ms.book.stepOf': 'Adım {n} / {total}', 'ms.book.back': 'Geri', 'ms.book.chooseBranch': 'Şube seçin',
    'ms.book.chooseService': 'Hizmet seçin', 'ms.book.chooseMaster': 'Uzman seçin', 'ms.book.chooseTime': 'Tarih ve saat seçin',
    'ms.book.contact': 'İletişim bilgileriniz', 'ms.book.anyMasterHint': 'Seçtiğiniz saat için müsait bir uzman atayacağız',
    'ms.book.phoneCheck': 'Numaranızı kontrol edin — randevu hatırlatmasını buraya göndereceğiz', 'ms.book.phoneLooksWrong': 'Bu numara eksik görünüyor — lütfen kontrol edin',
    'ms.book.consent': '{policy} kabul ediyorum ve randevu hatırlatmaları (WhatsApp / SMS) almayı onaylıyorum', 'ms.book.policy': 'Gizlilik politikasını',
    'ms.book.addToCalendar': 'Takvime ekle', 'ms.book.googleCal': 'Google Takvim', 'ms.book.writeWa': 'WhatsApp’tan yaz',
    'ms.book.reminderTo': 'Hatırlatma {phone} numarasına gönderilecek', 'ms.book.waHello': 'Merhaba! {date} {time} için {service} randevusu aldım.',
    'ms.book.total': 'Toplam', 'ms.book.noServicesHere': 'Burada henüz online randevu için hizmet yok — sohbetten yazın, size uygun bir zaman bulalım',
    'miniBuilder.autoTeam': 'Uzmanlar Ekip bölümünden otomatik doldurulur',
    'miniBuilder.autoServices': 'Hizmetler ve fiyatlar Ekip bölümünden otomatik doldurulur',
    'miniBuilder.autoOpen': 'Ekibi aç',
    'settings.calendarTitle': 'Chatity Takvimi', 'settings.calendarHint': 'Randevuları kendi CRM\'inizde tutuyorsanız kapatın: AI boş saat söylemez — talep toplar (ad, telefon, istenen saat) ve size anında iletir',
    'settings.modeTitle': 'Çalışma modu', 'settings.modeHint': 'AI ve takvim birlikte nasıl çalışır',
    'settings.modeAutopilot': 'Otomatik pilot', 'settings.modeAutopilotDesc': 'AI her uzmana göre boş saati seçer ve takvimde onaylı bir randevu oluşturur. Her randevu için bildirim alırsınız.',
    'settings.modeManual': 'AI olmadan takvim', 'settings.modeManualDesc': 'Takvim açık ama AI müşterilere yanıt vermez. Randevuları elle yönetirsiniz. Müşteri mesajları kaydedilir ve size iletilir.',
    'settings.modeCrmOnly': 'Yalnızca talepler (takvimsiz)', 'settings.modeCrmOnlyDesc': 'Takvim yok. AI sohbet eder ve talep toplar (ad, telefon, istekler); randevuları kendi CRM\'inizde tutarsınız.',
    'settings.timezone': "Salon saat dilimi", 'settings.timezoneMissing': "— ayarlanmadı (Europe/Paris varsayılır) —", 'settings.timezoneSaved': "Saat dilimi kaydedildi", 'settings.timezoneWarning': "Saat diliminizi ayarlayın: AI çalışma saatleri, boş slotlar ve hatırlatmalar buna bağlıdır.",
    'settings.aiScheduleScopeAll': "Tüm kanallar için tek program", 'settings.aiScheduleScopePerChannel': "Kanal bazında", 'settings.aiScheduleAppliesTo': "Geçerli olduğu kanallar", 'settings.aiScheduleChannelsHint': "Bir kanalın işaretini kaldırırsanız AI orada 7/24 yanıt verir (örn. site widget'ı her zaman, WhatsApp sadece mesai dışı).", 'settings.aiScheduleCh.widget': "Site widget'ı", 'settings.aiScheduleCh.whatsapp': "WhatsApp", 'settings.aiScheduleCh.instagram': "Instagram", 'settings.aiScheduleCh.phone': "Telefon", 'settings.aiScheduleChEnabled': "\"{channel}\" kanalında AI saatlerini sınırla", 'settings.aiSchedulePhoneHint': "Telefon: AI saatleri dışında arama aktarma numaranıza yönlendirilir (ayarlıysa).",
    'settings.aiScheduleTitle': 'AI resepsiyonist çalışma saatleri', 'settings.aiScheduleHint': 'Bu saatler dışında AI yanıt vermez — mesajlar kaydedilir ve size bildirim gelir. Salon saati', 'settings.aiScheduleAlways': '7/24', 'settings.aiScheduleOn': 'Programa göre', 'settings.aiScheduleDays': 'Pzt,Sal,Çar,Per,Cum,Cmt,Paz', 'settings.aiScheduleOffMsg': 'AI saatleri dışında otomatik yanıt (isteğe bağlı)', 'settings.aiScheduleOffMsgPh': 'Örn.: Mesajınız için teşekkürler! Yöneticimiz çalışma saatlerinde yanıt verecek 💛', 'settings.aiScheduleOffMsgHint': 'Diyalog başına 12 saatte bir gönderilir. Boş bırakılırsa AI sadece sessiz kalır.',
    'settings.deleteAccount': 'Chatity hesabını sil', 'settings.deleteWarn': 'Kalıcı olarak silinir: salonunuz, tüm kanallardaki tüm diyalog geçmişi, müşteriler, randevular, ekip, WhatsApp/Instagram bağlantıları (örnekler kapatılır); abonelik iptal edilir. Veriler geri alınamaz.', 'settings.deleteTypeHint': 'Onaylamak için DELETE yazın:', 'settings.deleteConfirmBtn': 'Her şeyi kalıcı olarak sil', 'settings.deleteCancel': 'İptal', 'settings.deleteDone': 'Hesap ve tüm veriler silindi',
    'settings.voiceTitle': 'AI sesli yanıtlar', 'settings.voiceHint': 'AI, WhatsApp ve Instagram\'da müşterilere metne ek olarak sesli mesajla yanıt verebilir. Ses, müşterinin dilinde konuşur.', 'settings.voiceMode_off': 'Kapalı', 'settings.voiceMode_off_desc': 'Sadece metin', 'settings.voiceMode_voice_in': 'Sese ses', 'settings.voiceMode_voice_in_desc': 'Müşteri sesli mesaj gönderirse sesli yanıt veririz (önerilir)', 'settings.voiceMode_always': 'Her zaman', 'settings.voiceMode_always_desc': 'Her AI yanıtı sesli mesaj olarak da gönderilir', 'settings.voicePreview': 'Dinle', 'settings.voiceStop': 'Durdur', 'settings.voiceQuota': 'Bu ayki karakterler',
    'settings.humanFirstTitle': "🙋 Önce insan: WhatsApp/Instagram'da AI yanıt gecikmesi", 'settings.humanFirstHint': "AI yanıt vermeden önce seçilen süre kadar bekler. Bu sürede ekibiniz yanıtlarsa (telefondan veya Mesajlar'dan) AI sessiz kalır. Site widget'ı her zaman anında yanıt verir.", 'settings.humanFirst0': "Gecikme yok — AI hemen yanıtlar", 'settings.humanFirst30': "30 saniye", 'settings.humanFirst60': "1 dakika", 'settings.humanFirst120': "2 dakika", 'settings.humanFirst300': "5 dakika", 'settings.humanFirst600': "10 dakika",
    'settings.manualPauseTitle': '⏸ Manuel yanıtınızdan sonra AI duraklaması', 'settings.manualPauseHint': 'Bir müşteriye kendiniz yanıt verdiğinizde (telefonunuzdan WhatsApp/Instagram\'da veya Mesajlar\'dan), AI bu diyalogda seçilen süre boyunca susar. AI\'yı Mesajlar\'dan daha erken geri getirebilirsiniz.',
    'settings.manualPause1': '1 saat', 'settings.manualPause6': '6 saat', 'settings.manualPause24': '24 saat', 'settings.manualPause72': '3 gün', 'settings.manualPause0': 'Manuel olarak açana kadar',
    'settings.brandingTitle': 'Chatity markasını kaldır', 'settings.brandingHint': 'AI "Chatity" adını anmaz — salonunuzun sanal asistanı olarak tarafsız tanıtır',
    'settings.introLabel': 'AI kendini nasıl tanıtsın', 'settings.introPlaceholder': 'Örn.: Merhaba! Ben Mia — Oui Beauté salonunun sanal resepsiyonistiyim 💛',
    'settings.introHint': 'Müşterinin diline otomatik çevrilir. Boş bırakırsanız varsayılan karşılama kullanılır.',
    'settings.languageTitle': 'Arayüz dili',
    'subscription.freeForever': 'Free plandasınız — takvim ve mini site sonsuza dek ücretsiz',
    'subscription.freeForeverHint': 'Ayda €39 itibaren AI resepsiyonist ekleyin — müşterilere yanıt verir ve randevu alır',
    'team.loadError': 'Ekip verileri yüklenemedi',
    'team.saved': 'Kaydedildi',
    'team.saveError': 'Kaydedilemedi',
    'team.deleted': 'Silindi',
    'team.inviteSent': 'Davet e-posta ile gönderildi',
    'team.inviteError': 'Davet gönderilemedi',
    'team.branchesTitle': 'Şubeler',
    'team.addBranch': 'Şube ekle',
    'team.branchesHint': 'AI şubelerinizi görür ve müşteriye hangisine randevu istediğini sorar',
    'team.mainBranch': 'Ana',
    'team.editBranch': 'Şubeyi düzenle',
    'team.branchName': 'Ad',
    'team.branchAddress': 'Adres',
    'team.branchPhone': 'Telefon',
    'team.branchHours': 'Çalışma saatleri',
    'team.branchHoursHint': 'Şube saatleri usta programlarını sınırlar — AI bu saatler dışında slot önermez',
    'team.staffTitle': 'Ekip üyeleri',
    'team.addStaff': 'Üye ekle',
    'team.noServicesWarning': 'Hizmet atanmadı — AI ve takvim bu ustaya randevu veremez. Hizmetleri işaretlemek için tıklayın',
    'team.staffHint': 'Ustaları ve yöneticileri e-posta ile davet edin — tek kullanımlık kod alırlar',
    'team.noStaff': 'Henüz üye yok — ilk ustayı ekleyin',
    'team.roleAdmin': 'Yönetici',
    'team.roleMaster': 'Usta',
    'team.roleMasterDesc': 'sadece kendi programını görür',
    'team.roleAdminDesc': 'şube randevularını yönetir',
    'team.joined': 'Katıldı',
    'team.invited': 'Davet edildi',
    'team.noEmail': 'e-posta yok',
    'team.invite': 'Davet et',
    'team.resendAccess': 'Erişimi geri yükle', 'team.accessSent': 'Erişim kurtarma e-postası gönderildi', 'team.resendHint': 'Giriş yapamıyor mu? E-postayı yeniden gönderin — usta bağlantı ve kodla yeni şifre belirler (24 saat geçerli).',
    'team.reinvite': 'Tekrar gönder',
    'team.schedule': 'Program',
    'team.editStaff': 'Üyeyi düzenle',
    'team.staffName': 'Ad',
    'team.forInvite': 'davet için',
    'team.role': 'Rol',
    'team.branches': 'Şubeler',
    'team.staffServices': 'Hizmetler',
    'team.addServicesFirst': 'Önce aşağıya hizmet ekleyin',
    'team.color': 'Takvim rengi',
    'team.planityTitle': 'Planity\'den takvimi içe aktar', 'team.planityHint': 'Bu uzmanın kişisel Planity iCal bağlantısını yapıştırın — sistem meşgul saatlerini otomatik dikkate alır ve yalnızca gerçekten boş saatleri önerir.', 'team.planityCheck': 'Kontrol et', 'team.planityFound': 'meşgul slot bulundu', 'team.planityError': 'Takvim okunamadı',
    'team.scheduleFor': 'Program —',
    'team.dayOff': 'Tatil',
    'team.photoUpload': 'Fotoğraf yükle', 'team.photoChange': 'Fotoğrafı değiştir', 'team.photoRemove': 'Kaldır', 'team.photoHint': 'JPG/PNG/WebP en fazla 2 MB — mini sitede gösterilir',
    'team.allBranches': 'Tüm şubeler', 'team.serviceBranches': 'Şubeler', 'team.serviceBranchesHint': 'Seçim yoksa hizmet tüm şubelerde sunulur. Şube fiyatı temel fiyatın yerine geçer; uzman seviyesi fiyatları bunun üzerine uygulanır.', 'team.priceIn': 'Fiyat:', 'team.duplicate': 'Kopyala', 'team.copySuffix': 'kopya',
    'team.repeat': 'Program sıklığı', 'team.repeatHint': 'Ör. uzman bu programla iki haftada bir çalışır. Boş haftalarda randevu önerilmez.', 'team.repeatWeekly': 'Her hafta', 'team.repeatEveryN': 'Her {n} haftada', 'team.repeatAnchor': 'İlk çalışma haftası (herhangi bir günü)', 'team.repeatUntil': 'Bitiş (isteğe bağlı)',
    'team.acceptsLower': 'Boş saat varsa daha düşük seviyeden müşteri kabul eder', 'team.acceptsLowerHint': 'Online randevu ve AI önce istenen seviyedeki uzmanları önerir; istenen saatte yoksa bu uzmanı normal (temel) fiyattan önerir.', 'cal.priceAuto': 'Otomatik', 'ms.book.fallbackNote': 'Bu saatte yalnızca üst seviye bir uzman müsait — normal fiyattan kaydedeceğiz',
    'team.allServices': 'Tüm hizmetler',
    'team.staffServicesHint': 'Uzmanın hizmetlerini işaretleyin. Yapay zekâ ve online randevu bu uzmanı YALNIZCA işaretli hizmetler için ayırır (hiçbiri işaretli değilse randevu alınamaz). İşaretlenenler için kendi süre ve fiyatını belirleyebilirsiniz — varsayılanları geçersiz kılar.', 'team.ownDurationPrice': 'Bu uzman için özel süre / fiyat',
    'team.category': 'Kategori', 'team.categoryPlaceholder': 'Tırnak / Kaş / Saç', 'team.noCategory': 'Kategorisiz', 'team.wholeCategory': 'tüm kategori',
    'team.exceptions': 'İstisnalar: izin ve özel günler', 'team.exceptionsHint': 'Bu günler haftalık programın önüne geçer: online randevu, AI ve telefon bu saatleri önermez.',
    'team.excFrom': 'Başlangıç', 'team.excTo': 'Bitiş', 'team.excDayOff': 'Tatil', 'team.excCustom': 'Özel saatler', 'team.excNote': 'Not (ör. izin)', 'team.excAdd': 'Ekle', 'team.excNone': 'İstisna yok', 'team.excAdded': 'İstisna eklendi', 'team.excRemoved': 'İstisna silindi',
    'cal.vacation': 'Çalışmıyor',
    'team.servicesTitle': 'Hizmetler ve süre', 'team.levels': 'Usta seviyeleri', 'team.level': 'Seviye', 'team.levelNone': 'Seviye yok', 'team.priceByLevel': 'Seviyeye göre fiyat', 'team.priceByLevelHint': 'Fiyat aynıysa boş bırakın. Yalnızca temel fiyattan farklı olan seviyeleri doldurun.', 'team.levelsTitle': 'Usta seviyeleri', 'team.levelsHint': 'Salonunuzdaki adlar ve yıldızlar. Mini sitede, randevuda ve AI yanıtlarında müşterilere gösterilir.', 'team.levelName': 'Ad', 'team.addLevel': 'Seviye ekle',
    'team.addService': 'Hizmet ekle',
    'team.servicesHint': 'Süre, AI\'nin gerçek boş saatler önermesini sağlar',
    'team.noServices': 'Fiyat ve süre ile hizmet ekleyin',
    'team.min': 'dk',
    'team.editService': 'Hizmeti düzenle',
    'team.serviceName': 'Hizmet adı',
    'team.servicePrice': 'Fiyat',
    'team.serviceDuration': 'Süre (dk)',
    'team.save': 'Kaydet',

    'partner.meta.title': 'Chatity Ortaklık Programı — Her ödemenin %30\'u',
    'partner.meta.description': 'Yönlendirdiğiniz müşterilerin her ödemesinden %30 kazanın. Referans bağlantıları, analizler, karta ödemeler.',
    'partner.nav.back': 'Chatity',
    'partner.nav.dashboard': 'Ortak paneli →',
    'partner.badge': 'Ortaklık programı',
    'partner.hero.title1': 'Müşterilerinizin',
    'partner.hero.title2': 'her ödemesinden',
    'partner.hero.title3': 'kazanın',
    'partner.hero.subtitle': 'Referans bağlantınızı paylaşın, salon, klinik ve stüdyolar yönlendirin — ödeme yaptıkları sürece pay alın.',
    'partner.feature.commission.title': 'Her ödemenin %30\'u',
    'partner.feature.commission.desc': 'Tekrarlayan. Sadece ilk ay değil.',
    'partner.feature.link.title': 'Kişisel referans kodu',
    'partner.feature.link.desc': 'Çerez ile 30 gün atıfta bulunma.',
    'partner.feature.dashboard.title': 'Analitik panel',
    'partner.feature.dashboard.desc': 'Tıklamalar, kayıtlar, ödemeler, bakiye.',
    'partner.feature.payout.title': 'Karta / hesaba ödeme',
    'partner.feature.payout.desc': '20 €\'dan itibaren. 14 gün bekleme.',
    'partner.form.title': 'Ortak olun',
    'partner.form.subtitle': 'Formu doldurun — bağlantınızı anında alın.',
    'partner.form.name': 'Ad',
    'partner.form.namePlaceholder': 'Ahmet Yılmaz',
    'partner.form.email': 'Email',
    'partner.form.code': 'İstenen kod (isteğe bağlı)',
    'partner.form.channel': 'Nasıl tanıtacaksınız?',
    'partner.form.channelPlaceholder': 'Salonlar için pazarlama blogu, Telegram kanalı ...',
    'partner.form.submit': 'Bağlantımı al',
    'partner.form.submitting': 'Gönderiliyor...',
    'partner.form.terms': 'Kaydolarak ortaklık koşullarını kabul edersiniz.',
    'partner.success.heading': 'Tamamlandı!',
    'partner.success.title': 'Referans bağlantınız',
    'partner.success.copy': 'Bağlantıyı kopyala',
    'partner.success.openDashboard': 'Ortak panelini aç',
    'partner.success.hint': '💡 İstatistikleri görmek için aynı email ile giriş yapın',
    'partner.toast.exists': 'Zaten ortak olarak kayıtlısınız',
    'partner.toast.created': 'Başvuru kabul edildi! Kodunuz aktif.',
    'partner.toast.error': 'Başvuru gönderilemedi',
    'partner.toast.copied': 'Panoya kopyalandı',
    'partner.dash.title': 'Ortak Paneli',
    'partner.dash.loading': 'Yükleniyor...',
    'partner.dash.breadcrumb': 'Ortak alanı',
    'partner.dash.backToClient': '← Müşteri paneline dön',
    'partner.dash.refLinkLabel': 'Referans bağlantınız',
    'partner.dash.commissionInfo': 'Komisyon %{pct} • Bekleme {days} gün',
    'partner.dash.copy': 'Kopyala',
    'partner.dash.copied': 'Kopyalandı',
    'partner.dash.stat.clicks': 'Tıklamalar (toplam)',
    'partner.dash.stat.clicks30d': 'son 30 gün: {n}',
    'partner.dash.stat.signups': 'Kayıtlar',
    'partner.dash.stat.paid': 'ödeyen: {n}',
    'partner.dash.stat.earned': 'Toplam kazanç',
    'partner.dash.stat.pending': 'beklemede: {amount}',
    'partner.dash.stat.available': 'Çekilebilir',
    'partner.dash.stat.paidOut': 'ödenen: {amount}',
    'partner.dash.payout.title': 'Ödeme bilgileri',
    'partner.dash.payout.subtitle': 'İlk talepten önce doldurun.',
    'partner.dash.payout.method': 'Yöntem',
    'partner.dash.payout.methodPlaceholder': 'Yöntem seçin',
    'partner.dash.payout.method.card_ru': 'Kart (Rusya)',
    'partner.dash.payout.method.bank': 'Banka transferi',
    'partner.dash.payout.method.bank_ru': 'Tüzel kişi (Rusya)',
    'partner.dash.payout.method.sepa_eu': 'IBAN / SEPA havalesi (Avrupa)',
    'partner.dash.payout.method.rib_eu': 'RIB (Fransa)',
    'partner.dash.payout.method.paypal': 'PayPal',
    'partner.dash.payout.method.crypto': 'Kripto para',
    'partner.dash.payout.region': 'Bölge',
    'partner.dash.payout.region.ru': 'Uluslararası ödeme (EUR)',
    'partner.dash.payout.region.eu': 'Avrupa / Uluslararası (EUR, USD)',
    'partner.dash.payout.field.cardNumber': 'Kart numarası',
    'partner.dash.payout.field.fullName': 'Ad soyad',
    'partner.dash.payout.field.companyName': 'Şirket adı',
    'partner.dash.payout.field.inn': 'INN',
    'partner.dash.payout.field.kpp': 'KPP',
    'partner.dash.payout.field.bik': 'BIK',
    'partner.dash.payout.field.account': 'Hesap numarası',
    'partner.dash.payout.field.bankName': 'Banka adı',
    'partner.dash.payout.field.iban': 'IBAN',
    'partner.dash.payout.field.swift': 'SWIFT / BIC',
    'partner.dash.payout.field.ribBankCode': 'Banka kodu (5 hane)',
    'partner.dash.payout.field.ribBranchCode': 'Şube kodu (5 hane)',
    'partner.dash.payout.field.ribAccount': 'Hesap numarası (11 hane)',
    'partner.dash.payout.field.ribKey': 'RIB anahtarı (2 hane)',
    'partner.dash.payout.field.paypalEmail': 'PayPal E-posta',
    'partner.dash.payout.field.walletAddress': 'Cüzdan adresi',
    'partner.dash.payout.field.cryptoNetwork': 'Ağ',
    'partner.dash.payout.edit': 'Detayları düzenle',
    'partner.dash.payout.savedSummary': 'Kaydedildi',
    'partner.dash.request.max': 'Maks',
    'partner.dash.request.maxHint': 'Maksimum tutarı kullan',
    'partner.dash.payout.details': 'Detaylar',
    'partner.dash.payout.detailsPlaceholder': 'Kart / hesap / cüzdan adresi + ad soyad',
    'partner.dash.payout.save': 'Kaydet',
    'partner.dash.payout.saved': 'Kaydedildi',
    'partner.dash.payout.saveError': 'Kaydedilemedi',
    'partner.dash.payout.fillFirst': 'Önce yöntem ve detayları doldurun',
    'partner.dash.request.title': 'Ödeme talep et',
    'partner.dash.request.available': 'Çekilebilir',
    'partner.dash.request.min': 'min. 20 €',
    'partner.dash.request.amount': 'Tutar',
    'partner.dash.request.currency': 'Para birimi',
    'partner.dash.request.submit': 'Ödeme talep et',
    'partner.dash.request.created': 'Ödeme talebi oluşturuldu',
    'partner.dash.referrals.title': 'Referanslarınız',
    'partner.dash.referrals.empty': 'Henüz kimse bağlantınız üzerinden kaydolmadı.',
    'partner.dash.referrals.email': 'Email',
    'partner.dash.referrals.business': 'İşletme',
    'partner.dash.referrals.plan': 'Plan',
    'partner.dash.referrals.status': 'Durum',
    'partner.dash.referrals.payments': 'Ödemeler',
    'partner.dash.referrals.earned': 'Kazanç',
    'partner.dash.referrals.paid': 'Ödendi',
    'partner.dash.referrals.trial': 'Deneme',
    'partner.dash.payouts.title': 'Ödeme geçmişi',
    'partner.dash.payouts.empty': 'Henüz ödeme talebi yok.',
    'partner.dash.payouts.date': 'Tarih',
    'partner.dash.payouts.amount': 'Tutar',
    'partner.dash.payouts.method': 'Yöntem',
    'partner.dash.payouts.status': 'Durum',
    'partner.dash.payouts.note': 'Not',
    'partner.onboard.title': 'Ortaklık programı',
    'partner.onboard.subtitle': 'Chatity\'ye müşteri getirin ve her ödemelerinin %30\'unu kazanın. 14 gün bekleme, 20 €\'dan ödemeler.',
    'partner.onboard.name': 'Adınız',
    'partner.onboard.code': 'İstenen kod (isteğe bağlı)',
    'partner.onboard.submit': 'Ortak ol',
    'partner.onboard.success': 'Harika! Artık ortaksınız.',
    'partner.onboard.error': 'Hata',
    'partner.cta.badge': 'Yönlendirmelerden kazanın',
    'partner.cta.title': 'Ortak olun',
    'partner.cta.desc': 'Getirdiğiniz müşterilerin her ödemesinden %30 alın',
    'partner.cta.button': 'Programı aç',
    'partner.footer': 'Ortaklar',
    'shortLink.title': 'Kısa rezervasyon bağlantısı',
    'shortLink.description': 'Müşterilerinize sohbet widget\'ına doğrudan bir bağlantı verin. Instagram bio, Linktree, kartvizit ve reklamlar için ideal. Tek tıkla yapay zeka sohbeti hazır açılır.',
    'shortLink.placeholder': 'oui-beaute',
    'shortLink.save': 'Kaydet',
    'shortLink.saving': 'Kaydediliyor...',
    'shortLink.copy': 'Kopyala',
    'shortLink.open': 'Aç',
    'shortLink.qr': 'QR-kod',
    'shortLink.qr.title': 'QR-kodunuz',
    'shortLink.qr.hint': 'Bunu basılı materyallere, kartvizitlere veya vitrine yerleştirin — tarama mini-sitenizi açar.',
    'shortLink.qr.download': 'PNG indir',
    'shortLink.qr.close': 'Kapat',
    'shortLink.toast.qrDownloaded': 'QR-kod indirildi',
    'shortLink.toast.qrDownloadFailed': 'QR-kod indirilemedi',
    'shortLink.status.checking': 'Kontrol ediliyor...',
    'shortLink.status.available': 'Müsait',
    'shortLink.status.taken': 'Müsait değil',
    'shortLink.status.currentLink': 'Bu sizin mevcut bağlantınız',
    'shortLink.status.error': 'Hata',
    'shortLink.reason.reserved': 'Bu slug sistem tarafından ayrıldı',
    'shortLink.reason.alreadyTaken': 'Başka bir salon tarafından alındı',
    'shortLink.reason.tooShort': 'En az 3 karakter',
    'shortLink.reason.tooLong': 'En fazla 50 karakter',
    'shortLink.reason.invalidChars': 'Yalnızca harfler, rakamlar ve tireler (boşluk veya özel karakter yok)',
    'shortLink.toast.saved': 'Kısa bağlantı kaydedildi',
    'shortLink.toast.saveFailed': 'Kaydedilemedi',
    'shortLink.toast.copied': 'Bağlantı kopyalandı',
    'shortLink.badge.active': 'AKTİF',
    'shortLink.badge.notSet': 'AYARLANMADI',
    'notFound.title': 'Sayfa bulunamadı',
    'notFound.headline': 'Bu sayfa kayboldu',
    'notFound.subtitle': 'Belki bağlantı süresi doldu veya yazım hatası var. Ama Chatity AI asla kaybolmaz 😉',
    'notFound.cta.home': 'Anasayfa',
    'notFound.cta.demo': 'AI\'yı dene',
    'notFound.helpfulLinks': 'Veya deneyin',
    'notFound.link.blog': 'Blog',
    'notFound.link.partner': 'Ortak ol',
    'notFound.link.login': 'Giriş yap',
    'notFound.link.support': 'Destek',
    'miniSite.cta.chat': 'Danışma alın',
    'miniSite.bookNow': 'Randevu al',
    'miniSite.showPhone': 'Göster',
    'miniSite.section.team': 'Uzmanlar',
    'miniSite.onMap': 'Haritada',
    'miniSite.services.viewAll': 'Tümünü göster',
    'miniSite.services.collapse': 'Daralt',
    'miniBuilder.colors.title': 'Mini site rengi',
    'miniBuilder.colors.hint': 'Herkese açık sayfadaki düğmeler, fiyatlar ve başlıklar için vurgu rengi.',
    'miniBuilder.colors.preview': 'düğme önizlemesi',
    'miniBuilder.team.title': 'Uzmanlar',
    'miniBuilder.team.add': 'Uzman ekle',
    'miniBuilder.team.name': 'Uzman adı',
    'miniBuilder.team.role': 'Uzmanlık (örn. Manikür ustası)',
    'miniBuilder.team.empty': 'Uzmanlarınızı ekleyin — mini sitede "Randevu al" düğmeli kartlar olarak görünecekler.',
    'miniSite.section.about': 'Hakkımızda',
    'miniSite.empty': 'Salon açıklaması yakında. Bu sırada — sağdaki AI\'ya istediğiniz soruyu sorun 👉',
    'miniSite.section.services': 'Hizmetler & fiyatlar',
    'miniSite.section.gallery': 'Galeri',
    'miniSite.section.contacts': 'İletişim & adres',
    'miniSite.contact.phone': 'Telefon',
    'miniSite.contact.address': 'Adres',
    'miniSite.map.openInMaps': 'Google Maps\'te aç',
    'miniSite.section.hours': 'Çalışma saatleri',
    'miniSite.contact.whatsapp': 'WhatsApp',
    'miniSite.contact.email': 'Email',
    'miniSite.gallery.close': 'Kapat (Esc)',
    'miniSite.gallery.prev': 'Önceki',
    'miniSite.gallery.next': 'Sonraki',
    'miniSite.translate.byAi': 'AI tarafından otomatik çevrildi',
    'miniSite.translate.showOriginal': 'Orijinali göster',
    'miniSite.translate.viewingOriginal': 'Orijinal sürüm görüntüleniyor',
    'miniSite.translate.translateBack': 'Dilime çevir',
    'miniSite.translate.loading': 'Otomatik çevriliyor…',
    'miniSite.translate.failed': 'Otomatik çeviri başarısız. Orijinal sürüm gösteriliyor.',
    'tabs.clients': 'Müşteriler',
    'bookings.historyLimitBanner': '30 günden eski rezervasyonlar Professional planında mevcuttur',
    'clients.title': 'Müşteri tabanı',
    'clients.subtitle': 'Rezervasyonlar telefon numarasına göre otomatik birleştirilir (farklı formatlar birleşir)',
    'clients.limitedNote': 'Starter planı son 30 günün müşterilerini gösterir. Tam geçmiş — Professional planında',
    'clients.search': 'İsim veya telefonla ara',
    'clients.noClients': 'Henüz müşteri yok',
    'clients.visits': 'rezervasyon',
    'clients.firstVisit': 'İlk ziyaret',
    'clients.lastVisit': 'Son ziyaret',
    'clients.phones': 'Tüm numaralar',
    'clients.services': 'Hizmetler',
    'clients.source': 'Kaynak',
    'clients.aiSummary': 'AI müşteri özeti', 'clients.aiSummaryBuild': 'Özet oluştur', 'clients.aiSummaryRefresh': 'Yenile', 'clients.aiSummaryBusy': 'Analiz ediliyor…', 'clients.aiSummaryHint': 'AI randevu ve mesaj geçmişini okur ve müşteriyi kısaca tanımlar: ziyaret ritmi, favori hizmetler, tercihler ve sonraki teklif.', 'clients.aiRisk': 'Kayıp riski', 'clients.aiRhythm': 'Ziyaret ritmi', 'clients.aiFavorites': 'Favori hizmetler', 'clients.aiNextOffer': 'Ne önerilmeli', 'clients.aiGenerated': 'Oluşturuldu',
    'clients.history': 'Rezervasyon geçmişi',
    
    // Upgrade banners
    'upgrade.telegram.title': 'Telegram bildirimleri Professional ve Unlimited planlarda kullanılabilir',
    'upgrade.telegram.button': 'Planı Yükselt',
    'upgrade.widget.title': 'Widget Özelleştirme',
    'upgrade.widget.description': 'Professional veya Unlimited planlarda markanız için widget görünümünü özelleştirin:',
    'upgrade.widget.feature1': 'Widget renklerini değiştir',
    'upgrade.widget.feature2': 'Hoş geldin mesajını özelleştir',
    'upgrade.widget.feature3': 'Bot adını kişiselleştir',
    'upgrade.widget.button': 'Planı Yükselt',
    
    // Widget
    'widget.title': 'Widget Kodu',
    'widget.subtitle': 'Bu kodu web sitenizde kapanış etiketinden önce ekleyin',
    'widget.copy': 'Kodu Kopyala',
    'widget.demo': 'Demoyu Aç',
    'widget.copied': 'Kod panoya kopyalandı!',
    'widget.status.title': 'Widget Kurulum Durumu',
    'widget.status.unchecked': 'Kurulumu doğrulamak için "Kontrol Et" düğmesine tıklayın',
    'widget.status.checking': 'Kontrol ediliyor...',
    'widget.status.active': 'Aktif • Son aktivite: {time}',
    'widget.status.configured': 'Yapılandırıldı, ilk mesaj bekleniyor',
    'widget.status.inactive': 'Kurulmadı veya çalışmıyor',
    'widget.status.checkButton': '🔍 Kontrol Et',
    'widget.status.successToast': '✅ Widget aktif ve çalışıyor!',
    'widget.status.configuredToast': '🟡 Widget yapılandırıldı, ancak henüz aktivite yok',
    'widget.status.errorToast': '🔴 Widget kurulmadı veya çalışmıyor',
    
    // Integrations
    'integrations.title': 'Entegrasyonlar',
    'integrations.subtitle': 'Chatity widget\'ını web sitenize entegre edin',
    'integrations.yourWidgetKey': 'Widget Anahtarınız',
    'integrations.copyKey': 'Anahtarı Kopyala',
    'integrations.copyInstructions': 'Talimatları Kopyala',
    'integrations.instructionsCopied': 'Talimatlar kopyalandı!',
    'integrations.keyCopied': 'Anahtar kopyalandı!',
    'integrations.sendToDeveloper': 'Geliştiriciye Gönder',
    'integrations.developerEmail': 'Geliştirici E-postası',
    'integrations.developerEmailPlaceholder': 'developer@example.com',
    'integrations.send': 'Gönder',
    'integrations.emailSent': 'Talimatlar gönderildi!',
    'integrations.wordpress.title': 'WordPress Eklentisi',
    'integrations.wordpress.description': 'WordPress web siteleri için kolay kurulum. Eklentiyi kurun ve widget anahtarınızı girin.',
    'integrations.wordpress.download': 'Eklentiyi İndir',
    'integrations.html.title': 'HTML / JavaScript',
    'integrations.html.description': 'Her web sitesi için evrensel yöntem',
    'integrations.html.step1': 'Yukarıdaki widget kodunu kopyalayın',
    'integrations.html.step2': 'Kodu web sitenizde kapanış </body> etiketinden önce yapıştırın',
    'integrations.webflow.description': 'Webflow web siteleri için',
    'integrations.webflow.step1': 'Webflow proje ayarlarınızı açın',
    'integrations.webflow.step2': 'Custom Code → Footer Code\'a gidin',
    'integrations.webflow.step3': 'Kopyalanan widget kodunu yapıştırın',
    'integrations.webflow.step4': 'Sitenizi kaydedin ve yayınlayın',
    'integrations.twilio.title': 'Twilio Voice AI',
    'integrations.twilio.description': 'Gelen aramaları işlemek için AI asistanı',
    'integrations.twilio.phoneNumber': 'Telefon numaranız',
    'integrations.twilio.status': 'Durum',
    'integrations.twilio.enabled': 'Etkin',
    'integrations.twilio.disabled': 'Devre dışı',
    'integrations.twilio.enable': 'Etkinleştir',
    'integrations.twilio.disable': 'Devre Dışı Bırak',
    'integrations.twilio.webhookUrl': 'Twilio kurulumu için Webhook URL',
    'integrations.twilio.instructions': 'Twilio hesabınızda webhook\'u yapılandırın',
    'integrations.twilio.credentials': 'Twilio Kimlik Bilgileri',
    'integrations.twilio.credentialsInfo': 'Twilio Konsolundan kimlik bilgilerinizi girin',
    'integrations.twilio.credentialsRequired': 'Lütfen tüm Twilio alanlarını doldurun',
    'integrations.twilio.voiceLanguage': 'Sesli Asistan Dili',
    'integrations.twilio.voiceSpeed': 'Konuşma Hızı',
    'integrations.twilio.howItWorks': 'Nasıl çalışır',
    'integrations.twilio.step1': '1. Müşteri numaranızı arar',
    'integrations.twilio.step2': '2. AI müşterinin dilinde yanıt verir',
    'integrations.twilio.step3': '3. Rezervasyon bilgilerini toplar',
    'integrations.twilio.step4': '4. Kontrol panelinizde otomatik olarak rezervasyon oluşturur',
    'integrations.shopify.description': 'Shopify çevrimiçi mağazalar için',
    'integrations.shopify.step1': 'Shopify yönetici panelinize giriş yapın',
    'integrations.shopify.step2': 'Online Store → Themes\'e gidin',
    'integrations.shopify.step3': 'Actions → Edit code\'a tıklayın',
    'integrations.shopify.step4': 'Layout klasöründe theme.liquid dosyasını açın',
    'integrations.shopify.step5': 'Widget kodunu kapanış </body> etiketinden önce yapıştırın ve kaydedin',
    'integrations.wix.description': 'Wix web siteleri için (Premium gerekli)',
    'integrations.wix.step1': 'Wix site düzenleyicinizi açın',
    'integrations.wix.step2': 'Settings → Custom Code\'a gidin',
    'integrations.wix.step3': '+ Add Custom Code\'a tıklayın',
    'integrations.wix.step4': 'Widget kodunu yapıştırın, "Load code on each new page" seçin ve "Body - end" konumunu seçin',
    'integrations.tilda.description': 'Tilda web siteleri için',
    'integrations.tilda.step1': 'Tilda\'da sayfa ayarlarını açın',
    'integrations.tilda.step2': '"Daha Fazla" → "Web sitesi için HTML kodu" bölümüne gidin',
    'integrations.tilda.step3': 'Widget kodunu "Before </body>" alanına yapıştırın',
    'integrations.tilda.step4': 'Sayfayı kaydedin ve yayınlayın',
    'integrations.squarespace.description': 'Squarespace web siteleri için',
    'integrations.squarespace.step1': 'Squarespace yönetici panelinize giriş yapın',
    'integrations.squarespace.step2': 'Settings → Advanced → Code Injection\'a gidin',
    'integrations.squarespace.step3': 'Widget kodunu Footer alanına yapıştırın',
    'integrations.squarespace.step4': 'Save\'e tıklayın',
    'integrations.gtm.description': 'Google Tag Manager ile ileri düzey kullanıcılar için',
    'integrations.gtm.step1': 'Google Tag Manager\'a giriş yapın',
    'integrations.gtm.step2': 'Yeni bir Etiket oluşturun → Custom HTML',
    'integrations.gtm.step3': 'Widget kodunu yapıştırın',
    'integrations.gtm.step4': 'Tetikleyiciyi All Pages olarak ayarlayın',
    'integrations.gtm.step5': 'Kaydedin, test edin ve konteynerı yayınlayın',
    
    // Admin
    'admin.title': 'Süper Yönetici Paneli',
    'admin.subtitle': 'Platform istatistikleri ve tüm salonlar',
    'admin.users': 'Kullanıcılar',
    'admin.salons': 'Salonlar',
    'admin.bookings': 'Rezervasyonlar',
    'admin.allSalons': 'Tüm platform salonları',
    'admin.registered': 'Kayıtlı',
    'admin.loading': 'Yükleniyor...',
    'admin.email': 'E-posta',
    'admin.plan': 'Plan',
    'admin.status': 'Durum',
    'admin.showingYourSalon': 'Yalnızca salonunuz gösteriliyor (demo için)',
    'admin.days': 'gün',
    'admin.allTime': 'Tüm Zamanlar',
    'admin.totalUsers': 'Toplam Kullanıcılar',
    'admin.totalBookings': 'Toplam Rezervasyonlar',
    'admin.paidVsTrial': 'Ücretli / Deneme',
    'admin.conversion': 'Dönüşüm',
    'admin.periodStats': 'Dönem İstatistikleri',
    'admin.newUsers': 'Yeni Kullanıcılar',
    'admin.newSalons': 'Yeni Salonlar',
    'admin.newBookings': 'Yeni Rezervasyonlar',
    'admin.grantUnlimited': 'Unlimited Ver',
    'admin.deleteAccount': 'Hesabı Sil',
    'admin.confirmDelete': 'Bu hesabı silmek istediğinizden emin misiniz? Tüm kullanıcı verileri kalıcı olarak silinecek.',
    'admin.confirmGrant': 'Bu kullanıcıya unlimited planı ver?',
    'admin.unlimitedGranted': 'Unlimited planı başarıyla verildi',
    'admin.accountDeleted': 'Hesap başarıyla silindi',
    'admin.error': 'İşlem gerçekleştirilirken hata',
    
    // Subscription
    'subscription.title': 'Abonelik Yönetimi',
    'subscription.subtitle': 'İşletmenize uygun bir plan seçin',
    'subscription.trialLeft': 'Deneme süresi:',
    'subscription.daysLeft': 'gün kaldı',
    'subscription.price': '7 gün ücretsiz, sonra €39/ay',
    'subscription.manageBilling': 'Aboneliği yönet',
    'subscription.manageBillingDesc': 'Aboneliği iptal et, kartı değiştir, faturaları indir',
    'subscription.manageBillingBtn': 'Portalı aç',
    'subscription.portalError': 'Fatura portalı açılamadı',
    'subscription.invoice': 'Fatura',
    'subscription.invoiceUnavailable': 'Bu ödeme için fatura mevcut değil',
    'subscription.button': 'Abone Ol',
    'subscription.error': 'Abonelik hatası',
    'subscription.currentPlan': 'Mevcut Plan',
    'subscription.trialPeriod': 'Deneme Süresi',
    'subscription.daysRemaining': 'kalan',
    'subscription.day': 'gün',
    'subscription.days': 'gün',
    'subscription.expired': 'Deneme süresi doldu',
    'subscription.usage': 'Konuşma Kullanımı',
    'subscription.used': 'kullanıldı',
    'subscription.selectPlan': 'Seç',
    'subscription.currentPlanBadge': 'Mevcut Plan',
    'subscription.popular': 'Popüler',
    'subscription.idealForStart': 'Başlamak için mükemmel',
    'subscription.forGrowingBusiness': 'Büyüyen işletmeler için',
    'subscription.forLargeBusiness': 'Büyük işletmeler için',
    'subscription.conversationsPerMonth': 'aylık konuşma',
    'subscription.unlimited': 'Sınırsız konuşma',
    'subscription.aiAssistant': 'AI Asistan',
    'subscription.telegramNotifications': 'Telegram bildirimleri',
    'subscription.emailNotifications': 'E-posta bildirimleri',
    'subscription.widgetCustomization': 'Widget özelleştirme',
    'subscription.analytics': 'Analitik',
    'subscription.extendedAnalytics': 'Genişletilmiş analitik',
    'subscription.prioritySupport': 'Öncelikli destek',
    'subscription.utmTracking': 'UTM takibi',
    'subscription.knowledgeBase': 'AI Bilgi Tabanı',
    'subscription.securePayment': 'Güvenli Ödeme',
    'subscription.securePaymentInfo': 'Tüm ödemeler Stripe aracılığıyla işlenir. Kart verilerinizi saklamıyoruz.',
    'subscription.cancelAnytime': 'İstediğiniz zaman iptal edin',
    'subscription.cancelInfo': 'Aboneliğinizi istediğiniz zaman iptal edebilirsiniz.',
    'subscription.checkingPayment': 'Ödeme durumu kontrol ediliyor...',
    'subscription.paymentSuccess': 'Ödeme başarılı! Planınız yükseltildi',
    'subscription.paymentFailedTitle': 'Abonelik ödeme sorunu',
    'subscription.paymentFailedText': 'Bankanız ödemeyi reddetti. AI asistanı ödeme alınana kadar tüm kanallarda (web sitesi, WhatsApp, Instagram, telefon) duraklatıldı. Devam etmek için kartınızı güncelleyin.',
    'subscription.updateCardBtn': 'Kartı güncelle',
    'subscription.paymentCancelled': 'Ödeme iptal edildi',
    'subscription.paymentTimeout': 'Ödeme kontrolü çok uzun sürdü',
    'subscription.sessionExpired': 'Ödeme oturumu süresi doldu',
    'subscription.paymentCheckError': 'Ödeme durumu kontrol edilirken hata',
    'subscription.checkoutError': 'Ödeme oturumu oluşturulurken hata',
    'subscription.paymentHistory': 'Ödeme Geçmişi',
    'subscription.date': 'Tarih',
    'subscription.plan': 'Plan',
    'subscription.amount': 'Tutar',
    'subscription.status': 'Durum',
    'subscription.paid': 'Ödendi',
    'subscription.pending': 'Beklemede',
    'subscription.failed': 'Başarısız',
    'subscription.monthly': 'Aylık',
    'subscription.yearly': 'Yıllık',
    'subscription.year': 'yıl',
    'subscription.save2Months': '2 ay tasarruf!',
    'subscription.upgradeToYearly': 'Yıllığa yükselt',
    'subscription.creditApplied': 'Kalan süre için kredi uygulandı',
    'subscription.renewalDate': 'Sonraki yenileme',
    'subscription.trialBannerTitle': 'Deneme Süresi',
    'subscription.trialExpiredTitle': 'Deneme Süresi Doldu',
    'subscription.selectPlanBeforeExpiry': 'Kullanmaya devam etmek için deneme süresi dolmadan önce bir plan seçin',
    'subscription.payToContinue': 'Devam etmek için abonelik ödeyin',
    'subscription.selectPlanButton': 'Plan Seç',
    'subscription.payButton': 'Öde',
    'subscription.activeSubscription': 'Abonelik Aktif',
    'subscription.conversations': 'Konuşmalar',
    'subscription.remaining': 'kalan',
    'subscription.upgradePlan': 'Planı Yükselt',
    
    // Promocodes
    'promocode.title': 'Promosyon kodunuz var mı?',
    'promocode.placeholder': 'KODU GİRİN',
    'promocode.apply': 'Uygula',
    'promocode.remove': 'Kaldır',
    'promocode.discount': 'indirim',
    'promocode.applied': 'Promosyon kodu uygulandı!',
    'promocode.error': 'Geçersiz promosyon kodu',
    'promocode.enterCode': 'Promosyon kodu girin',
    
    // Support Tickets
    'support.supportTickets': 'Destek Talepleri',
    'support.askOurTeam': 'Ekibimize soru sorun',
    'support.createTicket': 'Talep Oluştur',
    'support.cancel': 'İptal',
    'support.newTicket': 'Yeni Talep',
    'support.subject': 'Konu',
    'support.subjectPlaceholder': 'Sorunun kısa açıklaması',
    'support.priority': 'Öncelik',
    'support.priorityLow': 'Düşük',
    'support.priorityMedium': 'Orta',
    'support.priorityHigh': 'Yüksek',
    'support.message': 'Mesaj',
    'support.messagePlaceholder': 'Sorununuzu ayrıntılı olarak açıklayın...',
    'support.noTicketsYet': 'Henüz talebiniz yok',
    'support.createFirstTicket': 'Sorularınız varsa ilk talebinizi oluşturun',
    'support.messagesCount': 'Mesajlar',
    'support.statusOpen': 'Açık',
    'support.statusInProgress': 'İşlemde',
    'support.statusClosed': 'Kapalı',
    'support.backToList': 'Listeye dön',
    'support.supportTeam': 'Destek',
    'support.you': 'Siz',
    'support.reply': 'Yanıtla',
    'support.enterYourMessage': 'Mesajınızı girin...',
    'support.send': 'Gönder',
    'support.ticketClosed': 'Bu talep kapatıldı',
    'support.errorLoadingTicket': 'Talep yüklenirken hata',
    'support.fillAllFields': 'Tüm alanları doldurun',
    'support.ticketCreated': 'Talep başarıyla oluşturuldu!',
    'support.errorCreatingTicket': 'Talep oluşturulurken hata',
    'support.messageSent': 'Mesaj gönderildi',
    'support.errorSendingMessage': 'Mesaj gönderilirken hata',
    
    // Common
    'common.loading': 'Yükleniyor...',
    'common.error': 'Veri yüklenirken hata',
    
    // Landing Page
    'landing.home': 'Ana Sayfa',
    'landing.hero.title': 'Daha fazla randevu. Daha fazla gelir. Kaçırılan müşteri yok.',
    'landing.hero.subtitle': 'Chatity AI resepsiyonisti müşterilere 7/24 yanıt verir, her talebi işler ve randevuya dönüştürür.',
    'landing.hero.benefit1': 'Personel işe almadan daha fazla potansiyel müşteri',
    'landing.hero.benefit2': 'Hiçbir fırsat kaçmaz',
    'landing.hero.benefit3': 'Herhangi bir web sitesinde 5 dakikada kurulum',
    'landing.hero.cta': 'Ücretsiz Başla',
    'landing.hero2.eyebrow': 'Güzellik ve wellness için AI resepsiyon',
    'landing.hero2.title': 'Daha fazla randevu. Daha fazla gelir. Kaçırılan müşteri yok.',
    'landing.hero2.subtitle': 'Chatity AI resepsiyonisti müşterilere 7/24 yanıt verir, her talebi işler ve randevuya dönüştürür.',
    'landing.hero2.chWebsite': 'Web sitesi',
    'landing.hero2.chVoice': 'Ses',
    'landing.hero2.soon': 'yakında',
    'landing.hero2.demo': 'Nasıl çalışır',
    'landing.hero2.nocard': 'Kart gerekmez · 5 dakikada kurulum',
    'landing.hero2.hours': 's',
    'landing.hero2.stat1': 'daha fazla randevu',
    'landing.hero2.stat2': 'aylık admin işi',
    'landing.hero2.stat3': 'hiçbir müşteri kaçmaz',
    'landing.hero2.newBooking': 'Yeni randevu!',
    'landing.cta2.eyebrow': 'Daha fazla randevuya hazır mısınız?',
    'landing.cta2.title': 'Bugün ücretsiz başlayın',
    'landing.cta2.note': 'Kart gerekmez · 5 dakikada kurulum · İstediğiniz zaman iptal',
    'landing.cta2.join': 'Yüzlerce güzellik ve wellness işletmesine katılın',
    'landing.hero.trial': '7 gün ücretsiz • Kart gerekmez',
    'landing.login': 'Giriş',
    
    // Trust section
    'landing.trust.title': 'Güvenen Firmalar',
    'landing.trust.subtitle': 'Rezervasyon otomasyonu için Chatity kullananlar:',
    'landing.trust.category1': 'Güzellik Salonları',
    'landing.trust.category2': 'Klinikler ve Diş Hekimliği',
    'landing.trust.category3': 'Yoga ve Fitness Stüdyoları',
    'landing.trust.category4': 'Çevrimiçi Okullar',
    'landing.trust.category5': 'Hizmet Şirketleri',
    'landing.trust.case1.niche': 'Güzellik Salonu',
    'landing.trust.case1.metric': 'Rezervasyonlarda gözle görülür artış',
    'landing.trust.case1.description': 'Web sitesi üzerinden daha fazla çevrimiçi randevu',
    'landing.trust.case1.usecase': 'Sohbet prosedür soruları yanıtladı, müşterileri yönlendirdi ve randevu taleplerini kolaylaştırdı',
    'landing.trust.case2.niche': 'Diş Kliniği',
    'landing.trust.case2.metric': 'Mesai dışı sorular',
    'landing.trust.case2.description': 'Çoğu yeni soru çalışma saatleri dışında gelir',
    'landing.trust.case2.usecase': 'Sohbet robotu istekleri filtreledi, hizmetleri açıkladı ve hastaları doğru yönlendirdi',
    'landing.trust.case3.niche': 'Yoga Stüdyosu',
    'landing.trust.case3.metric': 'Daha az tekrarlayan iş',
    'landing.trust.case3.description': 'Tekrarlayan sorulara harcanan süre azaldı',
    'landing.trust.case3.usecase': 'Sohbet dersleri, programları ve fiyatları açıkladı, sıcak potansiyel müşterileri personele iletti',
    'landing.trust.case4.niche': 'Çevrimiçi Okul',
    'landing.trust.case4.metric': 'Daha yüksek etkileşim',
    'landing.trust.case4.description': 'Web sitesi ziyaretçilerinden daha yüksek potansiyel müşteri etkileşimi',
    'landing.trust.case4.usecase': 'Sohbet kurslar, fiyatlandırma ve deneme dersleri hakkında soruları yanıtlar',
    'landing.trust.case5.niche': 'Oto Servisi',
    'landing.trust.case5.metric': 'İstikrarlı büyüme',
    'landing.trust.case5.description': 'Rezervasyon taleplerinde istikrarlı artış',
    'landing.trust.case5.usecase': 'Sohbet araç bilgilerini, sorunları toplar ve servis taleplerini organize etmeye yardımcı olur',
    'landing.trust.case6.niche': 'Restoran',
    'landing.trust.case6.metric': 'Daha tutarlı rezervasyonlar',
    'landing.trust.case6.description': 'Daha tutarlı masa rezervasyonları',
    'landing.trust.case6.usecase': 'Sohbet rezervasyon taleplerini kabul eder ve menü ve uygunluk sorularını yanıtlar',
    
    // Integrations section
    'landing.integrations.title': 'Kolay Entegrasyon',
    'landing.integrations.subtitle': 'Sohbet robotunu herhangi bir platformda 5 dakikada kurun',
    'landing.integrations.cta': 'Her web sitesi oluşturucu ve CMS ile çalışır',
    'landing.integrations.button': 'Ücretsiz Başla',
    
    // Business types
    'landing.business.beautySalon': 'güzellik salonu',
    'landing.business.restaurant': 'restoran',
    'landing.business.dentalClinic': 'diş kliniği',
    'landing.business.medicalCenter': 'tıp merkezi',
    'landing.business.barbershop': 'berber',
    'landing.business.nailStudio': 'tırnak stüdyosu',
    'landing.business.yogaStudio': 'yoga stüdyosu',
    'landing.business.carService': 'oto servisi',
    
    'landing.features.title': 'Rezervasyon otomasyonu için her şey',
    'landing.feature1.title': 'AI Konuşma',
    'landing.feature1.desc': 'Bot doğal konuşmalar yapar, hizmet, tarih, ad ve telefon öğrenir',
    'landing.feature2.title': 'E-posta ve Telegram Bildirimleri',
    'landing.feature2.desc': 'E-postanıza veya Telegram grubunuza anında rezervasyon bildirimleri',
    'landing.feature3.title': 'Çok Dilli',
    'landing.feature3.desc': 'Otomatik olarak müşterinin dilinde konuşur (14+ dil)',
    'landing.feature4.title': 'Hazır Widget',
    'landing.feature4.desc': 'Kodu web sitesine ekleyin - ve çalışır',
    'landing.feature5.title': 'Rezervasyon Geçmişi',
    'landing.feature5.desc': 'Tüm rezervasyonlar kontrol panelinde kaydedilir',
    'landing.feature6.title': 'Tasarım Özelleştirme',
    'landing.feature6.desc': 'Markanız için renkler, metinler ve stil',
    'landing.feature7.title': 'Website Builder',
    'landing.feature7.desc': 'Hizmetler, fotoğraflar ve AI sohbeti ile hazır chatity.io/adınız sayfası — Instagram ve kartvizitler için ideal',
    'landing.builder.badge': 'Yeni',
    'landing.builder.title': 'Website Builder — 5 dakikada salon siteniz',
    'landing.builder.subtitle': 'Ayrı bir web sitesine gerek yok — işletme sayfanızı doğrudan Chatity içinde oluşturun, tasarımcı gerekmez',
    'landing.builder.point1': 'Hizmetler, fiyatlar, galeri ve harita ile kendi chatity.io/salonunuz sayfanız',
    'landing.builder.point2': 'Yerleşik AI sohbet müşterilere yanıt verir ve 7/24 randevu alır',
    'landing.builder.point3': 'Instagram, kartvizit ve vitrin için QR kod ve kısa bağlantı',
    'landing.builder.point4': 'Sayfanın ziyaretçinin diline otomatik çevirisi',
    'landing.builder.cta': 'Ücretsiz site oluştur',
    'landing.builder.mock.services': 'Hizmetler ve fiyatlar',
    'landing.builder.mock.chat': 'Merhaba! Randevu almak ister misiniz? 💬',
    'landing.partnerBlock.badge': 'Ortaklık programı',
    'landing.partnerBlock.title': 'Ortak olun — %30 kazanın',
    'landing.partnerBlock.subtitle': 'Chatity\'yi önerin ve yönlendirdiğiniz müşterilerin tüm ödemelerinden %30 kazanın. Kişisel bağlantı, gerçek zamanlı istatistikler ve talep üzerine ödemeler.',
    'landing.partnerBlock.point1': 'Yönlendirilen müşterilerin her ödemesinden %30',
    'landing.partnerBlock.point2': 'Kişisel referans bağlantısı ve promosyon kodu',
    'landing.partnerBlock.point3': 'İstatistik ve bakiye ile ortak paneli',
    'landing.partnerBlock.cta': 'Ortak ol',
    'auth.referralCode': 'Referans kodu (isteğe bağlı)',
    'dashboard.partnerProgram': 'Ortaklık',
    'bookings.totalCount': 'Toplam talep',
    'bookings.uniqueClients': 'Benzersiz müşteri',
    'bookings.repeatBadge': 'Tekrar',
    'dashboard.affiliateBlock.title': 'Ortaklık programı',
    'dashboard.affiliateBlock.desc': 'Diğer salonları davet edin ve tüm ödemelerinin %30\'unu bakiyenize kazanın. Ödemeler kart veya IBAN ile (Avrupa).',
    'dashboard.affiliateBlock.cta': 'Ortak panelini aç',
    'partner.dash.payout.method.card_eu': 'Banka kartı (Avrupa)',
    'partner.dash.payout.subtitleEu': 'Ödemeler yalnızca Avrupa: banka kartı veya IBAN/SEPA (EUR).',
    
    'landing.howItWorks.title': 'Nasıl çalışır',
    'landing.step1.title': 'Kayıt',
    'landing.step1.desc': '30 saniyede hesap oluşturun',
    'landing.step2.title': 'Kurulum',
    'landing.step2.desc': 'E-posta/Telegram\'ı bağlayın ve tasarımı özelleştirin',
    'landing.step3.title': 'Gömme',
    'landing.step3.desc': 'Widget kodunu sitenize ekleyin',
    'landing.step4.title': 'Rezervasyonlar',
    'landing.step4.desc': 'Otomatik olarak rezervasyon alın',
    
    'landing.pricing.title': 'Planınızı Seçin',
    'landing.pricing.subtitle': 'Her planda 7 gün ücretsiz deneme',
    'landing.price.perMonth': 'aylık',
    'landing.price.feature1': 'AI, müşterinizin dilinde konuşur',
    'landing.price.calendar': 'Randevu takvimi + online randevu',
    'landing.price.feature2': 'E-posta bildirimleri',
    'landing.price.feature3': 'Rezervasyon geçmişi (30 gün)',
    'landing.price.feature4': 'AI Bilgi Tabanı',
    'landing.price.feature5': 'Temel analitik',
    'landing.price.cta': 'Ücretsiz Denemeyi Başlat',
    
    'landing.plan.popular': 'POPÜLER',
    'landing.plan.starter.name': 'Starter',
    'landing.plan.starter.desc': 'Bağımsız profesyoneller için',
    'landing.plan.starter.limit': 'Aylık 100 konuşma',
    'landing.plan.professional.name': 'Professional',
    'landing.plan.professional.desc': 'Büyüyen salonlar için',
    'landing.plan.professional.limit': 'Aylık 1,000 konuşma',
    'landing.plan.free.name': 'Free', 'landing.plan.free.desc': 'Takvim, online randevu, mini site',
    'landing.plan.free.limit': '1 uzman · 1 şube',
    'landing.plan.free.f1': 'Randevu takvimi', 'landing.plan.free.f2': 'Mini sitenizde online randevu',
    'landing.plan.free.f3': 'Salon mini sitesi', 'landing.plan.free.f4': 'E-posta ve Telegram bildirimleri',
    'landing.plan.starter.tagline': 'AI, müşteri mesajlarını yanıtlar ve randevu alır',
    'landing.plan.starter.channels': '1 kanal (WhatsApp / Instagram / Telegram) + web widget',
    'landing.plan.professional.tagline': 'AI tüm kanallarınızdaki konuşmaları yönetsin',
    'landing.plan.professional.channels': 'Tüm kanallar: WhatsApp + Instagram + Telegram + widget',
    'landing.plan.addons': 'Ek: kanal ayda +€19 · +100 diyalog ayda +€10 · ek şube tarifenin %50 kadarı',
    'landing.freecrm.badge': 'START FREE TODAY', 'landing.freecrm.title': 'Güzellik için ücretsiz CRM',
    'landing.freecrm.subtitle': 'Takvim, online randevu ve mini site — €0. Sonsuza dek. Kart gerekmez.',
    'landing.freecrm.f1.title': 'Takvim', 'landing.freecrm.f1.desc': 'Randevular, ekip, programlar ve müşteri geçmişi',
    'landing.freecrm.f2.title': 'Online randevu', 'landing.freecrm.f2.desc': 'Müşteriler boş saatleri 7/24 kendileri seçer',
    'landing.freecrm.f3.title': 'Mini site', 'landing.freecrm.f3.desc': 'Hizmet ve fiyatlarla salon sayfanız 2 dakikada',
    'landing.freecrm.note': 'AI resepsiyonist mi lazım? Ayda €39 itibaren kanal ekleyin',
    'landing.freecrm.button': 'Bugün ücretsiz başlayın',
    'landing.plan.professional.feature1': 'Telegram bildirimleri',
    'landing.plan.professional.feature2': 'Gelişmiş analitik',
    'landing.plan.professional.feature3': 'UTM takibi',
    'landing.plan.professional.feature4': 'Website Builder (site oluşturucu) + QR bağlantısı',
    'landing.plan.professional.extraFeature': 'Widget özelleştirme',
    'landing.plan.unlimited.name': 'Unlimited',
    'landing.plan.unlimited.desc': 'Büyük işletmeler için',
    'landing.plan.unlimited.limit': '∞ Sınırsız konuşma',
    'landing.plan.unlimited.feature1': 'Excel dışa aktarma',
    'landing.plan.unlimited.feature2': 'Genişletilmiş özelleştirme',
    'landing.plan.unlimited.extraFeature1': 'Öncelikli destek',
    'landing.plan.unlimited.extraFeature2': 'Özel ayarlar',
    
    'landing.cta.title': 'Rezervasyonları otomatikleştirmeye hazır mısınız?',
    'landing.cta.subtitle': 'Chatity\'yi kullanan yüzlerce işletmeye katılın',
    'landing.cta.button': 'Ücretsiz denemeyi başlat',
    
    'landing.footer.product': 'Ürün',
    'landing.footer.features': 'Özellikler',
    'landing.footer.pricing': 'Fiyatlandırma',
    'landing.footer.docs': 'Dokümantasyon',
    'landing.footer.company': 'Şirket',
    'landing.footer.about': 'Hakkımızda',
    'landing.footer.contact': 'İletişim',
    'landing.footer.rights': '© 2025 Chatity. Tüm hakları saklıdır.',

    // Footer
    'footer.description': 'Güzellik ve wellness için AI resepsiyon',
    'footer.product': 'Ürün',
    'footer.features': 'Özellikler',
    'footer.pricing': 'Fiyatlandırma',
    'footer.getStarted': 'Başlayın',
    'footer.legal': 'Yasal',
    'footer.privacyPolicy': 'Gizlilik Politikası',
    'footer.termsOfService': 'Hizmet Koşulları',
    'footer.cookiePolicy': 'Çerez Politikası',
    'footer.contact': 'İletişim',
    'footer.address': '7 Avenue de Fabron, 06200 Nice, Fransa',
    'footer.allRightsReserved': 'Tüm hakları saklıdır.',
    
    // Cookie Consent
    'cookies.title': '🍪 Çerezleri kullanıyoruz',
    'cookies.description': 'Site performansını iyileştirmek, trafiği analiz etmek ve içeriği kişiselleştirmek için çerezleri kullanıyoruz. Siteyi kullanmaya devam ederek çerez kullanımını kabul etmiş olursunuz.',
    'cookies.learnMore': 'Daha fazla bilgi',
    'cookies.accept': 'Hepsini kabul et',
    'cookies.decline': 'Yalnızca gerekli olanlar',

    // Blog
    'blog.title': 'Blog',
    'blog.subtitle': 'İşletme otomasyonu ve AI teknolojileri hakkında faydalı makaleler',
    'blog.readMore': 'Devamını oku',
    'blog.minRead': 'dk okuma',
    'blog.noPosts': 'Makaleler yakında gelecek',
    'blog.backToBlog': 'Blog\'a dön',
    'blog.notFound': 'Makale bulunamadı',
    'blog.relatedPosts': 'İlgili makaleler',
    'blog.ctaTitle': 'İşletmenizi otomatikleştirmeye hazır mısınız?',
    'blog.ctaDescription': 'Chatity\'yi 7 gün ücretsiz deneyin. Kredi kartı gerekmez.',
    'blog.ctaButton': 'Ücretsiz denemeyi başlat',

    // Green API (WhatsApp by QR)
    'greenapi.title': 'QR kod ile WhatsApp',
    'greenapi.badgeConnected': 'Bağlandı',
    'greenapi.badgeWaiting': 'QR taraması bekleniyor',
    'greenapi.badgeNotConnected': 'Bağlı değil',
    'greenapi.description': 'En kolay yol: WhatsApp uygulamasında QR kodu tarayın — WhatsApp Web gibi. Numara telefonunuzda kalır, AI müşterilere hemen yanıt vermeye başlar.',
    'greenapi.connectedPhone': '✅ Bağlı numara: +{phone}',
    'greenapi.importBtn': '📥 WhatsApp\'tan müşterileri içe aktar',
    'greenapi.refreshChats': 'Yenile', 'greenapi.syncingChats': 'Sohbet listesi WhatsApp’tan eşitleniyor — QR taramasından sonra 1–2 dakika sürer. «Yenile»ye basın.',
    'greenapi.importHint': '«Müşteriler» bölümüne hangi sohbetlerin aktarılacağını seçin — kişisel kişileri atlayabilirsiniz. AI yazışma geçmişini bilir ve diyaloğu bağlam içinde sürdürür.',
    'greenapi.qrHint': 'WhatsApp → Ayarlar → Bağlı cihazlar → Cihaz bağla → tarayın',
    'greenapi.qrNotWorking': 'QR taranmıyor mu? QR kodunu yenile', 'greenapi.qrRefreshing': 'Bağlantı yeniden başlatılıyor — yeni QR 1–2 dakika içinde görünür', 'greenapi.qrRefreshFailed': 'QR yenilenemedi, tekrar deneyin',
    'greenapi.qrStarting': '⏳ Örnek başlatılıyor, QR bir dakika içinde görünecek…',
    'greenapi.connectBtn': 'QR ile bağlan',
    'greenapi.disconnectBtn': 'Bağlantıyı kes',
    'greenapi.confirmDisconnect': 'WhatsApp bağlantısı kesilsin mi? Örnek silinecek.',
    'greenapi.toastCreated': 'Örnek oluşturuldu — QR kod ~1 dakika içinde görünecek',
    'greenapi.toastCreateFail': 'Bağlantı oluşturulamadı',
    'greenapi.toastDisconnected': 'WhatsApp bağlantısı kesildi',
    'greenapi.toastDisconnectFail': 'Bağlantı kesilemedi',
    'greenapi.toastImported': 'İçe aktarılan yeni müşteriler: {imported}',
    'greenapi.toastImportFail': 'Sohbetler içe aktarılamadı',
    'greenapi.selectTitle': 'Hangi sohbetler içe aktarılsın?',
    'greenapi.selectHint': 'İçe aktarılacak müşterileri işaretleyin. Kişisel kişilerin işaretini kaldırın — veritabanına eklenmezler.',
    'greenapi.searchPlaceholder': 'İsim veya numara ile ara…',
    'greenapi.selectAll': 'Tümünü seç',
    'greenapi.deselectAll': 'Tümünü kaldır',
    'greenapi.alreadyImported': 'zaten içe aktarıldı',
    'greenapi.importSelected': 'Seçilenleri içe aktar ({n})',
    'greenapi.loadingChats': 'Sohbetler yükleniyor…',
    'greenapi.noChats': 'Kişisel sohbet bulunamadı',
    'greenapi.importing': 'İçe aktarılıyor…',
    'greenapi.aiOn': '🤖 AI yanıtlıyor',
    'greenapi.aiOff': '🚫 Kişisel — AI sessiz',
    'greenapi.contactsTitle': 'WhatsApp kişileri',
    'greenapi.contactsHint': 'AI\'nin kiminle konuşacağını, kiminle sessiz kalacağını seçin (kişisel sohbetler)',
    'greenapi.aiReplies': 'AI yanıtlıyor',
    'greenapi.aiSilent': 'AI sessiz',
    'greenapi.disableAllAi': 'Herkes için AI\'yi kapat',
    'greenapi.enableAllAi': 'Herkes için AI\'yi aç',
    'greenapi.personalHint': 'Kişisel yazışmalarda AI\'nın yanıt vermesini engellemek için sohbetin yanındaki «AI» düğmesine tıklayın. Bir müşteriye telefonunuzdan kendiniz yanıt verirseniz, AI o sohbette 6 saat sessiz kalır.',
    'greenapi.toastPersonalOn': 'AI bu sohbette artık yanıt vermeyecek',
    'greenapi.toastPersonalOff': 'AI bu sohbette tekrar yanıt veriyor',
    'greenapi.stepCreated': 'Örnek oluşturuldu',
    'greenapi.stepStarting': 'WhatsApp sunucularında başlatılıyor — genellikle 1–3 dakika, bazen 5 dakikaya kadar',
    'greenapi.stepQr': 'QR kod burada otomatik olarak görünecek',
    'greenapi.elapsed': 'Geçen süre: {time}',
    'greenapi.takingLong': 'Başlatma normalden uzun sürüyor — Green API sunucuları yoğun olduğunda olabilir. Biraz daha bekleyin veya «Bağlantıyı kes»e tıklayıp yeniden oluşturun.',
    'integrations.cat.website': 'Web sitesi',
    'integrations.cat.websiteDesc': 'WordPress, HTML, Tilda, Shopify ve daha fazlası',
    'integrations.cat.whatsappDesc': 'QR kod ile bağlantı',
    'integrations.cat.instagramDesc': 'AI Direct\'te yanıtlar',
    'integrations.cat.identDesc': 'IDENT CRM\'inize kayıtlar',
    'integrations.cat.altegioDesc': 'Altegio randevu defteri ve CRM',
    'integrations.cat.vk': 'VK',
    'integrations.cat.vkDesc': 'Topluluk mesajlarında AI',
    'integrations.cat.voice': 'Telefon',
    'integrations.cat.voiceDesc': 'AI çağrı yanıtlama',
    'settings.jobReply': 'İş başvurularına yanıt',
    'settings.jobReplyPlaceholder': 'Örn.: «CV\'nizi hello@salon.fr adresine gönderin — sahibi bizzat inceleyip size dönecek»',
    'settings.jobReplyTip': 'Boş bırakılırsa AI adayın iletişim bilgisini kibarca alır ve size iletir. Şikayet ve adaylar için Telegram/e-posta bildirimi alırsınız.',
    'settings.crmImportTitle': 'CRM\'den hizmet içe aktar (Planity/Booksy/Fresha)',
    'settings.crmImportHint': 'Herkese açık randevu sayfanızın bağlantısını yapıştırın — hizmetleri ve fiyatları doğrudan AI bilgi tabanına aktaralım.',
    'settings.crmImportFetch': 'Hizmetleri bul',
    'settings.crmImportEmpty': 'Bu bağlantıda fiyatlı hizmet bulunamadı. Sayfanın herkese açık olduğundan emin olun.',
    'settings.crmImportFound': 'Bulunan hizmet: {count}',
    'settings.crmImportConfirm': 'Bilgi tabanına ekle ({count})',
    'settings.crmImportSuccess': 'İçe aktarılan hizmet: {count}',
    'settings.crmImportNote': 'Seçili hizmetler bilgi tabanına eklenir. Yeniden içe aktarma önceki bloğu değiştirir.',

    // Onboarding Guide
    'onboarding.title': 'Hızlı Başlangıç',
    'onboarding.subtitle': 'AI\'nızın randevu almaya başlaması için 4 adımı tamamlayın',
    'onboarding.step1': 'Bilgi Tabanı',
    'onboarding.step1Desc': 'AI\'ya hizmetlerinizi, fiyatlarınızı ve çalışma saatlerinizi anlatın',
    'onboarding.step2': 'Kanal Bağlayın',
    'onboarding.step2Desc': 'WhatsApp, site widget\'ı veya mini site',
    'onboarding.step3': 'Kart Ekleyin',
    'onboarding.step3Desc': 'AI\'nın kesintisiz çalışması için bir plan seçin',
    'onboarding.step4': 'Test Mesajı',
    'onboarding.step4Desc': 'AI\'nıza yazın ve yanıtı kontrol edin',
    'onboarding.dismiss': 'Gizle',
    'settings.revenueTitle': 'Raporlar için gelir',
    'settings.revenueHint': 'Hizmet fiyatlarını bilgi tabanınızdan alıyoruz. Fiyatı olmayan hizmetler için ortalama sepet kullanılır — rapor, Chatity sayesinde oluşan geliri böyle hesaplar.',
    'settings.avgTicket': 'Ortalama sepet',
    'settings.currency': 'Para birimi',
    'settings.reactivationTitle': 'Müşteri reaktivasyonu',
    'settings.reactivationHint': 'Uyuyan müşterilere tekrar randevu hatırlatması + raporda dönüş ve gelir sayımı',
    'settings.reactivationDays': 'Şu kadar gün sonra hatırlat',
    'settings.reactivationChannel': 'Kanal',
    'settings.reactivationMessage': 'Mesaj metni',
    'settings.reactivationPlaceholder': 'Merhaba {name}! Sizi özledik 💐 Tekrar randevu almak ister misiniz?',
    'settings.reactivationTip': 'Müşteri adını eklemek için {name} kullanın. Günde bir kez otomatik gönderilir.',

  }
};

export const useTranslation = () => {
  // Check localStorage first, then browser language
  const savedLang = localStorage.getItem('userLanguage');
  const browserLang = navigator.language?.split('-')[0] || 'en';
  const lang = savedLang || browserLang;
  const supportedLang = ['ru', 'en', 'fr', 'tr'].includes(lang) ? lang : 'en';
  
  const t = (key, params) => {
    let str = translations[supportedLang]?.[key] || translations['en'][key] || key;
    if (params && typeof str === 'string') {
      Object.entries(params).forEach(([k, v]) => {
        str = str.split(`{${k}}`).join(String(v));
      });
    }
    return str;
  };
  
  const setLanguage = (newLang) => {
    if (['ru', 'en', 'fr', 'tr'].includes(newLang)) {
      localStorage.setItem('userLanguage', newLang);
      window.location.reload(); // Reload to apply new language
    }
  };
  
  return { t, lang: supportedLang, setLanguage };
};

